(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":91,"./util":105}],2:[function(require,module,exports){
var util = require('./util');
const analyticsUtils = require('./analytics/analyticsUtils');
const pdpUtils = require('./analytics/pdp/pdpUtils');
var unbind = 0;
var unbindcarousel = 0;
var unbindreccarousel = 0;

// Specific for checkout and cart page only
function couponsubcategory() {
  switch (window.Resources.PAGE_CATEGORY) {
    case 'cart-show':
      return 'Cart';
    case 'coshipping-start':
      return 'Shipping';
    case 'coshipping-singleshipping':
      return 'Payment';
    case 'cobilling-start':
      return 'Payment';
    case 'cobilling-removegiftcertificate':
      return 'Payment';
    case 'cobilling-billing':
      return 'Review';
    case 'account-editprofile':
      return 'Profile';
    case 'address-list':
      return 'Addresses';
    case 'paymentinstruments-list':
      return 'Payment Methods';
    case 'wishlist-show':
      return 'Saved For Later';
    case 'order-history':
      return 'Order History';
    case 'orderreplenishment-show':
      return 'Replenishment';
    case 'onlinequiz-getresult':
    case 'onlinequiz-show':
      return 'Online Quiz';
    default:
      return '';
  }
}

function isMobile() {
  return $(window).width() <= 640;
}

/**
 * @typedef CountPositionOptions
 * @type {object}
 * @property {string} container リストコンテナのセレクタ
 * @property {string} item リスト要素のセレクタ
 * @property {string} [superContainer] リスト要素と先行リストを内包するコンテナのセレクタ
 * @property {Array<CountPositionOptions>} [leads] 先行リストの定義
 */

/**
 * 要素数を数えて、リスト上の位置を計算する。
 * @param {HTMLElement} target 基準になる要素
 * @param {CountPositionOptions} options
 * @returns {number}
 */
function countCurrentProductTilePosition(target, options) {
  const leads = options.leads || [];
  const offset =
    options.superContainer == null
      ? 0
      : leads.reduce(function (acc, curr) {
        return (
            acc +
            $(target)
              .closest(options.superContainer)
              .find(curr.container + ' ' + curr.item).length
          );
      }, 0);
  const currentRecommendedItem = $(target).closest(options.item)[0];
  const index = $(target)
    .closest(options.container)
    .find(options.item)
    .toArray()
    .indexOf(currentRecommendedItem);
  const position = offset + index + 1;
  return position;
}

// page-specific: Cart, Checkout
function getPageError() {
  var $errorMsg = $('.error-form');
  if ($errorMsg.length === 0) {
    return '';
  }

  return $errorMsg.html().trim();
}

function getActiveSortingRule() {
  var httpParams = util.getQueryStringParams(window.location.href);
  var sortParam = httpParams['srule'];

  if (!sortParam) {
    return null;
  }

  return sortParam
    .split('-')
    .map(function (w) {
      return w[0].toUpperCase() + w.substr(1);
    })
    .join(' ');
}

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height() - 150;
  var elemTop = $(elem).offset().top;
  var result = [];
  result.push(elemTop <= docViewBottom && elemTop >= docViewTop);
  if (elemTop <= docViewBottom && elemTop >= docViewTop) {
    result.push($(elem).parent().attr('class'));
  }
  return result;
}

function getpage() {
  var url = window.location.href;
  var splittedurl = url.split('?');
  var page = splittedurl[0].split('/');
  return page[page.length - 1];
}
//page-specific: PLP
function getRefinementsFromURL() {
  var str = '';
  if (window.location.href.split('?').length > 1) {
    var urlparam;
    if (window.location.href.split('?')[1].indexOf('&') > -1) {
      urlparam = window.location.href.split('?')[1].split('&');
      var length = urlparam.length;
      var prefnval, prefnkey, prefvval, prefvkey;
      for (var i = 0; i < length; i++) {
        var prefn = urlparam[i].indexOf('prefn');
        if (prefn > -1) {
          prefnkey = urlparam[i].split('=')[0];
          prefnval = urlparam[i].split('=')[1];
          var num = prefnkey.charAt(5);
          for (var a = 0; a < length; a++) {
            prefvkey = urlparam[a].split('=')[0];
            if (prefvkey == 'prefv' + num) {
              prefvval = urlparam[a].split('=')[1];
              str += '[' + prefnval + ':' + prefvval + ']';
            }
          }
        }
      }
    }
  }
  return str;
}

function getNextPage(href) {
  if (href === '') {
    return '';
  } else {
    var newUrl = new URL(href);
    var pageURI = newUrl && newUrl.pathname ? newUrl.pathname : newUrl;
    return pageURI;
  }
}

function trackConsultationEvent(data) {
  var TOOL_TYPES = {
    skincareConsultation: 'Skincare Consultation'
  };

  analyticsUtils.pushToDataLayer({
    event: data.event,
    pageCategory: 'Consultation Tool',
    consultationToolType: TOOL_TYPES[data.toolname] || data.toolname,
    consultationQuestion: data.question,
    consultationResponse: data.answers
  });
}

function trackConsultationPageview(data) {
  analyticsUtils.pushToDataLayer({
    event: 'consultationSteps',
    pageCategory: 'Consultation Tool',
    consultationToolType: data.toolname,
    consultationStep: data.pagename
  });
}

function trackOnlineQuizPageview() {
  analyticsUtils.pushToDataLayer({
    userId: analyticsUtils.getCustomerNo(),
    pageSubCategory: couponsubcategory(),
    pageCategory: analyticsUtils.getPageCategory(),
    language: analyticsUtils.getLanguage(),
    websiteCountry: analyticsUtils.getCountryCode()
  });
}

function trackOnlineQuizResultPageview() {
  analyticsUtils.pushToDataLayer({
    eeAction: 'eeListView',
    event: 'eeListView',
    pageSubCategory: couponsubcategory(),
    pageCategory: analyticsUtils.getPageCategory(),
    language: analyticsUtils.getLanguage(),
    websiteCountry: analyticsUtils.getCountryCode(),
    products: window.onlineQuizResultProdData // Defined in quizresultpage.isml
  });
}

function trackOnlineQuizEvent(data) {
  analyticsUtils.pushToDataLayer({
    event: data.event,
    nextQuestionNumber: data.nextQuestionNumber,
    pageSubCategory: couponsubcategory(),
    pageCategory: analyticsUtils.getPageCategory(),
    language: analyticsUtils.getLanguage(),
    websiteCountry: analyticsUtils.getCountryCode()
  });
}

function initializeGlobalEvents() {
  var navctr = true;
  var gtmNavData = '';

  // 全体
  require('./analytics/global/navigationMenuClick')();
  require('./analytics/global/siteSearch')();
  // トップページ設定
  require('./analytics/home/eePromoView')();
  require('./analytics/home/eePromoClick')();
  require('./analytics/home/carouselChangeImage')();
  // ログイン
  require('./analytics/login/accountLogin')();
  // plp
  require('./analytics/plp/colorChange')();
  // pdp
  require('./analytics/pdp/colorChange')();
  require('./analytics/pdp/addToCart')();
  require('./analytics/pdp/retailerec')();
  // その他オンラインストアのご案内
  require('./analytics/retailerec/guidance')();
  // 最近見た商品
  require('./analytics/recentlyview/recentlyView')();
  // ファンデーションファインダー
  require('./analytics/foundationfinder/colorChange')();
  // 支払方法編集
  require('./analytics/checkout/couponSubmission')();

  $(document)
    // add to wishlist in pdp and quickview
    .on('click', '.wishlist-icon', function () {
      var _this = $(this);
      var _event = 'clickSaveForLater';
      if (_this.hasClass('wishlist-added')) {
        _event = 'removeFromWishlist';
      }
      if (_this.parents('.cart-row').length > 0) {
        var index = _this.parents('.cart-row').index();
        analyticsUtils.pushToDataLayer({
          event: _event,
          productCategory: basketConfirmation.productLineItems[index].category,
          productSubCategory:
            basketConfirmation.productLineItems[index].subCategory,
          productName: basketConfirmation.productLineItems[index].name,
          pageCategory: analyticsUtils.getPageCategory(),
          productId: basketConfirmation.productLineItems[index].id
        });
      } else {
        analyticsUtils.pushToDataLayer({
          event: _event,
          productCategory: pdpUtils.getProductCategory(),
          productSubCategory: pdpUtils.getProductSubcategory(),
          productName: _this.attr('data-element-name'),
          pageCategory: analyticsUtils.getPageCategory(),
          productId: _this.attr('data-element-pid')
        });
      }
    })

    // newsletter in navigation;
    .on('clicknewsletter', function (e, data) {
      analyticsUtils.pushToDataLayer({
        event: 'newsletterSubscription',
        siteLocation: data.siteloc,
        pageSubCategory:
          analyticsUtils.getPageCategory() == 'My Account'
            ? pdpUtils.getProductSubcategory()
            : '',
        pageCategory: analyticsUtils.getPageCategory()
      });
    })

    // click ask question in pdp
    .on('click', '.bv-ask-question', function () {
      analyticsUtils.pushToDataLayer({
        page: getpage(),
        event: 'askQuestion',
        productCategory: pdpUtils.getProductCategory(),
        pageSubCategory: 'Ask a Question',
        productName: pdpUtils.getProductName(),
        pageCategory: 'Product Page'
      });
    })

    // Scroll on reviews in pdp
    .scroll(function () {
      if ($('.bv-section-summary').length) {
        if (isScrolledIntoView('.bv-section-summary') && unbind < 1) {
          unbind = 1;
          analyticsUtils.pushToDataLayer({
            page: getpage(),
            event: 'productReviewsView',
            productCategory: pdpUtils.getProductCategory(),
            pageSubCategory: 'Reviews',
            productName: pdpUtils.getProductName(),
            pageCategory: 'Product Page'
          });
        }
      }

      // for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
      if (
        $('.pi .carousel-recommendations').length > 0 ||
        $('.cross-sell .carousel-recommendations').length > 0
      ) {
        $('.carousel-recommendations').each(function () {
          var result = isScrolledIntoView($(this));
          if (result[0]) {
            if (result[1] === 'recently-viewed cross-sell rv-section') {
              if (unbindreccarousel < 1) {
                unbindreccarousel = 1;
                analyticsUtils.pushToDataLayer({
                  currencyCode: window.User.currencyCode,
                  eeAction: 'eeListView',
                  event: 'eeListView',
                  pageCategory: analyticsUtils.getPageCategory(),
                  products: window.recentforpageload.product
                });
              }
            } else if (result[1].indexOf('pdp-social-media-section') == -1) {
              if (unbindcarousel < 1) {
                unbindcarousel = 1;
                analyticsUtils.pushToDataLayer({
                  currencyCode: window.User.currencyCode,
                  eeAction: 'eeListView',
                  event: 'eeListView',
                  pageCategory: analyticsUtils.getPageCategory(),
                  products: window.forpageload.product
                });
              }
            }
          }
        });
      }
    })

    // Click on Reviews in PDP
    .on('click', '.bv-inline-histogram-ratings-star-container', function () {
      analyticsUtils.pushToDataLayer({
        page: getpage(),
        event: 'productReviewsView',
        productCategory: pdpUtils.getProductCategory(),
        pageSubCategory: 'Reviews',
        productName: pdpUtils.getProductName(),
        pageCategory: 'Product Page'
      });
    })

    // Check balance giftcard in gift card page
    .on('click', '#CheckBalanceButton', function () {
      if (
        $('#dwfrm_giftcert_balance_giftCertID').val() != '' &&
        $('#dwfrm_giftcert_balance_giftCertPIN').val() != ''
      ) {
        analyticsUtils.pushToDataLayer({
          event: 'giftCard',
          pageSubCategory: 'Gift Card',
          pageCategory: 'My Account'
        });
      }
    })

    // Check balance giftcard in checkout page
    .on(
      'click',
      '.modal-body .gift-cert-balance-submit #check-giftcert-modal',
      function () {
        if (
          $(
            '.modal-body .gift-card-number #dwfrm_billing_giftCertCode'
          ).val() != '' &&
          $(
            '.modal-body .gift-card-pin #dwfrm_giftcert_balance_giftCertPIN'
          ).val() != ''
        ) {
          analyticsUtils.pushToDataLayer({
            event: 'giftCard',
            pageSubCategory: 'Payment',
            pageCategory: 'Checkout'
          });
        }
      }
    )

    // Submit ask a question
    .on(
      'click',
      '.bv-submission-section button:contains("Post Question")',
      function () {
        analyticsUtils.pushToDataLayer({
          page: getpage(),
          event: 'submitQuestion',
          productCategory: pdpUtils.getProductCategory(),
          question: $('#bv-textarea-field-questionsummary').val(),
          productName: pdpUtils.getProductName(),
          pageSubCategory: 'Ask a Question',
          pageCategory: analyticsUtils.getPageCategory()
        });
      }
    )

    // remove from cart
    .on(
      'click',
      '.user-action-remove .button-text[value="Remove"]',
      function () {
        var index = $(this).parents('.cart-row').index();
        analyticsUtils.pushToDataLayer({
          currencyCode: window.Resources.CURRENCY,
          event: 'removeFromCart',
          productOrderType:
            $(this)
              .parents('.cart-row')
              .find('.replenishment .replenishmentDays').length > 0
              ? 'Replenishment'
              : 'Regular',
          pageCategory: analyticsUtils.getPageCategory(),
          products: [
            {
              id: basketConfirmation.productLineItems[index].id,
              category: basketConfirmation.productLineItems[index].category,
              price: basketConfirmation.productLineItems[index].price,
              name: basketConfirmation.productLineItems[index].name,
              brand: analyticsUtils.getBrandName(),
              quantity: basketConfirmation.productLineItems[index].quantity,
              size: basketConfirmation.productLineItems[index].size,
              subCategory:
                basketConfirmation.productLineItems[index].subCategory,
              subSubCategory:
                basketConfirmation.productLineItems[index].subSubCategory,
              productAutoReplen:
                basketConfirmation.productLineItems[index].productAutoReplen,
              productOutOfStock:
                basketConfirmation.productLineItems[index].productOutOfStock,
              productColor:
                basketConfirmation.productLineItems[index].productColor,
              productType:
                basketConfirmation.productLineItems[index].productType,
              productOrderType:
                $(this)
                  .parents('.cart-row')
                  .find('.replenishment .replenishmentDays').length > 0
                  ? 'Replenishment'
                  : 'Regular',
              productVariantID:
                miniBasketConfirmation.productLineItems[index].productVariantID,
              collectionName:
                miniBasketConfirmation.productLineItems[index].collectionName
            }
          ]
        });
      }
    )

    // remove from minicart
    .on('click', '.mini-cart-details .remove-link', function () {
      var index = $(this).parents('.mini-cart-product').index();
      analyticsUtils.pushToDataLayer({
        currencyCode: window.Resources.CURRENCY,
        event: 'removeFromCart',
        pageCategory: analyticsUtils.getPageCategory(),
        products: [
          {
            id: miniBasketConfirmation.productLineItems[index].id,
            category: miniBasketConfirmation.productLineItems[index].category,
            price: miniBasketConfirmation.productLineItems[index].price,
            name: miniBasketConfirmation.productLineItems[index].name,
            brand: analyticsUtils.getBrandName(),
            quantity: miniBasketConfirmation.productLineItems[index].quantity,
            size: miniBasketConfirmation.productLineItems[index].size,
            subCategory:
              miniBasketConfirmation.productLineItems[index].subCategory,
            subSubCategory:
              miniBasketConfirmation.productLineItems[index].subSubCategory,
            productAutoReplen:
              miniBasketConfirmation.productLineItems[index].productAutoReplen,
            productOutOfStock:
              miniBasketConfirmation.productLineItems[index].productOutOfStock,
            productColor:
              miniBasketConfirmation.productLineItems[index].productColor,
            productType:
              miniBasketConfirmation.productLineItems[index].productType,
            productOrderType:
              $(this)
                .parents('.cart-row')
                .find('.replenishment .replenishmentDays').length > 0
                ? 'Replenishment'
                : 'Regular',
            productVariantID:
              miniBasketConfirmation.productLineItems[index].productVariantID,
            collectionName:
              miniBasketConfirmation.productLineItems[index].collectionName
          }
        ]
      });
    })
    // click zoom in pdp
    .on('click', '.productthumbnail.selected', function () {
      if ($('.quickview-modal').length === 0) {
        analyticsUtils.pushToDataLayer({
          event: 'productInteraction',
          productCategory: pdpUtils.getProductCategory(),
          productSubCategory: pdpUtils.getProductSubcategory(),
          productName: pdpUtils.getProductName(),
          pageCategory: analyticsUtils.getPageCategory(),
          productId: pdpUtils.getProductId(),
          interactionType: 'Zoom'
        });
      }
    })

    // click full ingredients in pdp
    .on('click', '.type-fullingredients_openBtn', function () {
      analyticsUtils.pushToDataLayer({
        event: 'productInteraction',
        productCategory: pdpUtils.getProductCategory(),
        productSubCategory: pdpUtils.getProductSubcategory(),
        productName: pdpUtils.getProductName(),
        pageCategory: analyticsUtils.getPageCategory(),
        productId: pdpUtils.getProductId(),
        interactionType: 'View Full Product Ingredients'
      });
    })

    .on('click', '.cart-promo-approaching', function () {
      analyticsUtils.pushToDataLayer({
        event: 'eePromoClick',
        pageSubCategory: 'Internal marketing',
        pageCategory: 'Cart Page',
        promotions: [
          {
            position: 'Cart',
            id: $('.cart-promo-approaching').data('promoid'),
            creative: 'Cart-Banner',
            name: $('.cart-promo-approaching').data('promoname')
          }
        ]
      });
    })

    .on('click', '.cart-coupon-code #add-coupon', function () {
      localStorage.removeItem('couponvalidation');
    })

    // track share button on PDP
    .on('click', '.socialsharing .share-icon', function () {
      analyticsUtils.pushToDataLayer({
        socialAction: 'Share',
        event: 'socialShare',
        siteLocation: 'product page',
        pageCategory: analyticsUtils.getPageCategory(),
        pageSubCategory: analyticsUtils.getPageSubcategory(),
        socialNetwork: $(this).data('share')
      });
    })

    // Track Follow button on Footer
    .on('click', '.social-links a', function () {
      analyticsUtils.pushToDataLayer({
        socialAction: 'Follow',
        event: 'socialFollow',
        siteLocation: 'footer',
        pageCategory: analyticsUtils.getPageCategory(),
        socialNetwork: $(this).data('follow')
      });
    })

    // Add to all to Cart
    .on('click', '#add-all-to-cart', function () {
      var $regimenbg = $(this).parents('.regimen-bg');
      var products = [];
      $regimenbg.find('.gtm-product-tile').each(function () {
        var product = {};
        var tileVariantData = $(this).data('value');
        product.ID = tileVariantData.masterID || tileVariantData.ID;
        product.productVariantID = tileVariantData.ID;
        product.category = tileVariantData.catid;
        product.price = tileVariantData.pricing.sale
          ? tileVariantData.pricing.sale
          : tileVariantData.pricing.minprice;
        product.name = tileVariantData.name;
        product.brand = tileVariantData.brand;
        product.quantity = tileVariantData.quantity;
        product.size = tileVariantData.size;
        product.subCategory = tileVariantData.subcategory;
        product.subSubCategory = tileVariantData.subsubcategory;
        product.productAutoReplen = tileVariantData.productautoreplenish;
        product.productOutOfStock = tileVariantData.productOutOfStock;
        product.productColor = tileVariantData.productColor;
        product.productType = 'Product';
        product.collectionName = tileVariantData.customBrand;
        product.productNumReviews = tileVariantData.productNumReviews;
        product.productStarRating = tileVariantData.productStarRating;
        products.push(product);
      });
      analyticsUtils.pushToDataLayer({
        currencyCode: window.Resources.CURRENCY,
        event: 'addToCart',
        productOrderType: pdpUtils.getProductOrderType(),
        addToCartType: analyticsUtils.getPageCategory(),
        pageSubCategory: pdpUtils.getProductSubcategory(),
        pageCategory: analyticsUtils.getPageCategory(),
        products: products
      });
    })

    // click email hyper link in navigation
    .on('click', '.emailcsr-nav', function () {
      if (window.Resources.PAGE_CATEGORY == 'page-show') {
        analyticsUtils.pushToDataLayer({
          event: 'contactRequest',
          contactType: 'Email',
          siteLocation: 'Header',
          //"pageSubCategory": couponsubcategory(),
          pageCategory: pdpUtils.getProductCategory()
        });
      } else {
        analyticsUtils.pushToDataLayer({
          event: 'contactRequest',
          contactType: 'Email',
          siteLocation: 'Header',
          pageSubCategory:
            window.Resources.PAGE_CATEGORY == 'cart-show'
              ? ''
              : couponsubcategory(),
          pageCategory: analyticsUtils.getPageCategory()
        });
      }
    })
    // Click email link in the customer care
    .on(
      'click',
      '.content-asset a:contains("customerservice@shiseidousa.com")',
      function () {
        analyticsUtils.pushToDataLayer({
          event: 'contactRequest',
          contactType: 'Email',
          siteLocation:
            window.Resources.PAGE_CATEGORY == 'cart-show'
              ? 'Right Nav'
              : 'Body',
          //"pageSubCategory": couponsubcategory(),
          pageCategory:
            window.Resources.PAGE_CATEGORY == 'cart-show'
              ? analyticsUtils.getPageCategory()
              : pdpUtils.getProductCategory()
        });
      }
    )

    .on('gtmcontactus', function () {
      analyticsUtils.pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Contact Customer Care Submission',
        siteLocation: 'Body',
        pageCategory: analyticsUtils.getPageCategory()
      });
    })
    .on('askanexpert', function () {
      analyticsUtils.pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Ask An Expert Submission',
        siteLocation: 'Body',
        pageSubCategory: couponsubcategory(),
        pageCategory: 'Ask An Expert'
      });
    })

    .on('click', '.LPMcontainer', function () {
      analyticsUtils.pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Live Chat',
        siteLocation:
          analyticsUtils.getPageCategory() == 'Checkout' ? 'Header' : 'Body',
        pageSubCategory: couponsubcategory(),
        pageCategory: analyticsUtils.getPageCategory()
      });
    })

    .on('click', '.LPMimage', function () {
      var id = $(this).attr('id');
      var chk = id.charAt(id.length - 1);
      if (chk == 1) {
        analyticsUtils.pushToDataLayer({
          event: 'contactRequest',
          contactType: 'Live Chat',
          siteLocation: 'Pop-up',
          pageSubCategory: couponsubcategory(),
          pageCategory: analyticsUtils.getPageCategory()
        });
      }
    })

    .on('click', '.footer-container .products ul li:nth-child(4)', function () {
      analyticsUtils.pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Phone',
        siteLocation: 'Footer',
        pageSubCategory:
          window.Resources.PAGE_CATEGORY == 'cart-show'
            ? ''
            : couponsubcategory(),
        pageCategory: analyticsUtils.getPageCategory()
      });
    })

    // click on recommendation
    .on('click', '.recommendation-item', function () {
      if (analyticsUtils.getPageCategory() == 'Product Page') {
        sessionStorage.setItem('listType', 'Recommended Product List');
        sessionStorage.setItem('listName', 'Product Page');
      } else if (analyticsUtils.getPageCategory() == 'Home Page') {
        sessionStorage.setItem('listType', 'Recently Viewed List');
        sessionStorage.setItem('listName', 'Home Page');
      }
    })

    .on('click', '.catalog-link', function () {
      if (navctr == true) {
        gtmNavData = $(this).text().trim();
        sessionStorage.setItem('navlink', gtmNavData);
        sessionStorage.setItem('menuloc', 'topmenu');
        util.setCookie('navdata', encodeURIComponent(gtmNavData), 0.2);
        navctr = false;
      }
    })

    .on('click', '.main-nav .has-sub-menu a', function () {
      if (navctr == true) {
        gtmNavData = $(this).text().trim();
        sessionStorage.setItem('navlink', gtmNavData);
        sessionStorage.setItem('menuloc', 'topmenu');
        util.setCookie('navdata', encodeURIComponent(gtmNavData), 0.2);
        navctr = false;
      }
    })

    .on('click', '.refinement-header', function () {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData);
      sessionStorage.setItem('menuloc', 'leftmenu');
    })

    .on('click', '.refinement-link', function () {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData);
      sessionStorage.setItem('menuloc', 'leftmenu');
    })

    .on('click', '.breadcrumb-element', function () {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('breadcrumbs', gtmNavData);
      sessionStorage.setItem('menuloc', 'leftmenu');
    })

    .on('change', '.cart-qty-select', function () {
      if (analyticsUtils.getPageCategory() == 'Cart Page') {
        if ($('.edit-modal').length > 0) {
          sessionStorage.setItem('cartupdate', '1');
        } else {
          sessionStorage.setItem('productUpdate', '1');
        }
      }
    })

    .on('change', '.quantity-select', function () {
      if (window.Resources.PAGE_CATEGORY == 'wishlist-show') {
        sessionStorage.setItem('productUpdate', '1');
      }
    })

    .on('click', '.account-left-nav li', function () {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData);
      sessionStorage.setItem('menuloc', 'leftmenu');
    })

    // Remove uservalidation attribute for userlogin validation
    .on('click', '.user-links .log-out-link', function () {
      localStorage.removeItem('uservalidation');
    })

    .on('change', '#va-color', function () {
      if (analyticsUtils.getPageCategory() == 'Cart Page') {
        sessionStorage.setItem('cartupdate', '1');
      }
    })

    .on('click', '.close-button', function () {
      if (analyticsUtils.getPageCategory() == 'Cart Page') {
        sessionStorage.setItem('cartupdate', '');
      }
    })

    .on('click', '#save-for-later', function () {
      if (analyticsUtils.getPageCategory() == 'Cart Page') {
        sessionStorage.setItem('cartupdate', '');
      }
    })

    .on('click', '#pdp-swatches .selectable', function () {
      if (analyticsUtils.getPageCategory() == 'Cart Page') {
        if (!$(this).hasClass('selected')) {
          sessionStorage.setItem('cartupdate', '1');
        }
      }
    })

    .on('click', '.search-suggestion-wrapper .hit', function () {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData.replace(/\s\s+/g, ' '));
      sessionStorage.setItem('menuloc', 'site search pop-in');
    })

    .on('click', '.search-suggestion-wrapper .product-suggestion', function () {
      gtmNavData = $(this).text().trim();
      var rep = gtmNavData.replace(/\n/g, ' ');
      sessionStorage.setItem('navlink', rep.replace(/ +/g, ' '));
      sessionStorage.setItem('menuloc', 'site search pop-in');
    })

    // PLP click in list image
    .on('click', '#search-result-items .gtmindex .thumb-link', function () {
      var index = $(this).parents('.gtmindex').index('.gtmindex');
      if (index >= 0) {
        if (productData.page >= 1) {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products: [prodholder[index]]
          });
          sessionStorage.setItem('listType', prodholder[index].listType);
          sessionStorage.setItem('listName', prodholder[index].listName);
        } else {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products:
              typeof prodholder !== 'undefined' ? [prodholder[0][index]] : ''
          });
          if (typeof prodholder !== 'undefined') {
            sessionStorage.setItem('listType', prodholder[0][index].listType);
            sessionStorage.setItem('listName', prodholder[0][index].listName);
          }
        }
      }
    })

    // PLP click in list name
    .on('click', '#search-result-items .gtmindex .name-link', function () {
      var index = $(this).parents('.gtmindex').index('.gtmindex');
      if (index >= 0) {
        if (productData.page > 0) {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products: [prodholder[index]]
          });
          sessionStorage.setItem('listType', prodholder[index].listType);
          sessionStorage.setItem('listName', prodholder[index].listName);
        } else {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products:
              typeof prodholder !== 'undefined' ? [prodholder[0][index]] : ''
          });
          if (typeof prodholder !== 'undefined') {
            sessionStorage.setItem('listType', prodholder[0][index].listType);
            sessionStorage.setItem('listName', prodholder[0][index].listName);
          }
        }
      }
    })

    // PLP click in list view details
    .on('click', '#search-result-items .gtmindex .buy-button', function () {
      var index = $(this).parents('.gtmindex').index('.gtmindex');
      if (index >= 0) {
        if (productData.page > 0) {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products: [prodholder[index]]
          });
          sessionStorage.setItem('listType', prodholder[index].listType);
          sessionStorage.setItem('listName', prodholder[index].listName);
        } else {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            filterChoice: getActiveSortingRule(),
            dropDown: getRefinementsFromURL(),
            products: [prodholder[0][index]]
          });
          sessionStorage.setItem('listType', prodholder[0][index].listType);
          sessionStorage.setItem('listName', prodholder[0][index].listName);
        }
      }
    })

    // Recommendation, bestseller eelistclick in homepage,pdp,cart
    .on(
      'click',
      '.cross-sell .carousel-recommendations .product-tile-inner',
      function () {
        var index = $(this).parents('[class^="item-"]').index();
        if (
          typeof forpageload.product[index] != undefined &&
          forpageload.product[index] != null
        ) {
          analyticsUtils.pushToDataLayer({
            event: 'eeListClick',
            pageSubCategory: '',
            pageCategory: analyticsUtils.getPageCategory(),
            filterChoice: '',
            dropDown: '',
            products: [
              {
                listType: forpageload.product[index].listType,
                listName: forpageload.product[index].listName,
                position: forpageload.product[index].position,
                id: forpageload.product[index].id,
                category: pdpUtils.getProductCategory(),
                price: forpageload.product[index].price,
                name: forpageload.product[index].name,
                brand: analyticsUtils.getBrandName(),
                quantity: forpageload.product[index].quantity,
                size: forpageload.product[index].size,
                subCategory: forpageload.product[index].subCategory,
                subSubCategory: forpageload.product[index].subSubCategory,
                productAutoReplen: forpageload.product[index].productAutoReplen,
                productOutOfStock: forpageload.product[index].productOutOfStock,
                productColor: forpageload.product[index].productColor,
                productType: forpageload.product[index].productType,
                productNumReviews: '',
                productStarRating: ''
              }
            ]
          });
          sessionStorage.setItem(
            'listType',
            forpageload.product[index].listType
          );
          sessionStorage.setItem(
            'listName',
            forpageload.product[index].listName
          );
        }
      }
    )

    // click on viewmore button
    .on('plpviewmore', function () {
      if (analyticsUtils.getPageCategory() == 'Category Page') {
        if (prodholder && typeof productData.product != undefined) {
          if (productData.page > 1) {
            prodholder = prodholder.concat(productData.product);
          } else {
            prodholder = prodholder[0].concat(productData.product);
          }

          for (var i = 0; i < prodholder.length; i++) {
            prodholder[i].position = i + 1;
          }
          for (var a = 0; a < productData.product.length; a++) {
            var diff = productData.product.length - a;
            productData.product[a].position = prodholder.length - diff + 1;
          }
          pushDtLayer({
            event: 'eeListView',
            eeAction: 'eeListView',
            pageCategory: searchItems.search
              ? 'Site Search'
              : 'Product List Page',
            dropDown: '',
            filterChoice: '',
            currencyCode: window.User.currencyCode,
            products: productData.product || new Array()
          });
        }
      }
    })

    // tracking change on image in
    .on('afterChange', '.pdp-product-thumbnail-slider', function () {
      analyticsUtils.pushToDataLayer({
        event: 'productInteraction',
        productCategory: pdpUtils.getProductCategory(),
        productSubCategory: pdpUtils.getProductSubcategory(),
        productName: pdpUtils.getProductName(),
        pageCategory: analyticsUtils.getPageCategory(),
        productId: pdpUtils.getProductId(),
        interactionType: 'Image Change'
      });
    })
    // click on next arrow recommendation carousel and best seller
    .on('click', '.pi .carousel-recommendations .slick-next', function () {
      if (typeof prodData != undefined && prodData != null) {
        var array = new Array();
        var listholder = new Array();
        var listchecker = false;
        var listctr = 0;
        $('.recommendation-item').each(function (index) {
          if ($('.recommendation-item').filter('.slick-active').length == 3) {
            if (index > 2 && $(this).hasClass('slick-active')) {
              array.push(index - 3);
            }
          } else {
            if (
              index > 2 &&
              ($(this).hasClass('slick-active') ||
                $(this).hasClass('slick-current'))
            ) {
              listctr = 2;
              if (prodData.product.length > 3) {
                listchecker = true;
                listctr = 0;
              }
              array.push(index - 3);
            } else {
              if (
                listchecker &&
                listctr < 2 &&
                index > 2 &&
                array.length <= 3
              ) {
                if (array[array.length] != index - 3) {
                  listctr += 1;
                  array.push(index - 3);
                }
              } else {
                listchecker = false;
              }
            }
          }
        });
        for (var i = 0; i < prodData.product.length; i++) {
          for (var a = 0; a < array.length; a++) {
            if (i == array[a]) {
              listholder.push(prodData.product[i]);
            }
          }
        }
        analyticsUtils.pushToDataLayer({
          currencyCode: window.User.currencyCode,
          eeAction: 'eeListView',
          event: 'eeListView',
          pageCategory: analyticsUtils.getPageCategory(),
          products: listholder
        });
      }
    })

    // click on prev arrow recommendation carousel and best seller
    .on('click', '.pi .carousel-recommendations .slick-prev', function () {
      if (typeof prodData != undefined && prodData != null) {
        var array = new Array();
        var listholder = new Array();
        var listchecker = false;
        var listctr = 0;
        $('.recommendation-item').each(function (index) {
          if ($('.recommendation-item').filter('.slick-active').length == 3) {
            if (index > 2 && $(this).hasClass('slick-active')) {
              array.push(index - 3);
            }
          } else {
            if (
              index > 2 &&
              ($(this).hasClass('slick-active') ||
                $(this).hasClass('slick-current'))
            ) {
              listctr = 2;
              if (prodData.product.length > 3) {
                listchecker = true;
                listctr = 0;
              }
              array.push(index - 3);
            } else {
              if (
                listchecker &&
                listctr < 2 &&
                index > 2 &&
                array.length <= 3
              ) {
                if (array[array.length] != index - 3) {
                  listctr += 1;
                  array.push(index - 3);
                }
              } else {
                listchecker = false;
              }
            }
          }
        });
        for (var i = 0; i < prodData.product.length; i++) {
          for (var a = 0; a < array.length; a++) {
            if (i == array[a]) {
              listholder.push(prodData.product[i]);
            }
          }
        }
        analyticsUtils.pushToDataLayer({
          currencyCode: window.User.currencyCode,
          eeAction: 'eeListView',
          event: 'eeListView',
          pageCategory: analyticsUtils.getPageCategory(),
          products: listholder
        });
      }
    })

    // click on next arrow recently viewed
    .on(
      'click',
      '.cross-sell .carousel-recommendations .slick-next',
      function () {
        if (typeof prodData != undefined && prodData != null) {
          var array = new Array();
          var listholder = new Array();
          $('.recommendation-item').each(function (index) {
            if (index > 2 && $(this).hasClass('slick-active')) {
              array.push(index - 3);
            }
          });
          for (var i = 0; i < prodData.product.length; i++) {
            for (var a = 0; a < array.length; a++) {
              if (i == array[a]) {
                listholder.push(prodData.product[i]);
              }
            }
          }
          analyticsUtils.pushToDataLayer({
            currencyCode: window.User.currencyCode,
            eeAction: 'eeListView',
            event: 'eeListView',
            pageCategory: analyticsUtils.getPageCategory(),
            products: listholder
          });
        }
      }
    )

    // click on next arrow recently viewed
    .on(
      'click',
      '.cross-sell .carousel-recommendations .slick-prev',
      function () {
        if (typeof prodData != undefined && prodData != null) {
          var array = new Array();
          var listholder = new Array();
          $('.recommendation-item').each(function (index) {
            if (index > 2 && $(this).hasClass('slick-active')) {
              array.push(index - 3);
            }
          });
          for (var i = 0; i < prodData.product.length; i++) {
            for (var a = 0; a < array.length; a++) {
              if (i == array[a]) {
                listholder.push(prodData.product[i]);
              }
            }
          }
          analyticsUtils.pushToDataLayer({
            currencyCode: window.User.currencyCode,
            eeAction: 'eeListView',
            event: 'eeListView',
            pageCategory: analyticsUtils.getPageCategory(),
            products: listholder
          });
        }
      }
    )

    // pdp fire when variation was change
    .on('gtvariationchange', function () {
      if (analyticsUtils.getPageCategory() == 'Product Page') {
        analyticsUtils.pushToDataLayer({
          eeAction: 'eeProductDetail',
          event: 'eeProductDetail',
          pageCategory: 'Product Page',
          products: [
            {
              listType: sessionStorage.getItem('listType'),
              listName: sessionStorage.getItem('listName'),
              id: pdpdata.ID,
              productVariantID: pdpdata.master
                ? pdpdata.defalutvariant
                : pdpdata.ID,
              category: pdpdata.catid,
              price: pdpdata.pricing.sale
                ? pdpdata.pricing.sale
                : pdpdata.pricing.minprice,
              name: pdpdata.name,
              brand: analyticsUtils.getBrandName(),
              quantity: pdpdata.quantity,
              size: pdpdata.size,
              subCategory: pdpdata.subcategory,
              subSubCategory: pdpdata.subsubcategory,
              productAutoReplen: pdpdata.productautoreplenish,
              productOutOfStock: pdpdata.productOutOfStock,
              productColor: pdpdata.productColor,
              productType: 'Product',
              collectionName: pdpdata.customBrand,
              productNumReviews: pdpdata.productNumReviews,
              productStarRating: pdpdata.productStarRating
            }
          ]
        });
      }
    })

    // Variation change on product tile
    .on('gttilevariationchange', function () {
      analyticsUtils.pushToDataLayer({
        event: 'eeListClick',
        pageCategory: analyticsUtils.getPageCategory(),
        products: [
          {
            listType: sessionStorage.getItem('listType'),
            listName: sessionStorage.getItem('listName'),
            id: tileVariantData.ID,
            productVariantID: tileVariantData.master
              ? tileVariantData.defalutvariant
              : tileVariantData.ID,
            category: tileVariantData.catid,
            price: tileVariantData.pricing.sale
              ? tileVariantData.pricing.sale
              : tileVariantData.pricing.minprice,
            name: tileVariantData.name,
            brand: analyticsUtils.getBrandName(),
            quantity: tileVariantData.quantity,
            size: tileVariantData.size,
            subCategory: tileVariantData.subcategory,
            subSubCategory: tileVariantData.subsubcategory,
            productAutoReplen: tileVariantData.productautoreplenish,
            productOutOfStock: tileVariantData.productOutOfStock,
            productColor: tileVariantData.productColor,
            productType: 'Product',
            collectionName: tileVariantData.customBrand,
            productNumReviews: tileVariantData.productNumReviews,
            productStarRating: tileVariantData.productStarRating
          }
        ]
      });
    })

    //PLP filter change
    .on('selectmenuchange', '.top-filter select', function (event, ui) {
      analyticsUtils.pushToDataLayer({
        event: 'dropDownChoice',
        dropDownType: event.target[0].label.trim(),
        filterChoice: ui.item.label.trim(),
        listType: 'Product Category List',
        listName:
          $('.breadcrumb').find('.breadcrumb-element:last').text().trim() +
          '>' +
          ui.item.label.trim()
      });
    })

    // 	Sort By in Makeup in PLP
    .on('selectmenuchange', '.sort-by select', function (event, ui) {
      analyticsUtils.pushToDataLayer({
        event: 'dropDownChoice',
        dropDownType: 'Sort By',
        filterChoice: ui.item.label.trim(),
        listType: 'Product Category List',
        listName:
          $('.breadcrumb').find('.breadcrumb-element:last').text().trim() +
          '>' +
          ui.item.label.trim()
      });
    })

    // 	related articles
    .on('click', '.related-article-sec .related-article-content', function () {
      analyticsUtils.pushToDataLayer({
        event: 'relatedArticle',
        page: $(this).children('a').text().trim(),
        pageSubCategory: analyticsUtils.getPageSubcategory(),
        pageCategory: $('.container .article-full-col h2').text().trim()
      });
    })

    // 	Article details product image click
    .on(
      'click',
      '.article-content-section .product-tile .thumb-link',
      function () {
        var $productTile = $(this).parents('.product-tile');
        analyticsUtils.pushToDataLayer({
          event: 'shopTheArticle',
          productName: $productTile.find('.product-name').text().trim(),
          pageSubCategory: analyticsUtils.getPageSubcategory(),
          pageCategory: $('.container .article-full-col h2').text().trim()
        });
      }
    )

    // 	Article details product name click
    .on(
      'click',
      '.article-content-section .product-tile .name-link',
      function () {
        var $productTile = $(this).parents('.product-tile');
        analyticsUtils.pushToDataLayer({
          event: 'shopTheArticle',
          productName: $productTile.find('.product-name').text().trim(),
          pageSubCategory: analyticsUtils.getPageSubcategory(),
          pageCategory: $('.container .article-full-col h2').text().trim()
        });
      }
    )

    // 	Article details product view details click
    .on(
      'click',
      '.article-content-section .product-tile .buy-button',
      function () {
        var $productTile = $(this).parents('.product-tile');
        analyticsUtils.pushToDataLayer({
          event: 'shopTheArticle',
          productName: $productTile.find('.product-name').text().trim(),
          pageSubCategory: analyticsUtils.getPageSubcategory(),
          pageCategory: $('.container .article-full-col h2').text().trim()
        });
      }
    )

    .on(
      'click',
      '.search-result-content .product-tile-wrapper.product-grid',
      function () {
        if ($('.container .article-full-col h2').length < 1) {
          analyticsUtils.pushToDataLayer({
            event: 'shopTheArticle',
            productName: $(this).find('.product-name').text().trim(),
            pageSubCategory: analyticsUtils.getPageSubcategory(),
            pageCategory: analyticsUtils.getPageCategory()
          });
        }
      }
    )

    //Add to cart from various pages
    .on('click', '.product-tile-inner .add-to-cart', function () {
      var $gtmProductTile = $(this)
        .parents('.product-tile')
        .find('.gtm-product-tile');
      var tileVariantData = $gtmProductTile.data('value');
      analyticsUtils.pushToDataLayer({
        currencyCode: window.Resources.CURRENCY,
        event: 'addToCart',
        productOrderType: pdpUtils.getProductOrderType(),
        addToCartType: analyticsUtils.getPageCategory(),
        pageCategory: analyticsUtils.getPageCategory(),
        products: [
          {
            id: tileVariantData.master
              ? tileVariantData.masterID
              : tileVariantData.ID,
            productVariantID: tileVariantData.ID,
            category: tileVariantData.catid,
            price: tileVariantData.pricing.sale
              ? tileVariantData.pricing.sale
              : tileVariantData.pricing.minprice,
            name: tileVariantData.name,
            brand: analyticsUtils.getBrandName(),
            quantity: tileVariantData.quantity,
            size: tileVariantData.size,
            subCategory: tileVariantData.subcategory,
            subSubCategory: tileVariantData.subsubcategory,
            productAutoReplen: tileVariantData.productautoreplenish,
            productOutOfStock: tileVariantData.productOutOfStock,
            productColor: tileVariantData.productColor,
            productType: 'Product',
            collectionName: tileVariantData.customBrand,
            productNumReviews: tileVariantData.productNumReviews,
            productStarRating: tileVariantData.productStarRating
          }
        ]
      });
    })

    //Product Category Pages
    .on('click', '.product-tile-outer', function () {
      var listName = '商品';
      $('.breadcrumb-element').each(function () {
        listName = $(this).text();
      });

      var parentCategory = [];
      $('ul.level-1 li:first-child ul.level-2 li.has-sub-menu-2 > a')
        .toArray()
        .forEach(function (element) {
          var regExp = new RegExp($(element).find('.total-count').text(), 'g');

          var categoryText = element.innerText.replace(regExp, '');
          parentCategory.push(categoryText.replace(/\r?\n/g, ''));
        });
      if (parentCategory.indexOf(listName) != -1) {
        var indexArray = [];
        $('.product-tile-outer').each(function () {
          indexArray.push($(this).find('.product-tile').data('itemid'));
        });

        var products = [];
        var productObj = {};
        productObj.listType = 'Product Category List';
        productObj.listName = listName;
        productObj.list = 'Product Page';
        productObj.position =
          $.inArray($(this).find('.product-tile').data('itemid'), indexArray) +
          1;
        productObj.id = $(this).find('.product-tile').data('masterpid');
        productObj.category = listName;
        productObj.price = $(this)
          .find('.price-sales')
          .text()
          .replace(/[^0-9]/g, '');
        productObj.name = $(this)
          .find('.product-name')
          .text()
          .replace(/\r?\n/g, '');
        productObj.brand = $(this)
          .find('.product-brand')
          .text()
          .replace(/\r?\n/g, '');
        productObj.quantity = $(this).find('.add-to-cart').data('quantity');
        productObj.size = $(this).find('.product-tile').data('size');
        productObj.subCategory = analyticsUtils.getPageSubcategory();
        productObj.subSubCategory = $(this)
          .find('.product-tile')
          .data('category');
        productObj.productAutoReplen = $(this)
          .find('.product-tile')
          .data('productautoreplinsh');
        productObj.productOutOfStock = $(this)
          .find('.product-tile')
          .data('availstatus');
        productObj.productColor = $(this).find('.product-tile').data('color');
        productObj.productType = 'Product';
        productObj.productVariantID = $(this)
          .find('.product-tile')
          .data('itemid');
        productObj.collectionName = $(this)
          .find('.product-brand')
          .text()
          .replace(/\r?\n/g, '');

        products.push(productObj);
        analyticsUtils.pushToDataLayer({
          event: 'eeListClick',
          pageSubCategory: analyticsUtils.getPageSubcategory(),
          pageCategory: analyticsUtils.getPageCategory(),
          products: products
        });
      }
      //クリックイベントがリンクタイプの為、リダイレクトイベントは不要
      //			(function(){
      //				setTimeout(function(){
      //					document.location = nextPage;
      //				}, 1000);
      //			})();
    })

    //Login Pages
    //	$('.pt_login').each(function() {
    .on('click', '#cart-checkout-button', function () {
      var products = [];
      if ($('#cart-action').data('funneltype') == 'Guest') {
        if ($('.utility-nav').length) {
          //デスクトップ
          $('.utility-nav').each(function () {
            $(this)
              .find('.mini-cart-product')
              .each(function () {
                var productObj = {};
                productObj.name = $(this)
                  .find('.mini-cart-name')
                  .text()
                  .replace(/\r?\n/g, '');
                productObj.id = $(this).data('masterpid');
                productObj.price = $(this)
                  .find('.mini-cart-price')
                  .text()
                  .replace(/[^0-9]/g, '');
                productObj.brand = $(this).data('brand');
                productObj.category = $(this).data('category');
                productObj.variant = $(this).data('size');
                productObj.quantity = $(this).data('quantity');
                productObj.productAutoReplen = $(this).data(
                  'productautoreplinsh'
                );
                productObj.productOutOfStock = $(this).data('availstatus');
                productObj.productColor = $(this).data('color');
                productObj.productType = 'Product';
                productObj.productVariantID = $(this).data('itemid');
                productObj.collectionName = $(this).data('brand');
                productObj.productOrderType = $(this).data('productordertype');

                products.push(productObj);
              });
          });
        } else if ($('.mobile-utility-nav').length) {
          //モバイル
          $('.mobile-utility-nav').each(function () {
            $(this)
              .find('.mini-cart-product')
              .each(function () {
                var productObj = {};
                productObj.name = $(this)
                  .find('.mini-cart-name')
                  .text()
                  .replace(/\r?\n/g, '');
                productObj.id = $(this).data('masterpid');
                productObj.price = $(this)
                  .find('.mini-cart-price')
                  .text()
                  .replace(/[^0-9]/g, '');
                productObj.brand = $(this).data('brand');
                productObj.category = $(this).data('category');
                productObj.variant = $(this).data('size');
                productObj.quantity = $(this).data('quantity');
                productObj.productAutoReplen = $(this).data(
                  'productautoreplinsh'
                );
                productObj.productOutOfStock = $(this).data('availstatus');
                productObj.productColor = $(this).data('color');
                productObj.productType = 'Product';
                productObj.productVariantID = $(this).data('itemid');
                productObj.collectionName = $(this).data('brand');
                productObj.productOrderType = $(this).data('productordertype');

                products.push(productObj);
              });
          });
        }
        analyticsUtils.pushToDataLayer({
          event: 'eecheckout',
          eeAction: 'funnelPage',
          checkoutStep: '2',
          funnelType: 'Guest',
          giftWrapping: $('#cart-action').data('giftwrapping'),
          checkoutErrorMessage: $('#cart-action').data('gterror'),
          pageCategory: analyticsUtils.getPageCategory(),
          pageSubCategory: analyticsUtils.getPageSubcategory(),
          products: products
        });
      }
    })
    // Wish ListAdd-Remove event of Online Quiz Result Page .wishlist-icon.icon-heart
    .on(
      'click',
      '.recommneded-section-online-quiz .product-tile .wishlist-icon.icon-heart',
      function (e) {
        e.stopImmediatePropagation();
        const wishlistadded = $(this).hasClass('wishlist-added');
        const $gtmProductTile = $(this)
          .parents('.product-tile')
          .find('.gtm-product-tile');
        const tileVariantData = $gtmProductTile.data('value');
        const _event = wishlistadded
          ? 'removeFromWhishlistOnlineQuiz'
          : 'clickSaveForLaterOnlineQuiz';
        analyticsUtils.pushToDataLayer({
          event: _event,
          productCategory: tileVariantData.catid,
          productSubCategory: tileVariantData.subcategory,
          productName: tileVariantData.name,
          productId: tileVariantData.ID,
          pageCategory: analyticsUtils.getPageCategory(),
          pageSubCategory: couponsubcategory(),
          language: analyticsUtils.getLanguage(),
          websiteCountry: analyticsUtils.getCountryCode()
        });
      }
    )
    .on(
      'click',
      '.recommneded-section-online-quiz .product-tile .thumb-link,.recommneded-section-online-quiz .product-tile .name-link',
      function () {
        const $gtmProductTile = $(this)
          .parents('.product-tile')
          .find('.gtm-product-tile');
        const tileVariantData = $gtmProductTile.data('value');
        const isDefendAndRegenerate =
          $(this).closest('.defend-regenerate').length > 0;
        const position = countCurrentProductTilePosition(this, {
          item: '.recommended-product',
          container: '.recommended-products.list-view',
          superContainer: isDefendAndRegenerate
            ? undefined
            : '.recommneded-section-online-quiz',
          leads: isDefendAndRegenerate
            ? []
            : [
              {
                item: '.recommended-product',
                container:
                    '.defend-regenerate .recommended-products.list-view'
              }
            ]
        });
        analyticsUtils.pushToDataLayer({
          eeAction: 'eeListClick',
          event: 'eeListClick',
          pageSubCategory: couponsubcategory(),
          pageCategory: analyticsUtils.getPageCategory(),
          language: analyticsUtils.getLanguage(),
          websiteCountry: analyticsUtils.getCountryCode(),
          products: [
            {
              listType: 'onlineQuiz',
              listName: isDefendAndRegenerate
                ? 'Defend & Generate'
                : 'Combating your personal concerns',
              position: position,
              id: tileVariantData.ID,
              category: tileVariantData.catid,
              price: tileVariantData.pricing.sale
                ? tileVariantData.pricing.sale
                : tileVariantData.pricing.minprice,
              name: tileVariantData.name,
              brand: analyticsUtils.getBrandName(),
              quantity: tileVariantData.quantity,
              size: tileVariantData.size,
              subCategory: tileVariantData.subcategory,
              subSubCategory: tileVariantData.subsubcategory,
              productAutoReplen: tileVariantData.productautoreplenish,
              productOutOfStock: tileVariantData.productOutOfStock,
              productColor: tileVariantData.productColor,
              productType: 'Product',
              productVariantID: tileVariantData.master
                ? tileVariantData.defalutvariant
                : tileVariantData.ID,
              collectionName: tileVariantData.customBrand,
              productNumReviews: tileVariantData.productNumReviews,
              productStarRating: tileVariantData.productStarRating
            }
          ]
        });
      }
    );
}

module.exports = {
  init: function () {
    initializeGlobalEvents();
  },
  tagmanager: {
    click: function (data) {
      return trackConsultationEvent(data);
    },

    pageview: function (data) {
      return trackConsultationPageview(data);
    }
  },
  onlinequiz: {
    click: function (data) {
      return trackOnlineQuizEvent(data);
    },

    pageview: function (onlineQuizPage) {
      if (onlineQuizPage == 'result') {
        return trackOnlineQuizResultPageview();
      } else {
        return trackOnlineQuizPageview();
      }
    }
  }
};

},{"./analytics/analyticsUtils":3,"./analytics/checkout/couponSubmission":4,"./analytics/foundationfinder/colorChange":5,"./analytics/global/navigationMenuClick":6,"./analytics/global/siteSearch":7,"./analytics/home/carouselChangeImage":8,"./analytics/home/eePromoClick":9,"./analytics/home/eePromoView":10,"./analytics/login/accountLogin":12,"./analytics/pdp/addToCart":13,"./analytics/pdp/colorChange":14,"./analytics/pdp/pdpUtils":15,"./analytics/pdp/retailerec":16,"./analytics/plp/colorChange":17,"./analytics/recentlyview/recentlyView":18,"./analytics/retailerec/guidance":19,"./util":105}],3:[function(require,module,exports){
'use strict';

const util = require('../util');

/**
 * 送信データを追加する。
 *
 * @param {object} data 送信データ
 */
function pushToDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(util.getEmptyPropertyDeletedObject(data));
}

/**
 * ページのカテゴリーを取得する。
 *
 * @returns {string} ページのカテゴリー
 */
function getPageCategory() {
  switch (window.Resources.PAGE_CATEGORY) {
    case 'product-showincategory':
      return 'Product Page';
    case 'product-show':
      return 'Product Page';
    case 'search-show':
      return 'Category Page';
    case 'home-show':
      return 'Home Page';
    case 'cart-show':
      return 'Cart Page';
    case 'cart-addtowishlist':
      return 'Cart Page';
    case 'customerservice-contactus':
      return 'Contact Customer Care';
    case 'customerservice-concierge':
      return 'Ask An Expert';
    case 'account-startregister':
      return 'Account Creation';
    case 'account-editprofile':
      return 'My Account';
    case 'address-list':
      return 'My Account';
    case 'paymentinstruments-list':
      return 'My Account';
    case 'wishlist-show':
      return 'My Account';
    case 'order-history':
      return 'My Account';
    case 'orderreplenishment-show':
      return 'My Account';
    case 'login-show':
      return 'Account Registration';
    case 'coshipping-start':
      return 'Checkout';
    case 'coshipping-singleshipping':
      return 'Checkout';
    case 'cobilling-start':
      return 'Checkout';
    case 'cobilling-billing':
      return 'Checkout';
    case 'search-showcontent':
      return 'Site Search';
    case 'giftcert-purchase':
      return 'Gift Card Page';
    case 'cocustomer-loginform':
      return 'Customer Login';
    case 'default-start':
      return 'Home Page';
    case 'search-brandify':
      return 'Store Locator Page';
    case 'onlinequiz-getresult':
    case 'onlinequiz-show':
      return 'Tool';
    default:
      return 'Content';
  }
}

/**
 * ページのサブカテゴリーを取得する。
 *
 * @returns {string} ページのサブカテゴリー
 */
function getPageSubcategory() {
  return window.pageContext.title || 'Content';
}

/**
 * 言語を取得する。
 *
 * @returns {string} 言語
 */
function getLanguage() {
  return 'Japanese';
}

/**
 * 国コードを取得する。
 *
 * @returns {string} 国コード(e.g. 'JP')
 */
function getCountryCode() {
  return 'JP';
}

/**
 * 顧客が認証されているかを判定する。
 *
 * @private
 * @returns {boolean} 認証済みの場合、true。その他の場合、false。
 */
function isCustomerAuthenticated() {
  return window.User.isCustomerAuthenticated === true;
}

/**
 * 顧客NOを取得する。
 *
 * @returns {string} 認証済みの場合、顧客NO。未認証時は空文字。
 */
function getCustomerNo() {
  return isCustomerAuthenticated() ? window.User.customerNo : '';
}

/**
 * ブランド名を取得する。
 *
 * @returns {string} ブランド名
 */
function getBrandName() {
  return SitePreferences.PRODUCT_BRAND;
}

/**
 * バリエーション名を取得する。
 *
 * @returns {string} バリエーション名
 */
function getItemVariant() {
  // 属性無し
  if (window.productCache.variations.attributes.length === 0) {
    return '';
  }
  // カラーバリエーション以外（サイズバリエーション）
  if (window.productCache.productColor == null) {
    return window.productCache.size;
  }
  // カラーバリエーション選択肢
  const attributeValue = window.productCache.variations.attributes[0].vals.find(
    (attribute) => attribute.id === window.productCache.productColor
  );
  return attributeValue != null ? attributeValue.val : '';
}

/**
 * 前後の空白を削除し、改行等の連続するスペースを半角スペースに置換する。
 *
 * @param {string} value 対象文字列
 * @returns {string} 対象文字列の前後空白を削除し、改行等の連続するスペースを半角スペースに置換した文字列
 * @example removeExtraSpaces("\n  foo \n bar  \n"); // => "foo bar"
 */
function removeExtraSpaces(value) {
  return value.trim().replace(/\s+/g, ' ');
}

module.exports = {
  pushToDataLayer: pushToDataLayer,
  getPageCategory: getPageCategory,
  getPageSubcategory: getPageSubcategory,
  getLanguage: getLanguage,
  getCountryCode: getCountryCode,
  getCustomerNo: getCustomerNo,
  getBrandName: getBrandName,
  getItemVariant: getItemVariant,
  removeExtraSpaces: removeExtraSpaces
};

},{"../util":105}],4:[function(require,module,exports){
/**
 * GA4 クーポン適用
 *
 * @module couponSubmission
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * クーポン適用イベント
 */
function couponSubmissionEvent() {
  sessionStorage.couponCode = $('.cart-coupon-code input[type=text]').val();
}

/**
 * クーポン時のdataLayer設定処理
 */
function setCouponSubmissionDataLayer() {
  if (sessionStorage.couponCode === undefined) {
    return;
  }
  const $couponDeleteButton = $('.edit-payment__box button.delete').last();
  if ($couponDeleteButton.length === 0) {
    return;
  }
  if ($couponDeleteButton.val() !== sessionStorage.couponCode) {
    return;
  }
  analyticsUtils.pushToDataLayer({
    navigationLocationClicked: 'topmenu',
    productCoupon: sessionStorage.couponCode,
    event: 'couponSubmission',
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    pageCategory: analyticsUtils.getPageCategory()
  });
  delete sessionStorage.couponCode;
}

module.exports = function () {
  $('#add-coupon')
    .off('click.couponSubmission')
    .on('click.couponSubmission', couponSubmissionEvent);
  setCouponSubmissionDataLayer();
};

},{"../analyticsUtils":3}],5:[function(require,module,exports){
/**
 * GA4 色変更（ファンデーションファインダー）
 *
 * @module colorChange
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * カラー変更イベント
 */
function colorChangeEvent() {
  const gtmProductTile = $(this)
    .closest('.product-tile')
    .find('.gtm-product-tile')
    .data('value');
  analyticsUtils.pushToDataLayer({
    event: 'productInteraction',
    productCategory: gtmProductTile.catid,
    productSubCategory: gtmProductTile.subcategory,
    productName: gtmProductTile.name,
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    productId: gtmProductTile.ID,
    interactionType: 'Image Change'
  });
}

module.exports = function () {
  $('.pt_foundationfinder .swatch-list').on('init', (slick) => {
    $(slick.target)
      .find('li.slick-slide')
      .off('click.colorChange')
      .on('click.colorChange', colorChangeEvent);
  });
};

},{"../analyticsUtils":3}],6:[function(require,module,exports){
/**
 * GA4 ナビゲーションメニュークリック
 *
 * @module navigationMenuClick
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * navigationMenuClick(ナビゲーションメニュークリック)イベント
 */
function navigationMenuClickEvent() {
  analyticsUtils.pushToDataLayer({
    event: 'navigationMenuClick',
    navigationLocationClicked: 'topmenu',
    navigationLinkNameClicked:
      $(this).find('span.name').text().trim() || $(this).text().trim(),
    userId: window.User.customerNo || '',
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    language: analyticsUtils.getLanguage(),
    websiteCountry: analyticsUtils.getCountryCode()
  });
}

/**
 * navigationMenuClick(ナビゲーションメニュークリック)イベント設定
 */
module.exports = function () {
  $('.top-navigation-list a')
    .not('.no-link')
    .off('click.navigationMenuClick')
    .on('click.navigationMenuClick', navigationMenuClickEvent);
};

},{"../analyticsUtils":3}],7:[function(require,module,exports){
/**
 * GA4 サイト検索
 *
 * @module siteSearch
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * サイト検索イベント
 */
function siteSearchEvent() {
  const $searchText = $('input#q').val().trim();
  if ($searchText.length < 3) {
    return;
  }
  analyticsUtils.pushToDataLayer({
    event: 'siteSearch',
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    cat55: 'site search',
    kw55: $searchText
  });
}

/**
 * サイト検索イベント設定
 */
module.exports = function () {
  $('input#q').on('blur.siteSearch', siteSearchEvent);
};

},{"../analyticsUtils":3}],8:[function(require,module,exports){
/**
 * GAトップページバナー画像切替
 *
 * @module carouselChangeImage
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');
const promotionHelper = require('./promotionHelper');

/**
 * slick sliderのブレークポイント
 *
 * @const
 * @type {number}
 */
const SLICK_SLIDER_BREAK_POINT = 768;

/**
 * windowリサイズ時処理
 */
function windowResizeEvent() {
  if (window.innerWidth >= SLICK_SLIDER_BREAK_POINT) {
    setCarouselChangeImageEvent();
    $(window).off('resize.carouselChangeImageEvent');
  }
}

/**
 * carouselImageChange(バナー切替)イベント設定
 */
function setCarouselChangeImageEvent() {
  $(promotionHelper.SLICK_SELECTOR)
    .find('.slick-arrow, .slick-dots li')
    .off('click.carouselImageChange')
    .on('click.carouselImageChange', carouselChangeImageEvent);
}

/**
 * carouselImageChange(バナー切替)イベント処理
 */
function carouselChangeImageEvent() {
  const promotionData = promotionHelper.getActivePromotionData();
  analyticsUtils.pushToDataLayer({
    event: 'carouselChangeImage',
    carouselTitle: promotionData.name,
    userId: window.User.customerNo || '',
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    language: analyticsUtils.getLanguage(),
    websiteCountry: analyticsUtils.getCountryCode()
  });
}

/**
 * ウィンドウサイズがモバイルサイズかを判定する。
 *
 * @returns {boolean} ウィンドウサイズがモバイルサイズの場合、true
 */
function isMobileSize() {
  return window.innerWidth < SLICK_SLIDER_BREAK_POINT;
}

/**
 * carouselChangeImage(バナー画像切替)イベント設定
 */
module.exports = function () {
  $(promotionHelper.SLICK_SELECTOR).on('init', () => {
    // モバイルで初期表示時、矢印アイコンが出力されないためリサイズしてPCになったとき、再度初期化する。
    if (isMobileSize()) {
      $(window).on('resize.carouselChangeImageEvent', windowResizeEvent);
    }
    setCarouselChangeImageEvent();
  });
};

},{"../analyticsUtils":3,"./promotionHelper":11}],9:[function(require,module,exports){
/**
 * GAトップページバナークリック
 *
 * @module eePromoClick
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');
const promotionHelper = require('./promotionHelper');

/**
 * eePromoClick(バナークリック)イベント処理
 */
function eePromoClickEvent() {
  const $heroSlides = $('.slick-slide')
    .not('.slick-cloned')
    .find('.hero-slide');
  const $heroSlide = $('.slick-slide.slick-current .hero-slide');
  const promotion = promotionHelper.getPromotionData($heroSlides, $heroSlide);
  analyticsUtils.pushToDataLayer({
    event: 'eePromoClick',
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    promotions: [promotion]
  });
}

/**
 * eePromoClick(バナークリック)イベント処理設定
 */
module.exports = function () {
  $('.hero-slide').on('click', eePromoClickEvent);
};

},{"../analyticsUtils":3,"./promotionHelper":11}],10:[function(require,module,exports){
/**
 * GAトップページバナー表示
 *
 * @module eePromoVIew
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');
const promotionHelper = require('./promotionHelper');

/**
 * eePromoView(バナー表示)イベントデータを追加。
 */
module.exports = function eePromoView() {
  $(promotionHelper.SLICK_SELECTOR).on('init', (slick) => {
    // スライドが初期表示、変更されたタイミングで実行
    $(slick.target).on('setPosition', () => {
      analyticsUtils.pushToDataLayer({
        event: 'eePromoView',
        pageCategory: analyticsUtils.getPageCategory(),
        pageSubCategory: analyticsUtils.getPageSubcategory(),
        promotions: [promotionHelper.getActivePromotionData()]
      });
    });
  });
};

},{"../analyticsUtils":3,"./promotionHelper":11}],11:[function(require,module,exports){
/**
 * トップページのプロモーションデータ関連処理
 *
 * @module promotionHelper
 */

'use strict';

/**
 * プロモーションデータ
 *
 * @typedef PromotionData
 * @property {string} id プロモーションID
 * @property {string} name プロモーション名
 * @property {string} creative プロモーション作成元
 * @property {number} position 表示位置
 */

const SLICK_SELECTOR = '#homepage-hero';
const PROMOTION_BANNER_SELECTOR = '.hero-slide';

/**
 * 指定されたプロモーションデータを取得する。
 *
 * @param {jQuery} $heroSlide 対象のバナー
 * @returns {PromotionData} プロモーションデータ
 */
function getPromotionData($heroSlide) {
  return {
    id: $heroSlide.data('promotion_id'),
    name: $heroSlide.data('promotion_name'),
    creative: $heroSlide.data('promotion_creative'),
    position: $(SLICK_SELECTOR).slick('slickCurrentSlide') + 1
  };
}

/**
 * アクティブなプロモーションデータを取得する。
 *
 * @returns {PromotionData} プロモーションデータ
 */
function getActivePromotionData() {
  const $currentHeroSlide = $(SLICK_SELECTOR)
    .find('.slick-current')
    .find(PROMOTION_BANNER_SELECTOR);
  return getPromotionData($currentHeroSlide);
}

module.exports = {
  SLICK_SELECTOR: SLICK_SELECTOR,
  getPromotionData: getPromotionData,
  getActivePromotionData: getActivePromotionData
};

},{}],12:[function(require,module,exports){
/**
 * GA4 ログインイベント
 *
 * @module accountLogin
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * ログインボタンクリックイベント
 */
function loginButtonClickEvent() {
  sessionStorage.loginPageCategory = analyticsUtils.getPageCategory();
  sessionStorage.loginPageSubCategory = analyticsUtils.getPageSubcategory();
}

/**
 * ログイン時のdataLayer設定処理
 */
function setAccountLoginDataLayer() {
  if (!window.User.isRegistered) {
    sessionStorage.isAccountLoginSent = 'false';
    return;
  }
  // ログイン後、初回のみ実行する。
  if (sessionStorage.isAccountLoginSent === 'true') {
    return;
  }
  analyticsUtils.pushToDataLayer({
    event: 'accountLogin',
    userId: window.User.customerNo,
    accountType: window.User.isExternallyAuthenticated,
    pageCategory: sessionStorage.loginPageCategory,
    pageSubCategory: sessionStorage.loginPageSubCategory,
    loginLocation: document.referrer
  });
  // 以降実行されないように書き換え
  sessionStorage.isAccountLoginSent = 'true';
}

module.exports = function () {
  $('#login')
    .off('click.accountLogin')
    .on('click.accountLogin', loginButtonClickEvent);
  setAccountLoginDataLayer();
};

},{"../analyticsUtils":3}],13:[function(require,module,exports){
/**
 * GA4 PDP カートに入れるボタンクリック
 *
 * @module addToCart
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');
const pdpUtils = require('./pdpUtils');

/**
 * カートに入れるボタンクリックイベント
 */
function addToCartEvent() {
  if (analyticsUtils.getPageCategory() == 'Cart Page') {
    if (sessionStorage.getItem('cartupdate')) {
      sessionStorage.setItem('productUpdate', '1');
    }
  } else {
    window.productCache = window.productCache || {};
    analyticsUtils.pushToDataLayer({
      currencyCode: window.Resources.CURRENCY,
      event: 'addToCart',
      addToCartType: 'Product Page',
      pageCategory: analyticsUtils.getPageCategory(),
      products: [
        {
          id: pdpUtils.getProductId(),
          productVariantID: pdpdata.master
            ? pdpdata.defalutvariant
            : pdpdata.ID,
          category: window.productCache.catid,
          price: pdpUtils.getProductPrice(),
          name: pdpUtils.getProductName(),
          brand: analyticsUtils.getBrandName(),
          quantity: Number($('.quantity select').val()),
          size: $('#pdp-swatches li.selected').text().trim(),
          subCategory: window.productCache.subcategory,
          subSubCategory: window.productCache.subsubcategory,
          productAutoReplen: $('.add-to-cart').data('replenishable'),
          productOutOfStock: $('.add-to-cart').data('instock'),
          productColor: $('#va-color option:selected')
            .text()
            .split('/')[0]
            .trim(),
          productType: 'Product',
          collectionName: pdpdata.customBrand,
          productNumReviews: pdpdata.productNumReviews,
          productStarRating: pdpdata.productStarRating,
          productOrderType: pdpUtils.getProductOrderType()
        }
      ]
    });
  }
}

module.exports = function () {
  $(document)
    .off('click.addToCart')
    .on('click.addToCart', '#pdpMain .add-to-cart', addToCartEvent);
};

},{"../analyticsUtils":3,"./pdpUtils":15}],14:[function(require,module,exports){
/**
 * GA4 色変更
 *
 * @module colorChange
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');
const pdpUtils = require('./pdpUtils');

/**
 * カラー変更イベント
 */
function colorChangeEvent() {
  analyticsUtils.pushToDataLayer({
    event: 'productInteraction',
    productCategory: pdpUtils.getProductCategory(),
    productSubCategory: pdpUtils.getProductSubcategory(),
    productName: pdpUtils.getProductName(),
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    productId: pdpUtils.getProductId(),
    interactionType: 'Image Change'
  });
}

module.exports = function () {
  $('#pdp-swatches li.selectable')
    .off('click.colorChange')
    .on('click.colorChange', colorChangeEvent);
  $('#va-color')
    .off('selectmenuchange.colorChange')
    .on('selectmenuchange.colorChange', colorChangeEvent);
};

},{"../analyticsUtils":3,"./pdpUtils":15}],15:[function(require,module,exports){
/**
 * PDP画面共通処理
 *
 * @module pdpUtils
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * 商品名を取得する。
 *
 * @returns {string} 商品名
 */
function getProductName() {
  return analyticsUtils.removeExtraSpaces(
    $('.product-detail .product-name').text()
  );
}

/**
 * 商品IDを取得する。
 *
 * @returns {string} 商品ID
 */
function getProductId() {
  return $('#pid').val();
}

/**
 * 商品カテゴリーを取得する。
 *
 * @returns {string} 商品カテゴリー
 */
function getProductCategory() {
  return analyticsUtils.removeExtraSpaces(
    $('.breadcrumb').find('.breadcrumb-element:eq(2)').text()
  );
}

/**
 * 商品サブカテゴリーを取得する。
 *
 * @returns {string} 商品サブカテゴリー
 */
function getProductSubcategory() {
  return analyticsUtils.removeExtraSpaces(
    $('.breadcrumb').find('.breadcrumb-element:eq(3)').text()
  );
}

/**
 * 商品サブサブカテゴリーを取得する。
 *
 * @returns {string} 商品サブサブカテゴリー
 * @deprecated
 */
function getProductSubSubcategory() {
  return analyticsUtils.removeExtraSpaces(
    $('.breadcrumb').find('.breadcrumb-element:eq(4)').text()
  );
}

/**
 * 注文タイプ(通常/定期購入)を取得する。
 *
 * @returns {string} 注文タイプ(通常/定期購入)
 */
function getProductOrderType() {
  return $('.replenishmentCycle').val() > 0 ? 'Replenishment' : 'Regular';
}

/**
 * 商品価格を取得する。
 *
 * @returns {number} 商品価格
 */
function getProductPrice() {
  return $('#add-to-cart').data('price');
}

module.exports = {
  getProductName: getProductName,
  getProductId: getProductId,
  getProductCategory: getProductCategory,
  getProductSubcategory: getProductSubcategory,
  getProductSubSubcategory: getProductSubSubcategory,
  getProductOrderType: getProductOrderType,
  getProductPrice: getProductPrice
};

},{"../analyticsUtils":3}],16:[function(require,module,exports){
'use strict';

/**
 * PDP リテーラーEC GTMイベント
 *
 * @module retailerec
 */

const analyticsUtils = require('../analyticsUtils');
const pdpUtils = require('./pdpUtils');

/**
 * PDPでのリテーラーEC関連イベントデータ
 *
 * @typedef {Object} RetailerEcGtmData
 * @property {'ee_retail_button_click'} event - イベント名。
 * @property {string} website_country - ウェブサイトの国コード。(例: "JP")
 * @property {string} language - ウェブサイトの言語。（例: "Japanese"）
 * @property {string} currency - 通貨コード。（例: "JPY"）
 * @property {string} item_name - 商品名。
 * @property {string|number} item_id - 商品ID。
 * @property {string|number} price - 商品の価格。
 * @property {string} item_brand - 商品のブランド名。
 * @property {string} item_variant - 選択された商品バリアント（例：色やサイズ）。
 * @property {string|number} item_category - 商品のメインカテゴリーID。
 * @property {string|number} item_category2 - 商品のサブカテゴリーID。
 * @property {string|number} item_category3 - 商品のサブサブカテゴリーID。
 * @property {string} button_text - イベントをトリガーしたボタンや要素のテキスト。
 * @property {string} next_page - 次のページのURL（href属性から取得）。
 * @property {string} section_name - トリガー要素が存在するセクション名、通常はそのテキスト。
 */

/**
 * GTMイベントデータを作成する。
 *
 * @private
 * @param {HTMLElement} triggerElement トリガー要素
 * @param {string} sectionName セクション名
 * @returns {RetailerEcGtmData} イベントデータ
 */
function makeGtmEventData(triggerElement, sectionName) {
  return {
    event: 'ee_retail_button_click',
    website_country: analyticsUtils.getCountryCode(),
    language: analyticsUtils.getLanguage(),
    currency: window.Resources.CURRENCY,
    item_name: pdpUtils.getProductName(),
    item_id: pdpUtils.getProductId(),
    price: pdpUtils.getProductPrice(),
    item_brand: analyticsUtils.getBrandName(),
    item_variant:
      window.productCache.variations.attributes.length === 0
        ? ''
        : $('select#va-color option:selected').data('value') ||
          $('.swatches.size .selected').text().trim() ||
          '',
    item_category: window.productCache.catid,
    item_category2: window.productCache.subcategory,
    item_category3: window.productCache.subsubcategory,
    button_text: analyticsUtils.removeExtraSpaces($(triggerElement).text()),
    next_page: URL.parse(
      $(triggerElement).attr('href'),
      location.href
    ).toString(),
    section_name: sectionName
  };
}

module.exports = function () {
  // 店舗検索ボタンクリックイベント
  $(document)
    .off('click.findStoreLink')
    .on('click.findStoreLink', 'a.find-store-link-button', (e) =>
      analyticsUtils.pushToDataLayer(
        makeGtmEventData(
          e.currentTarget,
          analyticsUtils.removeExtraSpaces($(e.currentTarget).text())
        )
      )
    );
  // 他のオンラインストアで購入ボタンクリックイベント
  $(document)
    .off('click.retailerEcLeadLink')
    .on('click.retailerEcLeadLink', 'a.retailer-ec-lead-link-button', (e) =>
      analyticsUtils.pushToDataLayer(
        makeGtmEventData(e.currentTarget, 'オンラインストア')
      )
    );
};

},{"../analyticsUtils":3,"./pdpUtils":15}],17:[function(require,module,exports){
/**
 * GA4 色変更（PLP）
 *
 * @module colorChange
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * カラー変更イベント
 */
function colorChangeEvent() {
  const gtmProductTile = $(this)
    .closest('.product-tile')
    .find('.gtm-product-tile')
    .data('value');
  analyticsUtils.pushToDataLayer({
    event: 'productInteraction',
    productCategory: gtmProductTile.catid,
    productSubCategory: gtmProductTile.subcategory,
    productName: gtmProductTile.name,
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    productId: gtmProductTile.ID,
    interactionType: 'Image Change'
  });
}

module.exports = function () {
  $('.pt_product-search-result .swatch-list').on('init', (slick) => {
    $(slick.target)
      .find('li.slick-slide')
      .off('click.colorChange')
      .on('click.colorChange', colorChangeEvent);
  });
};

},{"../analyticsUtils":3}],18:[function(require,module,exports){
/**
 * GA4 最近見た商品
 *
 * @module recentlyView
 */

'use strict';

const analyticsUtils = require('../analyticsUtils');

/**
 * 最近見た商品クリックイベント
 */
function recentlyViewClickEvent() {
  const gtmProductTileDataValue = $(this)
    .parent()
    .parent()
    .find('.gtm-product-tile')
    .data().value;
  const position =
    $('.recently-viewed .product-tile a.thumb-link').index(this) + 1;
  analyticsUtils.pushToDataLayer({
    event: 'eeListClick',
    pageCategory: analyticsUtils.getPageCategory(),
    pageSubCategory: analyticsUtils.getPageSubcategory(),
    products: [
      {
        listType: 'Recently Viewed List',
        listName: analyticsUtils.getPageCategory(),
        position: position,
        id: gtmProductTileDataValue.ID,
        category: gtmProductTileDataValue.catid,
        price: gtmProductTileDataValue.pricing.sale,
        name: gtmProductTileDataValue.name,
        brand: analyticsUtils.getBrandName(),
        quantity: gtmProductTileDataValue.quantity,
        size: gtmProductTileDataValue.size,
        subCategory: gtmProductTileDataValue.subcategory,
        subSubCategory: gtmProductTileDataValue.subsubcategory,
        productAutoReplen: gtmProductTileDataValue.productautoreplenish,
        productOutOfStock: gtmProductTileDataValue.productOutOfStock,
        productColor: gtmProductTileDataValue.productColor,
        productType: 'Product',
        productVariantID: gtmProductTileDataValue.master
          ? gtmProductTileDataValue.defaultvariant
          : gtmProductTileDataValue.ID,
        collectionName: gtmProductTileDataValue.customBrand
      }
    ]
  });
}

module.exports = function () {
  $('.recently-viewed .product-tile a.thumb-link')
    .off('click.recentlyView')
    .on('click.recentlyView', recentlyViewClickEvent);
};

},{"../analyticsUtils":3}],19:[function(require,module,exports){
'use strict';

/**
 * その他オンラインストアのご案内GTMイベント
 *
 * @module guidance
 */

const analyticsUtils = require('../analyticsUtils');

/**
 * 各種ECリンクボタンクリックイベント
 *
 * @private
 * @param {Event} e Event object
 * @returns {void}
 */
function clickOnlineShopGuide(e) {
  const data = {
    event: 'ee_retail_button_click',
    website_country: analyticsUtils.getCountryCode(),
    language: analyticsUtils.getLanguage(),
    currency: window.Resources.CURRENCY,
    item_brand: analyticsUtils.getBrandName(),
    button_text: analyticsUtils.removeExtraSpaces($(e.currentTarget).text()),
    next_page: URL.parse(
      $(e.currentTarget).attr('href'),
      location.href
    ).toString(),
    section_name:
      'オンラインストア：' +
      $(this)
        .closest('.lp-onlineshop-guide__list_wrap_inner')
        .find('h2')
        .html()
        .replace(/\s+/g, '')
  };

  if (window.productCache != null) {
    // 商品データがある場合、追加
    data.item_name = window.productCache.name;
    data.item_id = window.productCache.ID;
    data.price = window.productCache.pricing.sale;
    data.item_brand = analyticsUtils.getBrandName();
    data.item_variant = analyticsUtils.getItemVariant();
    data.item_category = window.productCache.catid;
    data.item_category2 = window.productCache.subcategory;
    data.item_category3 = window.productCache.subsubcategory;
  }

  analyticsUtils.pushToDataLayer(data);
}

module.exports = function () {
  $(document)
    .off('click.onlineshopGuide')
    .on(
      'click.onlineshopGuide',
      'a.lp-onlineshop-guide__btn',
      clickOnlineShopGuide
    );
};

},{"../analyticsUtils":3}],20:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var i=o[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var o={};return t.m=e,t.c=o,t.p="dist/",t(0)}([function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},a=o(1),r=(n(a),o(5)),c=n(r),u=o(6),s=n(u),d=o(7),f=n(d),l=o(8),m=n(l),p=o(9),b=n(p),v=o(10),g=n(v),y=o(13),w=n(y),h=[],k=!1,x=document.all&&!window.atob,j={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded"},O=function(){var e=arguments.length<=0||void 0===arguments[0]?!1:arguments[0];return e&&(k=!0),k?(h=(0,g["default"])(h,j),(0,b["default"])(h,j.once),h):void 0},_=function(){h=(0,w["default"])(),O()},z=function(){h.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},A=function(e){return e===!0||"mobile"===e&&m["default"].mobile()||"phone"===e&&m["default"].phone()||"tablet"===e&&m["default"].tablet()||"function"==typeof e&&e()===!0},S=function(e){return j=i(j,e),h=(0,w["default"])(),A(j.disable)||x?z():(document.querySelector("body").setAttribute("data-aos-easing",j.easing),document.querySelector("body").setAttribute("data-aos-duration",j.duration),document.querySelector("body").setAttribute("data-aos-delay",j.delay),"DOMContentLoaded"===j.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?O(!0):document.addEventListener(j.startEvent,function(){O(!0)}),window.addEventListener("resize",(0,s["default"])(O,50,!0)),window.addEventListener("orientationchange",(0,s["default"])(O,50,!0)),window.addEventListener("scroll",(0,c["default"])(function(){(0,b["default"])(h,j.once)},99)),document.addEventListener("DOMNodeRemoved",function(e){var t=e.target;t&&1===t.nodeType&&t.hasAttribute&&t.hasAttribute("data-aos")&&(0,s["default"])(_,50,!0)}),(0,f["default"])("[data-aos]",_),h)};e.exports={init:S,refresh:O,refreshHard:_}},function(e,t){},,,,function(e,t,o){"use strict";function n(e,t,o){var n=!0,a=!0;if("function"!=typeof e)throw new TypeError(c);return i(o)&&(n="leading"in o?!!o.leading:n,a="trailing"in o?!!o.trailing:a),r(e,t,{leading:n,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":a(e);return!!e&&("object"==t||"function"==t)}var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol?"symbol":typeof e},r=o(6),c="Expected a function";e.exports=n},function(e,t){"use strict";function o(e,t,o){function n(t){var o=b,n=v;return b=v=void 0,O=t,y=e.apply(n,o)}function a(e){return O=e,w=setTimeout(d,t),_?n(e):y}function r(e){var o=e-h,n=e-O,i=t-o;return z?x(i,g-n):i}function u(e){var o=e-h,n=e-O;return!h||o>=t||0>o||z&&n>=g}function d(){var e=j();return u(e)?f(e):void(w=setTimeout(d,r(e)))}function f(e){return clearTimeout(w),w=void 0,A&&b?n(e):(b=v=void 0,y)}function l(){void 0!==w&&clearTimeout(w),h=O=0,b=v=w=void 0}function m(){return void 0===w?y:f(j())}function p(){var e=j(),o=u(e);if(b=arguments,v=this,h=e,o){if(void 0===w)return a(h);if(z)return clearTimeout(w),w=setTimeout(d,t),n(h)}return void 0===w&&(w=setTimeout(d,t)),y}var b,v,g,y,w,h=0,O=0,_=!1,z=!1,A=!0;if("function"!=typeof e)throw new TypeError(s);return t=c(t)||0,i(o)&&(_=!!o.leading,z="maxWait"in o,g=z?k(c(o.maxWait)||0,t):g,A="trailing"in o?!!o.trailing:A),p.cancel=l,p.flush=m,p}function n(e){var t=i(e)?h.call(e):"";return t==f||t==l}function i(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function a(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||a(e)&&h.call(e)==m}function c(e){if("number"==typeof e)return e;if(r(e))return d;if(i(e)){var t=n(e.valueOf)?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(p,"");var o=v.test(e);return o||g.test(e)?y(e.slice(2),o?2:8):b.test(e)?d:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol?"symbol":typeof e},s="Expected a function",d=NaN,f="[object Function]",l="[object GeneratorFunction]",m="[object Symbol]",p=/^\s+|\s+$/g,b=/^[-+]0x[0-9a-f]+$/i,v=/^0b[01]+$/i,g=/^0o[0-7]+$/i,y=parseInt,w=Object.prototype,h=w.toString,k=Math.max,x=Math.min,j=Date.now;e.exports=o},function(e,t){"use strict";function o(e,t){r.push({selector:e,fn:t}),!c&&a&&(c=new a(n),c.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})),n()}function n(){for(var e,t,o=0,n=r.length;n>o;o++){e=r[o],t=i.querySelectorAll(e.selector);for(var a,c=0,u=t.length;u>c;c++)a=t[c],a.ready||(a.ready=!0,e.fn.call(a,a))}}Object.defineProperty(t,"__esModule",{value:!0});var i=window.document,a=window.MutationObserver||window.WebKitMutationObserver,r=[],c=void 0;t["default"]=o},function(e,t){"use strict";function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),i=function(){function e(){o(this,e)}return n(e,[{key:"phone",value:function(){var e=!1;return function(t){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}},{key:"mobile",value:function(){var e=!1;return function(t){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t["default"]=new i},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=function(e,t,o){var n=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof n&&("false"===n||!o&&"true"!==n)&&e.node.classList.remove("aos-animate")},n=function(e,t){var n=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,a){o(e,i+n,t)})};t["default"]=n},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0});var i=o(11),a=n(i),r=function(e,t){return e.forEach(function(e,o){e.node.classList.add("aos-init"),e.position=(0,a["default"])(e.node,t.offset)}),e};t["default"]=r},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0});var i=o(12),a=n(i),r=function(e,t){var o=0,n=0,i=window.innerHeight,r={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(r.offset&&!isNaN(r.offset)&&(n=parseInt(r.offset)),r.anchor&&document.querySelectorAll(r.anchor)&&(e=document.querySelectorAll(r.anchor)[0]),o=(0,a["default"])(e).top,r.anchorPlacement){case"top-bottom":break;case"center-bottom":o+=e.offsetHeight/2;break;case"bottom-bottom":o+=e.offsetHeight;break;case"top-center":o+=i/2;break;case"bottom-center":o+=i/2+e.offsetHeight;break;case"center-center":o+=i/2+e.offsetHeight/2;break;case"top-top":o+=i;break;case"bottom-top":o+=e.offsetHeight+i;break;case"center-top":o+=e.offsetHeight/2+i}return r.anchorPlacement||r.offset||isNaN(t)||(n=t),o+n};t["default"]=r},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=function(e){for(var t=0,o=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),o+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:o,left:t}};t["default"]=o},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var o=function(e){e=e||document.querySelectorAll("[data-aos]");var t=[];return[].forEach.call(e,function(e,o){t.push({node:e})}),t};t["default"]=o}])});
},{}],21:[function(require,module,exports){
'use strict';

var analytics = require('./analytics'),
  countries = require('./countries'),
  dialog = require('./dialog'),
  quickview = require('./quickview'),
  minicart = require('./minicart'),
  page = require('./page'),
  rating = require('./rating'),
  searchplaceholder = require('./searchplaceholder'),
  searchsuggest = require('./searchsuggest'),
  tooltip = require('./tooltip'),
  util = require('./util'),
  validator = require('./validator'),
  slick = require('./slick'),
  tls = require('./tls'),
  video = require('./video'),
  header = require('./header'),
  footerSelector = require('./footer-selector'),
  footerTelClass = require('./footer-tel-class'),
  newsletter = require('./newsletter'),
  orderreplenishment = require('./order-replenishment'),
  inputEntry = require('./input-entry'),
  pressrelease = require('./pressrelease'),
  shadedtool = require('./shaded-tool'),
  animation = require('./aos'),
  currentLayout = require('./detect-layout'),
  customModal = require('./modal'),
  search = require('./pages/search'),
  productTile = require('./product-tile'),
  quiz = require('./quiz'),
  consentTracking = require('./consentTracking'),
  delayImage = require('./delay-image'),
  cartInProductTile = require('./cartInProductTile');

// Initilize detect layout
var checkLayout = currentLayout.init();

//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
  var s = document.createElement('script');

  s.setAttribute(
    'src',
    'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js'
  );
  s.setAttribute('type', 'text/javascript');

  document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./jquery-ui-slider');
require('./cookieprivacy')();
consentTracking.init();
require('./captcha')();

function initializeEvents() {
  var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

  $('body')
    .on('keydown', 'textarea[data-character-limit]', function (e) {
      var text = $(this).val(),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length;

      if (
        charsUsed >= charsLimit &&
        controlKeys.indexOf(e.which.toString()) < 0
      ) {
        e.preventDefault();
      }
    })
    .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
      var text = $(this).val(),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length,
        charsRemain = charsLimit - charsUsed;

      if (charsRemain < 0) {
        $(this).val(text.slice(0, charsRemain));
        charsRemain = 0;
      }

      $(this)
        .closest('.field-wrapper')
        .find('.char-remain-count')
        .html(charsRemain);
      $(this)
        .closest('.field-wrapper')
        .find('.char-used-count')
        .html(charsUsed);
    });

  /**
   * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
   * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
   * */
  var $searchContainer = $('.header-search-wrapper .search-inner');

  searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

  // add show/hide navigation elements
  $('.secondary-navigation .toggle').click(function () {
    $(this).toggleClass('expanded').next('ul').toggle();
  });

  // add generic toggle functionality
  $('.toggle').next('.toggle-content').hide();
  $('.toggle').click(function () {
    $(this).toggleClass('expanded').next('.toggle-content').toggle();
  });

  // subscribe email box
  var $subscribeEmail = $('.subscribe-email');

  if ($subscribeEmail.length > 0) {
    $subscribeEmail
      .focus(function () {
        var val = $(this.val());

        if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
          return; // do not animate when contains non-default value
        }

        $(this).animate(
          {
            color: '#999999'
          },
          500,
          'linear',
          function () {
            $(this).val('').css('color', '#333333');
          }
        );
      })
      .blur(function () {
        var val = $.trim($(this.val()));

        if (val.length > 0) {
          return; // do not animate when contains value
        }

        $(this)
          .val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
          .css('color', '#999999')
          .animate(
            {
              color: '#333333'
            },
            500,
            'linear'
          );
      });
  }

  if (SitePreferences.MOTIONPOINT_ENABLED) {
    $('#chooseLanguage').on('click', function (e) {
      e.preventDefault();

      var script = document.createElement('script');

      //MP.SrcUrl = unescape('mp_js_orgin_url'); - commented out per MotionPoint
      MP.UrlLang = 'mp_js_current_lang';
      MP.oSite = decodeURIComponent('mp_js_origin_baseUrl');
      MP.tSite = decodeURIComponent('mp_js_translated_baseUrl');

      MP.init();

      script.src =
        'https://shiseidoamericas.mpeasylink.com/mpel/mpel_chooser.js';

      document.body.appendChild(script);

      return false;
    });
  }

  $('.js-quiz-modal,.tapable-on-mobile').on('click', function () {
    var quizModal = $('#quiz-modal'),
      quizLoader = quizModal.find('.ajax-loader'),
      quizContent = quizModal.find('.questions-content');

    quizLoader.show();
    quizContent.empty();

    $.ajax({
      url: Urls.quizModalUrl,
      success: function (response) {
        quizLoader.hide();
        quizContent.empty().html(response);
        quiz.bindQuizEvents();
        quiz.createStepsIndicators();
        quiz.registerPageView(quizContent);
      }
    });
  });
  $('.js-foundation-finder-start').on('click', function (e) {
    e.preventDefault();
    for (var i = 1; i <= 5; i++) {
      if (localStorage.getItem('question' + i) !== null) {
        localStorage.removeItem('question' + i);
      }
    }
    window.location.href = $(this).attr('href');
  });

  $('.privacy-policy').on('click', function (e) {
    e.preventDefault();

    dialog.open({
      url: $(e.target).attr('href'),
      options: {
        height: 600
      }
    });
  });

  if ($('.order-confirmation-details').length) {
    sessionStorage.removeItem('isGift');
    sessionStorage.removeItem('giftMessage');
  }

  var url = Urls.passwordReset;

  if ($('.reset-password-link').length) {
    if (location.protocol === 'https:') {
      url = Urls.securePasswordReset;
    }

    $('.reset-password-link').each(function () {
      $(this).find('a').attr('href', url);
    });
  }

  if ($('.user-recognized').length) {
    if (location.protocol === 'https:') {
      url = Urls.securePasswordReset;
    }

    $('.user-recognized').find('a').attr('href', url);
  }

  // checkout checkout minicart on right side event handling
  addSummaryScrollbar();

  //Accordion
  $(document).on('click', '.accordion .accordion_title', function () {
    const SlideSize = 300;
    if (!$(this).next().is(':visible')) {
      $('.accordion_description').slideUp(SlideSize);
      $('.open').removeClass('open');
    }
    $(this).next().slideToggle(SlideSize);

    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      if ($('.sb-checkout').length) {
        $('.sb-checkout .sb-container').scrollBox();
      }
    }
  });
  $(document).ready(function () {
    if ($('.accordion .accordion_title').hasClass('open')) {
      if ($('.sb-checkout').length) {
        $('.sb-checkout .sb-container').scrollBox();
      }
    }

    //To set header search icon alignment when Marketing site enabled
    if ($('.minicart-link').length === 0) {
      $('.courtesy-nav').css('margin-right', '0');
    }
  });

  //Hero Carousel Chevron animation
  $('.hero-chevron .chevron-icon').on('click', function (e) {
    const targetHeight = $('.top-hero-section').height();
    const duration = 1500;
    const isDesktop = checkLayout === 'desktop';
    const scrollTop = isDesktop ? targetHeight : targetHeight - 25;
    $('html, body, .content').animate({ scrollTop: scrollTop }, duration);
    e.preventDefault();
  });

  //Tips and Tutorial slider
  if ($('.tips-and-tutorials.variation-2').length) {
    var tutorialVariation2 = $('.tips-and-tutorials.variation-2 .slides');
    tutorialVariation2.slick({
      dots: true,
      infinite: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if ($('.tips-and-tutorials.variation-3').length) {
    var tutorialVariation3 = $('.tips-and-tutorials.variation-3 .videos');
    tutorialVariation3.slick({
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  if ($('.tips-and-tutorials.variation-4').length) {
    $('.tips-and-tutorials.variation-4 .slider-for').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      focusOnSelect: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('.tips-and-tutorials.variation-4 .slider-nav').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      focusOnSelect: true,
      adaptiveHeight: true,
      asNavFor: '.slider-for',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: false
          }
        }
      ]
    });
  }
}

/**
 * @private
 * @function
 * @description jquery UI Select Menu.
 */
function selectMenu() {
  $('select')
    .not(function (index, element) {
      return (
        $(element).closest('.entry-container, .entry-modal, .entry-wrapper')
          .length > 0
      );
    })
    .filter('[data-style != default]')
    .selectmenu({
      //Add class to Dropdown Set for css targeting
      width: false,
      position: { my: 'left top', at: 'left bottom', collision: 'flip flip' },
      change: function (event, ui) {
        var $element = $(event.delegateTarget).attr('id');
        $('.ui-selectmenu-button[aria-owns= "' + $element + '"]').addClass(
          'selected'
        );
      }
    });
}

function refreshSelectMenu() {
  if ($('[role="combobox"][aria-expanded="true"]').length > 0) {
    $('[role="combobox"][aria-expanded="true"]').each(function () {
      // anyone that is open
      $(this).prev().selectmenu('close');
    });
  }
}

/**
 * @private
 * @function
 * @description Screen Resize Handler.
 */
function screenResizeHandler() {
  $(window).on('resize orientationchange', function () {
    refreshSelectMenu();
    updateSigleTileContentHeight();
    aosInitialize();

    // Initilize detect layout on Resize
    checkLayout = currentLayout.init();
    if (checkLayout == 'desktop') {
      $('.main-nav').removeAttr('style');
    }

    if ($('#social-media-post-detail-modal').length) {
      $('#social-media-post-detail-modal')
        .find('.modal-close')
        .trigger('click');
    }
    //Check if Ipad and close megamenu is open
    if (
      navigator.userAgent.match(/iPad/i) !== null &&
      window.matchMedia('(orientation: landscape)').matches
    ) {
      if ($('ul.level-1 > li.has-sub-menu').hasClass('hover')) {
        $('.nav-close .close-icon').trigger('click');
      }
      if ($('.nav-open').length > 0) {
        $('html').removeClass('nav-open');
        $('.overlay').remove();
      }
    }
  });
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
  // add class to html for css targeting
  $('html').addClass('js');

  if (SitePreferences.LISTING_INFINITE_SCROLL) {
    $('html').addClass('infinite-scroll');
  }

  // load js specific styles
  util.limitCharacters();

  //Initialize custom select
  selectMenu();

  screenResizeHandler();
}

//Back to top function
function backToTopHandler() {
  $.fn.scrollEnd = function (callback, timeout) {
    $(this).scroll(function () {
      var $this = $(this);
      var scrollVal = 100;
      if (
        ($('.pt_storefront').length || $('.pt_articles_listing').length) &&
        $('.top-hero-section').length
      ) {
        scrollVal = $('.top-hero-section').height() + 100;
      }
      if ($(window).scrollTop() > scrollVal) {
        $('.scroll-top-wrapper').addClass('show');
      } else {
        $('.scroll-top-wrapper').removeClass('show');
      }

      if ($this.data('scrollTimeout')) {
        clearTimeout($this.data('scrollTimeout'));
      }
      $this.data('scrollTimeout', setTimeout(callback, timeout));
    });
  };
  $('.scroll-top-wrapper').on('click', scrollToTop);

  $(window).scrollEnd(function () {
    $('.scroll-top-wrapper').removeClass('show');
  }, 3000);
}

function scrollToTop(e) {
  e.preventDefault();
  var headerHeight = $('.header-wrapper').height();
  var verticalOffset =
    typeof verticalOffset != 'undefined' ? verticalOffset : 0;
  var element = $('#main');
  var offset = element.offset();
  var offsetTop;
  if ($('.pt_storefront').length || $('.pt_articles_listing').length) {
    if ($('.header-wrapper').css('position') === 'fixed') {
      offsetTop = offset.top;
    } else {
      offsetTop = offset.top - headerHeight;
    }
  } else {
    offsetTop = offset.top - headerHeight;
  }

  $('html, body').animate(
    {
      scrollTop: offsetTop
    },
    500,
    'linear'
  );
}

// Minimize header and make it stick to the top
function minimizedHeaderHandler() {
  checkScrolledDown();

  $(window).scroll(function () {
    checkScrolledDown();
  });
}

function checkScrolledDown() {
  var $stickyHeader = $('#minimized-header-container');
  var $headerScrollOffset = $('.header-banner').outerHeight();
  var $wrapper = $('#wrapper');

  if ($('body').hasClass('is-reveal-open')) {
    return false;
  }
}

function searchMenuEvent() {
  // Search for mobile view
  $('.quick-access-menu [title="Search"]').on('click', function (e) {
    e.preventDefault();

    $('.header-search').slideToggle(200);
  });
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar() {
  var itemCount = $(
    '.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product'
  ).length;

  if (itemCount > 4) {
    $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
  }
}

function playVideoHandler() {
  var MAIN_VIDEO_SELECTOR = '.main-video';
  var CAROUSEL_VIDEO_SELECTOR = '.modal-video';
  $(document)
    // main video (inline)
    .on('click', MAIN_VIDEO_SELECTOR, function () {
      var $this = $(this);

      var $inlineEle = $this.parent('div'),
        videoId = $this.data('video-id');

      video.playInline($inlineEle, videoId);
    })

    // carousel videos (launched in modal)
    .on('click', CAROUSEL_VIDEO_SELECTOR, function () {
      var videoId = $(this).data('video-id');

      video.playInModal(videoId);
    });
}

function resetFooterError() {
  $('.store-locator-form input[type="text"]').val('');

  if ($('.store-locator-form .field-button-container div').hasClass('error')) {
    $('.store-locator-form .field-button-container div').removeClass('error');
    $('.store-locator-form .field-button-container .error-message').remove();
  }
}

function aosInitialize() {
  if (
    $('.pt_storefront').length ||
    ($('.pt_product-search-result.category').length && checkLayout !== 'mobile')
  ) {
    animation.init({
      offset: 200,
      duration: 600,
      easing: 'ease-in-sine',
      delay: 100,
      once: true
    });
  }

  if (checkLayout == 'mobile') {
    if ($('.pt_storefront').length) {
      animation.init({
        offset: 200,
        disable: 'mobile',
        duration: 600,
        easing: 'ease-in-sine',
        delay: 100,
        once: true
      });
    }
    if ($('.pt_product-search-result.category').length) {
      animation.init({
        disable: 'mobile'
      });
    }
  } else {
    if ($('.pt_storefront').length) {
      animation.init({
        offset: 200,
        duration: 600,
        easing: 'ease-in-sine',
        delay: 100,
        once: true
      });
    }
  }
}
var pages = {
  account: require('./pages/account'),
  cart: require('./pages/cart'),
  productReview: require('./pages/productReview'),
  checkout: require('./pages/checkout'),
  compare: require('./pages/compare'),
  product: require('./pages/product'),
  registry: require('./pages/registry'),
  orderconfirmation: require('./pages/order-confirm'),
  search: require('./pages/search'),
  tutorial: require('./pages/tutorial'),
  storefront: require('./pages/storefront'),
  wishlist: require('./pages/wishlist'),
  storelocator: require('./pages/storelocator'),
  checkorder: require('./pages/checkorder'),
  content: require('./pages/content'),
  promotionlanding: require('./pages/promotionlanding'),
  consultation: require('./quiz'),
  foundationfinder: require('./pages/foundationfinder'),
  paymentinstruments: require('./pages/paymentinstruments'),
  stocknotification: require('./pages/stocknotification'),
  kit: require('./pages/product/kit'),
  onlinequiz: require('./pages/onlinequiz'),
  retailerEcConnect: require('./pages/additional-retailer-ec-connect'),
  showAddToCartButtonForLp: require('./pages/showaddtocartforlp')
};

var app = {
  init: function () {
    if (document.cookie.length === 0) {
      $('<div/>')
        .addClass('browser-compatibility-alert')
        .append(
          $('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)
        )
        .appendTo('#browser-check');
    }

    initializeDom();
    initializeEvents();
    backToTopHandler();
    minimizedHeaderHandler();
    resetFooterError();
    searchMenuEvent();
    // init specific global components
    analytics.init();
    countries.init();
    tooltip.init();
    minicart.init();
    validator.init();
    orderreplenishment.init();
    rating.init();
    slick.init();
    searchplaceholder.init();
    header.init();
    video.init();
    //checkoutLogin.init();
    footerSelector.countrySelector();
    footerTelClass.setFooterTelNumberBehavior();
    newsletter.newsletterHeader();
    newsletter.isNewsletterEnabled();
    inputEntry.entry();
    playVideoHandler();
    pressrelease.init();
    shadedtool.init();
    updateSigleTileContentHeight();
    customModal.modal();
    search.viewMore();
    //aosInitialize();
    productTile.initCarouselSwatches();
    video.initialize();
    delayImage.showDelayedImages();
    cartInProductTile.init();

    if ($('#selectcountry').length > 0) {
      countrySelectDropdown();
    }
    // execute page specific initializations
    $.extend(page, window.pageContext);

    var ns = page.ns;

    if (ns && pages[ns] && pages[ns].init) {
      pages[ns].init();
    }

    // Check TLS status if indicated by site preference
    if (SitePreferences.CHECK_TLS === true) {
      tls.getUserAgent();
    }

    defendAndRegenerate();
    aosInitialize();
  }
};

//Select menu widget to prepend span tag for the country flag on selected dropdown and options.
$.widget('ui.selectmenu', $.ui.selectmenu, {
  _renderItem: function (ul, item) {
    var _div = $('<div></div>');
    var li = $('<li></li>');

    if (item.disabled) {
      li.addClass('ui-state-disabled');
    }

    this._setText(_div, item.label);
    _div.appendTo(li);

    var setClass = item.element.attr('class');
    if (typeof setClass != 'undefined' && setClass !== '') {
      _div.prepend("<span class='" + setClass + "'></span>");
    }

    return li.appendTo(ul);
  },
  _renderButtonItem: function (item) {
    var buttonItem = $('<span>', {
      class: 'ui-selectmenu-text'
    });
    this._setText(buttonItem, item.label);

    var setClass = item.element.attr('class');
    if (typeof setClass != 'undefined' && setClass !== '') {
      buttonItem.prepend("<span class='" + setClass + "'></span>");
    }

    return buttonItem;
  }
});

function defendAndRegenerate() {
  if ($('.defend-regenerate-section').length > 0) {
    var offset = $('.defend-regenerate-section').offset().top,
      windowScroll = $(window).scrollTop();
    if (offset <= windowScroll) {
      $('.defend-regenerate-module').addClass('animate-step2');
    }
    var offset2 = $('.defend-regenerate-section .regenerate').offset().top;
    offset2 = offset2 - 800;
    if (offset2 <= windowScroll) {
      $('.defend-regenerate-module').addClass('animate-step3');
    }
    var offset3 = $('.defend-regenerate-section .regenerate').offset().top;
    if (offset3 <= windowScroll) {
      $('.defend-regenerate-module').addClass('animate-step4');
    }
  }
}

$(window).scroll(function () {
  defendAndRegenerate();
});

//general extension functions
(function () {
  String.format = function () {
    var s = arguments[0];
    var i,
      len = arguments.length - 1;

    for (i = 0; i < len; i++) {
      var reg = new RegExp('\\{' + i + '\\}', 'gm');

      s = s.replace(reg, arguments[i + 1]);
    }

    return s;
  };
})();

// initialize app
$(document).ready(function () {
  app.init();
});

$(window).on('load', function () {
  var heroVideo = document.getElementById('hero-video');
  if (heroVideo !== undefined && heroVideo !== null) {
    var playPromise = document.getElementById('hero-video').play();
    if (playPromise !== undefined) {
      playPromise
        .then(function () {})
        .catch(function (error) {
          // Auto-play was prevented
          // Show paused UI.
          $('.video-control').addClass('paused');
        });
    }
    $('.video-control').on('click', function (event) {
      if (!heroVideo.paused) {
        heroVideo.pause();
        $(this).addClass('paused');
      } else {
        heroVideo.play();
        $(this).removeClass('paused');
      }
    });
  }
});

//Country selector menu init
function countrySelectDropdown() {
  $('#selectcountry').selectmenu({
    position: {
      my: 'left+10 bottom',
      at: 'left top',
      of: '#countryheader-selector'
    }
  });
  $('#header-selectcountry').selectmenu({
    position: {
      my: 'left+10 top+15',
      at: 'left bottom',
      of: '#country-selector'
    }
  });
}

//make single tile content height same with product-tile
function updateSigleTileContentHeight() {
  var tileContentSiblingHeight = $('.product-tile:eq(0)').innerHeight();
  $('.single-tile-promo, .double-tile-content')
    .removeAttr('style')
    .css('height', tileContentSiblingHeight);
}
// expose global app obj for 3rd party integrations
window.app = {
  quickView: quickview,
  minicart: minicart,
  user: window.User,
  SCemailUrl: window.Urls.SCemailUrl,
  Product: {},
  tagmanager: analytics.tagmanager,
  gtmInternalPromotion: analytics.gtmInternalPromotion
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = addSummaryScrollbar;
window.scrollToTop = scrollToTop;

},{"./analytics":2,"./aos":20,"./captcha":23,"./cartInProductTile":24,"./consentTracking":26,"./cookieprivacy":27,"./countries":28,"./delay-image":29,"./detect-layout":30,"./dialog":31,"./footer-selector":33,"./footer-tel-class":34,"./header":37,"./input-entry":38,"./jquery-ext":39,"./jquery-ui-slider":40,"./minicart":42,"./modal":43,"./newsletter":44,"./order-replenishment":45,"./page":46,"./pages/account":47,"./pages/additional-retailer-ec-connect":48,"./pages/cart":49,"./pages/checkorder":50,"./pages/checkout":55,"./pages/compare":59,"./pages/content":60,"./pages/foundationfinder":61,"./pages/onlinequiz":62,"./pages/order-confirm":63,"./pages/paymentinstruments":64,"./pages/product":70,"./pages/product/kit":71,"./pages/productReview":65,"./pages/promotionlanding":78,"./pages/registry":79,"./pages/search":80,"./pages/showaddtocartforlp":81,"./pages/stocknotification":82,"./pages/storefront":83,"./pages/storelocator":84,"./pages/tutorial":86,"./pages/wishlist":87,"./pressrelease":89,"./product-tile":90,"./quickview":92,"./quiz":93,"./rating":94,"./searchplaceholder":96,"./searchsuggest":97,"./shaded-tool":98,"./slick":99,"./tls":103,"./tooltip":104,"./util":105,"./validator":106,"./video":107}],22:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    samples = require('./samples'),
	customModal = require('./modal');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">',
        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: ci.find('.item-qty').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
                $this.closest('.bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            $bonusProductList.find('.bonus-items-available').text('0');
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
            page.refresh();
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        // render content to modal by url
        url = util.appendParamToURL(url, 'format', 'ajax')

        $('.ajax-loader').show();
        var index = require('./pages/product/index');
        $.ajax({
            url: url,
            dataType: 'html',
            success: function(response)
            {
                customModal.createCustomModal('bonus-sample-selection');
                $('.bonus-sample-selection').find('.modal-body').html(response);
                index.bodyPositionFixed('bonus-sample-selection');
                $('.header-wrapper').css('transform','translate3d(0px,-100%,0)');
                $('.ajax-loader').hide();
            }
        }).done(function(data) {
        	samples.updateModalScroll();
        	$('.bonus-sample-selection .sample-bonus-contents').css('height', $('.bonus-sample-selection .modal-body').outerHeight() - $('.bonus-sample-selection .add-btn-container').outerHeight());
    		$('.bonus-sample-selection .sample-bonus-contents').scrollBox();
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
		var self = this,
			bonusDiscountContainer = document.querySelector('.bonus-discount-container');
		if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 'auto',
                title: Resources.BONUS_PRODUCT,
                dialogClass: 'bonus-eligibility-modal',
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.showBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 0,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        //self.show(url);
                        modal.addCustomClass('bonus-item-modal');
                        modal.renderByUrl(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    },

    hasBonusOptions: function () {
    	return ($(".bonus-discount-container").length > 0);
    }
};



module.exports = bonusProductsView;

},{"./dialog":31,"./modal":43,"./page":46,"./pages/product/index":70,"./samples":95,"./util":105}],23:[function(require,module,exports){
'use strict';

var util = require('./util'),
	customModal = require('./modal'),
	SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
module.exports = function () {
	/**
	 * if the session.privacy.ratelimited element is present then show the notification
	 * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
	 */
	if (SessionAttributes.SHOW_CAPTCHA) {
		customModal.createCustomModal('login-captcha');
		$('.login-captcha .modal-body').html('<h1>' + Resources.ARE_YOU_HUMAN + '</h1><button class="primary large">' + Resources.OK + '</button>');
		$('.login-captcha button').on('click', function() {
			var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
			$.ajax({
				url: url
			});
			$('.login-captcha .modal-close').trigger('click');
		});
	}
};

},{"./modal":43,"./util":105}],24:[function(require,module,exports){
'use strict';

/**
 * カートイン機能付きProductTile
 *
 * @module productTileCartIn
 */

/**
 * CssClass定義
 *
 * @enum {string}
 * @readonly
 */
const CssClass = {
  /** ProductTile Wrapper */
  TILE_WRAPPER: '.product-tile-wrapper',
  /** ProductTile */
  TILE: '.product-tile-cart-in',
  /** 選択肢 */
  OPTION: '.size-variant'
};

/**
 * 初期化処理
 *
 * @param {object} [_tile=${CssClass.TILE}] `CssClass.TILE`のクラスを持つ要素。未指定の場合、画面内からすべての `CssClass.TILE_WRAPPER`のクラスを持つ要素に対して処理を行う。
 */
function initializeTiles(_tile) {
  const tile = _tile || $(CssClass.TILE);
  $(tile).each(function (idx, tile) {
    // バリエーション選択値の表示
    const variationSelect = $(tile).find('select.variation-select');
    $(tile)
      .find('.variant-dropdown .ui-selectmenu-text')
      .text($(variationSelect).find(':selected').text());
    // バリエーション変更時イベント
    $(tile)
      .find('select.variation-select')
      .on('selectmenuchange', updateContentOnOptionClicked);
    // jquery-ui select
    $(tile)
      .find('select')
      .selectmenu({
        width: false,
        position: {
          my: 'left top',
          at: 'left bottom',
          collision: 'flip flip'
        },
        classes: {
          'ui-selectmenu-menu': 'qv-select'
        }
      });
  });
}

/**
 * 選択肢クリック時にコンテンツを更新する処理
 *
 * @returns {boolean} aタグクリック時の画面遷移をキャンセルするため、falseを返却。
 */
function updateContentOnOptionClicked() {
  const ajax = require('./ajax');
  const tileWrapper = $(this).closest(CssClass.TILE_WRAPPER);
  ajax.load({
    method: 'POST',
    target: tileWrapper,
    url: $(this).find('option:selected').data('url'),
    callback: function (result) {
      $(tileWrapper).html(result);
      const tile = $(tileWrapper).find(CssClass.TILE);
      initializeTiles(tile);
    }
  });
  return false;
}

exports.init = function () {
  $(function () {
    // GTAのイベントを抑制
    $(document).off('gttilevariationchange');
    // 初期化
    initializeTiles();
  });
};

},{"./ajax":1}],25:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) { return; }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) { $cb[0].checked = true; }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = true; }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        var $productTile = $('#' +  $(this).data('uuid'));
        if ($productTile.length === 0) {return;}
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":46,"./util":105,"promise":113}],26:[function(require,module,exports){
'use strict';

var util = require('./util');
/**
 * @function getConsent Used to display/control of the modal containing the consent management message
 **/


function getConsent() {
	$.get(util.appendParamsToUrl(Urls.consentTracking, {"format": "ajax"}) , function(data) {
		
    	$(document).find('body #main').append("<div class='cookie_popup_container'><div class='popup_overlay'/><div class='cookie_consent_popup'>"+data+"</div></div>");
    	
    	$(document).find('.cookie_consent_popup .trackingYes').on('click', function () {
    		$.ajax({
                type: 'GET',
                url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', true),
                success: function () {
                    showPrivacyDialog();
                },
                error: function () {
                    showPrivacyDialog();
                }
            })
            $('.cookie_popup_container').remove();
    	});
    	
    	$(document).find('.cookie_consent_popup .trackingNo').on('click', function () {
    		$.ajax({
                type: 'GET',
                url: util.appendParamToURL(Urls.consentTrackingSetSession, 'consentTracking', false),
                success: function () {
                    showPrivacyDialog();
                },
                error: function () {
                    showPrivacyDialog();
                }
            })
            $('.cookie_popup_container').remove();
    	});
    	
    });
}

function enablePrivacyCookies() {
    if (document.cookie.indexOf('dw=1') < 0) {
        document.cookie = 'dw=1; path=/';
    }
    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
        document.cookie = 'dw_cookies_accepted=1; path=/';
    }
}
function showPrivacyDialog(){

    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
    	// check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            $.get(util.appendParamsToUrl(Urls.cookieHint, {"format": "ajax"}) , function(data) {
            	$(document).find('body #main').append("<div class='cookie_consent_popup'>"+data+"</div>");
            	$(document).find('.cookie_consent_popup .agreeButton').on('click', function () {
            		$('.cookie_consent_popup').hide();
            	});
            	enablePrivacyCookies();
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enablePrivacyCookies();
    }
}
var consentTracking = {
    init: function () {
//        if (consent == null && SitePreferences.CONSENT_TRACKING_HINT) { // eslint-disable-line no-undef
//            getConsent();
//        }
//        
//        if (consent != null && SitePreferences.CONSENT_TRACKING_HINT){ // eslint-disable-line no-undef
//            showPrivacyDialog();
//        }
        
    },
    show: function () {
        getConsent();
    }
};
module.exports = consentTracking;

},{"./util":105}],27:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (!SitePreferences.CONSENT_TRACKING_HINT && SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            $.get(util.appendParamsToUrl(Urls.cookieHint, {"format": "ajax"}) , function(data) {
            	$(document).find('body #main').append("<div class='cookie_consent_popup'>"+data+"</div>");
            	$(document).find('.cookie_consent_popup .agreeButton').on('click', function () {
            		$('.cookie_consent_popup').remove();
            	});
            	enableCookies();
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    }
};

},{"./util":105}],28:[function(require,module,exports){
'use strict';

exports.init = function init () {
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });
    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });
};

},{}],29:[function(require,module,exports){
'use strict';

var currentLayout = require('./detect-layout'),
	RESPONSIVE_IMAGE_TAG = 'picture';

/*
* @Object
* @description a delayedimageload object for showing the images based on the data- attribute value
*/
var delayedimageload = {
	/**
	* @function
	* @description init function initialises the triggers and assigns the onload, ready elements.
	*/
	init: function () {
		this.$eldesktoponly = $('img[data-image-load-on=desktop]');
		$(window).on('resize orientationchange', function () {
			delayedimageload.showDesktopImages();
		});
	},
	/**
	* @function
	* @description A function to display all the images on document ready specifically
	*/
	showDesktopImages: function () {
		if (this.$eldesktoponly && currentLayout.init() === 'desktop') {
			var $desktopImageIndex = 0;
			var $desktopImagesLength = this.$eldesktoponly.length;
			for ($desktopImageIndex; $desktopImageIndex < $desktopImagesLength; $desktopImageIndex++) {
				var $desktopImage = this.$eldesktoponly[$desktopImageIndex];
				var $currentElement = $($desktopImage);
				if (!$currentElement.hasClass('js-loaded')) {
					showResponsiveImages($currentElement);
					$currentElement.attr('src', $currentElement.attr('data-image'));
					$currentElement.addClass('js-loaded');
				}
			}
		}
	}
};

function showDelayedImages() {
	delayedimageload.init();
	delayedimageload.showDesktopImages();
}

/**
* @function
* @description A function to determine and lazy-load responsive images
*/
function showResponsiveImages(image) {
	var $parentNode = image.parent();
	if ($parentNode.prop('tagName').toLowerCase() === RESPONSIVE_IMAGE_TAG) {
		var $imageSources = $parentNode.children();
		for (var i = 0; i < $imageSources.length; i++) {
			var $element = $imageSources.eq(i);
			$element.attr('srcset', $element.data('srcset'));
		}
	}
}


module.exports = delayedimageload;
module.exports.showDelayedImages = showDelayedImages;

},{"./detect-layout":30}],30:[function(require,module,exports){
'use strict';
var currLayout;
function initCurrentLayout() {
	if (window.innerWidth >= 769) {
		return currLayout = "desktop"
	} else {
		return currLayout = "mobile"
	}
}

exports.init = function () {
   return  initCurrentLayout();
};
},{}],31:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        // close any open dialog
        this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function () {
            $(this).dialog('close');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":1,"./util":105,"imagesloaded":111,"lodash":112}],32:[function(require,module,exports){
!function(e,n){"function"==typeof define&&define.amd?define(["exports"],n):"undefined"!=typeof exports?n(exports):n(e.dragscroll={})}(this,function(e){var n,t,o=window,l=document,c="mousemove",r="mouseup",i="mousedown",m="EventListener",d="add"+m,s="remove"+m,f=[],u=function(e,m){for(e=0;e<f.length;)(m=(m=f[e++]).container||m)[s](i,m.md,0),o[s](r,m.mu,0),o[s](c,m.mm,0);for(f=[].slice.call(l.getElementsByClassName("dragscroll")),e=0;e<f.length;)!function(e,m,s,f,u,a){(a=e.container||e)[d](i,a.md=function(n){e.hasAttribute("nochilddrag")&&l.elementFromPoint(n.pageX,n.pageY)!=a||(f=1,m=n.clientX,s=n.clientY,n.preventDefault())},0),o[d](r,a.mu=function(){f=0},0),o[d](c,a.mm=function(o){f&&((u=e.scroller||e).scrollLeft-=n=-m+(m=o.clientX),u.scrollTop-=t=-s+(s=o.clientY),e==l.body&&((u=l.documentElement).scrollLeft-=n,u.scrollTop-=t))},0)}(f[e++])};"complete"==l.readyState?u():o[d]("load",u,0),e.reset=u});
},{}],33:[function(require,module,exports){
'use strict';

var util = require('./util');

function countrySelector() {
  $('#selectcountry, #header-selectcountry').on(
    'selectmenuchange change',
    function(event, ui) {
      var countrySelected = $(this)
        .find(':selected')
        .attr('data-country')
        .trim()
        .toLowerCase();
      var redirectCheck;
      var countryUrl = $(this)
        .find(':selected')
        .val();
      if (
        $(this)
          .find(':selected')
          .attr('data-redirect')
      ) {
        redirectCheck = $(this)
          .find(':selected')
          .attr('data-redirect')
          .trim()
          .toLowerCase();
      }
      if (redirectCheck == 'no') {
        return false;
      }
      if (countrySelected.indexOf('other') >= 0) {
        if (countryUrl == '') {
          countryUrl = Urls.countrySelectorUrl;
        }
      }

      var countryUrl =
        countrySelected.indexOf('other') >= 0
          ? Urls.countrySelectorUrl
          : $(this)
              .find(':selected')
              .val();

      // _self parameter used so that user gets redirected to GMW region selector on the same window.
      if (window.open(countryUrl, '_self') == null) {
        document.location.href = countryUrl;
      }

      if (event.type === 'change') {
        const value = this.options[this.options.selectedIndex].label;
        $('#selectcountry-button').children(
          '.ui-selectmenu-text:first'
        )[0].textContent = value;
      }
    }
  );
}

exports.countrySelector = countrySelector;

},{"./util":105}],34:[function(require,module,exports){
'use strict';

//footerにスマホのみ適用するCSSを判定する
function setFooterTelNumberBehavior() {
  if (navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)) {
    $('#tell-number').addClass('link-tel-number');
  } else {
    $('#tell-number').addClass('no-link-tel-number');
  }
}

exports.setFooterTelNumberBehavior = setFooterTelNumberBehavior;

},{}],35:[function(require,module,exports){
'use strict';

var util = require('./util');
var giftcert = require('./giftcert');
var modal = require('./modal').global;
var validator = require('./validator');

function updateCart () {
    $('#AddToBasketButton').on('click', function () {
        $('#GiftCertificateForm').submit();
    });
}

exports.init = function () {
    $('.gift-cert-edit').on('click', function (e) {
        e.preventDefault();

        modal.addCustomClass('edit-modal quickview-modal');
        modal.renderByUrl($(this).attr('href'));
        modal.setCallback(function () {
            updateCart();
            giftcert.init();
            util.limitCharacters();
            validator.initForm('form#GiftCertificateForm');
        });
    });
}
},{"./giftcert":36,"./modal":43,"./util":105,"./validator":106}],36:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util');

var setAddToCartHandler = function (e) {
    e.preventDefault();
    if ($(".termsandconditions").hasClass("error")) {
    	return false;
    }
    setGiftCard();

    var form = $(this).closest('form');
    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };

    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {
                    lineItemId: response.result.lineItemId
                },
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                    setGiftCard();
                }
            });
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            return window.alert(Resources.BAD_RESPONSE);
        }

        window.alert(Resources.SERVER_CONNECTION_ERROR);
    });
};

function initializeEvents() {
    $('.gift-templates li').on('click', function (e) {
        e.preventDefault();

        $('.gift-templates li').removeClass('active');
        $(this).addClass('active');

        setGiftCard();
    });

    $('.gift-templates select').change(function () {
        var imageSource = $(this).find('option:selected').val();
        var imageAlt = $(this).find('option:selected').text();

        $('.gift-templates li.active').removeClass('active');
        $('.gift-templates li:has(img[alt="' + imageAlt + '"])').addClass('active');

        setGiftCardImage(imageSource);
        setGiftCardName(imageAlt);
    });
}

function setGiftCard() {
    var imageSource = $('.gift-templates li.active').find('img').attr('src') || $('.img-source input').val();
    var imageAlt = $('.gift-templates li.active').find('img').attr('alt') || $('.img-alt input').val();

    $('.gift-templates select').val(imageSource);
    $('.gift-templates li:has(img[alt="' + imageAlt + '"])').addClass('active');

    setGiftCardImage(imageSource);
    setGiftCardName(imageAlt);
}

function setGiftCardImage(imageSource) {
    $('.img-preview').html('<img src="' + imageSource + '" />');
    $('#GiftCertificateForm .img-source input').val(imageSource);
}

function setGiftCardName (imageAlt) {
    $('.gift-templates strong').text(imageAlt);
    $('#GiftCertificateForm .img-alt input').val(imageAlt);
}

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);

    if ($('.gift-check-balance').length) {
        $('.gift-templates li').first().addClass('active');
    }

    initializeEvents();
};

},{"./ajax":1,"./minicart":42,"./util":105}],37:[function(require,module,exports){
'use strict';

var currentLayout = require('./detect-layout'),
  resizedScreen = currentLayout.init(),
  util = require('./util');

/**
 * @function
 * @description Mobile navigation open/close handler
 */
function mobileNavHandler() {
  var windowScrollPosition;
  $(document).on('click', '.icon-hamburger', function () {
    if (window.innerWidth < 1024) {
      windowScrollPosition = $(window).scrollTop();
      // Scroll to the top to remove the flicker effect before the body scrolls off using CSS by nav-open class.
      $(window).scrollTop(0);
      $('html').addClass('nav-open');
      $('.top-navigation-list').scrollTop(0);
    }
  });
  $(document)
    .on('click', '.nav-overlay', function () {
      if ($('.nav-open').length > 0) {
        $('html').removeClass('nav-open');
        $(window).scrollTop(windowScrollPosition);
        $('.main-nav, .main-sub-nav, .sub-menu, #signin-overlay')
          .removeClass('active')
          .removeAttr('style');
        $('.main-nav, .main-sub-nav, .sub-menu, #contactus-overlay')
          .removeClass('active')
          .removeAttr('style');
      }
    })
    .on('click', '.has-sub-nav > a', function (e) {
      $('.utility-nav > ul > li').removeClass('hovered');
      if (window.innerWidth < 1024) {
        $(this).siblings('.sub-menu, .main-sub-nav').addClass('active');
        $('.main-nav').removeAttr('style');
        return false;
      } else {
        e.preventDefault();
      }
    })
    .on('click', '.back-link span', function () {
      if ($(this).closest('.sub-menu').hasClass('level-2')) {
        $(this).closest('.main-sub-nav').removeClass('active');
      } else {
        $(this).closest('.sub-menu').removeClass('active');
      }
    });
}

/**
 * @function
 * @description Desktop navigation flyout open/close handler
 */
function desktopNavHandler() {
  $(document)
    .on('mouseenter', '.top-navigation-list > li:not(.js-hover)', function () {
      if (window.innerWidth >= 1024) {
        var $this = $(this);
        setTimeout(function () {
          if (
            isMenuHovered($this) ||
            $this.is(':hover') ||
            $this.children('a').is(':focus')
          ) {
            $('.top-navigation-list .level-2-wrapper').scrollTop(0);
            $this.addClass('js-hover').siblings('li').removeClass('js-hover');
          }
        }, 300);
      }
    })
    .on('mouseleave', '.top-navigation-list > li', function () {
      if (window.innerWidth >= 1024) {
        var $this = $(this);
        setTimeout(function () {
          if (!isMenuHovered($this) || $this.is(':hover')) {
            $('.top-navigation-list .level-2-wrapper').scrollTop(0);
            $this.removeClass('js-hover');
          }
        }, 300);
      }
    })
    .on('click', '.top-navigation-list > li > a', function () {
      if (window.innerWidth >= 1024) {
        $(this).parent('li').trigger('mouseenter');
      }
    })
    .on(
      'click',
      '.top-navigation-list > li > .main-sub-nav .close',
      function () {
        if (window.innerWidth >= 1024) {
          $('.top-navigation-list .level-2-wrapper').scrollTop(0);
          $(this).closest('li.js-hover').removeClass('js-hover');
        }
      }
    )
    .on('mouseenter', '.level-2-bottom-space', function () {
      if (window.innerWidth >= 1024) {
        $('.top-navigation-list .level-2-wrapper').scrollTop(0);
        $('.top-navigation-list > li.js-hover').removeClass('js-hover');
      }
    })
    .keyup(function (e) {
      if (e.keyCode === 27) {
        //on click Esc key close the open menu flyout.
        if ($('.top-navigation-list > li.js-hover').length > 0) {
          $('.top-navigation-list > li.js-hover')
            .trigger('mouseleave')
            .children('a')
            .focus();
        }
      }
    });

  if ($('.top-notification').length > 0) {
    $('.header-container').addClass('top-notification-configured');
  }
}

/**
 * Since hover is not supported in jQuery v1.9.1,
 * it gets and returns the number of menu selectors in the hover state.
 * @param {Object}
 * @returns {boolean}
 */
function isMenuHovered(element) {
  return element.parent().find(element.selector + ':hover').length > 0;
}

/**
 * @function
 * @description Utility navigation hover and click handling.
 */
function utilityNavTouchHandler(event, anchor) {
  if (resizedScreen == 'desktop' && util.isMobile()) {
    if (!$(anchor).parent().hasClass('hovered')) {
      $(anchor).parent().siblings().removeClass('hovered');
      $(anchor).parent().toggleClass('hovered');
      if ($(anchor).parent().hasClass('hovered')) {
        event.preventDefault();
      }
    }
  }
}

exports.init = function () {
  $(window).on('resize', function () {
    resizedScreen = currentLayout.init();
    resizeScreenInit();
    handleResizeForBannerMessages();
  });

  // 'tap' doesn't work as expected so using touchstart instead
  $(document).on('touchstart', function (e) {
    // the tapped element
    var $target = $(e.target);
  });

  $('a.utility-link').on('click', function (evt) {
    evt.preventDefault();
  });

  var $submenuItems = $('.utility-nav .sub-menu-item > a');

  $('.contactus-overlay-container').on('click', function (e) {
    $('html').removeClass('sticky-header-contact');
    $('#contactus-overlay').removeClass('active');
    $('#contactus-overlay').hide();
    e.preventDefault();
    return false;
  });

  //Common signin-overlay close
  $('#signin-overlay .signin-overlay-close').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html').removeClass('nav-open sticky-header-signin');
    $('body').removeClass('body-fixed');
    $(this).parents('#signin-overlay').removeClass('active');
    $(this).parents('#signin-overlay').hide();
    $('#signin-link').removeClass('hovered');
  });

  $('#contactus-overlay .contactus-overlay-close').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html').removeClass('nav-open sticky-header-contact');
    $(this).parents('#contactus-overlay').removeClass('active');
    $(this).parents('#contactus-overlay').addClass('d-none');
    $(this).parents('#contactus-overlay').hide();
    $('#contactus-link').removeClass('hovered');
  });

  function handleSigninOverlayDisplay() {
    //Remove body fixed / sticky-header-signin after orientation change or resize in ipad landscape
    if (
      $('#signin-overlay').is(':visible') &&
      $('body').hasClass('body-fixed')
    ) {
      $('body').removeClass('body-fixed');
      $('html').removeClass('sticky-header-signin');
    }
  }

  //Desktop contactus-overlay
  function desktopContactusOverlay() {
    $('#contactus-link > a')
      .on('mouseover', function (e) {
        e.preventDefault();
        if ($('.contactus-link').hasClass('active')) {
          $('.contactus-overlay').addClass('d-none');
        }
        $(this).nextAll('#contactus-overlay').removeAttr('style');
        $('.signin-link').removeClass('hovered');
        $('.minicart-link').removeClass('hovered');
      })
      .on('click', function () {
        utilityNavTouchHandler(event, this);
      });
  }

  //Desktop signin-overlay
  function desktopSigninOverlay() {
    //$('.nav-container-row').removeAttr('style');

    $('.courtesy-nav li.signin-link').hover(function () {
      singinOverlayScroll();
    });

    $('#signin-link > a').on('mouseover', function (e) {
      $(this).nextAll('#signin-overlay').removeAttr('style');
      singinOverlayScroll();
      $('#header-selectcountry').selectmenu('close');
    });
  }

  //Mobile signin-overlay
  function mobileSigninOverlay() {
    $(document).on('click', '#signin-link > a', function (e) {
      if (window.innerWidth < 1024) {
        e.preventDefault();
        $(this).parent().addClass('hovered').siblings().removeClass('hovered');
      }
      if (window.innerWidth < 1024) {
        var overlay = $(this).nextAll('#signin-overlay');
        overlay.removeAttr('style');
        overlay.addClass('active');
        $('.signin-link').addClass('hovered');
        var vHeight = overlay.find('.sign-in-dropdown').innerHeight();

        if ($('.signin-overlay .sb-content').length > 0) {
          $('.signin-overlay .sb-content').removeAttr('style');
          $(window).trigger('resize.scrollBox');
        }

        if ($('#signin-link').hasClass('guest')) {
          $('html').addClass('sticky-header-signin');
          $('body').addClass('body-fixed');
        } else {
          $(document).on('click', '#signin-overlay .back-link', function (e) {
            e.preventDefault();
            $(this).parents('#signin-overlay').removeClass('active');
          });
        }
      }
    });
  }

  function mobileContactusOverlay() {
    $(document).on(
      'click',
      '#contactus-link > a, #contactus-link > .nav-toggle',
      function (e) {
        if (window.innerWidth < 1024) {
          e.preventDefault();
          $(this)
            .parent()
            .addClass('hovered')
            .siblings()
            .removeClass('hovered');
        }
        $('html.nav-open').addClass('sticky-header-contact');
        var overlay = $(this).nextAll('#contactus-overlay');
        overlay.removeClass('d-none');
        overlay.removeAttr('style');
        overlay.addClass('active');
      }
    );
  }

  function resizeScreenInit() {
    if (window.innerWidth < 1024) {
      mobileSigninOverlay();
    } else {
      desktopSigninOverlay();
      handleSigninOverlayDisplay();
    }

    $('.utility-nav > ul > li').toggleClass('no-touch', !util.isMobile());
  }

  $(window).on('orientationchange', function () {
    if (window.innerWidth >= 1024) {
      if ($('.nav-open').length > 0) {
        $('html').removeClass('nav-open');
        $('.main-nav, .main-sub-nav, .sub-menu, #signin-overlay')
          .removeClass('active')
          .removeAttr('style');
      }
    } else if (window.innerWidth <= 1024) {
      if ($('.top-navigation-list > li.js-hover').length > 0) {
        $(window).scrollTop(0);
      }
    }
  });

  resizeScreenInit();
  initStickyHeader();
  mobileNavHandler();
  desktopNavHandler();
  handleResizeForBannerMessages();
};

var lastScrollTop = 0;
//Function for sticky header behavior and other components impact of the same.
function initStickyHeader() {
  var threashHold = 50;
  if ($('#header-top-notification-message').length == 0) {
    threashHold = 30;
  }
  $(window).on('scroll', function () {
    var iCurScrollPos = $(window).scrollTop();
    if (iCurScrollPos > lastScrollTop) {
      //Downward Scroll
      if (!$('body').hasClass('pdp-page')) {
        if (iCurScrollPos > threashHold) {
          makeHeaderSticky();
        } else {
          removeStickyHeader();
        }
      } else {
        removeStickyHeader();
      }
    } else {
      if (iCurScrollPos > threashHold) {
        makeHeaderSticky();
      } else {
        removeStickyHeader();
      }
    }
    if (
      !$('body').hasClass('pdp-page') &&
      !$('#wrapper').hasClass('sticky-header') &&
      iCurScrollPos > threashHold
    ) {
      $('.sticky-component').addClass('sticky-component-hide');
    } else if ($('.sticky-component').hasClass('sticky-component-hide')) {
      $('.sticky-component').removeClass('sticky-component-hide');
    }
    if (!$('body').hasClass('pdp-page')) {
      lastScrollTop = iCurScrollPos;
    }
  });
}

function makeHeaderSticky() {
  if (!$('#wrapper').hasClass('sticky-header')) {
    $('#wrapper').addClass('sticky-header');
  }
}
function removeStickyHeader() {
  if ($('#wrapper').hasClass('sticky-header')) {
    $('#wrapper').removeClass('sticky-header');
  }
}

function handleResizeForBannerMessages() {
  var customMessagesTotalWidth = 0;
  $('.custom-message').each(function (i, m) {
    customMessagesTotalWidth += $(m).outerWidth();
  });
  if (
    customMessagesTotalWidth > 0 &&
    window.innerWidth > customMessagesTotalWidth
  ) {
    $('#header-bottom-notification-message').addClass('centered');
  } else {
    $('#header-bottom-notification-message').removeClass('centered');
  }
}

function singinOverlayScroll() {
  if ($('.signin-overlay .sb-content').length === 0) {
    $('.sb-container').scrollBox();
  } else {
    $('.signin-overlay .sb-content').removeAttr('style');
    $(window).trigger('resize.scrollBox');
  }
}

$(document).on('click', '#signin-link > a', function (e) {
  if ($(this).parent().hasClass('registered')) {
    e.preventDefault();
    e.stopPropagation();
  }
  $(this).parent().toggleClass('hovered');
  utilityNavTouchHandler(e, this);
  $('#header-selectcountry').selectmenu('close');
  singinOverlayScroll();
});

exports.handleResizeForBannerMessages = function () {
  handleResizeForBannerMessages();
};

exports.utilityNavTouchHandler = function (event, anchor) {
  utilityNavTouchHandler(event, anchor);
};

},{"./detect-layout":30,"./util":105}],38:[function(require,module,exports){
'use strict';

function entry () {
    $(document).on('keyup blur', '.search-text', function () {
        if ($(this).val().trim().length) {
            return $(this).siblings('button').prop('disabled', false);
        }

        $(this).siblings('button').prop('disabled', true);
    });
    $(document).on('blur keyup', '.cart-coupon-code input',function() {
		$('#add-coupon').prop('disabled', this.value == "" ? true : false); 
    });
    $(document).on('change', '.form-row .user-consent-container input[type="checkbox"], .checkout-login-container .user-consent-container input[type="checkbox"]', function(){
        var fieldErrorWrapper = $(this).parents('.form-row').find('.error-placement'),
        	form = $(this).parents('form'),
        	validator = form.validate(),
        	validElementFlag = validator.element($(this));
        if(validElementFlag === true && fieldErrorWrapper.length > 0) {
        	fieldErrorWrapper.remove();
        }
        $(form).find('button[type$="submit"]').prop('disabled', $(form).find('.error-placement').length > 0 ? true : false); 
    });
}

exports.entry = entry;
},{}],39:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };
    var getHeightProperty = function() {
        var browser_id = 0;
        var property = [
          // To avoid content overflow in synchronised boxes on font scaling, we
          // use 'min-height' property for modern browsers ...
          ['min-height','0px'],
          // and 'height' property for Internet Explorer.
          ['height','1%']
        ];

        var bMatch = /(msie) ([\w.]+)/.exec(navigator.userAgent.toLowerCase()) || [],
          browser = bMatch[1] || "",
          browserVersion = bMatch[2] || "0";

        // check for IE6 ...
        if(browser === 'msie' && browserVersion < 7){
          browser_id = 1;
        }

        return {
          'name': property[browser_id][0],
          'autoheightVal': property[browser_id][1]
        };
      };

      $.getSyncedHeight = function(selector) {
        var max = 0;
        var heightProperty = getHeightProperty();
        // get maximum element height ...
        $(selector).each(function() {
        	var hoveredSelector = $(this).parents('.product-tile-inner');
          // fallback to auto height before height check ...
          $(this).css(heightProperty.name, heightProperty.autoheightVal);
          if(hoveredSelector.hasClass('hovered')) {
        	  hoveredSelector.removeClass('hovered');
        	  hoveredSelector.addClass('triggerHovered');
          }
          var val = parseInt($(this).css('height'),10);
          if(val > max){
            max = val;
          }
          if(hoveredSelector.hasClass('triggerHovered')) {
        	  hoveredSelector.addClass('hovered');
        	  hoveredSelector.removeClass('triggerHovered');
          }
        });
        return max;
      };

    $.fn.syncHeight = function(config) {
        var defaults = {
          updateOnResize: false,  // re-sync element heights after a browser resize event (useful in flexible layouts)
          height: false,
          parentElement: ''
        };

        var options = $.extend(defaults, config);
        var e = this;
        var max = 0;
        var heightPropertyName = getHeightProperty().name;

        if(typeof(options.height) === "number") {
          max = options.height;
        } else {
          max = $.getSyncedHeight(this);
        }

        // set synchronized element height ...
        $(this).each(function() {
        	// optional sync refresh on resize event ...
          $(this).css(heightPropertyName, max+'px');
          if (options.parentElement !== '') {
	      	$(this).closest( options.parentElement ).css('height', max+'px');
	        }
        });

        // optional sync refresh on resize event ...
        if (options.updateOnResize === true) {
          $(window).bind('resize.syncHeight', function(){
        	  if (options.parentElement !== '') {
    			$(e).syncHeight({parentElement: options.parentElement});
    		} else {
    			$(e).syncHeight();
    		}
          });
        }
        return this;
      };

      $.fn.unSyncHeight = function() {
        // unbind optional resize event ...
        $(window).unbind('resize.syncHeight');

        var heightPropertyName = getHeightProperty().name;
        $(this).each(function() {
        	if (options.parentElement !== '') {
        		$(this).closest( options.parentElement ).css(height, '');
           }
           $(this).css(heightPropertyName, '');
        });
      };
};

},{}],40:[function(require,module,exports){
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(e){e.widget("ui.slider",e.ui.mouse,{version:"1.12.1",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,i,s=this.options,a=this.element.find(".ui-slider-handle"),n=[];for(i=s.values&&s.values.length||1,a.length>i&&(a.slice(i).remove(),a=a.slice(0,i)),t=a.length;t<i;t++)n.push("<span tabindex='0'></span>");this.handles=a.add(e(n.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(t){e(this).data("ui-slider-handle-index",t).attr("tabIndex",0)})},_createRange:function(){var t=this.options;t.range?(!0===t.range&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:e.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=e("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==t.range&&"max"!==t.range||this._addClass(this.range,"ui-slider-range-"+t.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(t){var i,s,a,n,h,l,u,r=this,o=this.options;return!o.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:t.pageX,y:t.pageY},s=this._normValueFromMouse(i),a=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var i=Math.abs(s-r.values(t));(a>i||a===i&&(t===r._lastChangedValue||r.values(t)===o.min))&&(a=i,n=e(this),h=t)}),!1!==this._start(t,h)&&(this._mouseSliding=!0,this._handleIndex=h,this._addClass(n,null,"ui-state-active"),n.trigger("focus"),l=n.offset(),u=!e(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=u?{left:0,top:0}:{left:t.pageX-l.left-n.width()/2,top:t.pageY-l.top-n.height()/2-(parseInt(n.css("borderTopWidth"),10)||0)-(parseInt(n.css("borderBottomWidth"),10)||0)+(parseInt(n.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,h,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(e){var t={x:e.pageX,y:e.pageY},i=this._normValueFromMouse(t);return this._slide(e,this._handleIndex,i),!1},_mouseStop:function(e){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(e,this._handleIndex),this._change(e,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(e){var t,i,s,a,n;return"horizontal"===this.orientation?(t=this.elementSize.width,i=e.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(t=this.elementSize.height,i=e.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),(s=i/t)>1&&(s=1),s<0&&(s=0),"vertical"===this.orientation&&(s=1-s),a=this._valueMax()-this._valueMin(),n=this._valueMin()+s*a,this._trimAlignValue(n)},_uiHash:function(e,t,i){var s={handle:this.handles[e],handleIndex:e,value:void 0!==t?t:this.value()};return this._hasMultipleValues()&&(s.value=void 0!==t?t:this.values(e),s.values=i||this.values()),s},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(e,t){return this._trigger("start",e,this._uiHash(t))},_slide:function(e,t,i){var s,a=this.value(),n=this.values();this._hasMultipleValues()&&(s=this.values(t?0:1),a=this.values(t),2===this.options.values.length&&!0===this.options.range&&(i=0===t?Math.min(s,i):Math.max(s,i)),n[t]=i),i!==a&&!1!==this._trigger("slide",e,this._uiHash(t,i,n))&&(this._hasMultipleValues()?this.values(t,i):this.value(i))},_stop:function(e,t){this._trigger("stop",e,this._uiHash(t))},_change:function(e,t){this._keySliding||this._mouseSliding||(this._lastChangedValue=t,this._trigger("change",e,this._uiHash(t)))},value:function(e){return arguments.length?(this.options.value=this._trimAlignValue(e),this._refreshValue(),void this._change(null,0)):this._value()},values:function(t,i){var s,a,n;if(arguments.length>1)return this.options.values[t]=this._trimAlignValue(i),this._refreshValue(),void this._change(null,t);if(!arguments.length)return this._values();if(!e.isArray(arguments[0]))return this._hasMultipleValues()?this._values(t):this.value();for(s=this.options.values,a=arguments[0],n=0;n<s.length;n+=1)s[n]=this._trimAlignValue(a[n]),this._change(null,n);this._refreshValue()},_setOption:function(t,i){var s,a=0;switch("range"===t&&!0===this.options.range&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),e.isArray(this.options.values)&&(a=this.options.values.length),this._super(t,i),t){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(i),this.handles.css("horizontal"===i?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=a-1;s>=0;s--)this._change(null,s);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(e){this._super(e),this._toggleClass(null,"ui-state-disabled",!!e)},_value:function(){var e=this.options.value;return e=this._trimAlignValue(e)},_values:function(e){var t,i,s;if(arguments.length)return t=this.options.values[e],t=this._trimAlignValue(t);if(this._hasMultipleValues()){for(i=this.options.values.slice(),s=0;s<i.length;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(e){if(e<=this._valueMin())return this._valueMin();if(e>=this._valueMax())return this._valueMax();var t=this.options.step>0?this.options.step:1,i=(e-this._valueMin())%t,s=e-i;return 2*Math.abs(i)>=t&&(s+=i>0?t:-t),parseFloat(s.toFixed(5))},_calculateNewMax:function(){var e=this.options.max,t=this._valueMin(),i=this.options.step;(e=Math.round((e-t)/i)*i+t)>this.options.max&&(e-=i),this.max=parseFloat(e.toFixed(this._precision()))},_precision:function(){var e=this._precisionOf(this.options.step);return null!==this.options.min&&(e=Math.max(e,this._precisionOf(this.options.min))),e},_precisionOf:function(e){var t=e.toString(),i=t.indexOf(".");return-1===i?0:t.length-i-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(e){"vertical"===e&&this.range.css({width:"",left:""}),"horizontal"===e&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var t,i,s,a,n,h=this.options.range,l=this.options,u=this,r=!this._animateOff&&l.animate,o={};this._hasMultipleValues()?this.handles.each(function(s){i=(u.values(s)-u._valueMin())/(u._valueMax()-u._valueMin())*100,o["horizontal"===u.orientation?"left":"bottom"]=i+"%",e(this).stop(1,1)[r?"animate":"css"](o,l.animate),!0===u.options.range&&("horizontal"===u.orientation?(0===s&&u.range.stop(1,1)[r?"animate":"css"]({left:i+"%"},l.animate),1===s&&u.range[r?"animate":"css"]({width:i-t+"%"},{queue:!1,duration:l.animate})):(0===s&&u.range.stop(1,1)[r?"animate":"css"]({bottom:i+"%"},l.animate),1===s&&u.range[r?"animate":"css"]({height:i-t+"%"},{queue:!1,duration:l.animate}))),t=i}):(s=this.value(),a=this._valueMin(),n=this._valueMax(),i=n!==a?(s-a)/(n-a)*100:0,o["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[r?"animate":"css"](o,l.animate),"min"===h&&"horizontal"===this.orientation&&this.range.stop(1,1)[r?"animate":"css"]({width:i+"%"},l.animate),"max"===h&&"horizontal"===this.orientation&&this.range.stop(1,1)[r?"animate":"css"]({width:100-i+"%"},l.animate),"min"===h&&"vertical"===this.orientation&&this.range.stop(1,1)[r?"animate":"css"]({height:i+"%"},l.animate),"max"===h&&"vertical"===this.orientation&&this.range.stop(1,1)[r?"animate":"css"]({height:100-i+"%"},l.animate))},_handleEvents:{keydown:function(t){var i,s,a,n=e(t.target).data("ui-slider-handle-index");switch(t.keyCode){case e.ui.keyCode.HOME:case e.ui.keyCode.END:case e.ui.keyCode.PAGE_UP:case e.ui.keyCode.PAGE_DOWN:case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(t.preventDefault(),!this._keySliding&&(this._keySliding=!0,this._addClass(e(t.target),null,"ui-state-active"),!1===this._start(t,n)))return}switch(a=this.options.step,i=s=this._hasMultipleValues()?this.values(n):this.value(),t.keyCode){case e.ui.keyCode.HOME:s=this._valueMin();break;case e.ui.keyCode.END:s=this._valueMax();break;case e.ui.keyCode.PAGE_UP:s=this._trimAlignValue(i+(this._valueMax()-this._valueMin())/this.numPages);break;case e.ui.keyCode.PAGE_DOWN:s=this._trimAlignValue(i-(this._valueMax()-this._valueMin())/this.numPages);break;case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:if(i===this._valueMax())return;s=this._trimAlignValue(i+a);break;case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(i===this._valueMin())return;s=this._trimAlignValue(i-a)}this._slide(t,n,s)},keyup:function(t){var i=e(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,i),this._change(t,i),this._removeClass(e(t.target),null,"ui-state-active"))}}})});
},{}],41:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
  modal = require('./modal').global,
  customModal = require('./modal'),
  page = require('./page'),
  util = require('./util'),
  index = require('./pages/product/index'),
  formPrepare = require('./pages/checkout/formPrepare'),
  validator = require('./validator');

var login = {
  /**
   * @private
   * @function
   * @description init events for the loginPage
   */
  init: function () {
    //o-auth binding for which icon is clicked
    $('.oAuthIcon').bind('click', function () {
      $('#OAuthProvider').val(this.id);
    });

    //toggle the value of the rememberme checkbox
    $('#dwfrm_login_rememberme').bind('change', function () {
      if ($('#dwfrm_login_rememberme').attr('checked')) {
        $('#rememberme').val('true');
      } else {
        $('#rememberme').val('false');
      }
    });
  },
  wishlistAjaxLogin: function (form) {
    var _this = this;
    $(form)
      .off('submit.wishlistAjaxLogin')
      .on('submit.wishlistAjaxLogin', function (event) {
        event.preventDefault();
        var url = $(form).attr('action');
        var data =
          $(form).serialize() +
          '&' +
          $(form).find('#login').attr('name') +
          '=x';

        url = util.appendParamToURL(url, 'format', 'ajax');
        url = util.appendParamToURL(url, 'scope', 'wishlist');

        $('.login-wrapper .ajax-loader').show();
        $.ajax({
          type: 'post',
          url: url,
          data: data
        }).done(function (response) {
          if (response !== '' && response !== null) {
            if (response.success) {
              window.location.href = response.url;
            } else {
              $('.login-modal').find('.modal-body').html(response);
              index.bodyPositionFixed('login-modal');
              var windowWidth = $(window).width();
              $('.modal-overlay .modal-body').addClass('login-modal-height');
              validator.initForm('.login-modal form[id$="dwfrm_login"]');
              _this.wishlistAjaxLogin('.login-modal form[id$="dwfrm_login"]');
              $('.login-wrapper .ajax-loader').hide();
            }
          } else {
            location.reload();
            if ($('.pt_articles_listing').length) {
              var offsetTop = '';
              if ($('.header-wrapper').css('position') === 'fixed') {
                offsetTop = $('#main').offset().top;
              } else {
                offsetTop =
                  $('#main').offset().top - $('.header-wrapper').height();
              }
              $(window).scrollTop(offsetTop);
            }
          }
        });
      });
  },
  wishListButtonEnableDisable: function () {
    //Guest Checkout
    if ($('.login-wrapper').length) {
      var emailButton2 = $('.login-wrapper button#login'),
        emailInput2 = $('.login-wrapper input[type="email"]'),
        password = $('.login-wrapper input[type="password"]');
      $(emailInput2, password).on('blur', function () {
        var email_regx = validator.regex.email;
        if (email_regx.test(emailInput2.val())) {
          if (
            !password.val().length ||
            login.enableDisableSubmitButton(emailButton2)
          ) {
            emailButton2.prop('disabled', 'disabled');
          } else {
            emailButton2.prop('disabled', false);
          }
        } else {
          emailButton2.prop('disabled', 'disabled');
        }
      });
      if (!emailInput2.val().length || !password.val().length) {
        emailButton2.prop('disabled', 'disabled');
      }
    }
  },
  enableDisableSubmitButton: function (el) {
    var $saveBtn = $(el).closest('form').find('button[type="submit"]');
    var hasError = $saveBtn.closest('form').find('span.error');
    if (hasError.length) {
      return true;
    } else {
      return false;
    }
  }
};

//Reset Password
$(document).on('click', '.password-reset', function (e) {
  e.preventDefault();
  var ajaxUrl;
  ajaxUrl = util.appendParamToURL(Urls.securePasswordReset, 'format', 'ajax');
  $.ajax({
    type: 'GET',
    url: ajaxUrl
  }).done(function (response) {
    if (response !== '' && response !== null && response.error === undefined) {
      customModal.createCustomModal('forgot-password-modal');
      $('.forgot-password-modal').find('.modal-body').html(response);
      validator.initForm('.forgot-password-modal form');
      var $requestPasswordForm = $('[name$="_requestpassword"]');
      var $submit = $requestPasswordForm.find(
        '[name$="_requestpassword_send"]'
      );
      $($submit).on('click', function (e) {
        if (!$requestPasswordForm.valid()) {
          return;
        }
        e.preventDefault();
        var data = $requestPasswordForm.serialize();
        // add form action to data
        data += '&' + $submit.attr('name') + '=';
        // make sure the server knows this is an ajax request
        if (data.indexOf('ajax') === -1) {
          data += '&format=ajax';
        }
        $.ajax({
          type: 'POST',
          url: $requestPasswordForm.attr('action'),
          data: data,
          success: function (response) {
            if (
              typeof response === 'object' &&
              !response.success &&
              response.error === 'CSRF Token Mismatch'
            ) {
              page.redirect(Urls.csrffailed);
            } else if (typeof response === 'string') {
              $('.forgot-password-modal').find('.modal-body').html(response);
            }
          },
          failure: function () {
            $('.forgot-password-modal')
              .find('.modal-body')
              .html('<h1>' + Resources.SERVER_ERROR + '</h1>');
          }
        });
      });
    }
  });
});

module.exports = login;

///Login Greetings
if (
  window.User.isCustomerAuthenticated != false ||
  window.User.isRegistered == true
) {
  var myDate = new Date();
  var hrs = myDate.getHours();
  var mins = myDate.getMinutes();
  var time;
  var greeting;

  mins = ('0' + mins).slice(-2);
  time = hrs + mins;
  time = Number(time);

  if (time >= 300 && time <= 1159) {
    greeting = window.Resources.GREETINGS_MORNING;
  } else if (time >= 1200 && time <= 1700) {
    greeting = window.Resources.GREETINGS_AFTERNOON;
  } else {
    greeting = window.Resources.GREETINGS_EVENING;
  }

  $('#login-greetings').text(greeting);
  $('.menu-greeting #login-greetings').text(greeting);
}

},{"./dialog":31,"./modal":43,"./page":46,"./pages/checkout/formPrepare":54,"./pages/product/index":70,"./util":105,"./validator":106}],42:[function(require,module,exports){
'use strict';

var util = require('./util'),
  bonusProductsView = require('./bonus-products-view'),
  samples = require('./samples'),
  currentLayout = require('./detect-layout');

var checkLayout = currentLayout.init();

var timer = {
  id: null,
  clear: function () {
    if (this.id) {
      window.clearTimeout(this.id);
      delete this.id;
    }
  },
  start: function (duration, callback) {
    this.id = setTimeout(callback, duration);
  }
};

var minicart = {
  init: function () {
    this.$el = $('#mini-cart');
    this.$elMobile = $('#mini-cart-mobile');
    this.$content = this.$el.find('.mini-cart-content');

    // events
    this.$el.find('.mini-cart-total').on(
      'mouseenter',
      function () {
        if (this.$content.not(':visible')) {
          this.slide();
        }
      }.bind(this)
    );

    this.$content
      .on('mouseenter', function () {
        timer.clear();
      })
      .on(
        'mouseleave',
        function () {
          timer.clear();
          timer.start(200, this.close.bind(this));
        }.bind(this)
      );
  },

  addProduct: function (data) {
    var show = this.show.bind(this);

    return new Promise(function (resolve, reject) {
      if (data.hasOwnProperty('pid') === false) {
        return reject();
      }

      // FIXME: add csrf_token to post parameter.
      $.post(
        util.appendParamsToUrl(Urls.addProduct, {
          format: 'ajax',
          pid: encodeURIComponent(data.pid),
          Quantity: data.hasOwnProperty('Quantity') ? data.Quantity : '1'
        }),
        function (data) {
          if (data.success === false) {
            return reject(data.error);
          }

          show(data);
          resolve();
        }
      ).fail(function (err) {
        reject(err.error);
      });
    });
  },

  addAllToWishlistFromContent: function (pids) {
    return (window.location.href =
      Urls.addAllFromContent +
      '?pid=' +
      pids.join(':1,') + // pass qty of one
      '&cid=' +
      window.contentAssetID +
      '&hashparam=' +
      window.location.hash.split('#')[1]);
  },

  addAllProducts: function (pids, to) {
    if (!pids || pids.length === 0) {
      return;
    }

    var isWishlist = to && to.toLowerCase() === 'wishlist';
    if (isWishlist && !window.User.isCustomerAuthenticated) {
      if (window.contentAssetID) {
        return this.addAllToWishlistFromContent(pids);
      } else {
        var footerURL = $('footer') ? $('footer').data('url') : null;
        window.location = util.appendParamToURL(
          Urls.showLogin,
          'original',
          footerURL
        );
        return;
      }
    }

    var show = this.show.bind(this);
    var urlName = Urls.addMultipleProducts;

    if (isWishlist) {
      urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
    }

    $.post(
      util.appendParamsToUrl(urlName, {
        format: 'ajax',
        pid: pids
      }),
      function (data) {
        if (isWishlist) {
          window.location.href = window.location.href;
          return;
        }

        if (data) {
          show(data);
        }
      }
    );
  },

  /**
   * @function
   * @description Shows the given content in the mini cart
   * @param {String} A HTML string with the content which will be shown
   */
  show: function (html) {
    var currentPosition = $('.header-wrapper').css('position');
    var headerHight = $('.header-wrapper').height() + 'px';
    if ($('.header-wrapper').css('position') != 'fixed') {
      $('.header-wrapper').css('position', 'fixed');
      $('.top-wrapper').css('padding-bottom', headerHight);
    }
    if (html && $('.minicart-link').length > 0) {
      $('.minicart-link.desktop-only').html(html);
      var timeOut = 3000;
      $('.minicart-link.mobile-only').html(html);
      if (checkLayout == 'mobile') {
        $('.minicart-link.mobile-only').find('.mini-cart-content').remove();
        $('body').addClass('add-to-confirmation');
        // LPページからカートインした場合はページ上部にスクロールさせない
        if ($('.product-add-to-cart.lp-text-block').length === 0) {
          $('html, body').animate({ scrollTop: 0 }, 500);
        }
        timeOut = 3000;
      }
      if ($('.add-cart-confirmation-product>div').length) {
        $('.minicart').addClass('confirmation-active');
        if (
          checkLayout == 'mobile' &&
          !$('div').hasClass('confirmation-footer')
        ) {
          var confirmationFooterHightPx = 34; // サンプルが選択されてない状態で表示されるfooterの高さ
          $('#minicart').height(
            $('#minicart').height() - confirmationFooterHightPx
          );
        }
      }
      $('.sb-container').scrollBox();
    }
    setTimeout(function () {
      $('.header-wrapper').css('position', currentPosition);
      $('.top-wrapper').removeAttr('style');
    }, timeOut);

    // identify if we can show the sample overlay
    var canShowSamples = false;
    $(document)
      .find('#minicart input[name="eligible-for-sample"]')
      .each(function () {
        if (!canShowSamples && $(this).val() == 'true') {
          canShowSamples = true;
        }
      });

    if (
      bonusProductsView.hasBonusOptions() === false &&
      samples.canShowSelection() &&
      canShowSamples
    ) {
      samples.showSelection();
    }

    bonusProductsView.loadBonusOption();
  },
  /**
   * @function
   * @description Slides down and show the contents of the mini cart
   */
  slide: function () {
    timer.clear();
    // show the item
    this.$content.slideDown('slow');
    this.$content.attr('aria-expanded', true);
    // after a time out automatically close it
    timer.start(6000, this.close.bind(this));
  },
  /**
   * @function
   * @description Closes the mini cart with given delay
   * @param {Number} delay The delay in milliseconds
   */
  close: function (delay) {
    $('.minicart').removeClass('confirmation-active');
    $('body').removeClass('add-to-confirmation');
    $('.minicart').hide();
  },
  remove: function (pid) {
    const CSRF_TOKEN_MISMATCH = 'CSRF Token Mismatch';
    $('.mini-cart-products .ajax-loader').show();
    $.post(
      util.appendParamsToUrl(Urls.removeMiniCartLineItem, {
        format: 'ajax',
        pid: pid,
        csrf_token: $('.mini-cart-token').val()
      }),
      function (data) {
        if (data.error === CSRF_TOKEN_MISMATCH) {
          window.location.href = Urls.csrffailed;
          return false;
        }
        if (data) {
          $('.minicart').parent('li').html(data);
          $('.sb-container').scrollBox();

          // PDP処理
          //カート追加ボタン有効
          if (!$('#minicart').length) {
            let selectedProductIds = getKitSelectedProductsIds();
            if (isAllCategoryItemSelected(selectedProductIds)) {
              $('input[name="kit_add_product"]').removeAttr('disabled');
            }
            $('.kit-result__error_cart_desktop').data('product-same', false);
            let errorElements = $(
              '.kit-result__error_cart_desktop, #kit-error'
            );
            errorElements.css('display', 'none');
          }
        }
      }
    ).fail(function (err) {
      reject(err.error);
    });
  }
};

function getKitSelectedProductsIds() {
  let i = 0;
  let ids = [];
  while (true) {
    // キット画面の選択済み商品フォームから情報を取得。同じnameが2つあるので :first 指定
    let id = $('input[name=' + i + '_id]:first').val();
    if (id === undefined) break;
    ids.push(id);
    i++;
  }
  return ids;
}

function isAllCategoryItemSelected(selectedProductIds) {
  return selectedProductIds.every(function (id) {
    return id !== '';
  });
}

/**
 * Global add to cart
 */
$('.global-add-to-cart').click(function () {
  var _this = $(this);
  var skuData = _this.data('sku');
  minicart.addProduct({ pid: skuData });
});

$(document).on('click', '.remove-link .icon-close', function () {
  minicart.remove($(this).data('pid'));
});

$(document).on('click', '.minicart-link .bag-icon', function (e) {
  if (checkLayout == 'desktop') {
    e.preventDefault();
    return false;
  }
});
$(document).on('mouseover', '.minicart-link .forLink', function (e) {
  $('.minicart').removeAttr('style');
  if ($('.minicart-link .sb-container .sb-content').length === 0) {
    $('.sb-container').scrollBox();
  } else {
    $('.minicart-link .sb-container .sb-content').removeAttr('style');
    $(window).trigger('resize.scrollBox');
  }
});
$(document).on('click', '.minicart-close, header, #main', function (e) {
  minicart.close();
});
$(document).mouseup(function (e) {
  var minicartContainer = $('.minicart'); //ミニカートdiv class名
  var sampleModal = $('.modal-wrapper'); //モーダルのclass名
  var sampleModalOuter = $('.modal-close-outer'); //モーダルが閉じられる領域class名
  var isClickedInsideSampleModal =
    sampleModal.is(e.target) && sampleModal.has(e.target).length > 0;
  var isClickedCloseModalPart =
    sampleModalOuter.is(e.target) && sampleModalOuter.has(e.target).length > 0;
  var isClickedOutsideMinicartDiv =
    !minicartContainer.is(e.target) &&
    minicartContainer.has(e.target).length === 0;

  if (
    isClickedInsideSampleModal &&
    isClickedCloseModalPart &&
    isClickedOutsideMinicartDiv
  ) {
    minicart.close();
  }
});

module.exports = minicart;

},{"./bonus-products-view":22,"./detect-layout":30,"./samples":95,"./util":105}],43:[function(require,module,exports){
var util = require('./util'),
	modalContainer  = '';

function customModal() {
	$('[data-modal="true"]').on('click', function(e) {
		e.preventDefault();
		var elementID = $(this).attr('data-modal-id'),
			modal = document.getElementById(elementID);
		customModalOpen(modal);
	});
	$(document).on('click', '.modal-close, .modal-close-outer, .modal-close-btn', function() {
		var modal = $(this).closest('.modal-overlay');
		if($('.modal-overlay.bonus-sample-selection.error').length > 0){
			$('.modal-overlay.bonus-sample-selection').removeClass('error');
		}
		customModalClose(modal);
	});
}

function createCustomModal(id, container) {
	var modalStructure = [],
		modal = document.createElement('div');

	modalContainer = container || 'body';
	modal.id= id;
	modal.className='modal-overlay ' + id;
	$(modal).html('<div class="modal-close-outer"></div><div class="modal-wrapper"><div class="icon-close modal-close"></div><div class="modal-body"></div></div>');
	modalStructure.push(modal);
	$(modalContainer).append(modalStructure);
	customModalOpen(modal);
	$('#wrapper').css('pointer-events','none');
	$('.header-wrapper').css('transform','translate3d(0px,-100%,0)');
	customModalRemove(modal);
}

function customModalOpen(modal) {
	$(modal).show();
	if(modalContainer === '' || modalContainer === 'body') {
		$('html').addClass('modal-open');
		if ($('body').find('.pt_checkout').length != 0 ) {
			$('body').addClass('showing_modal');
		}
	}
}

function customModalClose(modal) {
	$(modal).hide();
	$('html').removeClass('modal-open');
	$('html').css('overflow', 'auto');
	$('body').removeClass('showing_modal');
	$('body').removeClass('body-fixed');
	$('body').css('overflow', 'auto');
	setTimeout(function () {
		$('#wrapper').removeAttr('style');
		$('.header-wrapper').css('transform','');
	},1)
}

function customModalRemove(modal) {
	var eventType = ('ontouchstart' in window) ? 'touchend' : 'click';
	$(document).on(eventType, '.modal-close, .modal-close-outer', function() {
		if(!$(this).closest('.modal-overlay').hasClass('data-modal')){
			$(this).closest('.modal-overlay').remove();
		}
		$('html').removeClass('modal-open');
		$('html').css('overflow', 'auto');
		$('body').removeClass('showing_modal');
		$('body').removeClass('body-fixed');
		$('body').css('overflow', 'auto');
		setTimeout(function () {
			$('#wrapper').removeAttr('style');
			$('.header-wrapper').css('transform','');
		},1)
	});
}

function Modal(modalCntr, modalBody, option) {
    this.$cntr = $(modalCntr);
    this.$body = $(modalBody);
    
    this.callbackFn = null;

    this.events = {
        onOpen: function (cb) {
            $(document).off('open.zf.reveal').on('open.zf.reveal', function () {
                cb();
                $(document).off('open.zf.reveal');
            });
        },

        onClose: function (cb) {
            $(document).off('closed.zf.reveal').on('closed.zf.reveal', function () {
                cb();
                $(document).off('closed.zf.reveal');
            });
        }
    };
}

Modal.prototype.open = function () {
    this.modal.open();
};

Modal.prototype.close = function () {
    this.modal.close();
};

Modal.prototype.restoreDefaultClass = function () {
	this.$cntr.removeAttr('class');
	this.$cntr.attr('class','reveal');
};

Modal.prototype.addCustomClass = function(customClass){
	this.restoreDefaultClass();
	this.$cntr.addClass(customClass);
};

Modal.prototype.setContent = function (content) {
    return this.$body.html(content);
};

Modal.prototype.renderContent = function(content, type) {
    var classType = type || '';

    this.$body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
    this.modal.open();

    if(typeof this.callbackFn === 'function') {
    	this.callbackFn();
    	this.callbackFn = null; // clear after each use
    }
};

Modal.prototype.renderByUrl = function (contentUrl) {
    return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent.bind(this));
};

Modal.prototype.setCallback = function (cb) {
	this.callbackFn = cb;
};

module.exports.global = new Modal("#modal-cntr", ".modal-body", {}); // global modal
module.exports.create = function (modalCntr, modalBody, option) {
    return new Modal(modalCntr, modalBody, option);
};
module.exports.modal = function() {return customModal();};
exports.createCustomModal = function(id, container) {createCustomModal(id, container)};


},{"./util":105}],44:[function(require,module,exports){
'use strict';

var util = require('./util'),
	validator = require('./validator'),
    modal = require('./modal').global,
    index = require('./pages/product/index'),
    customModal = require('./modal');


function isNewsletterEnabled() {
    $('.register-newsletter').removeClass('hide');
    $('.newsletter-success').addClass('hide');

    if (!enableNewsletter) {
        return;
    }

    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    var isViewedNewsletterValid = util.getCookieSelector(hasViewedNewsletter);

    if (isViewedNewsletterValid === 'true') {
        return;
    }

    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

    if (isDisplayedNewsletterValid === 'false') {
        return;
    }

    util.setCookie(hasViewedNewsletter, false, newsletterCookieDuration);
    util.setCookie(shouldDisplayNewsletter, true, newsletterCookieDuration);

    setNewsletterCounterCookie();
    signUpEventListener();
    NewsletterModal();
}

function setNewsletterCounterCookie() {
    var pageViewCount = [siteId, 'pageViewCount'].join('-');
    var isCookieValid = util.getCookieSelector(pageViewCount);
    var counterCookie = Number(isCookieValid);

    if (!isCookieValid) {
        counterCookie = 0;
    } else {
        counterCookie += 1;
    }

    util.setCookie(pageViewCount, counterCookie, newsletterCookieDuration);
}

function signUpEventListener() {
    $(document)
        .on('submit', '.modal-content .news-letter-form', function (e) {
            e.preventDefault();

            var emailAddress = $('.modal-content input').val();
            validateNewsletterEmail(true, emailAddress);
        })

        .on('keyup blur', '.modal-content input', function (e) {
            var emailAddress = $(this).val();

            $('.modal-content button').prop('disabled', false);
            $('.modal-content button').css('color', '');

            if (!emailAddress.length) {
                $('.modal-content button').prop('disabled', true);
                $('.modal-content button').css('color', '#FFFFFF');
            }
        });
}

function newsletterHeader() {
    $(document).on('submit', '.newsletter-content .news-letter-form', function (e) {
        e.preventDefault();

        var emailAddress = $('.news-letter-form input').val();
        validateNewsletterEmail(false, emailAddress);
    });
}

function validateNewsletterEmail(isModal, emailAddress) {
    var validateClass = '.news-letter-form';

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
    $(validateClass + ' span').remove();

    if (!util.validateEmail(emailAddress)) {
        var errorMessage;

        if (isModal) {
            errorMessage = [
                '<span id="-error" class="error">',
                Resources.VALIDATE_EMAIL,
                '</span>'
            ].join('');

            $(validateClass + ' .promotions-container').after(errorMessage);
            $(validateClass + ' button').prop('disabled', true);
        } else {
            errorMessage = [
                '<span id="-error" class="error">',
                Resources.VALIDATE_EMAIL,
                '</span>'
            ].join('');

            $(validateClass + ' input').before(errorMessage);
        }
    }
    
    if (isModal) {
        setHasViewedNewsletterCookie(true);
    }
    
    if($('.news-letter-form').length > 0){
    	var dataToPost = 'email='+ emailAddress + '&' + $('.news-letter-form').serialize() + '&source=' + (isModal ? 'modal' : 'header');
    	$.ajax({
            type: 'POST',
            url: $('.news-letter-form').attr('action'),
            async: false,
            data: dataToPost,
            success: function (response) {
                if (isModal) {
                    modal.renderContent(response);
                    modal.addCustomClass('newsletter-signup-modal');
                    $(document).trigger("clicknewsletter",{"siteloc":"pop-up"});
                } else {
                    $('.newsletter-content').html(response);
                    $(document).trigger("clicknewsletter",{"siteloc":"navbar"});
                }
                if(window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')){
                	window.universal_variable.user.email = emailAddress;
                }
            }
        });
    }
    
}

function NewsletterModal(){
    $(document).on('click', '.newsletter-modal-btn', function(e) {
        e.preventDefault();
        if($('.newsletter-modal').length === 0){
            var ajaxUrl;
            ajaxUrl = util.appendParamToURL(Urls.showNewsletter, 'format', 'ajax')
            $.ajax({
                type: 'GET',
                url: ajaxUrl
            })
            .done(function (response) {
                if(response !== '' && response !== null && response.error === undefined){
                    customModal.createCustomModal('newsletter-modal');
                    $('.newsletter-modal').find('.modal-body').html(response);
                    index.bodyPositionFixed('newsletter-modal');
                    validator.initForm('.newsletter-modal form');
                }
            });
        }
    });
    $(document).on('click', '.newsletter-modal .continue-shopping .primary', function(e) {
        $('.newsletter-modal .modal-close').trigger('click');
    })
}

function setHasViewedNewsletterCookie(val) {
    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    util.setCookie(hasViewedNewsletter, val, newsletterCookieDuration);
}

exports.isNewsletterEnabled = isNewsletterEnabled;
exports.newsletterHeader = newsletterHeader;
},{"./modal":43,"./pages/product/index":70,"./util":105,"./validator":106}],45:[function(require,module,exports){
'use strict';

var modal = require('./modal').global, 
	util = require('./util'),
	customModal = require('./modal');

exports.init = function init() {
	$('.bottom-section-left  select').on( "selectmenuchange", function( event, ui ) {
		event.preventDefault();
		$(this).parents('.bottom-section').find('.view-detail-btn-container a').removeClass('disabled');
	});
	
	//pdp replenishment edit button
	$(document).on('click', '.order-replenishment-edit', function() {
		if ($(this).data('url')) {
			var hash = $(this).attr('href');
			window.location = $(this).data('url')+hash;
		}
	});

	$(document).on('click', '.replenishment .info-link', function() {
		$(window).trigger("resize.scrollBox");
		$('.replenishment-info-modal .modal-body').scrollBox();
	});
	
	//Update the Order replenishment suggestion based on product variant sizeVariations	
	$("input[name=size]").click(function() {
		//Get the recommendation from the input data-isreplenishable
		var replennumber = this.getAttribute('data-isreplenishable');

		//Construct the replenishment message
		var replenmsg = "";
		if(replennumber !== null && replennumber > 0){
			var message = Resources.RECOMMENDED_REPLENISHMENT;

			replenmsg += message;
			replenmsg += replennumber;			
			replenmsg += " ";
			replenmsg += replennumber > 1 ? "${spanPlural}" : "${span}";
			replenmsg += ".";
		}

		//Assign it to replenreccomendation
		$("#replenrecommendation").text(replenmsg);
	});
	
	//My Account Replenishment Update Button
	$( ".replenishmentupdate" ).click(function(e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var uuid = getQueryValue("rid", href);
		var rdays = $("." + uuid.substring(0,26) + "_days").val();
		var replenishmentQuantity = $("." + uuid.substring(0,26) + "_quantity").val();
		var updateReplenishment = href + "&rdays=" + rdays + "&qty=" + replenishmentQuantity;
		window.location = updateReplenishment;
	});

	// Gets the query string value if it exists, returns null if it does not.
	// Example: getQueryValue("reset") will return the value true if the URL is http://www.domain.com?reset=true
	function getQueryValue(str,href) 
	{
		var queryString = href;
		var queries = queryString.split("?");
		for (var i=0;i<queries.length;i++) {
			var ft = queries[i].split("=");
			if (ft[0] == str) {
				return ft[1];
			}
		}
		return null;
	}
	//My Account Replenishment Cancel Button
	$( ".replenishmentcancel" ).click(function(e) {
		e.preventDefault();
		var modalBody = $('#cancel-replenishment').html();
		customModal.createCustomModal('replenishment-cancel-modal' );
		$('.replenishment-cancel-modal').find('.modal-body').html(modalBody);
		
		var href = $(this).attr('href');
		
		$( ".modal-btn-confirm" ).click(function() {
			window.location = href;
		});
		
		$( ".modal-btn-keep" ).click(function() {
			$('.replenishment-cancel-modal .modal-close').trigger('click');
		});
	});

	//Replenishment info popup close 
	$(document).on('click','.rep-modal-close', function(e){
		e.preventDefault();
		var modal = $(this).closest('.modal-overlay');
		$(modal).hide();
		$('html').removeClass('modal-open');
	});
};

},{"./modal":43,"./util":105}],46:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":105}],47:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
  tooltip = require('../tooltip'),
  util = require('../util'),
  dialog = require('../dialog'),
  page = require('../page'),
  login = require('../login'),
  modal = require('../modal').global,
  customModal = require('../modal'),
  cardValidation = require('./checkout/card-validation'),
  validator = require('../validator'),
  search = require('./search'),
  productTile = require('../product-tile'),
  currentLayout = require('../detect-layout'),
  index = require('./product/index'),
  currLayout = currentLayout.init(),
  paymentinstruments = require('./paymentinstruments');

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
  $('.order-items')
    .find('li.hidden:first')
    .prev('li')
    .append('<a class="toggle">View All</a>')
    .children('.toggle')
    .click(function () {
      $(this).parent().siblings('li.hidden').show();
      $(this).remove();
    });
}

/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
  var addresses = $('#addresses');
  if (addresses.length === 0) {
    return;
  }

  $(document)
    .on('click', '.address-create', function (e) {
      e.preventDefault();
      $('.ajax-loader').show();
      $.ajax({
        url: util.appendParamToURL(
          Urls.checkoutAddAccountAddress,
          'format',
          'ajax'
        ),
        dataType: 'html',
        success: function (response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address').find('.modal-body').html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
          }
        }
      }).complete(function (data) {
        $('select').selectmenu();
        $('.edit-add-address .modal-body').scrollBox();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');
      });
    })
    .on('click', '.account-address-edit', function (evt) {
      var element = document.getElementById(evt.currentTarget.id);
      var addressID = element.dataset.addressId;
      var addressCode = element.dataset.addressCode;
      var url = Urls.checkoutEditAccountAddress + encodeURIComponent(addressID);
      $('.ajax-loader').show();
      $.ajax({
        url: util.appendParamToURL(url, 'format', 'ajax'),
        dataType: 'html',
        success: function (response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address').find('.modal-body').html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
          }
        }
      }).complete(function (data) {
        $('select').selectmenu();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');
        $('.edit-add-address .modal-body').scrollBox();
      });
    })
    .on('click', '.address-delete', function () {
      var href = $(this).attr('href');
      $('.remove-address-cc-cta')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          $.ajax({
            url: util.appendParamToURL(href, 'format', 'ajax'),
            dataType: 'json'
          }).done(function (data) {
            location.reload();
          });
        });
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
  $(document)
    .on('click', '.credit-card-create', function (evt) {
      evt.preventDefault();
      $('.ajax-loader').show();
      $.ajax({
        url: util.appendParamToURL(
          window.Urls.myaccountAddCreditCard,
          'format',
          'ajax'
        ),
        dataType: 'html',
        success: function (response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('add-credit-card');
            $('.add-credit-card').find('.modal-body').html(response);
            index.bodyPositionFixed('add-credit-card');
            creditCardTypeDetector();
            validator.initForm('form[id$="CreditCardForm"]');
            $('.ajax-loader').hide();
          }
        }
      }).complete(function (data) {
        $('.add-credit-card .modal-body').scrollBox();
        $('form[id$="CreditCardForm"] .input-text.cvn').val('');
        $('select').selectmenu();
        cardValidation.init();
      });
    })
    .on('submit', '#CreditCardForm', function (evt) {
      evt.preventDefault();
      var $form = $(this);
      $.ajax({
        url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
        data:
          $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
        type: 'POST'
      }).done(function (data) {
        if (data.length) {
          window.location.reload();
        }
      });
    });

  $('form.remove-card-form button.delete').on('click', function (e) {
    e.preventDefault();
    var $button = $(this);
    var $form = $button.closest('form.remove-card-form');

    $('.remove-address-cc-cta').unbind();
    $('.remove-address-cc-cta').click(function () {
      $('<input/>')
        .attr({
          type: 'hidden',
          name: $button.attr('name'),
          value: $button.attr('value') || 'delete card'
        })
        .appendTo($form);
      var data = $form.serialize();

      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: data
      }).done(function () {
        location.reload();
      });
    });
  });
}

function registerAccountEvents() {
  // get the field elements
  var $gender = $('.registration-box #dwfrm_profile_customer_gender');
  var $newsletterCB = $(
    '.registration-box #dwfrm_profile_customer_addtoemaillist'
  );

  $gender.on('selectmenuchange', function (e) {
    $(this)
      .closest('form')
      .find('button[type="submit"]')
      .prop('disabled', false);
  });
  $newsletterCB.on('change', function (e) {
    $(this)
      .closest('form')
      .find('button[type="submit"]')
      .prop('disabled', false);
  });
}
function initContactUs() {
  var registrationForm = $('form#RegistrationForm');

  registrationForm.on('click', 'button#sendBtn', function (e) {
    e.preventDefault();

    $.ajax({
      url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
      data: registrationForm.serialize(),
      method: 'POST'
    }).done(function (response) {
      if (response.status) {
        var modalBody = $('#contact-response').html();
        customModal.createCustomModal('customer-contact-us-modal');
        $('.customer-contact-us-modal').find('.modal-body').html(modalBody);

        clearContactUsForm();
      }
    });
  });
}
function initAsktheExpert() {
  var askexpertform = $('form#dwfrm_beautyconsultant');
  askexpertform.on('click', 'button#sendBtn', function (e) {
    e.preventDefault();
    $('.ajax-loader').show();
    var hasError = askexpertform.find('span.error');
    $.ajax({
      url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
      data: askexpertform.serialize(),
      method: 'POST'
    }).done(function (response) {
      if (!hasError.length) {
        var modalBody = $('#askexpert-response').html();
        customModal.createCustomModal('concierge-modal');
        $('#concierge-modal').find('.modal-body').html(modalBody);
        clearAskExpertForm();
      }
      $('.ajax-loader').hide();
    });
  });
}
function maxLengthTextArea() {
  $('.concierge-form-wrapper .input-textarea').onkeypress = function () {
    if (this.value.length >= 500) return false;
  };
}
/**
 * Clear Ask the expert form
 */
function clearAskExpertForm() {
  var askexpertform = $('form#dwfrm_beautyconsultant');
  if (window.User.isCustomerAuthenticated == false) {
    askexpertform.find('input[type="text"],input[type="email"]').val('');
  }
  askexpertform.find('input[type="checkbox"]').prop('checked', false);
  askexpertform.find('textarea').val('');
  askexpertform.find('select').prop('selectedIndex', 0);
  askexpertform.find('select').selectmenu('refresh');
  $('input[name$="_userconsent_termsandconditions"]').prop('checked', false);
}
/**
 * Clear contact us form
 */
function clearContactUsForm() {
  if (window.User.isCustomerAuthenticated == false) {
    $('input[name$="_contactus_firstname"]').val('');
    $('input[name$="_contactus_lastname"]').val('');
    $('input[name$="_contactus_email"]').val('');
    $('input[name$="_contactus_phone"]').val('');
  }

  $('input[name$="_contactus_ordernumber"]').val('');
  $('textarea[name$="_contactus_comment"]').val('').change();
  $('input[name$="_userconsent_termsandconditions"]').prop('checked', false);
}

function setGender() {
  var genderMenu = $('.registration-box #dwfrm_profile_customer_gender');
  var selectedGender = genderMenu.data('gender');
  genderMenu.val(selectedGender);
  genderMenu.selectmenu('refresh');
}

function getBirthday(birthmonth, dob, birthyear) {
  var birthday = [birthmonth, '/', dob, '/', birthyear].join('');

  if (birthday === '00/00/' || birthday === '0/0/') {
    birthday = '';

    $('.birthmonth select').val('00');
    $('.dob select').val('00');
  }

  $('.birthday input').val(birthday);
}

function setBirthday() {
  //Birth Month
  var birthmonthMenu = $('#dwfrm_profile_customer_birthmonth');
  var birthmonth = ('0' + birthmonthMenu.data('birthmonth')).slice(-2);
  if (birthmonth && birthmonth > 0) {
    birthmonthMenu.val(birthmonth);
    birthmonthMenu.selectmenu('refresh');
  }

  //Birth Day
  var dobMenu = $('#dwfrm_profile_customer_dob');
  var dob = ('0' + dobMenu.data('dob')).slice(-2);
  if (dob && dob > 0) {
    dobMenu.val(dob);
    dobMenu.selectmenu('refresh');
  }

  //Birth Year
  var birthyear = $('input.birthyear').data('birthyear');
  $('input.birthyear').val(birthyear);

  getBirthday(birthmonth, dob, birthyear);
}

function setNewBirthday(birthmonth, dob, birthyear) {
  var monthField = $('.birthmonth select');
  var dayField = $('.dob select');
  var yearField = $('.birthyear input');

  var month = ~~birthmonth ? birthmonth : '';
  var day = ~~dob ? dob : '';
  var year = ~~birthyear ? birthyear : '';

  yearField.siblings('.error').remove();
  yearField.removeClass('.error');

  if (month || day || year) {
    var now = new Date();
    var birthday = new Date(birthyear, birthmonth - 1, dob, 0, 0, 0, 0);

    if (
      !month.match(/^[\d]{1,2}$/) ||
      !day.match(/^[\d]{1,2}$/) ||
      !year.match(/^[\d]{4}$/) ||
      !birthday.getTime() ||
      now.getTime() <= birthday.getTime()
    ) {
      var customRow = $('.birthdate .form-row-custom');

      if ($(customRow).find('.error-placement').length === 0) {
        $(
          '<div class="error-placement"><i class="error-icon"></i><span class="error">' +
            Resources.INVALID_BIRTHDAY +
            '</span></div>'
        ).appendTo(customRow);
      }
      yearField.addClass('error');
      $('#profile-save-changes').prop('disabled', true);
    }
  }

  getBirthday(birthmonth, dob, birthyear);

  var hasError = $('#profile-save-changes').closest('form').find('span.error');

  if (!hasError.length) {
    $('#profile-save-changes').prop('disabled', false);
  }
}

function updateBirthday() {
  var birthday = $('.birthday input').val();
  var birthmonth = $('.birthmonth select').val();
  var dob = $('.dob select').val();
  var birthyear = $('.birthyear input').val();

  $('.birthmonth select').on('selectmenuchange', function () {
    birthmonth = $(this).val();

    if (birthyear || (birthmonth === '00' && !birthyear)) {
      setNewBirthday(birthmonth, dob, birthyear);
    }
  });

  $('.dob select').on('selectmenuchange', function () {
    dob = $(this).val();

    if (birthyear || (dob === '00' && !birthyear)) {
      setNewBirthday(birthmonth, dob, birthyear);
    }
  });

  $('.birthyear input').blur(function () {
    birthyear = $(this).val();

    setNewBirthday(birthmonth, dob, birthyear);
  });
}
function handleDisplayselectedCard(currentcard, $selectedCards) {
  $selectedCards.find('.card-icon').addClass('other-cards');
  $selectedCards
    .find("[data-card-type='" + currentcard + "']")
    .removeClass('other-cards')
    .addClass('current-card');
}
function creditCardTypeDetector(options) {
  // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
  // Visa
  var visa_regex = new RegExp('^4[0-9]{0,15}$'),
    // MasterCard
    mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),
    // American Express
    amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),
    //Discover
    discover_regex = new RegExp(
      '^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'
    ),
    //JCB
    unionpay_regex = new RegExp(
      '^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$'
    );

  $('.cc-number input').focusout(function (e) {
    var cur_val = $(this).val();

    var $ccNumberContain = $(this).parents('.cc-number');
    var $selectedCards = $('.available-cards');

    // get rid of spaces and dashes before using the regular expression
    cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

    var $creditCard = $('[data-method="CREDIT_CARD"]');

    // checks per each, as their could be multiple hits
    if (cur_val.match(visa_regex)) {
      $ccNumberContain.addClass('is_visa');
      $selectedCards.addClass('is_visa');
      handleDisplayselectedCard('is_visa', $selectedCards);
      $creditCard.find('input[name$="_type"]').val('Visa').trigger('change');
    } else {
      $ccNumberContain.removeClass('is_visa');
      $selectedCards.removeClass('is_visa', $selectedCards);
    }

    if (cur_val.match(mastercard_regex)) {
      $ccNumberContain.addClass('is_mastercard');
      $selectedCards.addClass('is_mastercard');
      handleDisplayselectedCard('is_mastercard', $selectedCards);
      $creditCard
        .find('input[name$="_type"]')
        .val('MasterCard')
        .trigger('change');
    } else {
      $ccNumberContain.removeClass('is_mastercard');
      $selectedCards.removeClass('is_mastercard', $selectedCards);
    }

    if (cur_val.match(amex_regex)) {
      $ccNumberContain.addClass('is_amex');
      $selectedCards.addClass('is_amex');
      handleDisplayselectedCard('is_amex', $selectedCards);
      $creditCard.find('input[name$="_type"]').val('Amex').trigger('change');
    } else {
      $ccNumberContain.removeClass('is_amex');
      $selectedCards.removeClass('is_amex', $selectedCards);
    }

    if (cur_val.match(discover_regex)) {
      $ccNumberContain.addClass('is_discover');
      $selectedCards.addClass('is_discover');
      handleDisplayselectedCard('is_discover', $selectedCards);
      $creditCard
        .find('input[name$="_type"]')
        .val('Discover')
        .trigger('change');
    } else {
      $ccNumberContain.removeClass('is_discover');
      $selectedCards.removeClass('is_discover', $selectedCards);
    }

    if (cur_val.match(unionpay_regex)) {
      $ccNumberContain.addClass('is_unionpay');
      $selectedCards.addClass('is_unionpay');
      handleDisplayselectedCard('is_unionpay', $selectedCards);
      $creditCard.find('input[name$="_type"]').val('Union').trigger('change');
    } else {
      $ccNumberContain.removeClass('is_unionpay');
      $selectedCards.removeClass('is_unionpay', $selectedCards);
    }

    // if nothing is a hit we add a class to fade them all out
    if (
      cur_val != '' &&
      !cur_val.match(visa_regex) &&
      !cur_val.match(mastercard_regex) &&
      !cur_val.match(amex_regex) &&
      !cur_val.match(discover_regex) &&
      !cur_val.match(unionpay_regex)
    ) {
      $ccNumberContain.addClass('is_nothing');
    } else {
      $ccNumberContain.removeClass('is_nothing');
    }
  });
}

//function to highlight the selected page on navigation bar
function setAccountNavText(checkLayout) {
  if ($('.account-left-nav').length > 0) {
    var selectvar = $('.selected-page').val() || '';
    $(".account-left-nav li[data-attr='" + selectvar + "']").addClass(
      'selected'
    );
    if (
      checkLayout === 'mobile' &&
      $(".account-left-nav li[data-attr='" + selectvar + "']").length > 0
    ) {
      if (selectvar != 'account-overview') {
        $('.pt_account #secondary-navigation').animate({
          scrollLeft: $(
            ".account-left-nav li[data-attr='" + selectvar + "']"
          ).offset().left
        });
      }
    }
  }
}

$(window).on('orientationchange', function () {
  currLayout = currentLayout.init();
  setAccountNavText(currLayout);
});

function initPaymentEvents_Default() {
  $('.remove-card, .set-default-card').on('click', function (e) {
    e.preventDefault();
    let $form = $(this).closest('form.remove-card-form');
    if ($form.data('submitting')) {
      e.stopPropagation();
      return false;
    }
    // Allow only one form to submit.
    $('.remove-card-form').data('submitting', true);
    $.ajax({
      type: 'POST',
      url: $(this).hasClass('remove-card')
        ? $form.attr('action')
        : Urls.setDefaultCreditCard,
      data: {
        CardId: $form.find('input[name="CardId"]').val(),
        CardSeq: $form.find('input[name="CardSeq"]').val(),
        CardNumber: $form.find('input[name="CardNumber"]').val(),
        csrf_token: $form.find('#csrf-token-modal').val()
      }
    }).done(function (response) {
      const responseType = typeof response;

      if (
        responseType === 'object' &&
        !response.success &&
        response.error === 'CSRF Token Mismatch'
      ) {
        window.location.href = Urls.csrffailed;
        return;
      }
      if (responseType === 'object' && response.success) {
        page.redirect(Urls.paymentsList);
        return;
      }
      page.redirect(Urls.generalError);
    });
  });
}

function readyForCardForm() {
  paymentinstruments.creditCardTypeDetector();
  validator.initStateValidation();
  validator.initForm('form[id$="CreditCardForm"]');
  cardValidation.init();
  paymentinstruments.initCardEvents();

  $('#dwfrm_paymentinstruments_creditcards_newcreditcard_number').attr({
    placeholder: '例）1234567890123456'
  });

  $('#dwfrm_paymentinstruments_creditcards_newcreditcard_number').addClass(
    'placeholder-style'
  );
}

function initBirthYearEvent() {
  const eventType = ['keydown', 'mousedown', 'touchstart']
    .map(function (item) {
      return item + '.birthyear.init' + '';
    })
    .join(' ');
  $('#entryForm [name$="_birthyear"]')
    .off(eventType)
    .on(eventType, function () {
      var $elem = $('#entryForm [name$="_birthyear"]');
      if (
        typeof defaultBirthYearOnEntryPage !== 'undefined' &&
        defaultBirthYearOnEntryPage
      ) {
        var current = $elem.val();
        if (!current || current === 'null' || current === 'undefined') {
          $elem.val(defaultBirthYearOnEntryPage);
        }
      }
      $elem.find('[value=""]').each(function (idx, el) {
        $(el).remove();
      });
    });
}

//アカウント登録の時、確認ボタンを一回以上押せないようにする
function initPreventResubmit() {
  $(document)
    .off('click.formConfirm', '.registration-confirm')
    .on('click.formConfirm', '.registration-confirm', function () {
      $('.registration-confirm').css('pointer-events', 'none');
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
  cardValidation.init();
  toggleFullOrder();
  initAddressEvents();
  initPaymentEvents();
  initPaymentEvents_Default();
  readyForCardForm();
  login.init();
  registerAccountEvents();
  initContactUs();
  initAsktheExpert();
  maxLengthTextArea();
  setGender();
  setBirthday();
  updateBirthday();
  search.viewMore();
  productTile.init();
  setAccountNavText(currLayout);
  initBirthYearEvent();
  initPreventResubmit();
}

var account = {
  init: function () {
    initializeEvents();
    giftcert.init();
  },
  initCartLogin: function () {
    login.init();
  },
  initPaymentEvents: function () {
    initPaymentEvents();
  }
};

module.exports = account;

},{"../detect-layout":30,"../dialog":31,"../giftcert":36,"../login":41,"../modal":43,"../page":46,"../product-tile":90,"../tooltip":104,"../util":105,"../validator":106,"./checkout/card-validation":53,"./paymentinstruments":64,"./product/index":70,"./search":80}],48:[function(require,module,exports){
var JS_Z_RETAILER_EC_CONNECT = {
  $checkbox: '',
  init: function () {
    this.setEventTermsCheckbox();
    this.setEventModal();
  },
  setResetCheckbox: function() {
    var _this = this;
    if(!this.$checkbox.length) { return; }
    window.addEventListener('pageshow', function() {
        _this.$checkbox.prop('checked',false).change();
    });
},
  setEventTermsCheckbox: function () {
    var CLS_IS_DISABLED = '-disabled';
    var $checkbox = $('.js-z-connect__checkbox');
    var $targets = $('.js-z-connect__checkbox_target');
    if (!$checkbox.length) { return; }
    $checkbox.on('change', function () {
      var $this = $(this);
      var isChecked = $this.prop('checked');
      var _$btn = $targets.filter('[data-checkbox="' + $this.attr('id') + '"');
      var hasDisabledClass = _$btn.hasClass(CLS_IS_DISABLED);
      if (isChecked && hasDisabledClass) {
        _$btn.removeClass(CLS_IS_DISABLED);
      } else if (!isChecked && !hasDisabledClass) {
        _$btn.addClass(CLS_IS_DISABLED);
      }
    });
  },
  setEventModal: function () {
    const $modal = $('.z-retailer-ec-connect__modal');
    // HTMLにモーダルが無ければ何もしない
    if ($modal.length === 0) { return; }
    // モーダルを表示
    $modal.show();
    // htmlのスクロールを削除
    $('html').css('overflow-y', 'hidden');
    $('.z-connect__btn.js-z-connect__checkbox_target')
      .on('click', function (e) {
        $('html').css('overflow-y', 'scroll');
        $modal.hide();
      });
  }
};

exports.init = function () {
  JS_Z_RETAILER_EC_CONNECT.init();
};

},{}],49:[function(require,module,exports){
'use strict';

var account = require('./account'),
  bonusProductsView = require('../bonus-products-view'),
  quickview = require('../quickview'),
  giftShipping = require('./checkout/shipping'),
  recommendations = require('./product/recommendations'),
  cartStoreInventory = require('../storeinventory/cart'),
  modal = require('../modal').global,
  samples = require('../samples'),
  giftCert = require('../giftcert-modal'),
  login = require('./checkout/login'),
  util = require('../util'),
  summarysection = require('./summarysection'),
  productTile = require('../product-tile');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
  $('#cart-table')
    .on('click', '.item-edit-details a', function(e) {
      e.preventDefault();
      quickview.show({
        url: e.target.href,
        source: 'cart'
      });
    })
    .on(
      'click',
      '.bonus-item-actions a, .item-details .bonusproducts a',
      function(e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
      }
    );

  //to prevent multiple submissions of the form when removing a product from the cart
  var removeItemEvent = false;
  $('button[name$="deleteProduct"]').on('click', function(e) {
    if (removeItemEvent) {
      e.preventDefault();
    } else {
      removeItemEvent = true;
    }
  });

  $('select.cart-qty-select').selectmenu({
    classes: {
      'ui-selectmenu-menu': 'cart-qty-select'
    }
  });
  // product level bonus modal
  $('div.bonus-item-promo').on('click', 'a.select-bonus', function(e) {
    e.preventDefault();
    bonusProductsView.show(this.href);
  });

  $(document).on('click', '.paypal-container a', function(e) {
    e.preventDefault();

    var cartCheckoutForm = $('.cart-action-checkout');
    if (cartCheckoutForm.length > 0) {
      cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
      cartCheckoutForm.submit();
    }
  });

  $(document).on('click', 'button#cart-checkout-button', function(e) {
    e.preventDefault();
    var $form = $('#checkout-form');
    $form.find('button[name$="_cart_checkoutCart"]').trigger('click');
    enableDisableButtonBasedOnCoupon();
  });

  $(document).on(
    'click',
    'button.removebutton, .user-action-remove button',
    function(e) {
      enableDisableButtonBasedOnCoupon();
    }
  );

  $(document).on('change', '.isproductgiftwrap ', function(e) {
    console.log('update');
    updateGift(Number(this.checked));
  });
}

// Enable or disable coupon form button based on coupon code
function enableDisableButtonBasedOnCoupon() {
  $('#add-coupon').prop(
    'disabled',
    $('input[name$="couponCode"]').val() == '' ? true : false
  );
}

function isGift() {
  var isGift = $('.gift-container .input-checkbox').is(':checked');
  var isGiftName = [$('#cart-items-form').attr('name'), 'isGift'].join('_');

  $('#checkout-form .is-gift').val(isGift);
  $('#checkout-form .is-gift').attr('name', isGiftName);
  $('.gift-container .input-checkbox').attr('checked', isGift);
  $('.gift-container .input-checkbox').change(function() {
    isGift = $(this).is(':checked');

    if (!isGift) {
      $('.gift-container .input-textarea').val('');
      $('#checkout-form .gift-message').val('');

      sessionStorage.removeItem('isGift');
      sessionStorage.removeItem('giftMessage');
    } else {
      $('.gift-container .input-textarea').keyup();
    }

    $('#checkout-form .is-gift').val(isGift);
  });
}

function giftMessage() {
  var giftMessage = sessionStorage.getItem('giftMessage')
    ? sessionStorage.getItem('giftMessage')
    : '';
  var giftMessageName = [
    $('#cart-items-form').attr('name'),
    'giftMessage'
  ].join('_');

  $('#checkout-form .gift-message').val(giftMessage);
  $('#checkout-form .gift-message').attr('name', giftMessageName);
  $('.gift-container .input-textarea').val(giftMessage);
  $('.gift-container .input-textarea').on('keyup', function() {
    giftMessage = $(this)
      .val()
      .trim();

    if (giftMessage === '' || util.validateMessage(giftMessage)) {
      $('#checkout-form .gift-message').val(giftMessage);
      $('.gift-message-textarea .form-caption').removeClass('error-message');
      $('.gift-message-textarea .form-caption').empty();
      $('#checkout-form button').prop('disabled', false);
      $('.third-party-container').css('opacity', 1);
      $('.third-party-container').css('pointer-events', 'all');
      sessionStorage.setItem('giftMessage', giftMessage);
    } else {
      $('.gift-message-textarea .form-caption').addClass('error-message');
      $('.gift-message-textarea .form-caption').text('Invalid message');
      $('#checkout-form button').prop('disabled', true);
      $('.third-party-container').css('opacity', 0.5);
      $('.third-party-container').css('pointer-events', 'none');
    }
  });
}

function isProductGiftWrap() {
  var isProductGiftWrap = $('.product-gift-container .input-checkbox').is(
    ':checked'
  );
  var isProductGiftName = [
    $('#cart-items-form').attr('name'),
    'isProductGiftWrap'
  ].join('_');

  $('#checkout-form .is-product-gift').val(isProductGiftWrap);
  $('#checkout-form .is-product-gift').attr('name', isProductGiftName);
  $('.product-gift-container .input-checkbox').attr(
    'checked',
    isProductGiftWrap
  );
  $('.product-gift-container .input-checkbox').change(function() {
    isProductGiftWrap = $(this).is(':checked');
    $('#checkout-form .is-product-gift').val(isProductGiftWrap);
  });
}

function updateCart() {
  $('.quantity-container select').on('selectmenuchange', function() {
    $('#cart-items-form').submit();
  });
}

function cartCount() {
  if ($('.cart-empty').length) {
    sessionStorage.removeItem('isGift');
    sessionStorage.removeItem('giftMessage');
  }
}

$.fn.isInViewport = function() {
  if ($(this).length) {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }
};

function stickyCheckout() {
  $(window).on('scroll', function() {
    if ($(window).width() < 769) {
      if ($('.cart-right-column .cart-actions button').isInViewport()) {
        $('.cart-actions-checkout').removeClass('show');
      } else {
        $('.cart-actions-checkout').addClass('show');
      }

      $('.cart-right-column, .cart-right-column > div').removeAttr('style');
      $('.resize-sensor').remove();
    } else {
      var topoffset =
        $('.cart-top').outerHeight(true) +
        $('.cart-item-qty').outerHeight(true) +
        parseInt($('.cart-left-column').css('padding-top'), 10);
      var cartoffset =
        $('#cart-table').offset().top + $('#cart-table').outerHeight();
      var scrollTopCart = $(window).scrollTop();
      var stickyWidth = $('.for-sticky').css('width');
      if (scrollTopCart > topoffset && scrollTopCart < cartoffset) {
        $('.for-sticky').addClass('cart-right-column-sticky');
        $('.for-sticky').css('width', stickyWidth);
      } else if (scrollTopCart > cartoffset) {
        $('.for-sticky').removeClass('cart-right-column-sticky');
        $('.for-sticky').removeAttr('style');
      } else {
        $('.for-sticky').removeClass('cart-right-column-sticky');
        $('.for-sticky').removeAttr('style');
      }
    }
  });
  $('.for-sticky')
    .removeClass('cart-right-column-sticky')
    .removeAttr('style');
}

$(window).on('resize', function() {
  if ($('.cart-right-column').length > 0) {
    stickyCheckout();
  }
});

function updateGift(flag) {
  $.post(
    util.appendParamsToUrl(Urls.updateGiftFlag, {
      format: 'ajax',
      giftFlag: flag,
      csrf_token: $('input[name=csrf_token]').val()
    }),
    function(data) {
      if (data.success === false) {
        return reject(data.error);
      }
    }
  ).fail(function(err) {
    reject(err.error);
  });
}

exports.init = function() {
  login.init();
  initializeEvents();
  recommendations();
  productTile.init();
  isGift();
  isProductGiftWrap();
  giftMessage();
  updateCart();
  cartCount();
  giftShipping.init();
  giftCert.init();
  summarysection.init();
  if (SitePreferences.STORE_PICKUP) {
    cartStoreInventory.init();
  }
  account.initCartLogin();
  if ($('.cart-column').length) {
    stickyCheckout();
  }
};

},{"../bonus-products-view":22,"../giftcert-modal":35,"../modal":43,"../product-tile":90,"../quickview":92,"../samples":95,"../storeinventory/cart":100,"../util":105,"./account":47,"./checkout/login":56,"./checkout/shipping":58,"./product/recommendations":74,"./summarysection":85}],50:[function(require,module,exports){
'use strict';

var formPrepare = require('./checkout/formPrepare'),
	validator = require('../validator');

/**
 * @private
 * @function
 * @description Validates if check order form is filled out before enabling button
 */
function initializeEvents() {
	validator.initForm('form[id$="ordertrack"]');
}

exports.init = function () {
    initializeEvents();

}

},{"../validator":106,"./checkout/formPrepare":54}],51:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
    });
};

},{"../../util":105,"./shipping":58}],52:[function(require,module,exports){
'use strict';

const util = require('../../util');
const modal = require('../../modal').global;
const cardValidation = require('./card-validation');
const validator = require('../../validator');
const summarysection = require('../../pages/summarysection');
const index = require('../product/index');
const customModal = require('../../modal');

var $cache;

/**
 * 注文税込小計を取得する。
 *
 * @private
 * @returns {number} 注文税込小計
 */
function getOrderSubTotalAmount() {
  // JSONデータから取得
  // eslint-disable-next-line no-undef
  return basketConfirmation.subtotal;
}

/**
 * 支払方法
 *
 * @typedef PaymentMethodId
 * @type {string}
 */

/**
 * 支払方法Enum
 *
 * @private
 * @readonly
 * @enum {PaymentMethodId}
 */
const PaymentMethodId = {
  /** クレジットカード */
  CREDIT_CARD: 'CREDIT_CARD',
  /** 全額ポイント利用 */
  POINT_DISCOUNT: 'POINT_DISCOUNT',
  /** Credit Card - Secure Acceptance Web/Mobile(iframe) ※利用していない */
  SA_SILENTPOST: 'SA_SILENTPOST',
  /** Credit Card - Secure Acceptance Web/Mobile(Redirect) ※利用していない */
  SA_REDIRECT: 'SA_REDIRECT',
  /** Credit Card - Secure Acceptance Silent Order POST ※利用していない */
  SA_IFRAME: 'SA_IFRAME'
};

/**
 * 現在の支払方法IDを取得する。
 *
 * @private
 * @param {PointViewer} pointViewer PointViewerオブジェクト
 * @returns {string} 支払方法ID
 */
function getSelectedPaymentMethodId(pointViewer) {
  // ポイント全額支払
  if (pointViewer.isUseFullPoint) {
    return PaymentMethodId.POINT_DISCOUNT;
  }
  // 支払方法選択肢
  const $paymentMethodId = $('[name$=_selectedPaymentMethodID]');
  // value値の取得が .val() で取得できないためchecked属性を持つラジオを取得
  const $checkedRadio = $paymentMethodId.filter(':checked');
  // 選択されている支払方法を取得
  if ($checkedRadio.val() != null) {
    return $checkedRadio.val();
  }
  // 未選択の場合は、クレジットカードを初期選択して返却する。
  $paymentMethodId.val([PaymentMethodId.CREDIT_CARD]);
  return PaymentMethodId.CREDIT_CARD;
}

/**
 * SP表示時のカード保存ボタン表示制御
 *
 * @private
 * @param {PaymentMethodId} paymentMethodId 支払方法ID
 */
function setSpSaveCardVisibility(paymentMethodId) {
  switch (paymentMethodId) {
    case PaymentMethodId.CREDIT_CARD:
    case PaymentMethodId.SA_SILENTPOST:
      $('.spsavecard').show();
      return;
    case PaymentMethodId.SA_REDIRECT:
    case PaymentMethodId.SA_IFRAME:
      if (SitePreferences.TOKENIZATION_ENABLED) {
        $('.spsavecard').show();
      } else {
        $('.spsavecard').hide();
      }
      return;
    default:
      $('.spsavecard').hide();
      return;
  }
}

/**
 * 「次に進む」ボタンの制御
 *
 * @private
 * @param {PointViewer} pointViewer PointViewerオブジェクト
 */
function setApplyButtonAvailability(pointViewer) {
  // ポイント支払に不備がある場合は一律CSSで押下不可にする
  // MEMO:クレジットカードのフォームで別途、disabled属性を解除する動作をするので、
  //      ポイントに不正があるときはずっと押下不可にする。
  if (!pointViewer.isValid) {
    $('#applyBtn').addClass('disabled');
    return;
  } else {
    $('#applyBtn').removeClass('disabled');
  }
  // クレジットカードの以外場合は無条件に押下可
  if (getSelectedPaymentMethodId(pointViewer) !== PaymentMethodId.CREDIT_CARD) {
    $('#applyBtn').prop('disabled', false);
    return;
  }
  // クレカの場合
  const $selectedCardOption = $('#gmoPaymentCardList option:selected');
  if ($selectedCardOption.val() === 'AddNewCard') {
    $('#applyBtn').prop('disabled', true).removeClass('disabled');
    $('.js-owner-unregistered-message').addClass('d-none');
    return;
  }
  const selectedCardData = $selectedCardOption.data('card');
  if (selectedCardData && selectedCardData.owner === '') {
    // クラス属性で強制的に常時disabledに設定
    $('#applyBtn').addClass('disabled');
    $('.js-owner-unregistered-message').removeClass('d-none');
  } else {
    // classでdisabled設定されていると即時有効化されないので、disabled属性を削除
    $('#applyBtn').removeClass('disabled').removeAttr('disabled');
    $('.js-owner-unregistered-message').addClass('d-none');
  }
}

/**
 * Changes the payment method form depending on the passed paymentMethodID
 *
 * @param {PointViewer} pointViewer PointViewerオブジェクト
 * @private
 */
function updatePaymentMethod(pointViewer) {
  // 支払方法を現在の状況に応じて取得（選択されていなければクレジットカードを選択する）
  const paymentMethodId = getSelectedPaymentMethodId(pointViewer);

  // 展開している入力部を非表示にする
  $('.payment-method').removeClass('payment-method-expanded');

  // 支払方法選択肢を有効化（全額ポイント支払から変更時に初期化）
  $('fieldset').prop('disabled', false);
  $('fieldset')
    .find('.form-row')
    .not('.js-always-unabled-item')
    .removeClass('disabled');
  // 楽天ペイ、コンビニ払いの支払制限
  togglePaymentMethodOption(pointViewer.totalUsingPoint);
  // SP表示時のカード保存ボタン表示制御
  setSpSaveCardVisibility(paymentMethodId);

  // SA_SILENTPOSTはクレジットカードの入力フォームを展開する
  // MEMO: SA_SILENTPOSTは使用していない支払方法
  const dataMethod =
    paymentMethodId === PaymentMethodId.SA_SILENTPOST
      ? PaymentMethodId.CREDIT_CARD
      : paymentMethodId;

  // 選択している支払方法のラジオボタンが有れば入力フォームを展開。無ければCustomの入力フォームを展開。
  // MEMO: data-method=Customに該当するものは現在無い。
  const paymentMethodElement =
    $('.payment-method[data-method=' + dataMethod + ']').length === 0
      ? $('.payment-method[data-method=Custom]') // 該当する選択肢が無い場合
      : $('.payment-method[data-method=' + dataMethod + ']');

  // ラジオボタンに紐づけられた入力フォームを表示
  $(paymentMethodElement).addClass('payment-method-expanded');

  // ポイント支払に不備がある場合は一律押下不可
  setApplyButtonAvailability(pointViewer);

  // 全額ポイント支払の場合は支払方法選択肢を無効化
  if (paymentMethodId === PaymentMethodId.POINT_DISCOUNT) {
    $('fieldset').prop('disabled', true);
    $('fieldset').find('.form-row').addClass('disabled');
    $('fieldset').find('input[type=radio]').prop('checked', false);
  }
  // 支払方法選択フォームバリデーションを初期化
  initValidateSelectPayment();
  // 支払方法制御
  initPaymentRestriction(pointViewer);
}

function initCache() {
  $cache = {};

  $cache.checkoutForm = $('.checkout-billing');
  $cache.selectedCardIdInput = $cache.checkoutForm.find(
    'input[name$="_selectedCardID"]'
  );
}

function initCreditCardForm() {
  $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  $cache.checkoutForm.find('input[name*="_number"]').val('');

  var $ccContainer = $cache.checkoutForm
    .find('.payment-method')
    .filter(function () {
      return $(this).data('method') == 'CREDIT_CARD';
    });

  $ccContainer.find('input[name*="_number"]').on('change', function () {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  });
  $ccContainer.find('input[name$="_owner"]').on('change', function () {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  });

  $ccContainer.find('select[name*="expiration"]').on('change', function () {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

    var selectedPaymentMethodID = $(
      'input[name$="_selectedPaymentMethodID"]:checked'
    ).val();
    var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
    if (
      cardNumber.indexOf('****') != -1 &&
      selectedPaymentMethodID == 'SA_SILENTPOST'
    ) {
      $cache.checkoutForm.find('input[name*="_number"]').val('');
    }
  });
}

function setSelectedCardID(uuid) {
  $cache.selectedCardIdInput.val(uuid);
}

function addCVNEvent() {
  $('input[name$="creditCard_cvn"]').on('keydown', function (e) {
    if (
      e.key.toString().match(/[\d]/) ||
      $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0
    ) {
      // do nothing
    } else {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  });
}

//address modal close
function addressModalClose() {
  $(document).on('click', '.edit-add-address .cancel-button', function () {
    $(this).closest('.modal-overlay').remove();
    $('html').removeClass('modal-open');
  });
}

function initCreditCardEvents(pointViewer) {
  //select credit card tile
  $(document).on('click', '.creditcard-tile', function () {
    var $this = $(this);

    if ($this.is('.selected, .default')) {
      return false;
    }

    $('.credit-card-save').css('display', 'flex');

    const selectedSeq = $this.find('input[name="CardSeq"]').val();
    $('#gmoPaymentCardList option').prop('selected', false);
    $('#gmoPaymentCardList option[value="' + selectedSeq + '"]').prop(
      'selected',
      true
    );
    $('#gmoPaymentCardList').trigger('change');
  });

  $(document).on('change', '#gmoPaymentCardList', function () {
    setApplyButtonAvailability(pointViewer);
  });
}

/**
 * 楽天ペイ、コンビニ払いの支払制限
 *
 * @private
 * @param {number} totalPoint 利用ポイント合計
 * @returns {void}
 */
function togglePaymentMethodOption(totalPoint) {
  const subTotalAmount = getOrderSubTotalAmount();
  const minAmount = SitePreferences.RAKUTENID_MIN_AMOUNT;
  const message = Resources.RAKUTENID_LOWERLIMIT.replace('{min}', minAmount);

  const paymentAlert = $('.payment-method-options > .alert-payment-method');
  const radioRakutenID = $('#is-RAKUTENID');
  const radioCvsID = $('#is-GMO_CVSSTORE');
  const parentRakutenID = radioRakutenID.parents('.form-row');

  // 予約商品の場合は楽天ペイ及びコンビニ払いの選択項目は無効化
  if (
    radioRakutenID.hasClass('js-preorder') ||
    radioCvsID.hasClass('js-preorder')
  ) {
    //選択されていた場合は暫定的にカード払いを選択する
    if (radioRakutenID.prop('checked') || radioCvsID.prop('checked')) {
      radioRakutenID.prop('checked', false);
      radioCvsID.prop('checked', false);
      $('#is-CREDIT_CARD').trigger('click');
    }
    return;
  }

  if (subTotalAmount - totalPoint === 0) {
    // 全額ポイントで支払いを行う場合
    // 支払金額制限のメッセージが表示されていたら削除
    paymentAlert.text('');
    paymentAlert.hide();
  } else if (subTotalAmount - totalPoint < minAmount) {
    // 支払金額が下限未満の場合は楽天ペイを無効化。
    // MEMO: 価格調整する機能を代引き以外に使用していないため(ブランド S では、クーポン・プロモーション等による値引きは行われないため)、注文税込小計を基準に算出。
    radioRakutenID.prop('disabled', true);
    parentRakutenID.addClass('disabled');

    // 支払金額制限のメッセージを表示
    paymentAlert.text(message);
    paymentAlert.show();

    // 楽天ペイが選択されていた場合は暫定的にカード払いを選択する
    if (radioRakutenID.prop('checked')) {
      radioRakutenID.prop('checked', false);
      $('#is-CREDIT_CARD').trigger('click');
    }
  } else {
    // 支払金額が下限以上の場合は楽天ペイを有効化
    radioRakutenID.prop('disabled', false);
    if (!parentRakutenID.hasClass('js-always-unabled-item')) {
      parentRakutenID.removeClass('disabled');
    }

    // 支払金額制限のメッセージが表示されていたら削除
    paymentAlert.text('');
    paymentAlert.hide();
  }
}

/**
 * 支払方法制限を初期化
 *
 * @private
 * @param {PointViewer} pointViewer PointViewerオブジェクト
 */
function initPaymentRestriction(pointViewer) {
  // ポイント利用のinputが変化した場合に利用金額をチェック
  $('table.edit-payment__table').on('change', 'input', function () {
    togglePaymentMethodOption(pointViewer.totalUsingPoint);
  });

  // 初回表示時にも一応チェック
  togglePaymentMethodOption(pointViewer.totalUsingPoint);
}

//クレカ入力フォームを初期化するメソッド
function formInitialization() {
  $('#dwfrm_billing_paymentMethods_creditCard_type').selectmenu('destroy');
  $('#dwfrm_billing_paymentMethods_creditCard_type option:eq(0)').prop(
    'selected',
    true
  );
  $('#cardType').val($('#dwfrm_billing_paymentMethods_creditCard_type').val());
  $('#dwfrm_billing_paymentMethods_creditCard_type').selectmenu();

  $('#dwfrm_billing_paymentMethods_creditCard_expiration_month').selectmenu(
    'destroy'
  );
  $(
    '#dwfrm_billing_paymentMethods_creditCard_expiration_month option:eq(0)'
  ).prop('selected', true);
  $('#dwfrm_billing_paymentMethods_creditCard_expiration_month').selectmenu();

  $('#dwfrm_billing_paymentMethods_creditCard_expiration_year').selectmenu(
    'destroy'
  );
  $(
    '#dwfrm_billing_paymentMethods_creditCard_expiration_year option:eq(0)'
  ).prop('selected', true);
  $('#dwfrm_billing_paymentMethods_creditCard_expiration_year').selectmenu();
}

//支払方法に合わせてバリデータを適用させる
//支払方法がクレカだとしてももう保存されているクレカがある場合、テキストではなくhiddenで値を渡すため、クレカバリデータを適用する必要がない
function initValidateSelectPayment() {
  var selectPaymentID = $(
    'input[name$="dwfrm_billing_paymentMethods_selectedPaymentMethodID"]:checked'
  ).val();

  var selectCreditCard = $('input:radio[name$="creditcard"]:checked').val();

  if (
    selectPaymentID == 'CREDIT_CARD' &&
    !(typeof selectCreditCard != 'undefined' && selectCreditCard == 'on')
  ) {
    $('form[id$="billing"]').addClass('for-creditcard-validation');
  } else {
    $('form[id$="billing"]').removeClass('for-creditcard-validation');
  }

  validator.initStateValidation();
  validator.initForm('form[id$="billing"]');
  cardValidation.init();
}

function clearCreditCardInfo() {
  $('[name$="_paymentMethods_creditCard_number"]').val('');
  $('[name$="_paymentMethods_creditCard_cvn"]').val('');
}

function initClearCreditCardEvent() {
  $('form[id$="_billing"]')
    .off('submit.clear.credit')
    .on('submit.clear.credit', function () {
      const paymentMethodID =
        $('[name$="_paymentMethods_selectedPaymentMethodID"]:checked').val() ||
        '';
      if (paymentMethodID === 'CREDIT_CARD') {
        return;
      }
      clearCreditCardInfo();
    });
}

// ********************** Class PointViewer

/**
 * @constructor
 * @classdesc ポイント入力部
 * @param {HTMLElement} element ポイント入力部のwrapperエレメント
 */
function PointViewer(element) {
  const _this = this;

  /**
   * PointGroup配列
   *
   * @private
   * @type {PointGroup[]}
   */
  this._pointGroups = $(element)
    .find('.js-PointGroup')
    .toArray()
    .map(function (pointGroup) {
      return new PointGroup(pointGroup, _this);
    });

  /**
   * ポイント入力部の入力の有効/無効
   *
   * @type {boolean}
   */
  this.isValid = false;

  /**
   * 全額ポイント支払のときtrue
   *
   * @type {boolean}
   */
  this.isUseFullPoint = false;

  /**
   * 利用ポイント合計
   *
   * @type {number}
   */
  this.totalUsingPoint = 0;

  /**
   * エラーメッセージ行
   *
   * @private
   * @type {JQuery}
   */
  this._$errorMessage = $(element).find('.js-PointViewer_errorMessage');
}

/**
 * ポイント更新
 */
PointViewer.prototype.update = function () {
  // 検証
  const pointGroupsValidationResult = this.validatePointGroups();
  // エラーメッセージ表示
  this.showPointGroupValidationErrors(pointGroupsValidationResult);
  // ステータス設定
  this.isValid = !(
    pointGroupsValidationResult.isTypeError ||
    pointGroupsValidationResult.isVolumeError ||
    pointGroupsValidationResult.isTotalError
  );
  // 合計利用ポイント更新
  this.totalUsingPoint = pointGroupsValidationResult.usingPointForTotal;
  // 全額ポイント支払判定
  this.isUseFullPoint =
    this.isValid && this.totalUsingPoint === getOrderSubTotalAmount();
  // 支払方法更新
  updatePaymentMethod(this);
};

/**
 * PointGroupsの検証
 *
 * @returns {UsingPointValidationResult} PointGroupの検証結果まとめ
 */
PointViewer.prototype.validatePointGroups = function () {
  const pointGroupValidationResults = this._pointGroups.map(
    function (pointGroup) {
      return pointGroup.validateUsingPoint();
    }
  );
  const isTypeError = pointGroupValidationResults.some(
    function (validationResult) {
      return validationResult.isTypeError;
    }
  );
  // 合計利用ポイントを取得（型エラー、保有ポイント超過の入力を除く合計）
  const totalUsingPoint = pointGroupValidationResults.reduce(function (
    value,
    validationResult
  ) {
    return value + validationResult.usingPointForTotal;
  }, 0);
  // 入力値が注文税込小計より大きい場合、または入力値合計が注文税込小計より大きい場合エラー
  const isTotalError =
    pointGroupValidationResults.some(function (validationResult) {
      return validationResult.isTotalError;
    }) || getOrderSubTotalAmount() < totalUsingPoint;
  // 入力値が保有ポイントより大きい場合、エラー
  const isVolumeError = pointGroupValidationResults.some(
    function (validationResult) {
      return validationResult.isVolumeError;
    }
  );
  return {
    isTypeError: isTypeError,
    isTotalError: isTotalError,
    isVolumeError: isVolumeError,
    usingPointForTotal: totalUsingPoint
  };
};

/**
 * API関連エラーメッセージ表示
 */
PointViewer.prototype.showApiErrors = function () {
  // ポイント利用APIエラー
  if (this._$errorMessage.find('li#api-error').length) {
    // hasErrorを付与して表示
    this._$errorMessage.find('li#api-error').addClass('hasError');
  }
  // WEBポイント照会APIエラー
  if (this._$errorMessage.find('li#beautykey-response-error').length) {
    // hasErrorを付与して表示
    this._$errorMessage
      .find('li#beautykey-response-error')
      .addClass('hasError');
  }
  // 1件以上エラーがあればエラー行を表示
  if (this._$errorMessage.find('li.hasError').length) {
    this._$errorMessage.addClass('hasError');
  }
};

/**
 * PointGroupバリデーションエラーを表示
 *
 * @params {UsingPointValidationResult} 全ての利用ポイント検証結果
 */
PointViewer.prototype.showPointGroupValidationErrors = function (
  pointGroupsValidationResult
) {
  // エラー表示初期化（API関連エラーは初期表示のみ）
  this._$errorMessage.removeClass('hasError');
  // 入力値に応じて表示/非表示する要素の初期化
  this._$errorMessage.find('li').removeClass('hasError');

  // 入力値型チェック
  if (pointGroupsValidationResult.isTypeError) {
    this._$errorMessage.addClass('hasError');
    this._$errorMessage
      .find('li[data-error-type=type-error]')
      .addClass('hasError');
  }

  // 入力値が注文税込小計より大きい場合、または入力値合計が注文税込小計より大きい場合エラー
  if (pointGroupsValidationResult.isTotalError) {
    this._$errorMessage.addClass('hasError');
    this._$errorMessage
      .find('li[data-error-type=total-error]')
      .addClass('hasError');
  }

  // 入力値が保有ポイントより大きい場合、エラー
  if (pointGroupsValidationResult.isVolumeError) {
    this._$errorMessage.addClass('hasError');
    this._$errorMessage
      .find('li[data-error-type=volume-error]')
      .addClass('hasError');
  }
};

// ********************** Class PointGroup

/**
 * @constructor
 * @classdesc ポイント入力行
 * @param {HTMLElement} element ポイント入力行のwrapperエレメント
 * @param {PointViewer} pointViewer PointViewerオブジェクト
 */
function PointGroup(element, pointViewer) {
  /**
   * 保有ポイント（テキスト）
   *
   * @private
   * @type {string}
   */
  this._remainingPointText = $(element)
    .find('.js-PointGroup_remainingPoint')
    .text();

  /**
   * 利用ポイント入力項目
   *
   * @private
   * @type {HTMLInputElement}
   */
  this._$usingTextInput = $(element).find('input.js-PointGroup_usingPoint');

  if (!this._remainingPointText || this.getRemainingPoint() <= 0) {
    // APIエラー等で要素が無いか、保有ポイントが0以下（マイナスポイント）の場合は編集不可
    $(element).addClass('disabled');
    this._$usingTextInput.prop('disabled', true);
  } else {
    // 利用ポイント変更イベント
    this._$usingTextInput.on('change', function () {
      pointViewer.update();
    });
  }
}

/**
 * 保有ポイントを取得する。
 *
 * @returns {number} 保有ポイント
 */
PointGroup.prototype.getRemainingPoint = function () {
  // 対象が無い場合はゼロ
  if (!this._remainingPointText) {
    return 0;
  }
  const remainingPointText = this._remainingPointText.replace(/,/g, '');
  // 数字以外の場合はゼロ
  const regExp = new RegExp(/^\d+$/g);
  if (!regExp.test(remainingPointText)) {
    return 0;
  }
  // 数値変換して返却
  return Number(remainingPointText);
};

/**
 * 利用ポイントを取得する。
 *
 * @returns {number} 利用ポイント
 */
PointGroup.prototype.getUsingPoint = function () {
  // 対象が無い場合はゼロ
  if (!this._$usingTextInput) {
    return 0;
  }
  // 数字以外入力時はゼロ
  const regExp = new RegExp(/^\d+$/g);
  if (!regExp.test(this._$usingTextInput.val())) {
    return 0;
  }
  // 数値変換して
  return Number(this._$usingTextInput.val());
};

/**
 * 利用ポイント検証を行う。
 *
 * @returns {UsingPointValidationResult} 利用ポイント検証結果
 */
PointGroup.prototype.validateUsingPoint = function () {
  // 未入力時は検証不要
  if (!this._$usingTextInput.val()) {
    return {
      isTypeError: false,
      isTotalError: false,
      isVolumeError: false,
      usingPointForTotal: 0
    };
  }
  // 数値のみ入力可）
  const numberRegExp = new RegExp(/^\d+$/g);
  const isTypeError = !numberRegExp.test(this._$usingTextInput.val());
  const usingPoint = this.getUsingPoint();
  // 注文税込小計以下
  const isTotalError = getOrderSubTotalAmount() < usingPoint;
  // 所有ポイント以下（保有ポイントが1以上のときだけ）
  const remainingPoint = this.getRemainingPoint();
  const isVolumeError = remainingPoint > 0 && remainingPoint < usingPoint;
  // 合計利用ポイント算出用の利用ポイント（注文税込小計チェック以外でエラーが無い場合、合計に合算する。）
  const usingPointForTotal = !isTypeError && !isVolumeError ? usingPoint : 0;
  return {
    isTypeError: isTypeError,
    isTotalError: isTotalError,
    isVolumeError: isVolumeError,
    usingPointForTotal: usingPointForTotal
  };
};

// ********************** Class Accordion

/**
 * @param $target
 * @constructor
 * @classdesc ポイント入力部アコーディオン
 */
function Accordion($target) {
  this._$target = $target;
  // jQueryオブジェクト
  this._$link = this._$target.find('.js-Accordion_link') || null;
  this._$container = this._$target.find('.js-Accordion_container') || null;
  this._$contens = this._$target.find('.js-Accordion_contents') || null;
  // メンバ変数
  this._isOpened = false;
  // イベント
  if (this._$link) {
    var _this = this;
    var totalPoint2 = $('.js-PointViewer_totalPoint2').text();
    if (totalPoint2 != '0') {
      _this.open();
    }
    this._$link.on('click', function (e) {
      e.preventDefault();
      //
      if (_this._isOpened) {
        _this.close();
      } else {
        _this.open();
      }
    });
  }
}
Accordion.prototype.init = function () {
  if (this._isOpened) {
    this.open();
  } else {
    this.close();
  }
};
Accordion.prototype.open = function () {
  this._isOpened = true;
  //
  if (this._$container) {
    this._$container.css({
      display: 'block',
      height: 0,
      overflow: 'hidden'
    });
    var _this = this;
    this._$container.stop().animate(
      {
        height: this._$contens.height()
      },
      300,
      'swing',
      function () {
        _this._$container.css({
          height: 'auto',
          overflow: 'visible'
        });
      }
    );
  }
  if (this._$link) {
    this._$link.addClass('opened');
  }
};
Accordion.prototype.close = function () {
  this._isOpened = false;
  //
  if (this._$container) {
    this._$container.css({
      overflow: 'hidden'
    });
    var _this = this;
    this._$container.stop().animate(
      {
        height: 0
      },
      300,
      'swing',
      function () {
        _this._$container.css({
          display: 'none',
          height: 'auto',
          overflow: 'visible'
        });
      }
    );
  }
  if (this._$link) {
    this._$link.removeClass('opened');
  }
};
/**
 * @function
 * @description loads billing address, Coupon and Payment methods
 */
exports.init = function () {
  const pointViewer = new PointViewer($('.js-PointViewer'));

  /**
   * 支払方法選択時イベント
   */
  $('.payment-method-options').on('click', 'input[type="radio"]', function () {
    updatePaymentMethod(pointViewer);
  });

  //select credit card tile
  $(document).on('click', '.creditcard-tile', function (evt) {
    var $this = $(this);
    var $thisInner = $this.children('.creditcard-tile-inner');

    if (
      $thisInner.find('#dwfrm_billing_paymentMethods_creditCard_cvn').length > 0
    ) {
      return;
    }

    var ccEdit = $this.find('.credit-card-edit');
    var fauxCVNInput = '<div class="cvn-input"></div>';
    var CVNInput =
      '<input class="input-text " type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn1" value="" maxlength="4" aria-invalid="false">';

    if (evt.target == ccEdit[0]) {
      return;
    }

    if (
      $(this).is('.is-current, .default') ||
      $(this).hasClass('.is-current, .default')
    ) {
      return false;
    } else {
      $('.creditcard-tile-inner').each(function () {
        $(this).removeClass('is-current');
        $(this).removeClass('default');
        $(this).find('.saved-cvn').addClass('disabled');
        $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
      });

      $thisInner.addClass('is-current');
      $this.find('.cvn-input').removeClass('disabled');
      $this.find('.saved-cvn .cvn-input').replaceWith(CVNInput);

      if (
        $('.creditcard-check-wrapper').find('.creditcard-check').is(':checked')
      ) {
        $('.creditcard-check-wrapper')
          .find('.creditcard-check')
          .prop('checked', false);
      }

      var element = document.getElementById(
        evt.currentTarget.getElementsByClassName('creditcard-tile-inner')[0].id
      );

      var creditcardPosition = element.dataset.creditcardPosition;

      var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
        position: creditcardPosition
      });
      $.ajax({
        url: url,
        type: 'GET',
        success: function success() {
          // nothing todo
        }
      });

      setSelectedCardID($this.data('uuid'));
      addCVNEvent();
    }
  });

  $(document).on('click', '.creditcard-label', function () {
    var fauxCVNInput = '<div class="cvn-input"></div>';
    var $cardList = $('.applicable-creditcard-list')
      .find('.creditcard-tile')
      .find('.creditcard-tile-inner');
    var $cardForm = $('.creditcard-check-wrapper');

    $cardForm.find('.error-placement').remove();

    for (var i = 0; i < $cardList.length; i++) {
      if ($cardList.hasClass('is-current')) {
        $cardList.removeClass('is-current');
        $cardList.removeClass('default');
        $cardList.find('.saved-cvn').addClass('disabled');
        $cardList.find('.saved-cvn input').replaceWith(fauxCVNInput);
        $cardList
          .find('.cmd-chk_parts')
          .find('input[name="creditcard"]')
          .prop('checked', false);
      }
    }
  });

  /*決済課程でのクレカ削除*/
  $('.remove-cardpayment').on('click', function (e) {
    e.preventDefault();
    const $paymentItemData = $(this).closest('.cmd-chk_parts');
    $.ajax({
      type: 'POST',
      url: $(this).attr('href'),
      data: {
        CardId: $paymentItemData.find('input[name="Card_id"]').val(),
        CardSeq: $paymentItemData.find('input[name="CardSeq"]').val(),
        CardNumber: $paymentItemData.find('input[name="CardNumber"]').val(),
        // eslint-disable-next-line camelcase
        csrf_token: $paymentItemData.find('#csrf-token-modal').val()
      }
    }).done(function (response) {
      if (!response.success && response.error === 'CSRF Token Mismatch') {
        window.location.href = Urls.csrffailed;
        return;
      }
      if (response.success) {
        location.reload();
        return;
      }
      window.location.href = Urls.generalError;
    });
  });

  $(function () {
    if ($('#paymentmethods_defaultCardPositionNum') !== 0) {
      var selectCreditId =
        '#card_' + $('#paymentmethods_defaultCardPositionNum').val();
      $(selectCreditId).trigger('click');
      $(selectCreditId).closest('.creditcard-tile').trigger('click');
    }
  });

  $(document)
    .on('click', '.billing .address-create', function () {
      $('.ajax-loader').show();
      $.ajax({
        url: Urls.checkoutAddBillingAddress,
        dataType: 'html',
        success: function (response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address').find('.modal-body').html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
            addressModalClose();
          }
        }
      }).complete(function () {
        $('select').selectmenu();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');
        $('.edit-add-address .modal-body').scrollBox();
        //Hide addressname on billing
        if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
          $('.edit-add-address').find('.addressname').addClass('hidden');
        }
      });
    })
    // edit address link
    .on('click', '.billing .address-edit', function () {
      var $this = $(this);
      var addressID = $this.data('addressId');

      $('.ajax-loader').show();
      $.ajax({
        url: Urls.checkoutEditBillingAddress + encodeURIComponent(addressID),
        dataType: 'html',
        success: function (response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address').find('.modal-body').html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
            addressModalClose();
          }
        }
      }).complete(function () {
        $('select').selectmenu();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');
        var setDefaultCheckbox = $('input[id$="_setdefault"]');
        if (setDefaultCheckbox.prop('checked')) {
          setDefaultCheckbox.attr('disabled', 'true');
        }
        $('.edit-add-address .modal-body').scrollBox();
        //Hide addressname on billing
        if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
          $('.edit-add-address').find('.addressname').addClass('hidden');
        }
      });
    });

  validator.initStateValidation();
  validator.initForm('form[id$="billing"]');
  cardValidation.init();

  function toggleBillingAddressFields(visible) {
    if (visible == true) {
      $('.country-dependent').each(function () {
        $(this).show();
      });
    } else {
      $('.country-dependent').each(function () {
        $(this).hide();
      });
    }

    if (window.User.isCustomerAuthenticated == false) {
      $('.checkout-billing').find('.set-default-cb').hide();
    }
  }

  $(document).on(
    'change',
    '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country',
    function () {
      var selectContry = $(this).val();
      if (selectContry == '') {
        toggleBillingAddressFields();
      } else if (selectContry == 'us') {
        toggleBillingAddressFields(true);
        $('.us-fields').show();
        $('.us-fields input').each(function () {
          $(this).addClass('required');
        });

        $('.cn-fields').hide();
        $('.cn-fields input').each(function () {
          $(this).removeClass('required');
        });
      } else {
        toggleBillingAddressFields(true);
        $('.cn-fields').show().css({
          display: 'flex'
        });
        $('.cn-fields input').each(function () {
          $(this).addClass('required');
        });

        $('.us-fields').hide();
        $('.us-fields input').each(function () {
          $(this).removeClass('required');
        });
      }
    }
  );

  $(document).on('click', '.creditcard-label', function () {
    $('.creditcard-tile').each(function () {
      $(this).removeClass('is-current');
    });

    //formの初期化
    formInitialization();
    //選択されているクレカがないのでそれに合わせてバリデータを適用させる
    initValidateSelectPayment();
    $('#gmoPaymentCardList option[value="AddNewCard"]').prop('selected', true);
    $('#gmoPaymentCardList').trigger('change');
    $('.credit-card-save').css('display', 'flex');
    $('#panel-newcard')
      .find('select,input')
      .not('.payinfo')
      .prop('disabled', false);
  });

  $('#dwfrm_billing_paymentMethods_creditCard_type').on(
    'selectmenuchange',
    function () {
      var cardType = $(
        '#dwfrm_billing_paymentMethods_creditCard_type option:selected'
      ).val();

      $('#dwfrm_billing_paymentMethods_creditCard_type').selectmenu('destroy');
      $('#dwfrm_billing_paymentMethods_creditCard_type')
        .val(cardType)
        .prop('selected', true);
      $('#dwfrm_billing_paymentMethods_creditCard_type').selectmenu();
      // gmo.jsの処理呼出
      setSelectPayInfo();
    }
  );
  $('#dwfrm_billing_paymentMethods_creditCard_expiration_month').on(
    'change',
    function () {
      var expirationMonth = $(
        '#dwfrm_billing_paymentMethods_creditCard_expiration_month option:selected'
      ).val();

      $('#dwfrm_billing_paymentMethods_creditCard_expiration_month').selectmenu(
        'destroy'
      );
      $('#dwfrm_billing_paymentMethods_creditCard_expiration_month')
        .val(expirationMonth)
        .prop('selected', true);
      $(
        '#dwfrm_billing_paymentMethods_creditCard_expiration_month'
      ).selectmenu();
    }
  );
  $('#dwfrm_billing_paymentMethods_creditCard_expiration_year').on(
    'change',
    function () {
      var expirationYear = $(
        '#dwfrm_billing_paymentMethods_creditCard_expiration_year option:selected'
      ).val();

      $('#dwfrm_billing_paymentMethods_creditCard_expiration_year').selectmenu(
        'destroy'
      );
      $('#dwfrm_billing_paymentMethods_creditCard_expiration_year')
        .val(expirationYear)
        .prop('selected', true);
      $(
        '#dwfrm_billing_paymentMethods_creditCard_expiration_year'
      ).selectmenu();
    }
  );

  $(document).on('submit', '#CreditCardForm', function (evt) {
    evt.preventDefault();

    var $form = $(this);

    $.ajax({
      url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
      data:
        $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
      type: 'POST'
    }).done(function (data) {
      if (data.length) {
        modal.setContent(data);
        validator.initForm('form[id$="CreditCardForm"]');
        cardValidation.init();
        return;
      }

      if (!location.assign(Urls.billing)) {
        window.location.href = Urls.billing;
      }
    });
  });

  //select credit card tile
  $(document).on('click', '.payment-list .creditcard-tile', function (evt) {
    var $this = $(this);

    var ccEdit = $this.find('.credit-card-edit');
    var fauxCVNInput = '<div class="cvn-input"></div>';
    var CVNInput =
      '<input class="input-text required" type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn_value" maxlength="4" required aria-required="true" data-required-text="' +
      Resources.SAVED_CARD_CVV_REQUIRED_ERROR +
      '"  placeholder="' +
      Resources.SAVED_CARD_CVV_PLACEHOLDER +
      '">';

    if (evt.target == ccEdit[0]) {
      return;
    }

    if ($(this).is('.selected, .default')) {
      return false;
    } else {
      $('.creditcard-tile').each(function () {
        $(this).removeClass('selected');
        $(this).removeClass('default');
        $(this).find('.saved-cvn').addClass('disabled');
        $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
        $(this).find('.js-editCVVLink').addClass('hidden');
        $(this).find('.error-placement').remove();
      });

      $this.addClass('selected');
      $this.find('.cvn-input').removeClass('disabled');
      $this
        .find('.saved-cvn .cvn-input')
        .replaceWith(CVNInput)
        .removeClass('hidden');
      $('.masked-values').addClass('hidden');

      var element = document.getElementById(evt.currentTarget.id);

      var creditcardPosition = element.dataset.creditcardPosition;

      var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
        position: creditcardPosition
      });
      $.ajax({
        url: url,
        type: 'GET',
        success: function () {
          // nothing todo
        }
      });

      setSelectedCardID($this.data('uuid'));
      addCVNEvent();
    }
    $(this)
      .find('input')
      .focusout(function () {
        if ($(this).val() !== '') {
          $('.selected .masked-values')
            .removeClass('hidden')
            .text(creditCardMask($(this)[0].value));
          $(this).addClass('hideCVV');
          $('.selected .js-editCVVLink').removeClass('hidden');
          $('.selected .error-placement').remove();
          validator.initForm('form[id$="billing"]');
        }
      });
  });

  function creditCardMask(number) {
    number = number.replace(/[^0-9]+/g, ''); /*ensureOnlyNumbers*/
    return Array(number.length + 1)
      .join('*')
      .toString();
  }

  $('.order-summary-footer form').submit(function () {
    $('#summary-place-order').prop('disabled', true).addClass('loading');
    return true;
  });

  // trigger click event for selected by default cc (to manually trigger cc code)
  var selectedCC = $('div.payment-method div.creditcard-tile.selected');
  if (selectedCC) {
    selectedCC.removeClass('selected').trigger('click');
  }

  // maximize order checkout summary dropdown
  util.maximizeCheckoutSummary();

  // trigger only for non-registered users
  if (window.User.isCustomerAuthenticated == false) {
    $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on(
      'change',
      function () {
        $('select[name$="_creditCard_expiration_month"]').trigger('change');
        $('select[name$="_creditCard_expiration_month"]').trigger('change');
      }
    );
  }

  //初期支払方法によって呼び出すバリデータが違うようになる
  initValidateSelectPayment();

  //支払方法が変更されるたびにそれに合わせてバリデータを呼び出す
  $(document)
    .off(
      'change.paymentSelect',
      'input[name$="dwfrm_billing_paymentMethods_selectedPaymentMethodID"]'
    )
    .on(
      'change.paymentSelect',
      'input[name$="dwfrm_billing_paymentMethods_selectedPaymentMethodID"]',
      function () {
        initValidateSelectPayment();
      }
    );

  $(document)
    .off('change.creditCardSelect', 'input:radio[name$="creditcard"]')
    .on(
      'change.creditCardSelect',
      'input:radio[name$="creditcard"]',
      function () {
        initValidateSelectPayment();
      }
    );

  /**
   * 支払方法がコンビニ支払の時、選択したコンビニの情報を保持する
   */
  $(document)
    .off('click.gmoCvsCode', 'ul#gmoCvsCode-menu')
    .on('click.gmoCvsCode', 'ul#gmoCvsCode-menu', function () {
      // 「gmoCvsCode」を取得
      const gmoCvsCode = $('select#gmoCvsCode').val();
      const csrfToken = $('#gmoCvsCode')
        .closest('form')
        .find('input[name=csrf_token]')
        .val();
      $.ajax({
        url: Urls.gmoCvsCode + '?gmoCvsCode=' + gmoCvsCode,
        type: 'POST',
        data: {
          gmoCvsCode: gmoCvsCode,
          // eslint-disable-next-line camelcase
          csrf_token: csrfToken
        },
        success: function () {
          // nothing todo
        }
      });
    });

  cardValidation.init();
  initCache();
  initCreditCardForm();
  summarysection.init();
  initCreditCardEvents(pointViewer);
  initClearCreditCardEvent();

  $('select').selectmenu();

  pointViewer.update();
  pointViewer.showApiErrors();
  const accordion = new Accordion($('.js-Accordion'));
  accordion.init();

  // 支払方法を設定
  updatePaymentMethod(pointViewer);

  // 初期表示時にポイント入力部にエラーがあるかポイント入力がある場合、展開する。
  if (
    $('.point_form_error_list').children('.hasError').length > 0 ||
    pointViewer.totalUsingPoint > 0
  ) {
    accordion.open();
  } else {
    accordion.close();
  }
};

$('[for=dwfrm_billing_paymentMethods_creditCard_saveCard]').css(
  'color',
  '#000'
);

//購入フローのコンテンツアセットorder-assistanceのクラス判定
if (navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)) {
  $('#tell-number-order').addClass('link-tel-number-order');
} else {
  $('#tell-number-order').addClass('no-link-tel-number-order');
}

},{"../../modal":43,"../../pages/summarysection":85,"../../util":105,"../../validator":106,"../product/index":70,"./card-validation":53}],53:[function(require,module,exports){
'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

var cvvCheck = function (cvv) {
    return /^[0-9]{3,4}$/.test(cvv);    
};

var initCardExpiry = function(){
	
	var ccSave = $('#CreditCardForm #applyBtn');
	ccSave.on('click', function(e){
		validateCardExpiry(this, true , false);
	});
	 $(".billing-continue-container .continue").off('click.card.expiry').on('click.card.expiry', function (e) {
		 validateCardExpiry(this, true , false);
	 });

	$('.month-field .ui-selectmenu-button, .year-field .ui-selectmenu-button').on('blur', function(){
		validateCardExpiry(this, false, true);
	});

};

var validateCardExpiry = function(el, checkEmpty ,flagOnBlur){
	const selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
	if (selectedPaymentMethodID != 'CREDIT_CARD') {
		return;
	}
	
	// need to declare specifically in order not to confuse with other forms with similar inputs
	var $this = $(el);
	var $month = $this.closest('form').find('.card-expiry.month');
	var $year = $this.closest('form').find('.card-expiry.year');
	var hasError = false;
	
	var now = new Date();
	var nowMonth = now.getMonth() + 1; 
	var nowYear = now.getFullYear();
	
	if(flagOnBlur && $this.siblings('select').val() == ""){
		var customyearRow = $this.parents().siblings('label');
		customyearRow.next('.error-placement').remove();
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ Resources.INVALID_CARDEXPIRY +'</span></div>').insertAfter(customyearRow);
		customyearRow.parent().find('span.ui-selectmenu-button').addClass('dropdownerror');
		hasError = true;
	} else {
		$this.removeClass('dropdownerror');
		$this.parents().siblings('.error-placement').remove();
	} 
	// validate only on form submit
	if(checkEmpty && (!$month.val() || !$year.val()) ){
		var customyearRow = $('.month-field label');
		customyearRow.next('.error-placement').remove();
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ Resources.INVALID_CARDEXPIRY +'</span></div>').insertAfter(customyearRow);
		customyearRow.parent().find('span.ui-selectmenu-button').addClass('dropdownerror');
		hasError = true;
	
	// validate only if month and year has value, otherwise, ignore
	} else if($month.val() && $year.val() && (($month.val() < nowMonth && $year.val() <= nowYear)||($month.val() > nowMonth && $year.val() < nowYear))){
		var customyearRow = $('.month-field label');
		customyearRow.next('.error-placement').remove();
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ Resources.INVALID_CARDEXPIRY +'</span></div>').insertAfter(customyearRow);
		$('.expiration-date span.ui-selectmenu-button').addClass('dropdownerror');
		hasError = true;
	} 
	
	// highlight inputs if expiry has error 
	if(hasError){
		$this.not('#applyBtn').addClass('dropdownerror');
		if($('.add-cc-button-wrap').length > 0) {
			$('.add-cc-button-wrap #applyBtn').attr('disabled','true');
		}
		if($('.billing-address-section').length > 0) {
			$('.billing-address-section .continue').attr('disabled','true');
		}
	} else {
		hasError = false;
		$month.next().removeClass('dropdownerror');
		$year.next().removeClass('dropdownerror');
		$month.parents().siblings('.error-placement').remove();
		$year.parents().siblings('.error-placement').remove();
		if($('.add-cc-button-wrap').length > 0) { //for popup on registered
			$('.add-cc-button-wrap #applyBtn').removeAttr('disabled');
		}
		if($('.billing-address-section').length > 0) { //for page form guest user and unsaved card registered
			$('.billing-address-section .continue').removeAttr('disabled');
		}
	}
};

exports.init = function () {
	initCardExpiry();
}
},{}],54:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var hasEmptyRequired = function () {
  // filter out only the visible fields
  var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
    return $(this).val();
  });
  return _(requiredValues).contains('');
};

var validateForm = function () {
  var _self = this;
  // only validate form when all required fields are filled to avoid
  // throwing errors on empty form
  if (!this.validator) {
    return;
  }

  // wait for the form to show before validating.. this applies to modals
  this.timer = setInterval(function () {
    if (_self.$form.is(':visible')) {
      if (
        _self.$form.find('span.error:visible, .error-form:visible').length == 0
      ) {
        //!_self.hasEmptyRequired() &&
        _self.$continue.removeAttr('disabled');
      } else {
        _self.$continue.prop('disabled', true);
      }
      clearInterval(_self.timer);
    }
  }, 100);
};

var validateEl = function (e) {
  if ($(e.target).val() === '') {
    this.$continue.prop('disabled', true);
  } else {
    // enable continue button on last required field that is valid
    // only validate single field
    if (!this.hasEmptyRequired()) {
      //this.$continue.removeAttr('disabled');
    } else {
      this.$continue.prop('disabled', true);
    }
  }
};

var checkValue = function (repopulateRequiredFields, e) {
  var $el = $(e.target);
  var attr = $el.attr('clear-on-error');

  // check for new required fields (e.g. changing US -> CH in address)
  if (repopulateRequiredFields) {
    this.$requiredInputs = this.$form.find('input.required');
  }

  // remove any error message residue from previous validation
  $el
    .parents('.form-row')
    .find('.error-placement')
    .remove();

  if (
    this.validator.element($el) &&
    this.$form.find('span.error:visible').length == 0
  ) {
    this.$continue.prop('disabled', false);
  } else {
    this.$continue.prop('disabled', true);

    // clear the value if input has error
    if (typeof attr !== typeof undefined && attr !== false) $el.val('');
  }
};

var checkValueBlank = function (repopulateRequiredFields, e) {
  var $el = $(e.target);
  var attr = $el.attr('clear-on-error');

  var $cardForm = $('[data-method="CREDIT_CARD"]');
  this.$requiredInputs = $cardForm.find('input[type="text"]');

  // 支払方法選択画面では、支払方法がクレジットカードの場合のみ確認を行う
  if (
    $('form[id$="_billing"]').length !== 0 &&
    !$('#is-CREDIT_CARD').prop('checked')
  ) {
    return;
  }
  var formValueBlank = this.$requiredInputs.get().some(function (textValue) {
    return textValue.value == '' || textValue.value == null;
  });

  // remove any error message residue from previous validation
  $el
    .parents('.form-row')
    .find('.error-placement')
    .remove();
  if (
    this.validator.element($el) &&
    this.$form.find('span.error:visible').length == 0 &&
    !formValueBlank
  ) {
    this.$continue.prop('disabled', false);
  } else {
    this.$continue.prop('disabled', true);

    // clear the value if input has error
    if (typeof attr !== typeof undefined && attr !== false) $el.val('');
  }
};

var submitForm = function (e) {
  this.$form.find('input').blur();
  this.$form.find('select').blur();
  this.$form.find('.ui-selectmenu-button').blur();

  if (
    this.validator.numberOfInvalids() > 0 ||
    this.$form.data('submitting') == true ||
    $('.state .required option:selected').text() ==
    Resources.SELECT_STATE_OPTION
  ) {
    //    	this.$continue.prop('disabled', true);
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  // adding this to prevent multiple submission of forms
  if (this.$form.attr('multiple-submission') === 'false') {
    this.$form.data('submitting', true);
  }
};

var init = function (opts, settings) {
  if (!opts.formSelector || !opts.continueSelector) {
    throw new Error('Missing form and continue action selectors.');
  }
  this.$form = $(opts.formSelector);
  this.$continue = $(opts.continueSelector);
  this.validator = settings
    ? this.$form.validate(settings)
    : this.$form.validate();
  this.$allInputs = $('input, textarea', this.$form);
  this.$allSelect = $('select', this.$form);
  this.$requiredInputs = this.$form.find('input.required');
  //    this.validateForm();

  // start listening
  //this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
  var checkValue_formInfo = this.$form.hasClass('for-creditcard-validation')
    ? this.checkValueBlank
    : this.checkValue;
  this.$allSelect.on('blur', $.proxy(checkValue_formInfo, this, true));
  this.$allInputs.on('blur', $.proxy(checkValue_formInfo, this, false));
  this.$continue.on('click', $.proxy(this.submitForm, this));
  // [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
  if (this.$continue.attr('mousesubmit') === 'true') {
    this.$continue.on(
      'mousedown',
      $.proxy(function (e) {
        this.$continue.click();
      }, this)
    );
  }
};

var formPrepare = function () {
  return {
    $form: null,
    $continue: null,
    $allInputs: null,
    $allSelect: null,
    $requiredInputs: null,
    validator: null,
    init: init,
    timer: null,
    hasEmptyRequired: hasEmptyRequired,
    checkValue: checkValue,
    checkValueBlank: checkValueBlank,
    validateForm: validateForm,
    submitForm: submitForm,
    validateEl: validateEl
  };
};

module.exports = formPrepare;

},{"lodash":112}],55:[function(require,module,exports){
'use strict';

const address = require('./address');
const billing = require('./billing');
const multiship = require('./multiship');
const shipping = require('./shipping');
const summarysection = require('../summarysection');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
  address.init();
  if ($('.checkout-shipping').length > 0) {
    shipping.init();
  } else if ($('.checkout-multi-shipping').length > 0) {
    multiship.init();
  } else if ($('form.checkout-billing').length > 0) {
    billing.init();
  } else if ($('.order-summary-footer form').length > 0) {
    summarysection.init();
  }

  //if on the order review page and there are products that are not available diable the submit order button
  if ($('.order-summary-footer').length > 0) {
    if ($('.notavailable').length > 0) {
      $('.order-summary-footer .submit-order .button-fancy-large').attr(
        'disabled',
        'disabled'
      );
    }
  }
};

},{"../summarysection":85,"./address":51,"./billing":52,"./multiship":57,"./shipping":58}],56:[function(require,module,exports){
'use strict';

var validator = require('../../validator');

/**
 * @function
 * @description Toggle between guest and account checkout
 */
function toggleCheckoutMethod() {
	$('.checkout-toggle-link').on('click', function() {
		$('.checkoutlogin').toggleClass('account');
	});
}

/**
 * @function
 * @description Enable/disable button depending if input has value and mandatory field
 */
function enableDisableSubmitButton(el) {
	var $saveBtn = $(el).closest('form').find('button[type="submit"]');
	var hasError = $saveBtn.closest('form').find('span.error');
	if(hasError.length) {
		return true
	} else {
		return false;
	}
}

function checkoutButtonEnableDisable() {
	//Guest Checkout
	if($('.guest-checkout').length) {
		var form = $('form[id="guest-login"]'),
			emailButton1 = $('.guest-checkout button'),
			emailInput1 = $('.guest-checkout input[type="email"]'),
			setDefaultCheckbox1 = $('input[id$="_termsandconditions"]');

			$(emailInput1).on('blur', function() {
				var validator = form.validate();
				var validFlag = validator.element($(this));
				emailButton1.prop('disabled', $(form).find('.error-placement').length > 0 ? true : false);
			});
	}

	//Account Checkout
	if($('.account-checkout').length) {
		var emailButton2 = $('.account-checkout .login-account button'),
			emailInput2 = $('.account-checkout .login-account input[type="email"]'),
			password = $('.account-checkout .login-account input[type="password"]');
		$(emailInput2, password).on('blur focus', function() {
			var email_regx =  validator.regex.email;
			if (email_regx.test(emailInput2.val())) {
				if(!password.val().length || enableDisableSubmitButton(emailButton2)) {
					emailButton2.prop('disabled', 'disabled');
				} else {
					emailButton2.prop('disabled', false);
				}
			} else {
				emailButton2.prop('disabled', 'disabled');
			}
		});
	}

	//Existing Account Checkout
	if($('.existing-account-login').length) {
		var emailButton3 = $('.existing-account-login button#login'),
			emailButton4 = $('.existing-account-login button#guestcheckout'),
			password3 = $('.existing-account-login input[type="password"]');
		$(password3).on('blur', function() {
			if (!password3.val().length) {
				emailButton3.prop('disabled', 'disabled');
			} else {
				emailButton3.prop('disabled', false);
			}
			enableDisableSubmitButton(emailButton3);
			emailButton4.prop('disabled', false);
		});
	
		if (!password3.val().length) {
			emailButton3.prop('disabled', 'disabled');
		}
	}
}

exports.init = function () {
	toggleCheckoutMethod();
	checkoutButtonEnableDisable();
};

},{"../../validator":106}],57:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}


/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if  (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' +
                    ((address.ID) ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' +
                    address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode +
                    '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
    	validator.initForm('form[id$="multishipping_addressSelection"]');
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({url: this.attributes.href.value,  options: {open: function () {
            address.init();
            addEditAddress(e.target);
        }}});
    });
};

},{"../../dialog":31,"../../util":105,"../../validator":106,"./address":51,"./formPrepare":54}],58:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  progress = require('../../progress'),
  tooltip = require('../../tooltip'),
  util = require('../../util'),
  validator = require('../../validator'),
  modal = require('../../modal').global,
  //addressVerificationSvc = require('../../qas'),
  summarysection = require('../../pages/summarysection'),
  index = require('../product/index'),
  customModal = require('../../modal');

/**
 * Filter the delivery timespan based on the selected date and nearly date.
 * */
function filterDeliveryTimespan() {
  var selectedDate = $('.deliveryDate').val();

  if ($('.deliveryTime').length <= 0) {
    return;
  }

  var url = Urls.filterDeliveryTimespan;
  var params = {
    selectedDate: selectedDate,
    format: 'ajax',
    zip7: $('#zip7').val()
  };
  url = util.appendParamsToUrl(url, params);

  progress.show($('.add-deliverydate'));
  $.ajax({
    dataType: 'json',
    url: url,
    type: 'GET',
    data: params
  }).done(function(data) {
    if (!data) {
      return;
    }
    var selectbox = $('.deliveryTime');
    var selectedTime = $(selectbox).val();
    $(selectbox).empty();
    var deliveryTime = data.data;
    var selected = '';
    for (var i = 0; i < deliveryTime.length; i++) {
      if (deliveryTime[i].value === selectedTime) {
        selected = 'selected="selected"';
      } else {
        selected = '';
      }
      $(selectbox).append(
        $('<option ' + selected + '></option>')
          .attr('value', deliveryTime[i].value)
          .text(deliveryTime[i].name)
      );
    }

    if (data.isUnavailableTimespan) {
      $('.error-timespan').show();
      $('.error-timespan').text(Resources.UNAVAILABLE_TIMESPAN);
    } else {
      $('.error-timespan').hide();
      $('.error-timespan').text('');
    }

    progress.hide();
  });
}

var $cache, shippingMethods;

function initCache() {
  var $formEle = $('form[id$="_shippingAddress"]');
  $cache = {
    addrForm: {
      address1: $formEle.find('input[name$="_address1"]'),
      address2: $formEle.find('input[name$="_address2"]'),
      countryCode: $formEle.find('select[id$="_country"]'),
      stateCode: $formEle.find('select[id$="_state"]'),
      postalCode: $formEle.find('input[name$="_postal"]'),
      city: $formEle.find('input[name$="_city"]')
    }
  };
}

//address modal close
function addressModalClose() {
  $(document).on('click', '.edit-add-address .cancel-button', function() {
    $(this)
      .closest('.modal-overlay')
      .remove();
    $('html').removeClass('modal-open');
  });
}

function initEvents() {
  addressModalClose();
  $(document)
    // create address link
    .on('click', '.address-create', function(evt) {
      $('.ajax-loader').show();
      $.ajax({
        url: Urls.checkoutAddAddress,
        dataType: 'html',
        success: function(response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address')
              .find('.modal-body')
              .html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
            addressModalClose();
          }
        }
      }).complete(function(data) {
        $('select').selectmenu();
        $('.edit-add-address .modal-body').scrollBox();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');
      });
    })
    // scheduled delivery requests
    .on('click', '.delivery-date-create', function(evt) {
      evt.preventDefault();
      $('.delivery-date-error').remove();
      $('.ajax-loader').show();
      $.ajax({
        url: $(this).attr('href'),
        dataType: 'html',
        success: function(response) {
          if (response) {
            customModal.createCustomModal('add-deliverydate');
            $('.add-deliverydate')
              .find('.modal-body')
              .html(response);
          } else {
            if ($('.delivery-date-error').length === 0) {
              $('div.delivery-date').before(
                '<div class="error-form delivery-date-error">' +
                  Resources.DELIVERY_DATE_API_ERROR +
                  '</div>'
              );
            }
          }
          $('.ajax-loader').hide();
        }
      });
    })
    .on('change', '.deliveryDate', function(e) {
      filterDeliveryTimespan();
    })
    // edit address link
    .on('click', '.address-edit', function(evt) {
      var $this = $(this);
      var addressID = $this.data('addressId');

      $('.ajax-loader').show();
      $.ajax({
        url: Urls.checkoutEditAddress + encodeURIComponent(addressID),
        dataType: 'html',
        success: function(response) {
          if (response.indexOf('header-wrapper') === -1) {
            customModal.createCustomModal('edit-add-address');
            $('.edit-add-address')
              .find('.modal-body')
              .html(response);
            index.bodyPositionFixed('edit-add-address');
            $('.ajax-loader').hide();
            addressModalClose();
          }
        }
      }).complete(function(data) {
        $('select').selectmenu();
        validator.initStateValidation();
        validator.initForm('form[id="EditAddressForm"]');

        var setDefaultCheckbox = $('input[id$="_setdefault"]');
        if (setDefaultCheckbox.prop('checked')) {
          setDefaultCheckbox.attr('disabled', 'true');
        }

        $('.edit-add-address .modal-body').scrollBox();
      });
    })

    // authenticated user address change
    .on('click', '.address-list .address-tile', function(evt) {
      if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
        return false;
      }

      $('.address-list .address-tile').each(function() {
        $(this).removeClass('selected');
        $(this).removeClass('default');
      });

      $(this).addClass('selected');

      var element = document.getElementById(evt.currentTarget.id);
      var addressID = element.dataset.addressId;

      // update address; on success update shipping method list
      $.get(
        Urls.updateAddressDetails,
        {
          addressID: addressID
        },
        function(response) {
          updateShippingMethodList();
        }
      );
    });

  // guest user address change
  var timer = null;
  $('form[id$="_shippingAddress"]').on(
    'change',
    'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], select[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]',
    function() {
      if (!validateAddrForm()) {
        return;
      }

      if (timer) {
        window.clearTimeout(timer);
      }

      timer = window.setTimeout(function() {
        $.post(
          Urls.setShippingAddressDetails,
          $('form[id$="_singleshipping_shippingAddress"]').serialize(),
          function(result) {
            updateShippingMethodList();
          }
        );
      }, 200);
    }
  );

  $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
  $('input[name$="_cart_isGift"]').on('click', function() {
    giftMessageBox();
    //Update Order Summary
    $('.ajax-loader').show();
    $.ajax({
      url: Urls.updateGiftWrap,
      dataType: 'html',
      success: function(response) {
        $('.order-estimation-details').html(response);
        $('.ajax-loader').hide();
      }
    });
  });
}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
  // show gift message box, if shipment is gift
  $('.gift-message-text').toggleClass(
    'hidden',
    $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true'
  );
  $('.complimentary-gift-container').toggleClass(
    'd-none',
    $('input[name$="_cart_isGift"]:checked').val() !== 'true'
  );
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
  var $summary = $('#secondary.summary');
  var couponError;

  if ($('.cart-coupon-code .error').length) {
    couponError = $('.cart-coupon-code .error').clone();
  }

  // indicate progress
  progress.show($summary);

  // load the updated summary area
  $summary.load(Urls.summaryRefreshURL, function() {
    // hide edit shipping method link
    $summary.fadeIn('fast');

    // checkout checkout minicart on right side event handling
    addSummaryScrollbar();

    $summary.find('.checkout-mini-cart .minishipment .header a').hide();
    $summary.find('.order-totals-table .order-shipping .label a').hide();
    $('.cart-coupon-code').append(couponError);
    util.maximizeCheckoutSummary();
  });
}

function getAddressFromTile() {
  var $selectedAddress = $('.address-tile.selected address');

  return {
    address1: $selectedAddress.data('address-one'),
    address2: $selectedAddress.data('address-two') || '',
    countryCode: $selectedAddress.data('country-code'),
    stateCode: $selectedAddress.data('state-code'),
    postalCode: $selectedAddress.data('postal-code'),
    city: $selectedAddress.data('city')
  };
}

function getAddressFromForm() {
  return {
    address1: $cache.addrForm.address1.val(),
    address2: $cache.addrForm.address2.val(),
    countryCode: $cache.addrForm.countryCode.val(),
    stateCode: $cache.addrForm.stateCode.val(),
    postalCode: $cache.addrForm.postalCode.val(),
    city: $cache.addrForm.city.val()
  };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
  var params = User.isCustomerAuthenticated
    ? getAddressFromTile()
    : getAddressFromForm();
  return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
  // nothing entered
  if (!shippingMethodID) {
    return;
  }
  // attempt to set shipping method
  var url = getShippingMethodURL(Urls.selectShippingMethodsList, {
    shippingMethodID: shippingMethodID
  });
  ajax.getJson({
    url: url,
    callback: function(data) {
      updateSummary();
      if (!data || !data.shippingMethodID) {
        window.alert("Couldn't select shipping method.");
        return false;
      }
      // display promotion in UI and update the summary section,
      // if some promotions were applied
      $('.shippingpromotions').empty();
    }
  });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
  var $shippingMethodList = $('#shipping-method-list');
  if (!$shippingMethodList || $shippingMethodList.length === 0) {
    return;
  }
  var url = getShippingMethodURL(Urls.shippingMethodsJSON);
  ajax.getJson({
    url: url,
    callback: function(data) {
      if (!data) {
        window.alert("Couldn't get list of applicable shipping methods.");
        return false;
      }

      // shipping methods remain unchanged; update summary as selected method may/may not change
      if (shippingMethods && shippingMethods.toString() === data.toString()) {
        updateSummary();
        return true;
      }

      // We need to update the UI.  The list has changed.
      // Cache the array of returned shipping methods.
      shippingMethods = data;
      // indicate progress
      progress.show($shippingMethodList);

      // load the shipping method form
      var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
      $shippingMethodList.load(smlUrl, function() {
        $shippingMethodList.fadeIn('fast');
        // rebind the radio buttons onclick function to a handler.
        $shippingMethodList
          .find('[name$="_shippingMethodID"]')
          .click(function() {
            selectShippingMethod($(this).val());
          });

        // update the summary
        updateSummary();
        progress.hide();
        tooltip.init();
        //if nothing is selected in the shipping methods select the first one
        if ($shippingMethodList.find('.input-radio:checked').length === 0) {
          $shippingMethodList
            .find('.input-radio:first')
            .prop('checked', 'checked');
        }
      });
    }
  });
}

function validateAddrForm() {
  var addr = getAddressFromForm();
  return (
    addr.address1 &&
    addr.city &&
    addr.postalCode &&
    addr.stateCode &&
    addr.countryCode
  );
}

function selectedAddress() {
  $(document).on(
    'click',
    '#add-coupon, #primarybtn, #remove-coupon',
    function() {
      var element = document.getElementById(
        'dwfrm_singleshipping_shippingAddress'
      );
      var radioNodeList = element.dwfrm_shippingaddress_addressnumber;
      if (radioNodeList.value != null) {
        $("input[name='selectShippingAddressNumber']").val(radioNodeList.value);
      } else {
        for (var i = 0; i < radioNodeList.length; i++) {
          if (radioNodeList[i].checked) {
            $("input[name='selectShippingAddressNumber']").val(
              radioNodeList[i].value
            );
          }
        }
      }
    }
  );
}

exports.init = function() {
  initCache();
  initEvents();
  summarysection.init();
  selectedAddress();
  //addressVerificationSvc.init();

  if (window.User.isCustomerAuthenticated == false) {
    validator.initStateValidation();
    $('.checkout-shipping')
      .find('.set-default-cb')
      .hide();
  }

  validator.initForm('form[name$="shippingAddress_save"]');

  giftMessageBox();

  $(document)
    .find('div.address-list div.address-tile')
    .each(function() {
      if (
        $(this).hasClass('default') ||
        $(this).hasClass('selected') ||
        $(this).hasClass('address-default')
      ) {
        $(this).removeClass('selected');
        $(this).removeClass('default');

        $(this).click();
      }
    });
};

exports.updateShippingMethodList = updateShippingMethodList;

},{"../../ajax":1,"../../modal":43,"../../pages/summarysection":85,"../../progress":91,"../../tooltip":104,"../../util":105,"../../validator":106,"../product/index":70}],59:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":1,"../page":46,"../product-tile":90,"../quickview":92,"./product/addToCart":66}],60:[function(require,module,exports){
'use strict';

var util = require('../util'),
	currentLayout = require('../detect-layout'),
	productTile = require('../product-tile'),
	addToCart = require('./product/addToCart'),
	socialShareIcons = require('./product/socialShareIcons');

var currLayout = currentLayout.init();

function initializeEvents() {
	$(document)

		// mobile navigation
		.on('change', '.promotion-nav-select select', function (e) {
			var newUrl = $(this).find("option:selected").val();

			if (newUrl) {
				window.location.href = newUrl;
			}
		});

    // concierge form events
    var conciergeForm = $('form[id$="_beautyconsultant"]');
    if (conciergeForm.length > 0) {
        // secure concierge access
        /*if (location && location.protocol === 'http:') {
            window.location.href = Urls.secureConciergeForm;
        }*/

        var successShown = false;
        conciergeForm.on('click', 'button#sendBtn', function(e) {
            e.preventDefault();

            $.ajax({
                url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
                data: conciergeForm.serialize(),
                method: 'POST'
            }).done(function (response) {
                var conciergeModal = $('#concierge-modal');
                if (response && response.success && conciergeModal.length > 0) {
                    // show success modal
                    successShown = true;
                    var popup = new Foundation.Reveal(conciergeModal);
                    //Window height minus 80px, which sets the modal to fit inside the device's screen
                    var windowHeight = window.innerHeight - 130;

                    popup.$element.children('.modal-body').css('max-height', windowHeight);	
                    popup.open();

                    // trigger ga
                    window.history.pushState("", "", Urls.conciergeForm);
                    $(document).trigger("askanexpert");
                }
            });
        });

        $(document).on('click', '.reveal-overlay', function () {
            // trigger redirect when concierge overlay is closed
            if (successShown && $(this).css('display') == 'none') {
                successShown = false;
               window.location.href = Urls.secureConciergeForm;
            }
        });
    }


	$('.article-navigation .icon-downCarrot').on('click',function(){
		$(this).parents('.article-navigation').toggleClass('article-open');
	})

	if(currLayout == 'desktop') {
		if($('.pt_content.pt_article').length && $('.product-content .product-tile').length) {
			$('.product-content .product-tile').height($('.article-content.bottom').innerHeight())
		}
	}

	//Article content featured carousel
	if($('.article-carousel-slick').length > 0) {
		$('.article-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}

	if($('.pt_article [data-attr="slide"]') && $('.pt_article [data-attr="slide"]').length > 1 ) {
		$(window).on('load resize orientationchange', function() {
			var $carousel = $('.article-hero-component .slick-slider');
		
			if (!$carousel.hasClass('slick-initialized')) {
				$('.pt_article [data-attr="slide"]').each( function() {
					$carousel.append($(this).html());
				});
				$carousel.slick({
					easing: 'ease',
					arrows: false,
					slidesToShow: 1.14,
					centerMode: true,
					centerPadding: '1px',
					infinite: false
				});
			}
		});
	}
	$(document).on('click', '.articles-view-more', function(e){
		e.preventDefault();
		$('.ajax-loader').show();
		var gridUrl = $(this).attr('data-grid-url');
		$.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
				$('.ajax-loader').hide();
				var delimiter = $('.article-bottom').offset().top;
				$('.article-bottom').replaceWith(response);
				 $('html, body').animate({
					    scrollTop: delimiter
					  }, 500 ,'linear');
            }
        });
	});
	productTile.init();
	
	addToCart();
	
	socialShareIcons();
}

module.exports.init = function () {
	initializeEvents();
};
},{"../detect-layout":30,"../product-tile":90,"../util":105,"./product/addToCart":66,"./product/socialShareIcons":76}],61:[function(require,module,exports){
'use strict';

exports.init = function() {
  (function() {
    var order = [],
      orderValue = [],
      checkBoxSelectionLimit = 2,
      $util = require('../util'),
      $layout = require('../detect-layout'),
      $currentLayout = $layout.init(),
      $skinToneSlider = $('.skin-tone-wrapper .question-body.carousel'),
      $selectedSkinToneSlickIndex = '',
      $normalCarousel = $(
        '.content-wrapper:not(.js-question-5) .question-body.carousel'
      ),
      $question5Carousel = $(
        '.content-wrapper.js-question-5 .question-body.carousel'
      ),
      $currentQuestion = $('input.current-question').val();

    /*
     * function definition
     * Question's options image height handler.
     */
    function updateOptionsHeight() {
      var $maxHeight = '',
        $contentImages = $('.content-wrapper .img-wrapper');
      if ($contentImages.length > 0) {
        $contentImages.removeAttr('style');
        $maxHeight = Math.max.apply(
          null,
          $contentImages
            .map(function() {
              return $(this).width();
            })
            .get()
        );
        $contentImages.css(
          'min-height',
          Math.floor($maxHeight + $maxHeight / 2)
        );
      }
    }

    /*
     * function definition
     * Header visibility handler on window scroll and load.
     */
    function updateHeaderVisibility() {
      if ($('.pt_foundation').length > 0 && $(window).scrollTop() == 0) {
        setTimeout(function() {
          if (
            !$('html').hasClass('nav-open') &&
            !$('html').hasClass('sticky-header-search') &&
            !$('.has-sub-menu').hasClass('hover') &&
            !$('.utility-nav li').hasClass('hovered') &&
            !$('.header-wrapper').hasClass('hovered')
          ) {
          }
        }, 3000);
      }
    }

    /*
     * function definition
     * Retain question1 selected answer in the client-side storage.
     */
    function retainSelectedSkinTone() {
      var $selectedSkinToneIndex = localStorage.getItem(
        'question' + $currentQuestion
      );
      if ($selectedSkinToneIndex !== null) {
        $skinToneSlider.slick('slickGoTo', $selectedSkinToneIndex);
        $(
          '.slick-slide[data-slick-index=' +
            $selectedSkinToneIndex +
            '] .single-radio'
        ).addClass('selected');
        $('input.selected-answer').val(
          $(
            '.slick-slide[data-slick-index=' +
              $selectedSkinToneIndex +
              '] .single-radio .js-answer-option'
          ).val()
        );
        $('.js-foundation-finder-next').attr('disabled', false);
        localStorage.removeItem('question' + $currentQuestion);
      }
    }

    /*
     * function definition
     * Retain question5 selected answer on page back and remove it.
     */
    function retainSelectedBenefit() {
      var $answers = [],
        $selectedId = localStorage.getItem('question' + $currentQuestion);
      if ($selectedId !== null) {
        $('.foundation-finder-wrapper .js-answer-option:checked').prop(
          'checked',
          false
        );
        $answers = $selectedId.split(',');
        for (var $i = 0; $i <= $answers.length; ++$i) {
          $('#' + $answers[$i]).trigger('click');
        }
      }
      localStorage.removeItem('question' + $currentQuestion);
    }

    /*
     * function definition
     * Store selected answer in the client-side storage.
     */
    function storeSelectedValuesIE() {
      localStorage.setItem(
        'question' + $currentQuestion,
        $('.foundation-finder-wrapper .js-answer-option:checked + label').attr(
          'for'
        )
      );
    }

    /*
     * function definition
     * Retain selected answer on page back.
     */
    function retainSelectedValuesIE() {
      var $selectedAnswer = localStorage.getItem('question' + $currentQuestion);
      if ($selectedAnswer !== null) {
        $('label[for=' + $selectedAnswer + ']').trigger('click');
        localStorage.removeItem('question' + $currentQuestion);

        $('.foundation-finder-wrapper .js-answer-option:checked').addClass(
          'checked'
        );
        $('.js-foundation-finder-next').attr('disabled', false);
        $('input.selected-answer').val(
          $('.foundation-finder-wrapper .js-answer-option:checked').val()
        );
      }
    }

    /*
     * function definition
     * Retain scroll position to top of the page. Hence, last scroll position will be '0' on browser back.
     */
    function backToPageTop() {
      // hide body to prevent the flicker effect when window scroll to top.
      $('body').hide();
      $(window).scrollTop(0);
    }

    $(document)
      .on(
        {
          beforeChange: updateOptionsHeight
        },
        '.content-wrapper .carousel'
      )
      /*
       * Click event : Radio button selection.
       */
      .on('click', '.skin-tone-wrapper .single-radio', function() {
        $skinToneSlider.find('.single-radio').removeClass('selected');
        $(this).addClass('selected');
        $('input.selected-answer').val(
          $skinToneSlider.find('.single-radio.selected .js-answer-option').val()
        );
        $('.js-foundation-finder-next').attr('disabled', false);
        $selectedSkinToneSlickIndex = $(this)
          .closest('.slick-slide')
          .data('slick-index');
      })
      /*
       * Click event : Radio and Checkbox
       * Toggle radio checked/unchecked radio.
       * Unchecked checkbox : when checkbox selection limit exceed.
       */
      .on('click', '.foundation-finder-wrapper .js-answer-option', function() {
        if ($(this).is(':radio')) {
          if ($(this).hasClass('checked')) {
            $(this).prop('checked', false);
          }
          $(this)
            .closest('.single-radio')
            .siblings()
            .find('.js-answer-option')
            .removeClass('checked');
          $(this).toggleClass('checked');

          $('input.selected-answer').val($(this).val());

          if ($('.js-answer-option:checked').length > 0) {
            $('.js-foundation-finder-next').attr('disabled', false);
          } else {
            $('.js-foundation-finder-next').attr('disabled', true);
          }
        } else {
          if (
            $(this)
              .closest('.question-body')
              .find('.js-answer-option:checked').length > checkBoxSelectionLimit
          ) {
            this.checked = false;
          }
        }
      })
      /*
       * Click event : Checkbox
       * Prevent to slect checkbox when exceed "checkBoxSelectionLimit".
       * Display numeric selection order.
       */
      .on('change', '.multi-checkbox .js-answer-option', function() {
        var idx = order.indexOf(this);
        if (idx !== -1) {
          order.splice(idx, 1);
        }
        if (
          this.checked &&
          $('.foundation-finder-wrapper .js-answer-option:checked').length <=
            checkBoxSelectionLimit
        ) {
          order.push(this);
        }
        if (
          $('.foundation-finder-wrapper .js-answer-option:checked').length >=
          checkBoxSelectionLimit
        ) {
          $('.multi-checkbox').addClass('unselectable');
        } else {
          $('.multi-checkbox').removeClass('unselectable');
        }
        var map = $.map(order, function(e) {
          return $(e).closest('.multi-checkbox');
        });
        if (map.length === 0) {
          orderValue = [];
          $('.multi-checkbox .selection-order')
            .html('')
            .attr('order', '')
            .hide();
          $('.js-foundation-finder-finish.mandatory').attr('disabled', true);
        } else {
          orderValue = [];
          $('.multi-checkbox .selection-order')
            .html('')
            .attr('order', '')
            .hide();
          for (
            var i = 1, $selectedOptions = map.length;
            i <= $selectedOptions;
            i++
          ) {
            if (map[i - 1] !== undefined) {
              map[i - 1]
                .find('.selection-order')
                .html('0' + i)
                .attr('order', i)
                .css('display', 'inline-block');
              orderValue.push(map[i - 1].find('.js-answer-option').val());
            }
          }
          $('.js-foundation-finder-finish.mandatory').attr('disabled', false);
        }

        $('input.selected-answer').val(orderValue);
      });

    /*
     * click event : Next button
     * Create and store selected value in the client-side storage.
     * Append selected answer in the URL and redirect to the result page.
     */
    $('.js-foundation-finder-next').on('click', function() {
      if ($currentQuestion == 1) {
        localStorage.setItem(
          'question' + $currentQuestion,
          $('.single-radio.selected')
            .closest('.slick-slide')
            .data('slick-index')
        );
      } else if (
        (document.documentMode || /Edge/.test(navigator.userAgent)) &&
        ($currentQuestion == 2 ||
          $currentQuestion == 3 ||
          $currentQuestion == 4)
      ) {
        storeSelectedValuesIE();
      }
      backToPageTop();
      window.location.href = $util.appendParamToURL(
        window.location.href,
        'q' + $('input.current-question').val(),
        $('input.selected-answer').val()
      );
    });

    /*
     * click event : Finish button
     * Create and store selected value in the client-side storage.
     * Append selected answer in the URL and redirect to the result page.
     */
    $('.js-foundation-finder-finish').on('click', function() {
      var $index = 1,
        $selectedBenefit = $('.multi-checkbox .js-answer-option:checked')
          .length,
        $selectedAnswers = window.location.href.split('?')[1],
        $finishUrl =
          $('#foundation-finder-form').attr('action') + '?' + $selectedAnswers,
        $selectedBenefitOrder = [];

      while ($index <= $selectedBenefit) {
        $selectedBenefitOrder.push(
          $('.selection-order[order=' + $index + ']')
            .closest('label')
            .attr('for')
        );
        $index++;
      }

      localStorage.setItem(
        'question' + $currentQuestion,
        $selectedBenefitOrder.join()
      );

      backToPageTop();
      window.location.href = $util.appendParamToURL(
        $finishUrl,
        'q' + $('input.current-question').val(),
        $('input.selected-answer').val()
      );
    });

    /*
     * if-else Statement
     * Retain form data on browser back.
     */
    if ($('.foundation-finder-wrapper .js-answer-option:checked').length > 0) {
      if ($('.single-radio').length > 0) {
        $('.foundation-finder-wrapper .js-answer-option:checked').addClass(
          'checked'
        );
        $('.js-foundation-finder-next').attr('disabled', false);
        $('input.selected-answer').val(
          $('.foundation-finder-wrapper .js-answer-option:checked').val()
        );
      } else {
        retainSelectedBenefit();
      }
    }

    /*
     * if-else Statement
     * Execute on IE and Edge browser, as form data lost on IE/Edge browser back if dynamically created by script.
     */
    if (
      (document.documentMode || /Edge/.test(navigator.userAgent)) &&
      ($currentQuestion == 2 || $currentQuestion == 3 || $currentQuestion == 4)
    ) {
      retainSelectedValuesIE();
    } else if (
      (document.documentMode || /Edge/.test(navigator.userAgent)) &&
      $currentQuestion == 5
    ) {
      setTimeout(function() {
        retainSelectedBenefit();
      }, 500);
    }

    /*
     * Slick Initialization : question1
     */
    if (
      $skinToneSlider.length > 0 &&
      !$skinToneSlider.hasClass('slick-initialized')
    ) {
      $skinToneSlider.slick({
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      });
      retainSelectedSkinTone();
    }

    /*
     * Slick Initialization : question2 to question4
     */
    if (
      $normalCarousel.length > 0 &&
      !$normalCarousel.hasClass('slick-initialized')
    ) {
      $normalCarousel.slick({
        dots: false,
        slidesToShow: 5,
        infinite: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }

    /*
     * Slick Initialization : question5
     */
    if (
      $question5Carousel.length > 0 &&
      !$question5Carousel.hasClass('slick-initialized')
    ) {
      $question5Carousel.slick({
        dots: false,
        slidesToShow: 6,
        infinite: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }

    /*
     * mouse pointer hovers over the header. Execute on desktop.
     * Adding a class when the user interacts with any of the header components.
     * Function "updateHeaderVisibility" dependent on this class.
     */
    $('.header-wrapper').hover(
      function() {
        if (
          !('ontouchstart' in document.documentElement) &&
          $currentLayout == 'desktop'
        ) {
          $(this).addClass('hovered');
        }
      },
      function() {
        $(this).removeClass('hovered');
      }
    );

    updateOptionsHeight();

    $(window)
      .on('scroll load', function() {
        updateHeaderVisibility();
      })
      .on('orientationchange', function() {
        /*
         * js-skinToneOnResize controls the flicker effect on the carousel.
         * Slick will scroll to the slide where the selected slide belongs(only on touch devices).
         * setTimeOut will scroll to the selected slide after slick resize triggered.
         */
        if (
          'ontouchstart' in document.documentElement &&
          $selectedSkinToneSlickIndex !== ''
        ) {
          $('.skin-tone-wrapper .question-body.carousel').addClass(
            'js-skinToneOnResize'
          );
          setTimeout(function() {
            window.console.log($selectedSkinToneSlickIndex);
            $('.skin-tone-wrapper .question-body.carousel')
              .slick('slickGoTo', $selectedSkinToneSlickIndex)
              .removeClass('js-skinToneOnResize');
          }, 1000);
        }

        $('.content-wrapper .img-wrapper').removeAttr('style');
        setTimeout(function() {
          updateOptionsHeight();
        }, 500);
      });
  })();
};

},{"../detect-layout":30,"../util":105}],62:[function(require,module,exports){
'use strict';

var analytics = require('../analytics');

function onlineQuizInitialize() {
  $('.quiz-wrapper')
    .slick({
      fade: true,
      draggable: false,
      autoplay: false,
      arrows: false,
      dots: false,
      infinite: false,
      cssEase: 'ease-in-out',
      adaptiveHeight: true,
      touchMove: false,
      swipe: false
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      if (nextSlide > 0) {
        $('.quiz-cta.cta-prev').addClass('show-prev');
      } else {
        $('.quiz-cta.cta-prev').removeClass('show-prev');
      }
      if (nextSlide < slick.slideCount - 1) {
        $('.quiz-cta.cta-next').addClass('show-next');
      } else {
        $('.quiz-cta.cta-next').removeClass('show-next');
      }
    })
    .on('afterChange', function (slick, currentSlide) {
      checkValidation();
      if ($('.quiz-wrapper .slick-slide').hasClass('slick-active')) {
        $('html,body').animate({ scrollTop: 0 }, 1500);
      }
    });
  $(document)
    .on('click', '.quiz-cta .prev-label', function (event) {
      event.preventDefault();
      $('.quiz-wrapper').slick('slickPrev');
    })
    .on('click', '.quiz-cta .next-label', function (event) {
      event.preventDefault();
      $('.quiz-wrapper').slick('slickNext');
      registerClick('next');
    });

  if ($('.slider-question').length > 0) {
    $('.slider-wrapper').each(function () {
      var sliderValues = $(this).data('values');
      var $this = $(this);
      $(this)
        .find('.slider-question')
        .slider({
          min: sliderValues[0],
          value: sliderValues[1],
          max: sliderValues[2],
          create: function () {
            $(this)
              .next('.selected-age')
              .find('input')
              .val($(this).slider('value'));
            checkValidation();
          },
          slide: function (event, ui) {
            $(this)
              .next('.selected-age')
              .find('input')
              .val(ui.value)
              .trigger('change');
            checkValidation();
          }
        });

      $(this)
        .find('.age-value')
        .on('change keypress keyup keydown', function () {
          var selectedValue = parseInt($(this).val());
          $this.find('.error-wrapper span').removeClass('show-error');
          if (/\D/g.test(this.value)) {
            // Filter non-digits from input value.
            this.value = this.value.replace(/\D/g, '');
          }
          if (selectedValue < sliderValues[0]) {
            $this.find('.error-wrapper .min-error').addClass('show-error');
            $(this).addClass('show-error');
          } else if (selectedValue > sliderValues[3]) {
            $this.find('.error-wrapper .max-error').addClass('show-error');
            $(this).addClass('show-error');
          } else {
            $this
              .find('.slider-question')
              .slider('option', 'value', selectedValue);
            $(this).removeClass('show-error');
          }
          checkValidation();
        });
    });
  }

  $(document).on(
    'change',
    '.answer-section input[type=checkbox], .answer-section input[type=radio]',
    function () {
      var $this = $(this);
      var $element = function (attr) {
        return $this.attr(attr);
      };
      var selectedData = $this.closest('.form-row').data('select');
      var loadvariation = '';

      if (selectedData === 'noneOfAbove') {
        if ($this.prop('checked') && $element('type') === 'checkbox') {
          $(this)
            .closest('.answer-option')
            .find('input[type=checkbox]')
            .not(this)
            .prop('checked', '')
            .prop('disabled', 'disabled');
          $('#' + $element('name') + '-images')
            .find('.overlay-image')
            .remove();
          $(this).prop('checked', 'checked');
        } else {
          $(this)
            .closest('.answer-option')
            .find('input[type=checkbox]')
            .prop('disabled', '');
          $('#' + $element('name') + '-images')
            .find('.overlay-image')
            .remove();
        }
      } else {
        if ($this.prop('checked')) {
          if ($element('type') === 'checkbox') {
            var answerLimit = $this.closest('.answer-option').data('limit');
            if (
              $('input[name=' + $element('name') + ']:checked').length ===
              answerLimit
            ) {
              $('input[name=' + $element('name') + ']:not(:checked)').prop(
                'disabled',
                'disabled'
              );
            }
          }
          if ($element('type') === 'radio') {
            $('#' + $element('name') + '-images')
              .find('.overlay-image')
              .not('.fade-overlay')
              .remove();
            $('#' + $element('name') + '-images')
              .find('.fade-overlay')
              .removeClass('fade-overlay');
          }
          if (
            $this.closest('.answer-option').data('loadvariation') === 'yes' &&
            $element('id') === $element('name') + '-answer2'
          ) {
            loadvariation = 'no-transparent';
            $('#' + $element('name') + '-images .overlay-boolean').removeClass(
              'overlay-boolean'
            );
          }
          if (selectedData !== '') {
            if (
              $('#' + $element('name') + '-images').find('.overlay-boolean')
                .length === 0
            ) {
              $('#' + $element('name') + '-images').append(
                '<div class="overlay-image ' +
                  $element('id') +
                  ' ' +
                  loadvariation +
                  '"><img src="' +
                  selectedData +
                  '" alt="" /></div>'
              );
            }
          } else {
            $('#' + $element('name') + '-images')
              .find('.overlay-image')
              .remove();
          }
        } else {
          $('input[name=' + $element('name') + ']').prop('disabled', '');
          $('#' + $element('name') + '-images')
            .find('.' + $element('id'))
            .remove();
        }
      }
      checkValidation();
    }
  );

  // setTimeout無しだと、':checked' のチェックボックス要素が取得できない。
  setTimeout(function () {
    if ($('.answer-section input[type=checkbox]:checked').length > 0) {
      $('.answer-section input[type=checkbox]:checked').trigger('change');
    }
  }, 1);
}

function checkValidation() {
  var currentQuestion = $('.slick-slide.slick-current');
  var queType = currentQuestion.find('.question-slide').data('quetype');

  var enableCTA = false;
  if (queType === 'slider') {
    if (
      currentQuestion.find('.age-value').val() !== '' &&
      currentQuestion.find('.show-error').length === 0
    ) {
      enableCTA = true;
    }
  } else {
    if (currentQuestion.find('.answer-section input:checked').length > 0) {
      enableCTA = true;
    }
  }
  if (enableCTA) {
    $('.quiz-cta.cta-next').removeClass('inactive');
  } else {
    $('.quiz-cta.cta-next').addClass('inactive');
  }
  updateAnswers();
}

var savedAnswers = {};

function updateAnswers() {
  var currentQuestion = $('.slick-slide.slick-current');
  var queType = currentQuestion.find('.question-slide').data('quetype');
  var queParam = currentQuestion.find('.question-slide').data('queparam');
  var quenum = currentQuestion.find('.question-slide').data('quenum');
  var selectedAnswers = '';
  if (queType === 'multiSelect') {
    selectedAnswers = [];
    currentQuestion.find('.answer-section input:checked').each(function () {
      selectedAnswers.push($(this).val());
    });
  }
  if (queType === 'singleSelect' || queType === 'boolean') {
    selectedAnswers = currentQuestion
      .find('.answer-section input:checked')
      .val();
  }
  if (queType === 'slider') {
    selectedAnswers = currentQuestion.find('.age-value').val();
  }
  if (queParam !== '' && queParam !== null && queType !== 'multiSelect') {
    selectedAnswers = [selectedAnswers];
  }

  if (queParam === '' || queParam === null) {
    savedAnswers['q' + quenum] = selectedAnswers;
  } else {
    savedAnswers['q' + quenum] = {};
    savedAnswers['q' + quenum][queParam] = selectedAnswers;
  }
  $('#saved-answers').val(JSON.stringify(savedAnswers));
  if (typeof Storage !== 'undefined') {
    localStorage.setItem('savedAnswers', JSON.stringify(savedAnswers));
  }
}
function toggleSectionContent() {
  $(document).on('click', '[data-toggle="section-toggle"]', function () {
    $(this).toggleClass('active');
    $($(this).data('target')).slideToggle('slow');
    return false;
  });
}
function paintTriangle() {
  var radiance, resilience, smoothness;
  var width = 247;
  var height = 213;
  var triangleSvg = $('.magic-triangle svg');
  var center = { x: width / 2, y: 143 };

  radiance = $('.magic-triangle').data('radiance');
  resilience = $('.magic-triangle').data('resilience');
  smoothness = $('.magic-triangle').data('smoothness');

  var radiancePoint = {
    x: center.x,
    y: center.y * (1 - radiance / 100)
  };

  var resiliencePoint = {
    x: center.x - center.x * (resilience / 100),
    y: center.y + (height - center.y) * (resilience / 100)
  };

  var smoothnessPoint = {
    x: center.x + (width - center.x) * (smoothness / 100),
    y: center.y + (height - center.y) * (smoothness / 100)
  };

  const polygon = $(triangleSvg).find('polygon')[0];
  $(polygon).attr(
    'points',
    radiancePoint.x +
      ',' +
      radiancePoint.y +
      ' ' +
      resiliencePoint.x +
      ',' +
      resiliencePoint.y +
      ' ' +
      smoothnessPoint.x +
      ',' +
      smoothnessPoint.y
  );
  // jquery2 で polygon や svg に対してaddClassメソッドが効かない。
  polygon.classList.add('load-polygon');
}
function initOnlineQuizCarousel() {
  $(document).on('init', '.tile-size-carousel', function () {
    if ($(this).hasClass('slick-initialized')) {
      var that = $(this);
      setTimeout(function () {
        that.slick(
          'slickSetOption',
          {
            responsive: [
              {
                breakpoint: 1300,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
              },
              {
                breakpoint: 769,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
              },
              {
                breakpoint: 601,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
              },
              {
                breakpoint: 451,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
              },
              {
                breakpoint: 321,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
              }
            ]
          },
          true
        );
      }, 1);
    }
  });

  $(document).on('init', '.tile-color-carousel', function () {
    if ($(this).hasClass('slick-initialized')) {
      var that = $(this);
      setTimeout(function () {
        that.slick(
          'slickSetOption',
          {
            responsive: [
              {
                breakpoint: 1300,
                settings: { slidesToShow: 5, slidesToScroll: 5 }
              },
              {
                breakpoint: 769,
                settings: { slidesToShow: 5, slidesToScroll: 5 }
              },
              {
                breakpoint: 601,
                settings: { slidesToShow: 6, slidesToScroll: 6 }
              },
              {
                breakpoint: 451,
                settings: { slidesToShow: 6, slidesToScroll: 6 }
              },
              {
                breakpoint: 321,
                settings: { slidesToShow: 5, slidesToScroll: 5 }
              }
            ]
          },
          true
        );
      }, 1);
    }
  });
}
function showLoaderPages() {
  setTimeout(function () {
    $('.camelia-loader1').fadeOut(500);
  }, 1000);
  setTimeout(function () {
    $('.camelia-loader2').fadeOut(500, function () {
      paintTriangle();
    });
  }, 2500);
}

function registerPageView(onlineQuizPage) {
  analytics.onlinequiz.pageview(onlineQuizPage);
}

function registerClick(event) {
  var onlineQuizModal = $('.quiz-wrapper'),
    onlineQuizContent = onlineQuizModal.find(
      '.slick-slide.slick-current .question-slide'
    );
  var nextQueNumber = onlineQuizContent.data('quenum');
  var data = {};
  data.nextQuestionNumber = nextQueNumber;
  data.event = 'consultationBack';

  if (event === 'next') {
    data.event = 'nextQuestionOnlineQuiz';
  }

  analytics.onlinequiz.click(data);
}
$(window).on('load', function () {
  if (
    $('.camelia-loader1').length > 0 &&
    $('.quiz-result-container').length > 0
  ) {
    showLoaderPages();
  }
});
exports.init = function () {
  if ($('.quiz-wrapper').length > 0) {
    onlineQuizInitialize();

    //Trigger GTM page Load event for quiz page
    registerPageView('quiz');
  }
  if ($('.quiz-result-container').length > 0) {
    toggleSectionContent();
    initOnlineQuizCarousel();

    //Trigger GTM page Load event for result page
    registerPageView('result');
  }
};

},{"../analytics":2}],63:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {
	if ($('.pt_order-confirmation').length) {
		recommendations();
		$(document).on('blur', '.pt_order-confirmation input.create-password',function() {
			var fieldErrorWrapper = $(this).parents('div.password-label'),
				form = $('.checkout-registration-form'),
				validator = form.validate(),
				validFlag = validator.element($(this));
				if(!validFlag) {
					fieldErrorWrapper.addClass('error');
				} else {
					fieldErrorWrapper.removeClass('error');
				}
		});
	} else {
		return;
	}
};
},{"./product/recommendations":74}],64:[function(require,module,exports){
'use strict';

const cardValidation = require('./checkout/card-validation');
const validator = require('../validator');
const modal = require('../modal').global;

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),

        // MasterCard
        mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

        // American Express
        amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

        //Discover
        discover_regex = new RegExp('^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'),

        //JCB
        unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');
        var $selectedCards =  $('.available-cards');
        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $selectedCards.addClass('is_visa');
            handleDisplayselectedCard('is_visa',$selectedCards);
            
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
            
        } else {
            $ccNumberContain.removeClass('is_visa');
            $selectedCards.removeClass('is_visa',$selectedCards);
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $selectedCards.addClass('is_mastercard');
            handleDisplayselectedCard('is_mastercard',$selectedCards);
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
            $selectedCards.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $selectedCards.addClass('is_amex');
            handleDisplayselectedCard('is_amex',$selectedCards);
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_amex');
            $selectedCards.removeClass('is_amex');
        }

        if (cur_val.match(discover_regex)) {
            $ccNumberContain.addClass('is_discover');
            $selectedCards.addClass('is_discover');
            handleDisplayselectedCard('is_discover',$selectedCards);
            $creditCard.find('input[name$="_type"]').val("Discover").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_discover');
            $selectedCards.removeClass('is_discover');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $selectedCards.addClass('is_unionpay');
            handleDisplayselectedCard('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
            $selectedCards.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) &&
            !cur_val.match(amex_regex) && !cur_val.match(discover_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
            $selectedCards.addClass('is_nothing');
            handleDisplayselectedCard('is_nothing');
        } else {
            $ccNumberContain.removeClass('is_nothing');
            $selectedCards.removeClass('is_nothing');
        }
    });
    
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_type').selectmenu();
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month').selectmenu();
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year').selectmenu();

};

$('#dwfrm_paymentinstruments_creditcards_newcreditcard_type').on('change', function() {
	var cardType = $('#dwfrm_paymentinstruments_creditcards_newcreditcard_type option:selected').val();
	
	$('#dwfrm_paymentinstruments_creditcards_newcreditcard_type').selectmenu('destroy');
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_type').val(cardType).prop('selected', true);
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_type').selectmenu();
});
$('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month').on('change', function() {
	var expiration_month = $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month option:selected').val();
	
	$('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month').selectmenu('destroy');
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month').val(expiration_month).prop('selected', true);
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_month').selectmenu();
});
$('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year').on('change', function() {
	var expiration_year = $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year option:selected').val();
	
	$('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year').selectmenu('destroy');
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year').val(expiration_year).prop('selected', true);
    $('#dwfrm_paymentinstruments_creditcards_newcreditcard_expiration_year').selectmenu();
});

function initCardEditEvent() {
	$(document).on("click", ".credit-card-edit", function (evt) {
		const $this = $(this);
		const $parent = $this.parent();
		const cardSeq = $parent.find('input[name="CardSeq"]').val();
		const url = Urls.paymentEditCreditCard + cardSeq;

		modal.restoreDefaultClass();
		modal.events.onOpen(function () {
			$('select[name$="_type"]').prop('disabled', true);
			$('input[name$="number"]').prop('disabled', true);
			//validator.initForm('form[id$="CreditCardForm"]');
		});

		modal.addCustomClass('small edit-credit-card');
		modal.renderByUrl(url);
	});
}

$(document).on("click", ".resubmit-prevention", function (e) {
	const $this = $(this);
	$this.css('pointer-events','none');
});

function initCardEvents() {
	initCardEditEvent();
}

const paymentinstruments = {
	creditCardTypeDetector: creditCardTypeDetector,
	initCardEvents: initCardEvents,
};

exports.init = function () {
	
}
module.exports = paymentinstruments;

},{"../modal":43,"../validator":106,"./checkout/card-validation":53}],65:[function(require,module,exports){
'use strict';

/**
 * ワタシプラス商品レビュー
 *
 * @module pages/productReview
 */

/**
 * ソート順変更
 */
function changeSortOrder() {
  $.ajax({
    method: 'GET',
    url: `${$(this).data('action')}&sort=${$(this).val()}`
  })
    .done((result) => {
      $('#reviewList').html(result);
      bindPaginationEvent();
      // 外部js(additional-lp-wp-online-reviews.js)のクラスを参照
      // eslint-disable-next-line no-undef
      LP_JS_WP_ONLINE_REVIEWS.init();
    })
    .fail((result) => {
      window.href.location = result.redirectUrl;
    });
}

/**
 * ページネーション
 *
 * @returns {boolean} aタグイベントキャンセルのためにfalseを返却
 */
function pagination() {
  $('#reviewList').load($(this).attr('href'), (response, status) => {
    if (status === 'error') {
      const result = JSON.parse(response);
      window.location.href = result.redirectUrl;
      return;
    }
    bindPaginationEvent();
    $(window).scrollTop(
      $('.lp-wp-online-reviews__main').position().top - $('header').height()
    );
    // 外部js(additional-lp-wp-online-reviews.js)のクラスを参照
    // eslint-disable-next-line no-undef
    LP_JS_WP_ONLINE_REVIEWS.init();
  });
  return false;
}

/**
 * ページネーションイベント設定
 */
function bindPaginationEvent() {
  $('.lp-wp-online-reviews__pagination a:not([tabindex=-1])')
    .off('click.pagination')
    .on('click.pagination', pagination);
  $('.lp-wp-online-reviews__pagination a[tabindex=-1]')
    .off('click.paginationDisable')
    .on('click.paginationDisable', () => false);
}

module.exports = {
  init: () => {
    // ソート順変更イベント設定
    $('select[name=sort]')
      .off('selectmenuchange.sort')
      .on('selectmenuchange.sort', changeSortOrder);
    // ページネーションイベント設定
    bindPaginationEvent();
  }
};

},{}],66:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
  minicart = require('../../minicart'),
  page = require('../../page'),
  util = require('../../util'),
  Promise = require('promise'),
  samples = require('../../samples'),
  _ = require('lodash'),
  skincheck = require('./skincheck_modal');

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function (msg, form) {
  var $errEle = $('#a2c-error');
  var $errEleSticky = $('#product-content-sticky #a2c-error');
  if ($errEle.length === 0) {
    var classid = '#a2c-error_' + form.find('input[name="pid"]').val();
    // 親要素からエラーメッセージを表示させる要素を取得
    $errEle = $(form).parent().find(classid);
  }
  var classHeightValue =
    $('.product-title').height() +
    $('.product-description').height() +
    $('.product-info').height() +
    $('.add-to-cart-wrapper').height() -
    40;

  $('.modal-body .sb-content').stop().animate(
    {
      scrollTop: classHeightValue
    },
    500
  );

  $errEle.html(msg).slideDown('fast', function () {
    setTimeout(function () {
      $errEle.slideUp(500);
    }, 2000);
  });

  $errEleSticky.html(msg).slideDown('fast', function () {
    setTimeout(function () {
      $errEleSticky.slideUp(500);
    }, 2000);
  });
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
  var $form = $(form);

  return Promise.resolve(
    $.ajax({
      type: 'POST',
      url: util.ajaxUrl(Urls.addProduct),
      data: $form.serialize()
    })
  ).then(function (response) {
    // handle error in the response
    if (response.error) {
      setAddToCartError(response.error, $form);
      throw new Error(response.error);
      return false;
    }

    //セット商品の場合、カート追加に成功後、エラーメッセージを事前に表示
    setProductMultiplePurchaseError();

    return response;
  });
};

/**
 * セット商品PDPにてエラーメッセージの表示処理。
 * 表示後は、setAddToCartError()が発火しないようにidを変更
 */
var setProductMultiplePurchaseError = function () {
  if ($('#add-to-cart').data('isset')) {
    var $errEle = $('#a2c-error, #kit-error');
    $errEle.html(Resources.KIT_ERROR_MIXIN);
    $errEle.css('display', 'block');
    $errEle.attr('id', 'kit-error');
  }
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e, $this) {
  e.preventDefault();
  if ($this) {
    var $form = $this.closest('form');
  } else {
    var $form = $(this).closest('form');
  }

  addItemToCart($form).then(
    function (response) {
      var $uuid = $form.find('input[name="uuid"]');
      if ($uuid.length > 0 && $uuid.val().length > 0) {
        page.refresh();
      } else {
        // do not close quickview if adding individual item that is part of product set
        // @TODO should notify the user some other way that the add action has completed successfully
        if (!$(this).hasClass('sub-product-item')) {
          dialog.close();
        }
        $('.stick-buy-container').removeClass('open');
        $('.sticky-buy-link').removeClass('active');
        $(document).trigger('gtadd-to-cart');
        minicart.show(response);
      }
    }.bind(this)
  );
};
exports.addToCart = addToCart;

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function (e) {
  e.preventDefault();

  var pidData = $('#pids').val();
  minicart.addAllProducts(pidData, e.data.to);
};

// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
  return $selector
    .toArray()
    .map(function (ele) {
      var $ele = $(ele),
        pid = $ele.data('pid'),
        qty = $ele.find('select[name="Quantity"]').length
          ? $ele.find('select[name="Quantity"]').val()
          : 1;

      return pid + ':' + qty;
    })
    .join(',');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
  $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
  $('#add-all-to-cart').on('click', { to: 'Cart' }, addAllTo);
  $('.product-form-actions .product-set-wishlist').on(
    'click',
    { to: 'Wishlist' },
    addAllTo
  );
};

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '.product-detail .add-to-cart', skinCheck);
$(document).on('click', '#product-content-sticky .add-to-cart', skinCheck);
$(document).on('click', '.product-tile-cart-in .add-to-cart', skinCheck);
$(document).on('click', 'button.sample-bonus-add-to-cart', addSamplesToCart);
$(document).on(
  'click',
  '.bonus-sample-selection .product-tile-wrapper',
  sampleTileSelect
);
$(document).on('click', '.reveal.sample-selection .close-button', function (e) {
  scrollToTop(e);
});
$('form.multi-select-form').on('submit', function (e) {
  e.preventDefault();

  var pidData = formatPidDataFromEles(
    $(this).find('button.multiselect[value="selected"]')
  );
  minicart.addAllProducts(pidData, 'Cart');
});

function sampleTileSelect(e) {
  e.preventDefault();

  var $this = $(this);
  var $btn = $this.find('button.multiselect');
  var $multiSelectForm = $this.parents('form');
  var $thresholdInput = $multiSelectForm.find('input#pids');

  var selectedCount = $multiSelectForm.find('button[value="selected"]').length;
  var limitCount = $thresholdInput.data('limit');

  if ($('#samples-bonus-error')) {
    $('#samples-bonus-error').html(null);
  }

  // do checking to compare if limit is met
  var btnIsSelected = $btn.val() == 'selected';

  if (btnIsSelected || selectedCount < limitCount) {
    // toggle val/text
    var selectionChanged = true;
    $btn.toggleClass('remove');
    $btn.val(btnIsSelected ? 'selectable' : 'selected');
    $btn.html(btnIsSelected ? $btn.data('select') : $btn.data('selected'));
  } else if ($('#samples-bonus-error')) {
    // cap reached, report error
    $('#samples-bonus-error').html($('input#pids').data('error'));
    $('.modal-body .sample-content-wrapper .sb-content').animate(
      {
        scrollTop: 0
      },
      200
    );
  }

  var selectedProductList = [];
  var enableAddToBag = true;

  // fetch all items that are selected
  $multiSelectForm
    .find('button[value="selected"]')
    .each(function (index, item) {
      selectedProductList.push($(item).data('pid'));
      enableAddToBag = true;
    });

  // store all selected products to hidden input
  $thresholdInput.val(selectedProductList);

  // enable "Add to Bag" button
  var cartButton = $thresholdInput.data('button');
  if (enableAddToBag && selectionChanged) {
    $('button.' + cartButton).removeAttr('disabled');
  }

  // update selected counter
  var selectedCount = parseInt(selectedProductList.length);
  var selectedLimit = parseInt($thresholdInput.data('count'));
  if (selectedCount > 0) {
    if ($('.sample-bonus-add-to-cart').hasClass('add-button')) {
      $('span.sample-bonus-count').html(
        ' [' +
          (selectedCount <= selectedLimit ? selectedCount : selectedLimit) +
          ']'
      );
    }
  } else {
    $('span.sample-bonus-count').html('');
    if ($('.sample-bonus-add-to-cart').hasClass('add-button')) {
      $('button.' + cartButton).attr('disabled', 'true');
    }
  }
}

function addSamplesToCart(e) {
  e.preventDefault();

  var url = util.toAbsoluteUrl($(this).data('action'));

  $('.sample-selection .ajax-loader').show();
  $.ajax({
    url: util.appendParamToURL(url, 'format', 'ajax'),
    data: $(this).parents('form').serialize(),
    method: 'POST'
  }).done(function (response) {
    if (response.error) {
      window.location.assign(Urls.generalError);
    } else if ($('.sample-bonus-add-to-cart').data('redirect')) {
      $('#bonus-sample-selection .modal-close').trigger('click');
      if ($('.pt_cart').length) {
        window.location.assign(Urls.cartShow);
      } else {
        minicart.show(response);
      }
    } else {
      var $div = $('<div>').html(response);
      if ($div.find('.add-cart-confirmation-product').length) {
        minicart.show(response);
      }
      if ($('.sample-bonus-add-to-cart')) {
        $('#bonus-sample-selection .modal-close').trigger('click');
      }
    }
    $('.sample-selection .ajax-loader').hide();
  });
}

function skinCheck(e) {
  var skinCheckResultCookie = skincheck.readCookie('skinCheckResult');
  if ($(this).data('skincheck') === false || skinCheckResultCookie === 'OK') {
    addToCart(e, $(this));
  } else {
    skincheck.skinTroubleExecute(skinCheckResultCookie, $(this));
  }
}

module.exports.skinCheck = skinCheck;

},{"../../dialog":31,"../../minicart":42,"../../page":46,"../../samples":95,"../../util":105,"./skincheck_modal":75,"lodash":112,"promise":113}],67:[function(require,module,exports){
'use strict';

var ajax =  require('../../ajax'),
    util = require('../../util');

var updateContainer = function (data) {
    var $availabilityMsg = $('#pdpMain .availability .availability-msg');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html(Resources.ITEM_STATUS_NOTAVAILABLE);
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = data.inStockMsg;
        }
        $availabilityMsg.append('<p class="in-stock-msg">' + message + '</p>');
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = data.preOrderMsg;
        }
        $availabilityMsg.append('<p class="preorder-msg">' + message + '</p>');
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = data.backOrderMsg;
        }
        $availabilityMsg.append('<p class="backorder-msg">' + message + '</p>');
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append('<p class="in-stock-date-msg">' + String.format(Resources.IN_STOCK_DATE, data.inStockDate) + '</p>');
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<p class="not-available-msg">' + message + '</p>');
    }
};

var getAvailability = function () {
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $('#pid').val(),
            Quantity: $(this).val()
        }),
        callback: updateContainer
    });
};

module.exports = function () {
    $('#pdpMain').on('change', '.pdpForm input[name="Quantity"]', getAvailability);
};

},{"../../ajax":1,"../../util":105}],68:[function(require,module,exports){

function initializeEvents() {
	$('.video-carousel').slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 480,
			settings: 'unslick'
			}
		]
	});
}

module.exports = {
	init: function () {
		initializeEvents();
	}
};
},{}],69:[function(require,module,exports){
'use strict';
var dialog = require('../../dialog');
var modal = require('../../modal').global;
var customModal = require('../../modal');
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');
var currentLayout = require('../../detect-layout');
var zoom = require('../../pinch-zoom');
var dragscroll = require('../../dragscroll');

var checkLayout = currentLayout.init();

function getProductImageURL(viewType) {
    var pid = $("span[itemprop='productID']").data("pid");
    return util.appendParamsToUrl(Urls.getProductImages, { "pid": pid, "sz": viewType });
}

function lazyLoadThumbnails() {
	var viewType = "large";
    var thumbnailProductImageURL = getProductImageURL(viewType);

    $.get(thumbnailProductImageURL).done(function (res) {
        $("#thumbnails").html(res);
        customModal.modal();
 
        var thumbnailImageCount = $("#thumbnails li").length;
        if (thumbnailImageCount <= 1) {
            if(checkLayout == "desktop"){
                $(".pdp-product-thumbnail-slider").addClass('pdp-product-thumbnail-slider-single');
            }
            return false;
        } else {
        	initThumbnailCarousel();
        }
    });
}

function initThumbnailCarousel() {   
    $('#thumbnails ul').slick({
        dots: true,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '.pdp-product-thumbnail-slider'
    });
        $('.pdp-product-thumbnail-slider').slick({
            infinite:true,
            arrows: false,
            slidesToShow:4,
            slidesToScroll: 1,
            asNavFor: 'ul.product-images',
            dots: false,
            variableWidth:false,
            focusOnSelect: true
        });    
 }
 $(window).on('resize orientationchange', function(){
    if(window.innerWidth>1023 && ($(".pdp-product-thumbnail-slider").find('.slick-slide').length<=4))
    {
          $(".pdp-product-thumbnail-slider").find('.slick-track').addClass("no-transform");
    }
});
   
/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts) {
    $('#pdpMain .primary-image').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
    updatePinButton(atts.url);
    updateFacebookButton(atts.url);
    if (!dialog.isActive() && !util.isMobile()) {
        $('#pdpMain .main-image').find('img').attr('src', atts.hires);
    }
}

function updatePinButton(imageUrl) {
    var pinButton = document.querySelector('.share-icon[data-share=pinterest]');

    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    query.media = url.resolve(window.location.href, newUrl);
    query.url = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    pinButton.href = newHref;
}

function updateFacebookButton(imageUrl) {
    var facebookButton = document.querySelector('.share-icon[data-share=facebook]');

    if (!facebookButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(facebookButton.href);
    var query = qs.parse(href.query);
    query.picture = url.resolve(window.location.href, newUrl);
    query.u = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    facebookButton.href = newHref;
}
/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    if (dialog.isActive() || util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    }
  
    updatePinButton($('.productthumbnail .selected').find('img').attr('src'));
    updateFacebookButton();
    lazyLoadThumbnails();

    // bind zoom event handler
    $(document).on('click', '.productthumbnail', function (evt) {
        evt.preventDefault();
        var viewType = "zoom";

        var zoomImageUrl = null;
        if($('.productthumbnail').length > 1) {
        	zoomImageUrl = $('#thumbnails .slick-current .productthumbnail').data('zoomimg');
        } else {
        	// for only one thumbnail, select that one image
        	zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
        }

        $('.zoomProductImage .modal-body').html('<img class="zoom-img" src="' + zoomImageUrl + '">');
        var widthModal_zoom = window.innerWidth;
        if(widthModal_zoom < 769){
             zoomTouch();
        }
        else{
            $('.zoom-img').on('load', function() { 
                var outerContent = $('#zoomProductImage .modal-body');
                var innerContent = $('#zoomProductImage .modal-body>img');
                outerContent.scrollLeft( (innerContent.width() - outerContent.width()) / 2);
                outerContent.scrollTop( (innerContent.height() - outerContent.height()) / 2);    
            });
        }
        
    });
        function zoomTouch(){
            var pdp_modal = $('#zoomProductImage').css('display') == 'none'
            if(screen.width > window.innerWidth){
                screen.width = '100%' ;
           }
            if(!pdp_modal){
                var myel = document.querySelector('div.pinch-zoom');
                if(myel !== undefined){
                new zoom.default(myel, {});
                }
            }
        }
        $(document).on('click', '.zoom-img', function(e) {
            if(window.innerWidth > 1023){
               dragscroll.reset();
            }
         });
       $(document).on('click', '.modal-close, .modal-close-outer', function() {
        if(window.innerWidth < 1023){
            $(".pinch-zoom").removeAttr('style');
            var innerHtml = $(".pinch-zoom-container").html();
            $("#zoomProductImage .modal-close").after(innerHtml);
            $(".pinch-zoom-container").remove();
        }
      });
      $(window).on('resize orientationchange', function(){
        var pdp_modal_check = $('#zoomProductImage').css('display') == 'none'
        var layout_width =  window.innerWidth;
           if(!pdp_modal_check && layout_width > 1023){
                $(".pinch-zoom").removeAttr('style');
                var innerHtml = $(".pinch-zoom-container").html();
                $("#zoomProductImage .modal-close").after(innerHtml);
                $(".pinch-zoom-container").remove();
                $("#zoomProductImage").hide();
                $('html').removeClass('modal-open');
           }
      });
    // handle product thumbnail click event
    $("#thumbnails").on('click', '.productthumbnail', function () {
        var $that = $(this);
        if(!$that.hasClass("selected")){
        	$(document).trigger("clickproductthumbnail");
        }

        $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
        $that.addClass('selected');
        setMainImage($that.data('lgimg'));

    });
};



module.exports.setMainImage = setMainImage;
module.exports.lazyLoadThumbnails = lazyLoadThumbnails;
},{"../../detect-layout":30,"../../dialog":31,"../../dragscroll":32,"../../modal":43,"../../pinch-zoom":88,"../../util":105,"lodash":112,"qs":123,"url":130}],70:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
  modal = require('../../modal').global,
  productStoreInventory = require('../../storeinventory/product'),
  util = require('../../util'),
  addToCart = require('./addToCart'),
  productTile = require('../../product-tile'),
  availability = require('./availability'),
  image = require('./image'),
  //productNav = require('./productNav'),
  howToSection = require('./howToSection'),
  productSet = require('./productSet'),
  recommendations = require('./recommendations'),
  socialShareIcons = require('./socialShareIcons'),
  variant = require('./variant'),
  customModal = require('../../modal'),
  currentLayout = require('../../detect-layout'),
  reStock = require('./reStock');

var currLayout = currentLayout.init();

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
  recommendations();
  screenResizeHandler();
}

/**
 * @private
 * @function
 * @description Screen Resize Handler.
 */
function screenResizeHandler() {
  $(window).on('resize orientationchange', function() {
    recommendations();
    handleSocialModalOverlay(currentLayout.init());
  });
}

function ellipsifySocialContentDesc(str, charlength) {
  if (str.length > charlength) {
    return str.substring(0, charlength);
  } else {
    return str;
  }
}

function handleSocialModalOverlay(layoutType) {
  if (layoutType === 'desktop') {
    $(document).on(
      'click',
      '.social-media-post-detail-modal .modal-close',
      function() {
        $('.social-media-overlay').removeClass('show');
      }
    );
    $(document).on('click', '.social-media-overlay', function() {
      $('.social-media-overlay').removeClass('show');
      $('#social-media-post-detail-modal').remove();
    });
  }
}

var showSocialPostDetailModal = function(target) {
  // render content to modal by url
  var url = util.appendParamToURL($(target).attr('href'), 'format', 'ajax');

  currLayout = currentLayout.init();

  $.ajax({
    url: url,
    dataType: 'html',
    success: function(response) {
      if (currLayout === 'desktop') {
        customModal.createCustomModal(
          'social-media-post-detail-modal',
          '.pdp-social-media-section'
        );
      } else {
        customModal.createCustomModal('social-media-post-detail-modal');
      }
      $('.social-media-post-detail-modal')
        .find('.modal-body')
        .html(response);
    }
  }).complete(function(data) {
    if (currLayout === 'mobile') {
      if (window.innerHeight > window.innerWidth) {
        $('.social-post-detail-content .post-detail-image').css(
          'height',
          $('.social-media-post-detail-modal')
            .find('.modal-body')
            .width()
        );
        $('.social-post-detail-content .post-detail-content').css(
          'height',
          $('.social-media-post-detail-modal')
            .find('.modal-body')
            .height() -
            $('.social-media-post-detail-modal')
              .find('.modal-body')
              .width()
        );
      }
      if (window.innerHeight < window.innerWidth) {
        $('.social-post-detail-content .post-detail-image').css(
          'height',
          window.innerHeight * 0.5
        );
        $('.social-post-detail-content .post-detail-content').css(
          'height',
          window.innerHeight * 0.3
        );
      }
    }

    if (currLayout === 'desktop') {
      $('.social-post-detail-content .post-detail-image').css(
        'height',
        $('.social-post-detail-content .post-detail-image').width()
      );
      $('.social-post-detail-content .post-detail-content').css(
        'height',
        $('.social-post-detail-content .post-detail-image').width()
      );
      $('.social-media-overlay').addClass('show');
    }
    $('.social-post-detail-content .sb-container').scrollBox();
  });
};

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
  var $pdpMain = $('#pdpMain');

  addToCart();
  availability();
  variant();
  image();
  howToSection.init();
  productSet();
  socialShareIcons();
  productTile.init();
  if (SitePreferences.STORE_PICKUP) {
    productStoreInventory.init();
  }

  // Add to Wishlist and Add to Gift Registry links behaviors
  $pdpMain.on(
    'click',
    '[data-action="wishlist"], [data-action="gift-registry"]',
    function() {
      var data = util.getQueryStringParams($('.pdpForm').serialize());
      if (data.cartAction) {
        delete data.cartAction;
      }
      var url = util.appendParamsToUrl(this.href, data);
      this.setAttribute('href', url);
    }
  );

  // product options
  $pdpMain.on('change', '.product-options select', function() {
    var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
    var selectedItem = $(this)
      .children()
      .filter(':selected')
      .first();
    salesPrice.text(selectedItem.data('combined'));
  });

  // prevent default behavior of thumbnail link and add this Button
  $pdpMain.on('click', '.thumbnail-link, .unselectable a', function(e) {
    e.preventDefault();
  });

  $('.keyingredients .view-all').on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
    var $fullIngredientList = $('.keyingredients-full');
    var contentUrl = $this.attr('href');

    $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(function(
      content
    ) {
      $(
        '<div class="keyingredients-outer-close"></div><div class="keyingredients-full"><span class="close icon icon-close"></span><div class="scrollbar-wrap"><div class="scrollbar"><div class="track"><div class="thumb"><div class="end"></div></div></div></div><div class="viewport"><div class="overview">' +
          content +
          '</div></div></div></div>'
      ).insertAfter($this);
      $('.scrollbar-wrap').tinyscrollbar();
      $('.keyingredients .close, .keyingredients-outer-close').on(
        'click',
        function() {
          $('.keyingredients-full, .keyingredients-outer-close').hide();
          $('.view-all').css('pointer-events', 'auto');
        }
      );
    });
  });

  $(document).on('click', function(evt) {
    if ($(evt.target).closest('.keyingredients-outer-close').length) {
      $('.view-all').css('pointer-events', 'auto');
    }
  });

  $pdpMain.on(
    'click',
    '.keyingredients .close, .keyingredients-outer-close',
    function(e) {
      e.preventDefault();
      $('html').removeClass('ingredient-modal');
      $('.keyingredients-modal, .keyingredients-outer-close').remove();
    }
  );

  if ($('.product-set-actions').length) {
    var $productForms = $('.product-set-list')
      .find('form')
      .toArray();
    var pids = $productForms
      .map(function(formEle) {
        return $(formEle).data('pid');
      })
      .join(',');

    $.post(
      util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
        pid: pids
      }),
      function(data) {
        if (data === 'false') {
          $('.product-form-actions .product-set-wishlist').removeClass(
            'd-none'
          );
          $('.product-form-actions .remove-product-set-from-wishlist').addClass(
            'd-none'
          );
        } else {
          $('.product-form-actions .product-set-wishlist').addClass('d-none');
          $(
            '.product-form-actions .remove-product-set-from-wishlist'
          ).removeClass('d-none');
        }
      }
    );

    $('.remove-product-set-from-wishlist').on('click', function(e) {
      e.preventDefault();

      $.post(
        util.appendParamsToUrl(Urls.wishlistRemoveAll, {
          pid: pids
        }),
        function() {
          window.location.href = window.location.href;
        }
      );
    });
  }

  $('.size-chart-link a').on('click', function(e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href')
    });
  });

  $('.accordion-toggle').on('click', function(e) {
    e.preventDefault();
    var $toggleFor = $(this).attr('href');
    var $toggleHeight = $('.accordion-toggle').outerHeight();
    var $stickyHeader = $('.sticky-header').outerHeight();
    var totalOffset = $toggleHeight + $stickyHeader;

    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $($toggleFor)
        .removeClass('is-open')
        .slideUp();
      return false;
    } else {
      var accordionToggle = $('.accordion-toggle.is-open');
      var accordionContent = $('.pdp-content-section.is-open');

      $(this).toggleClass('is-open');
      $($toggleFor)
        .toggleClass('is-open')
        .slideDown(function() {
          $('html, body').animate(
            {
              scrollTop: $(this).offset().top - totalOffset
            },
            400
          );
        });
    }

    if ($(this).attr('id') == 'rec-toggle') {
      $('.carousel-recommendations.slick-slider').slick('refresh');
    }
  });

  /**
   * @description Social Media integration Section
   **/
  if ($('.pdp-social-media-section').length > 0) {
    $('.media-post-slot-inner').on('touchend mouseenter mouseleave', function(
      e
    ) {
      if (e.type === 'touchend') {
        $(this)
          .find('.detail-link')
          .trigger('click');
      } else if (e.type === 'mouseenter') {
        $(this)
          .not('.video-inner')
          .addClass('show-details');
      } else {
        $(this).removeClass('show-details');
      }
    });
    $('.post-descriptor p').each(function() {
      $(this).html(ellipsifySocialContentDesc($(this).html(), 83));
    });
    $('.media-post-slot .copy').each(function() {
      $(this).html(ellipsifySocialContentDesc($(this).html(), 100));
    });
    $(document).on('click', 'a#social-post-detail-link', function(e) {
      e.preventDefault();
      showSocialPostDetailModal($(this));
    });
    handleSocialModalOverlay(currLayout);
  }

  if ($('.pdp-main .product-description .shortDescPart2').length) {
    $(document).on('click', '.pdp-desc-read-more', function(e) {
      e.preventDefault();
      var $pdpDescReadmore = $('.product-description .read-more-wrapper');
      $('.pdp-main .product-description .shortDescPart2').toggleClass(
        'visually-hidden'
      );
      $('.pdp-main .product-description .product-desc-dots').toggle();
      if (!$pdpDescReadmore.hasClass('less')) {
        $pdpDescReadmore.find('a').html(Resources.LESS_DESC);
        $pdpDescReadmore.addClass('less');
      } else {
        $pdpDescReadmore.find('a').html(Resources.MORE_DESC);
        $pdpDescReadmore.removeClass('less');
      }
    });
  }

  $('.product-tile-regimen .product-brand-name-block').on(
    'click touchstart',
    function() {
      $('.product-tile-regimen').removeClass('product-regimen-device');
    }
  );

  $('.product-tile-regimen .product-image').on('click touchstart', function() {
    $('.product-tile-regimen').removeClass('product-regimen-device');
    $(this)
      .parent()
      .addClass('product-regimen-device');
  });
}

function bodyPositionFixed(id) {
  if (navigator.userAgent.match(/(iPhone|iPad)/)) {
    var windowScrollPosition = $(window).scrollTop();
    $('body').addClass('body-fixed');
    $('.' + id + ' .modal-close, .' + id + ' .modal-close-outer')
      .off('click')
      .on('click', function() {
        $('.' + id).remove();
        $('body').removeClass('body-fixed');
        $('html').removeClass('modal-open');
        $(window).scrollTop(windowScrollPosition);
      });
  }
}

var product = {
  initializeEvents: initializeEvents,
  bodyPositionFixed: bodyPositionFixed,
  init: function() {
    initializeDom();
    initializeEvents();
  }
};

module.exports = product;

},{"../../detect-layout":30,"../../dialog":31,"../../modal":43,"../../product-tile":90,"../../storeinventory/product":102,"../../util":105,"./addToCart":66,"./availability":67,"./howToSection":68,"./image":69,"./productSet":72,"./reStock":73,"./recommendations":74,"./socialShareIcons":76,"./variant":77}],71:[function(require,module,exports){
'use strict';

// require
let skincheck = require('./skincheck_modal');
let Promise = require('promise');
let util = require('../../util');
let minicart = require('../../minicart');

function initEvents() {
  // キット画面 購入ボタン初期処理
  initAddKitButton();
  // キット画面 購入ボタンイベント
  $('.pt_kit').on(
    'click',
    'input[type=submit][name=kit_add_product]',
    addKitProduct
  );
}

/**
 * キット画面 購入ボタン初期処理
 */
function initAddKitButton() {
  let errorElements = $('.kit-result__error_cart_desktop');
  errorElements.css('display', 'block');
}

/**
 * キット画面 購入ボタンクリック時
 */
function addKitProduct(e) {
  e.preventDefault();
  // 選択された商品IDを取得
  let selectedProductIds = getKitSelectedProductsIds();
  //--------------------- 全カテゴリーで選択済みかチェック
  if (!isAllCategoryItemSelected(selectedProductIds)) {
    // TODO 何する？悪いことしないと通らないパターン
    alert('addKitProduct isAllCategoryItemSelected false.');
    return false;
  }
  //--------------------- 肌トラブルチェック
  let skinCheckResultCookie = skincheck.readCookie('skinCheckResult');
  let needSkinCheck = containsNeedSkinTroubleCheckProduct(selectedProductIds);
  if (needSkinCheck && skinCheckResultCookie !== 'OK') {
    // 肌トラブルチェック実施。問題なければ再度addKitProductが実行される。
    skincheck.skinTroubleExecute(skinCheckResultCookie, $(this));
    return false;
  }
  //--------------------- カート追加
  let form = $('[name=kit_result_form]');
  Promise.resolve(
    $.ajax({
      type: 'POST',
      url: util.ajaxUrl(form.attr('action'), 'format', 'ajax'),
      data: $('[name=kit_result_form]').serialize()
    })
  ).then(function(response) {
    let errorElements = $(
      '.kit-result__error_bottom_desktop,' + '.kit-result__error_bottom_mobile'
    );
    if (response.error) {
      errorElements.find('p').html(response.error);
      errorElements.slideDown('fast', function() {
        setTimeout(function() {
          errorElements.slideUp(500);
        }, 5000);
      });
    } else {
      errorElements.removeAttr('style');
      $(document).trigger('gtadd-to-cart');
      minicart.show(response);
      $('.kit-result__error_cart_desktop').data('product-same', true);
    }
  });
}

/**
 * キット商品の選択されたIDを配列で返します。
 * @returns string[]
 */
function getKitSelectedProductsIds() {
  let i = 0;
  let ids = [];
  while (true) {
    // キット画面の選択済み商品フォームから情報を取得。同じnameが2つあるので :first 指定
    let id = $('input[name=' + i + '_id]:first').val();
    if (id === undefined) break;
    ids.push(id);
    i++;
  }
  return ids;
}

/**
 * 全カテゴリーの商品が選択されている場合、Trueを返します。
 * @param string[] selectedProductIds
 * @returns Boolean
 */
function isAllCategoryItemSelected(selectedProductIds) {
  return selectedProductIds.every(function(id) {
    return id !== '';
  });
}

/**
 * 選択した商品の中に、肌トラブルチェックが必要な商品が含まれている場合、Trueを返します。
 * @param string[] selectedProductIds
 * @returns Boolean
 */
function containsNeedSkinTroubleCheckProduct(selectedProductIds) {
  // 配列形式で設定された値を取得 => 自動的に配列として処理される
  let needSkincheckProductIds = eval(
    $('input[name=skincheck_product_ids]').val()
  );
  return needSkincheckProductIds.some(function(id) {
    return selectedProductIds.some(function(_id) {
      return id === _id;
    });
  });
}

exports.init = function() {
  initEvents();
};

},{"../../minicart":42,"../../util":105,"./skincheck_modal":75,"promise":113}],72:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('.add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });

    $productSetList.on('change', '.product-set-item .variation-select', function (e) {
        e.preventDefault();

        var $selectedVariantOption = $(this).find("option:selected");
        if($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
            return;
        }

        var url = Urls.getSetItem + "?" + util.getQueryString($selectedVariantOption.val());
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('select[name="Quantity"] option:selected').val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
    if (screen.width > 640) {
	    $(window).load(function() {
	    	$('#pdpMain').find('#BVRRSummaryContainer .bv-rating-stars-container').off().on('click', function (e) {
	    		e.preventDefault();
	    		e.stopPropagation();
	    		$(".tabs-title:nth-child(1)").removeClass("is-active");
	    		$(".tabs-title:nth-child(2)").addClass("is-active");
	    		$("#questions").removeClass("is-active");
	    		$("#reviews").addClass("is-active").stop(true, true);
	    		$('html, body').stop( true, true ).animate({
	    	        scrollTop: $("#bazaarvoice-tabs").offset().top-150
	    	    }, 1000);
	    	});
	    });
    }
};

$(document).on('click', '.bv-popup-in .bv-read-review', function() {
	$(".tabs-title:nth-child(1)").removeClass("is-active");
	$(".tabs-title:nth-child(2)").addClass("is-active");
	$("#questions").removeClass("is-active");
	$("#reviews").addClass("is-active");
	e.preventDefault();
	e.stopPropagation();
	$('html, body').stop( true, true ).animate({
        scrollTop: $("#bazaarvoice-tabs").offset().top-150
    }, 1000);
});




},{"../../ajax":1,"../../tooltip":104,"../../util":105}],73:[function(require,module,exports){
'use strict';

//二重送信の防止
$(function() {
  //再入荷お知らせ「リストから削除」
  $('.c-btn-delete').on('click', function() {
    $('.c-btn-delete').css('pointer-events', 'none');
  });

  //PDP「再入荷通知を希望する」
  $('.stock-notification-email').on('click', function() {
    $('.stock-notification-email').css('pointer-events', 'none');
  });

  //PDP「再入荷通知登録済み」
  $('.remove-from-stock-notification').on('click', function() {
    $('.remove-from-stock-notification').css('pointer-events', 'none');
  });
});

//再入荷通知 登録/解除 後の画面スクロール
$(window).on('load', function() {
  //登録
  if ($('.remove-from-stock-notification').data('scroll')) {
    $('html, body').animate({
      scrollTop:
        $('.remove-from-stock-notification').offset().top -
        $(window).height() / 2
    });
  }

  //解除
  if ($('.stock-notification-email').data('scroll')) {
    $('html, body').animate({
      scrollTop:
        $('.stock-notification-email').offset().top - $(window).height() / 2
    });
  }
});

},{}],74:[function(require,module,exports){
'use strict';

var currentLayout = require('../../detect-layout');

var currLayout = currentLayout.init();
/**
 * @description Creates product recommendation carousel using Slick carousel
 **/
module.exports = function () {
    var $rvcarousel = $('.recently-viewed .carousel-recommendations').not('.slick-initialized');
    var $instacarousel = $('.js-insta .carousel-recommendations').not('.slick-initialized');
    var $socialMediaCarousel = $('.pdp-social-media-section .carousel-recommendations').not('.slick-initialized');
    var $slideCount = '01';

	if ($rvcarousel && $rvcarousel.length && $rvcarousel.children().length) {
		initializeSlick($rvcarousel, $slideCount, 5, 3);
	} 
	if ($instacarousel && $instacarousel.length && $instacarousel.children().length) { 
		initializeSlick($instacarousel, $slideCount, 4, 2);
	}
	if ($socialMediaCarousel && $socialMediaCarousel.length && $socialMediaCarousel.children().length) { 
		initializeSlick($socialMediaCarousel, $slideCount, 1, 1);
	} 
	if (!$rvcarousel || !$instacarousel || !$socialMediaCarousel) {
		return;
	}
};

if($(".carousel-recommendations").length > 0 && $(".js-insta .carousel-recommendations").children('li').length>0){
	var count = $('.js-insta .carousel-recommendations>li').length;
	if(count >= 17){
	  $(".js-insta .carousel-recommendations").children('li').slice(16).detach();
	}
}

function initializeSlick($carousel, $slideCount, maxItems, minItems) {
	$carousel.on('init.slick', function(event, slick) {
		var $getSlickParentDiv = (slick.$dots) ? slick.$dots.parents('.rv-section') : slick.$slider.parents('.rv-section');
    	var $carouselCounter = $getSlickParentDiv.find('.slick-counter');
    	if((currLayout == 'desktop' && slick.slideCount > maxItems) || (currLayout == 'mobile' && slick.slideCount > minItems)) {
    		$carouselCounter.append('<span>'+ $slideCount +'</span><span>'+ ( slick.$dots.children().length < 10 ? "0" : "") + slick.$dots.children().length +'</span>');
    	}
    	if($carousel.hasClass('social-carousel')) {
    		$('.social-carousel .slick-slide:not(".slick-active")').find('.social-slide').addClass('active-slide-animation');
    	}
    });
    var slickSettings;
    if($carousel.hasClass('insta-carousel')) {
    	slickSettings = {
    	    	infinite: false,
    	    	easing: 'ease',
    	    	dots: true,	
    	        arrows: false,
    	        slidesToShow: maxItems,
    	        slidesToScroll: maxItems,
    	        rows:1,
    	        adaptiveHeight: true,
    	        responsive: [
                 {
                     breakpoint: 769,
                     settings: {
                    	slidesToShow: minItems,
             	        slidesToScroll: minItems,
             	        rows: 2
             	     }
                 }
               ]
    	    }
    } else if($carousel.hasClass('social-carousel')) {
    	slickSettings = {
    	    	infinite: false,
    	    	easing: 'ease',
    	        dots: true,	
    	        arrows: false,
    	        slidesToShow: maxItems,
    	        slidesToScroll: maxItems,
    	        slide: 'div',
    	        adaptiveHeight: true,
    	        speed: 400,
    	        waitForAnimate: true,
    	        responsive: [
                 {
                     breakpoint: 769,
                     settings: {
                    	slidesToShow: minItems,
             	        slidesToScroll: minItems
             	     }
                 }
               ]
    	    }
    } else {
    	slickSettings = {
    	    	infinite: false,
    	    	easing: 'ease',
    	        dots: true,	
    	        arrows: false,
    	        slidesToShow: maxItems,
    	        slidesToScroll: maxItems,
    	        slide: 'div',
    	        adaptiveHeight: true,
    	        responsive: [
                 {
                     breakpoint: 769,
                     settings: {
                    	slidesToShow: minItems,
             	        slidesToScroll: minItems
             	     }
                 }
               ]
    	    }
    }
    $carousel.slick(slickSettings).on('afterChange', function(event, slick, currentSlide) {
       	if(slick.$dots) {
    		var $currSlideFrame = parseInt(slick.$dots.find('.slick-active').index());
	       	var $carouselCounter = slick.$dots.parents('.rv-section').find('.slick-counter');
	       	if(dragEle) {
	       		dragEle.setValue($currSlideFrame / ( slick.$dots.children().length -1 ) )
	       	}
	    	$slideCount = $currSlideFrame + 1;
	    	if((currLayout == 'desktop' && slick.slideCount > maxItems) || (currLayout == 'mobile' && slick.slideCount > minItems)) {
	    		$carouselCounter.html('<span>' + ( $slideCount < 10 ? "0" : "") + $slideCount + '</span><span>' + ( slick.$dots.children().length < 10 ? "0" : "") + slick.$dots.children().length + '</span>' );
	    	}
       	}
    });
    var $slick = $carousel.slick( "getSlick" );
    if((currLayout == 'desktop' && $slick.slideCount > maxItems) || (currLayout == 'mobile' && $slick.slideCount > minItems)) {
		var slideCounts = $slick.$dots.children().length;
		var $dragdealer = $slick.$slider.parent('.rv-section').find('.dragdealer .handle');
		$dragdealer.width((100 / slideCounts)+'%');
		var $dragInstance;
		if($carousel.hasClass('insta-carousel')) {
			$dragInstance = 'insta-dragable-slider';
		} else if($carousel.hasClass('social-carousel')) {
			$dragInstance = 'social-dragable-slider';
			var pevX = 0;
		} else {
			$dragInstance = 'dragable-slider';
		}
		
	    var dragEle =  new Dragdealer($dragInstance, {
	    	disabled: false,
			steps: slideCounts,
			speed: 0.5,
			requestAnimationFrame: true,
			callback: function(x, y) {
				currLayout = currentLayout.init();
				var slickTiggerItems = $slick.$dots.children();
				var x = x * (slickTiggerItems.length - 1);
				if(currLayout == 'desktop' && $carousel.hasClass('social-carousel') && !(x === pevX)) {
					$('.social-carousel .slick-slide').eq(pevX).find('.social-slide').addClass('active-slide-animation');
					setTimeout(function(){
						if(!(slickTiggerItems.eq(x).hasClass('slick-active'))) {
							slickTiggerItems.eq(x).trigger('click');
						}
					}, 300);
					setTimeout(function(){
						$('.social-carousel .slick-slide').eq(x).find('.social-slide').removeClass('active-slide-animation');
					}, 600);
					pevX = x;
				} else {
					if(!(slickTiggerItems.eq(x).hasClass('slick-active'))) {
						slickTiggerItems.eq(x).trigger('click');
					}
				}
			}
		});
    } else {
    	$slick.$slider.parent('.rv-section').find('.dragdealer').hide();
    }
}

},{"../../detect-layout":30}],75:[function(require,module,exports){
var util = require('../../util'),
  productTile = require('../../product-tile'),
  addToCart = require('./addToCart');

(function() {
  'use strict';
  var BODY = document.body;
  var SCROLLING_ELEMENT = null;
  var UA = window.navigator.userAgent.toLowerCase();

  if (document.scrollingElement) {
    SCROLLING_ELEMENT = document.scrollingElement;
  } else if (UA.indexOf('WebKit') != -1) {
    SCROLLING_ELEMENT = BODY;
  } else {
    SCROLLING_ELEMENT = document.documentElement;
  }

  var init = function($originButton) {
    /**
     * modal widget
     */
    var modalWidget = document.querySelector('.js-skincheck_modal_widget');
    var skinCheckRoot = modalWidget.querySelector('[data-id="skinCheck"]');

    if (UA.match('mac')) {
      modalWidget.classList.add('isMac');
    } else if (UA.match('windows')) {
      modalWidget.classList.add('isWin');
    }

    if (!modalWidget || !skinCheckRoot) return;

    var modalOpen = function(elm) {
      elm.classList.add('isOpen');
      modalWidget.classList.add('isVisible');
      // BODY.classList.add('isMode');
      // BODY.style.position = 'absolute';
      // BODY.style.top = SCROLLING_ELEMENT.scrollTop * -1 + 'px';
      // BODY.style.left = 0;
      // BODY.style.right = 0;
      // BODY.style.bottom = 0;
    };

    var modalClose = function(elm) {
      modalWidget.style.opacity = 0;

      modalWidget.addEventListener(
        'transitionend',
        function() {
          elm.classList.remove('isOpen');
          // BODY.classList.remove('isMode');
          // BODY.style.position = '';
          // SCROLLING_ELEMENT.scrollTo(0, parseInt(BODY.style.top) * -1)
          // BODY.style.top = '';
          // BODY.style.left = '';
          // BODY.style.right = '';
          // BODY.style.bottom = '';
          setTimeout(function() {
            modalWidget.style.opcity = '';
          }, 1);
        },
        {
          once: true
        }
      );
      var body = document.getElementsByTagName('BODY')[0];
      body.removeChild(modalWidget);
    };

    /*
     * skinCheck
     */
    skinCheckRoot._result = skinCheckRoot.querySelector(
      '.js-skincheck-content.result'
    );
    skinCheckRoot._result._lead = skinCheckRoot._result.querySelector(
      '.result-lead'
    );
    skinCheckRoot._result._detail = skinCheckRoot._result.querySelector(
      '.result-box'
    );

    var skincheckForm = document.skincheckForm;

    var skinCheck = function(formData) {
      if (formData === 'NG') {
        skinCheckRoot._result.type = 'A';
      } else {
        // タイプ判定
        formData['q1'] === '1' && formData['q1-1'] === '0'
          ? (skinCheckRoot._result.type = 'A')
          : formData['q1'] === '1' &&
            formData['q1-1'] === '1' &&
            formData['q2'] === '1'
          ? (skinCheckRoot._result.type = 'B')
          : formData['q1'] === '1' &&
            formData['q1-1'] === '1' &&
            formData['q2'] === '0'
          ? (skinCheckRoot._result.type = 'C')
          : formData['q1'] === '0' && formData['q2'] === '1'
          ? (skinCheckRoot._result.type = 'D')
          : (skinCheckRoot._result.type = 'E');
      }

      // 振り分け
      $.ajax({
        url: util.ajaxUrl(
          util.appendParamToURL(
            Urls.getSkinCheckResult,
            'type',
            skinCheckRoot._result.type
          )
        )
      }).done(function(response) {
        if (response.success) {
          skinCheckRoot._result.dataset.status = response.data.status;
          skinCheckRoot._result._lead.innerHTML = response.data.lead;
          skinCheckRoot._result._detail.innerHTML = response.data.detail;
        }
      });
    };

    // 次へボタン押下
    skincheckForm.onsubmit = function(e) {
      e.preventDefault();

      var errorMsg = skinCheckRoot.querySelector('.errorMsg');
      errorMsg.innerHTML = '';
      var isRequired = this.querySelectorAll('.isRequired');
      for (var i = 0; i < isRequired.length; i++) {
        var checked = isRequired[i].querySelector('input:checked');
        if (!checked) {
          var p = document.createElement('p');
          var name = isRequired[i].querySelector('input').name;
          name = name.match(/q(.*)$/)[1];
          p.textContent = '質問' + name + 'は必須項目です。';
          errorMsg.appendChild(p);
        }
      }
      if (errorMsg.innerHTML) return;
      // var formData = new FormData(skincheckForm);
      // formData = Array.from(formData).reduce(function(obj, [key, value]){
      //   obj[key] = value;
      //   return obj
      // }, {});

      var formData = {};
      var checkedElms = skincheckForm.querySelectorAll('input:checked');
      for (var i = 0; i < checkedElms.length; i++) {
        var key = checkedElms[i].name;
        var value = checkedElms[i].value;
        formData[key] = value;
      }

      skinCheck(formData);
      skinCheckRoot.classList.add('comp');
      var opendNests = skincheckForm.querySelectorAll('.nestQ.isRequired');
      for (var i = 0; i < opendNests.length; i++) {
        opendNests[i].classList.remove('isRequired');
      }
    };
    var skincheckFormButton = modalWidget.querySelector('.js-agein');
    skincheckFormButton.onclick = function(e) {
      e.preventDefault();
      skincheckForm.reset();
      skinCheckRoot.classList.remove('init');
      skinCheckRoot.classList.remove('comp');

      skinCheckRoot._result.dataset.status = '';
      skinCheckRoot._result._lead.innerHTML = '';
      skinCheckRoot._result._detail.innerHTML = '';
    };

    var modalClickHandler = function(e) {
      var toolTip = skinCheckRoot.querySelector('.js-toolTip');

      if (
        skinCheckRoot.classList.contains('comp') &&
        e.target.classList.contains('js-closeModal')
      ) {
        // cookie付与
        if (skinCheckRoot._result.type === 'A') {
          $.ajax({
            url: util.ajaxUrl(
              util.appendParamsToUrl(Urls.setSkinCheckCookie, {
                value: 'NG',
                type: skinCheckRoot._result.type
              })
            )
          });
        } else {
          $.ajax({
            url: util.ajaxUrl(
              util.appendParamsToUrl(Urls.setSkinCheckCookie, {
                value: 'OK',
                type: skinCheckRoot._result.type
              })
            )
          }).done(function(response) {
            if (response.success) {
              if (
                $originButton.closest('.product-tile').length > 0 &&
                $originButton.closest('.product-tile').data('itemid') ===
                  $originButton.data('pid')
              ) {
                productTile.plpAddItemToCart(e, $originButton);
              } else if (
                $originButton.closest('.product-detail').length ||
                $originButton.closest(
                  '.stick-buy-container.open .product-details'
                ).length
              ) {
                addToCart.addToCart(e, $('.product-detail .add-to-cart'));
              } else if (
                $originButton.hasClass('buy-button') &&
                Boolean($originButton.data('pid'))
              ) {
                // 静的ページからの [購入]
                productTile.plpAddItemToCart(e, $originButton);
              } else {
                $originButton.click();
              }
            }
          });
        }
        modalClose(skinCheckRoot);
      } else if (e.target.classList.contains('js-forceClose')) {
        modalClose(skinCheckRoot);
      } else if (
        !skinCheckRoot.classList.contains('comp') &&
        e.target.classList.contains('js-closeModal')
      ) {
        toolTip.classList.add('isOpen');
        toolTip.dataset.position = e.target.dataset.position;
        skinCheckRoot.style.overflow = 'visible';
        $('.isMac').removeClass('z-skincheck_modal_widget');
        setTimeout(function() {
          $('.isMac').addClass('z-skincheck_modal_widget');
        }, 120);
      } else {
        if (
          !e.target.classList.contains('js-closeModal') &&
          e.target !== toolTip &&
          e.target.parentElement !== toolTip
        ) {
          toolTip.classList.remove('isOpen');
          toolTip.addEventListener(
            'transitionend',
            function() {
              if (toolTip.classList.contains('isOpen')) return;
              skinCheckRoot.style.overflow = '';
            },
            { once: true }
          );
        }
      }
    };

    modalOpen(skinCheckRoot);
    modalWidget.onclick = modalClickHandler;
    if (skinCheckRoot.classList.contains('init')) {
      skinCheck('NG');
    }

    var handles = document.querySelectorAll('[data-nest-taget]');
    if (!handles.length) return;
    for (var i = 0; i < handles.length; i++) {
      var target = handles[i].dataset.nestTaget;
      var targetElms = document.querySelectorAll(
        '[data-nest-id="' + target + '"]'
      );
      handles[i].onchange = function() {
        if (this.querySelector('[value="1"]').checked) {
          for (var n = 0; n < targetElms.length; n++) {
            targetElms[n].classList.add('isRequired');
          }
        } else {
          for (var n = 0; n < targetElms.length; n++) {
            targetElms[n].classList.remove('isRequired');
            // if (targetElms[n].querySelector('input:checked')) {
            // targetElms[n].querySelector('input:checked').checked = false;
            // }
          }
        }
      };
    }
  };
  exports.init = init;

  //Read cookie
  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  exports.readCookie = readCookie;

  function skinTroubleExecute(cookieValue, $this) {
    $.ajax({
      url: util.appendParamToURL(Urls.skinCheck, 'cv', cookieValue)
    }).done(function(response) {
      $('body').append(response);
      init($this);
    });
  }
  exports.skinTroubleExecute = skinTroubleExecute;
})();

},{"../../product-tile":90,"../../util":105,"./addToCart":66}],76:[function(require,module,exports){
module.exports = function socialShareIcons() {

	if (/Mobi/.test(navigator.userAgent)) {
		$(document).on('touchstart',  '.social-modal-close-outer', function() {
			$('.socialsharing').toggleClass('active');
		});
		$(document).on('touchstart', '.social-share-trigger', function() {
				$('.socialsharing').toggleClass('active');
		});
	}else{
		$(document).on('click',  '.social-modal-close-outer', function() {
			$('.socialsharing').toggleClass('active');
		});
		$(document).on('click', '.social-share-trigger', function() {
				$('.socialsharing').toggleClass('active');
		});
	}
};
},{}],77:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
  image = require('./image'),
  progress = require('../../progress'),
  productStoreInventory = require('../../storeinventory/product'),
  socialShareIcons = require('./socialShareIcons'),
  util = require('../../util'),
  recommendations = require('./recommendations'),
  imagesLoaded = require('imagesloaded');

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
function pdpMobileSwatchesCarousel() {
  if ($(window).width() <= 640) {
    $('.swatches.color').slick({
      arrows: true,
      centerMode: false,
      centerPadding: '16px',
      slidesToShow: 5,
      slidesToScroll: 5
    });

    // get the selected variant
    var selectedVariant = $('.swatches.color li.selected');

    // know it's index
    var indexOfSelected = selectedVariant.attr('data-slick-index');

    // automatically slide to variant upon page load
    $('.swatches.color').slick('slickGoTo', indexOfSelected, false);
  }
}

function updateContent(href) {
  var $pdpForm = $('.pdpForm');
  var qty = $pdpForm.find('select[name="Quantity"] option:selected').val();

  var params = {
    Quantity: isNaN(qty) ? '1' : qty,
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    target: $('#product-content'),
    callback: function () {
      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }
      var stickyElememt = $('#product-content').find('.sticky-buy-section');
      var stickyContent = stickyElememt.html();
      stickyElememt.html('');
      updateContentSticky(stickyContent);
      image();
      $(document).trigger('gtvariationchange');
      socialShareIcons();
      recommendations();
      // カラー変更イベント
      require('../../analytics/pdp/colorChange')();

      if ($('#pdp-top-quantity').length) {
        $('select')
          .not(function (index, element) {
            return (
              $(element).closest(
                '.entry-container, .entry-modal, .entry-wrapper'
              ).length > 0
            );
          })
          .selectmenu({
            width: false,
            position: {
              my: 'left top',
              at: 'left bottom',
              collision: 'flip flip'
            },
            classes: {
              'ui-selectmenu-menu': 'qv-select'
            }
          });
        $('#pdp-top-quantity-menu').parent().addClass('pdp-qty-width');
        syncQtyDropdownValue($('.quantity-dropdown'));
      }

      updateStickyBuySwatchDropdown();
      updateReplanishCycle();
      imagesLoaded('.product-thumbnails .productthumbnail').on(
        'done',
        function () {
          $('.fade-circle').removeClass('hidden');
        }
      );
    }
  });
}

function updateContentSticky(stickContent) {
  var $pdpForm = $('.pdpForm');
  var qty = $('#product-content-sticky')
    .find('select[name="Quantity"] option:selected')
    .val();

  $('#product-content-sticky').html(stickContent);

  if (SitePreferences.STORE_PICKUP) {
    productStoreInventory.init();
  }
  $('select').selectmenu({
    width: false,
    position: { my: 'left top', at: 'left bottom', collision: 'flip flip' },
    classes: {
      'ui-selectmenu-menu': 'qv-select'
    }
  });
  $('#pdp-top-quantity-menu').parent().addClass('pdp-qty-width');
  syncQtyDropdownValue($('.quantity-dropdown'));
  socialShareIcons();
  updateStickyBuySwatchDropdown();

  // LINE API 連携
  try {
    // 開発環境では例外が発生する
    auto_line_pv_event_support_duplication(
      'detail',
      $('.product-number span').data('pid')
    );
  } catch (e) {
    console.log(e);
  }
}

function updateSetContent($ele, href) {
  var $productSetItemCtnr = $ele.parents('.product-set-item'),
    qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

  progress.show($productSetItemCtnr);

  $.get(
    util.appendParamsToUrl(href, {
      Quantity: isNaN(qty) ? '1' : qty,
      format: 'ajax',
      setproduct: true
    })
  ).success(function (html) {
    $productSetItemCtnr.html(html);
    image();
    socialShareIcons();
  });
}

/**
 * @description update sticky buy swatch dropdown
 **/
function updateStickyBuySwatchDropdown() {
  var $swatchsDropdown = $('.stick-buy-container .swatches-dropdown'),
    $selectedSwatch = $(
      '.stick-buy-container #pdp-swatches li.selected .swatchanchor'
    );
  $swatchsDropdown.html($selectedSwatch.html());
  $swatchsDropdown.off().on('click', function () {
    $(this).toggleClass('active');
    $(this)
      .siblings('#pdp-swatches')
      .toggleClass('active')
      .css('width', $swatchsDropdown.innerWidth());
  });
}

function syncQtyDropdownValue($dropdownElem) {
  $dropdownElem.on('selectmenuchange', function () {
    $dropdownElem.val($(this).val());
    $dropdownElem.selectmenu().selectmenu('refresh');
  });
}

function updateQuantityOnChange() {
  var $quantityDropdown = $('.quantity-dropdown');
  $quantityDropdown.selectmenu({
    width: false,
    position: { my: 'left top', at: 'left bottom', collision: 'flip flip' },
    classes: {
      'ui-selectmenu-menu': 'qv-select'
    }
  });
  syncQtyDropdownValue($quantityDropdown);
}

function updateReplanishCycle() {
  //On Change Select in PDP
  $('.replenishmentCycle').on('selectmenuchange', function (event, ui) {
    var footerURL = window.location.href;
    var selection = $(this).val();

    if (window.User.isCustomerAuthenticated == false && selection != 0) {
      $('.replenishmentCycle').val('0');
      $('.replenishmentCycle').selectmenu('refresh');

      $.ajax({
        url: Urls.replenishmentLogin,
        success: function (response) {
          $('.replenishment-onchange-modal .modal-body').html(response);
          $('.replenishment-onchange-modal').show();
          $('.replenishment-onchange-modal .modal-body').scrollBox();

          $('.modal-btn-signin').click(function () {
            var urlLink = util.appendParamToURL(
              Urls.showLogin,
              'original',
              footerURL
            );
            window.location = urlLink;
          });

          $('.modal-btn-register').click(function () {
            var urlLink = util.appendParamToURL(
              Urls.showCreateAccount,
              'original',
              footerURL
            );
            window.location = urlLink;
          });
        }
      });
    } else {
      var $dropdownElem = $('.replenishmentCycle');
      $dropdownElem.val(selection);
      $("input[name='replenishmentCycle']").val(selection);
      $dropdownElem.selectmenu().selectmenu('refresh');
    }
  });
}

module.exports = function () {
  var $pdpMain = $('#pdpMain');
  var $pdpSticky = $('.stick-buy-container');

  // // hover on swatch - should update main image with swatch image
  // $pdpMain.on('mouseenter mouseleave', '.swatchanchor', function () {
  //     var largeImg = $(this).data('lgimg'),
  //         $imgZoom = $pdpMain.find('.image-zoom'),
  //         $mainImage = $pdpMain.find('.primary-image');

  //     if (!largeImg) {
  //         return;
  //     }

  //     // store the old data from main image for mouseleave handler
  //     $(this).data('lgimg', {
  //         hires: $imgZoom.attr('href'),
  //         url: $mainImage.attr('src'),
  //         alt: $mainImage.attr('alt'),
  //         title: $mainImage.attr('title')
  //     });

  //     // set the main image
  //     image.setMainImage($(this).data('lgimg'));
  // });

  $pdpMain
    .on('click', '#product-content .swatchanchor', function (e) {
      e.preventDefault();

      updateContent(this.href);
    })
    .on('change', '#product-content .variation-select', function () {
      var img = $(
        '#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() + '"])'
      );
      var href = img.closest('a').attr('href');

      var $selectedVariantOption = $(this).find('option:selected');
      if (
        $selectedVariantOption.length === 0 ||
        !$selectedVariantOption.val()
      ) {
        return;
      }

      updateContent(href);
    });

  $pdpMain.on(
    'selectmenuchange',
    '#product-content .variation-select',
    function (event, ui) {
      var img = $(
        '#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() + '"])'
      );
      var href = img.closest('a').attr('href');

      var $selectedVariantOption = $(this).find('option:selected');
      if (
        $selectedVariantOption.length === 0 ||
        !$selectedVariantOption.val()
      ) {
        return;
      }

      updateContent(href);
    }
  );

  $pdpSticky.on('click', '#product-content-sticky .swatchanchor', function (e) {
    e.preventDefault();

    updateContent(this.href);
  });

  $pdpSticky.on(
    'selectmenuchange',
    '#product-content-sticky .variation-select',
    function (event, ui) {
      var img = $(
        '#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() + '"])'
      );
      var href = img.closest('a').attr('href');

      var $selectedVariantOption = $(this).find('option:selected');
      if (
        $selectedVariantOption.length === 0 ||
        !$selectedVariantOption.val()
      ) {
        return;
      }

      updateContent(href);
    }
  );

  $pdpMain
    .on('click', '#product-set .swatchanchor', function (e) {
      e.preventDefault();

      updateSetContent($(this), $(this).attr('href'));
    })
    .on('change', '#product-set .variation-select', function () {
      var img = $(this)
        .closest('ul')
        .find(
          '#pdp-swatches .swatchanchor:has(img[alt="' + $(this).val() + '"])'
        );
      var href = img.closest('a').attr('href');

      updateSetContent($(this), href);
    });
  //pdpMobileSwatchesCarousel();
  updateStickyBuySwatchDropdown();
  updateQuantityOnChange();
  updateReplanishCycle();
};

},{"../../ajax":1,"../../analytics/pdp/colorChange":14,"../../progress":91,"../../storeinventory/product":102,"../../util":105,"./image":69,"./recommendations":74,"./socialShareIcons":76,"imagesloaded":111}],78:[function(require,module,exports){
'use strict';
var util = require('../util');

var $cache;

function initializeCache() {
	$cache = {};
	$cache['errorMsg'] = $('#promotion-landing-container .landing-error');
}

function initializeEvents() {
	$(document)
		.on('submit', '#PromoLandingForm', function (e) {
			var httpParams = util.getQueryStringParams(util.getQueryString(window.location.href));
			$('<input type="hidden" name="promoid" value="' + httpParams["promoid"] + '" />').appendTo(e.target);
		})

		.on('focus', '#PromoLandingForm input', function () {
			$cache.errorMsg.hide();
		});
}

module.exports.init = function () {
	initializeCache();
	initializeEvents();

	if (window.location.href.indexOf('error') > -1) {
		$cache.errorMsg.show();
	}
	if (window.couponCode) {
		$("#promo-code").text(window.couponCode);
	}
};
},{"../util":105}],79:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) { return; }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":1,"../login":41,"../quickview":92,"../util":105,"./product/addToCart":66}],80:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
	productTile = require('../product-tile'),
	addToCart = require('./product/addToCart'),
	progress = require('../progress'),
	video = require("../video"),
	util = require('../util'),
	recommendations = require('./product/recommendations'),
	currentLayout = require('../detect-layout'),
	orderReplenish = require('../order-replenishment');

var currLayout = currentLayout.init();

function copyBottomResultHitsToTop() {
	if($('.search-folder-content-list').length == 0 ) {
		$("#results-hits-top").html($("#results-hits-bottom .results-hits").html());
	}
}

//PLP wishlist heart icon
function wishListElem() {	
    $('.plp-wishlist-icon').off().on('click', function() {
    	var ajaxUrl;
    	var _this = $(this);
    	var currProductID = _this.attr('data-element-pid');
    	var productInwishlist = _this.attr('data-item-in-wishlist');
    	var data = {pid:currProductID};
    	
    	if(_this.hasClass("plp-active-wishlist")){
    		ajaxUrl = _this.attr('data-ajax-remove');
    		_this.removeClass("plp-active-wishlist");
    	}else{
    		ajaxUrl = _this.attr('data-ajax-add');
    		_this.addClass("plp-active-wishlist"); 
    	}
    	
    	$.ajax({
    		type: 'GET',
            url: ajaxUrl,
            data: data
        })
        .done(function (response) { });
    });

    window.onload = function() {
    	var wishlistProd = window.User.wishlistProducts;	
    	$(".plp-product-grid-block .product-tile").each(function(){
    		var _this = $(this);
    		var currEle = _this.find('.plp-wishlist-icon').attr('data-element-pid');
    		if(window.User.wishlistProducts != null && wishlistProd.indexOf(currEle) >= 0){
    			_this.find(".plp-wishlist-icon").addClass("plp-active-wishlist");
    		}
    	});	
    };
}

function productCarouselelem() {
	$('#product-list-page-carousel').slick({
    	  dots: false,
    	  infinite: false,
    	  speed: 300,
    	  slidesToShow: 1,
    	  slidesToScroll: 1,
    	  responsive: [
    	    {
    	      breakpoint: 1024,
    	      settings: {
    	        slidesToShow: 1,
    	        slidesToScroll: 1,
    	        infinite: true,
    	        dots: false
    	      }
    	    },
    	    {
    	      breakpoint: 600,
    	      settings: {
    	        slidesToShow: 1,
    	        slidesToScroll: 1
    	      }
    	    },
    	    {
    	      breakpoint: 480,
    	      settings: {
    	        slidesToShow: 1,
    	        slidesToScroll: 1
    	      }
    	    }
    	    // You can unslick at a given breakpoint now by adding:
    	    // settings: "unslick"
    	    // instead of a settings object
    	  ]
    	});
}

function viewMoreClick(e) {
	e.preventDefault();
	// getting the hidden div, which is the placeholder for the next page
	var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
	// get url hidden in DOM
	var gridUrl = loadingPlaceHolder.attr('data-grid-url');

	if (loadingPlaceHolder.length === 1) {
		// switch state to 'loading'
		// - switches state, so the above selector is only matching once
		// - shows loading indicator
		loadingPlaceHolder.attr('data-loading-state', 'loading');
		loadingPlaceHolder.addClass('infinite-scroll-loading');

		$('.ajax-loader.page-loader').show();
	
		// named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
		var fillEndlessScrollChunk = function (html) {
			loadingPlaceHolder.removeClass('infinite-scroll-loading');
			loadingPlaceHolder.attr('data-loading-state', 'loaded');
			$('#results-hits-bottom'). remove();
			if($('.tutorial-listing').length > 0 ) {
				$('div.search-result-content .folder-content-list').append(html);
			} else if($('.ordereplenishments').length > 0){
				$('.ordereplenishments .replenishment-items').append(html);
			} else if ($('.order-history-wrap').length > 0){
				$('div.order-history-results').append(html);
			} else {
				$('div.search-result-content').append(html);
			}

			// move all product tiles up to search grid to prevent arbitrary breaklines
			$(".tiles-container .tile-wrapper").appendTo("#search-result-items");

			// If category bottom image configured then append bottom-empty li at last position(Exclusive Page)
			if($('.renderbottommotiveimage').length) {
				$('.renderbottommotiveimage').appendTo("#search-result-items");
			}
			viewMorePosition();

			//Remove when there is duplicate/empty search-result-items
			$('#search-result-items.page-element').remove();

			$('img.product-image-initial').off().on('mouseenter mouseleave', function() {
				$(this).attr({
					src: $(this).attr('data-alt-src'),
					'data-alt-src': $(this).attr('src') 
				});
			});
			// PLP wishlist heart icon
			wishListElem();
			// rebind the View More event
			$("#view-more").off();
			$("#view-more").bind("click", viewMoreClick);
			tileSelectSizeInit();
			if($('.ordereplenishments').length > 0) {
				orderReplenish.init();
			}
			$( "select" ).selectmenu().selectmenu('refresh', true);
			$('.ajax-loader.page-loader').hide();
		};

		// old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
		// it was removed to temporarily address RAP-2649

		$.ajax({
			type: 'GET',
			dataType: 'html',
			url: gridUrl,
			success: function (response) {
				// put response into cache
				try {
					sessionStorage['scroll-cache_' + gridUrl] = response;
				} catch (e) {
					// nothing to catch in case of out of memory of session storage
					// it will fall back to load via ajax
				}
				// update UI
				$(".pagination-buttons").remove();
				if($('.search-folder-content-list').length == 0 ) {
					$(".results-hits").remove();
				}
				fillEndlessScrollChunk(response);
				copyBottomResultHitsToTop();
				productTile.init();
				ellipsifyContentDescInt();
				$(document).trigger("plpviewmore");
				video.initialize();
			}
		});
	}
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url,stickFilter) {
	progress.show($('.search-result-content'));
	$('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
		compareWidget.init();
		productTile.init();
		progress.hide();
		history.pushState(undefined, '', url);
		//reinitialize the functions
		initializeEvents();
		// PLP wishlist heart icon
		wishListElem();
		$('img.product-image-initial').off().on('mouseenter mouseleave', function() {
			$(this).attr({
				src: $(this).attr('data-alt-src'),
				'data-alt-src': $(this).attr('src')
			});
		});
		productCarouselelem();       
		if(stickFilter){
			if($(".shop-by-btn").length){
				$(".shop-by-btn").trigger('click');
			}
		}
		plpSelectMenuInit();
		tileSelectSizeInit();
		recommendations();
		/*$(".shop-by-btn").trigger('click');*/
		$( "select" ).selectmenu().selectmenu('refresh', true);
		sortByDropdown();
		categoryCarousel();
		catShopByCollectionMenuInit();
		simpleSearchClearFunc();
		simpleSearchStickyFunc();
		viewMorePosition();
		video.initialize();
		groupingSelector();
		bindFilterSortRefinement();
		if($(".tutorial-listing").length > 0 ){
			destroyCarouselTutorial();
			createCarouselTutorial();
			updateFolderDescriptionOnChange();
		}
		$('.ajax-loader.page-loader').hide();
	});
}
function destroyCarouselTutorial() {
	if ($('.tutorial-carousel-slick').hasClass('slick-initialized')) {
	  $('.tutorial-carousel-slick').slick('destroy');
	}      
  }
function createCarouselTutorial(){
	if($('.tutorial-carousel-slick').length > 0) {
		$('.tutorial-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}
}
function sortByDropdown() {
	if($('#grid-sort-header').length > 0){
		if(window.innerWidth < 769) {
			$( '#grid-sort-header' ).selectmenu({
				classes: {
					"ui-selectmenu-menu": "sort-by-selectmenu"
				}
			});
		} else{
			$('#grid-sort-header').selectmenu( {
				position: { my : 'right top', at: 'right bottom', collision: "flip"}
			});
		}
	}
}
function excludeCompoundAttributeRefinements(refineUrl) {
    var newUrl = refineUrl;

    var params = util.getQueryStringParams(refineUrl, true);
    Object.keys(params).forEach(function (paramName) {
        if (paramName.indexOf('prefv') === -1) {
            return;
        }

        var splitParam = params[paramName].split("|");
        newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
    });

    return newUrl;
}


if (!$('#shop-by-dropdown').hasClass('is-open')) {
	$('body').removeClass("sticky-body");
}


/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
	// compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
		});
	
	});
	$(document).on("click", ".top-filter a.filter-option", function(e) {
    	e.preventDefault();
        var $this = $(this);
        $this.toggleClass("checked-filter");
        var url = $this.attr( $this.hasClass("checked-filter") ? 'data-refineurl': 'data-url' ) ;
        var stickFilter = true;
        updateProductListing(url,stickFilter);
    }); 

    $(document).on("click", ".selected-breadcrumb-refinement a.breadcrumb-relax", function(e) {
        e.preventDefault();
    	$('body').removeClass("sticky-body");
    	$('.mega-menu-logo-container').show();
        var $this = $(this);
        var url = $this.attr('data-relaxurl') ;
        updateProductListing(url);
        // PLP wishlist heart icon
        wishListElem();
        productCarouselelem();
    });
        
    // handle events for updating grid
    $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

	sortByDropdown();
	

   $main.on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });

	$main.on('change', '.items-per-page select', function() {
			var refineUrl = $(this).find('option:selected').val();
			$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
			updateProductListing(refineUrl);
	});

    $('.category-tab-links select').on('change', function(e){
    	var $selected = $(this).find(":selected");
    	var link = $selected.attr('href');

    	if(link){
    		window.location.href = link;
    	}
    });
    
  $(".close-shop-by").click(function(e){
    	 e.preventDefault();
        $(".shop-by-btn").trigger("click");
    });
    
    $(".dropdown-panel-button").on('click', function(){
    	$(".dropdown-pane").removeClass("is-open");
    	$('body').removeClass("sticky-body");
    	$(".mega-menu-logo-container").show();
    	$(".scroll-top-wrapper").show();
    });
    
    $(".filter-option").on("click", function(){
    	setTimeout(function(){
    		$('body').removeClass("sticky-body");
    	},2000);
    });
    
    $(".shop-by-btn").on('click', function(){
    	$(".plp-product-grid-category").addClass("small-flyout");
    	if (screen.width <= 767) {
	    	$(".mega-menu-logo-container").hide();
	    	$(".scroll-top-wrapper").hide();
    	}
    	$('body').addClass("sticky-body");
    });
    
    $(".close-shop-by").on('click', function(){
    	$(".dropdown-pane").removeClass("is-open");
    	$(".shop-by-btn").removeClass("hover");
    	$(".plp-product-grid-category").removeClass("small-flyout");
    	$(".mega-menu-logo-container").show();
    	$(".scroll-top-wrapper").show();
    	$('body').removeClass("sticky-body");
    });
    
	
    plpSelectMenuInit();
    catShopByCollectionMenuInit();
}



$('a.plp-menu-anchor').click(function(){	
	var _this = $(this);
	if(!_this.parent().hasClass('is-active')){
		_this.closest('.dropdown-pane').find('.is-active .accordion-title').trigger('click');
	}
});

function bindFilterSortRefinement() {
	// handle sorting change
	$('#grid-sort-header').on( "selectmenuchange", function( event, ui ) {
		event.preventDefault();
		$('.ajax-loader.page-loader').show();
		updateProductListing($(this).find('option:selected').val());
	});
	
	//handle refinement change
	$('.top-filter select').on( "selectmenuchange", function( event, ui ) {
		event.preventDefault();

		var refineUrl = $(this).find('option:selected').val();
		if (refineUrl.indexOf('prefv') > -1) {
			refineUrl = excludeCompoundAttributeRefinements(refineUrl);
		}

		$('.ajax-loader.page-loader').show();
		updateProductListing(refineUrl);
	});
}

function plpSelectMenuInit() {
	$( ".toolbar-wrapper select" ).selectmenu ({
		//Add class to Dropdown Set for css targeting
		width: false,
		position: {  my: "left top", at: "left bottom-2", collision: "flip flip"  },
		change: function(event, ui) {
			var $element = $(event.delegateTarget).attr('id');
			$('.ui-selectmenu-button[aria-owns= "'+$element+'"]').addClass('selected');
		}
	});
}

function catShopByCollectionMenuInit() {
	$( "#clp-collection-select" ).selectmenu ({
		//Add class to Dropdown Set for css targeting
		width: false,
		position: {  my: "left top", at: "left bottom-2", collision: "flip flip" },
		classes: { "ui-selectmenu-menu": "catShopByCollection" },
		change: function(event, ui) {
			var $element = $(event.delegateTarget).attr('id');
			$('.ui-selectmenu-button[aria-owns= "'+$element+'"]').addClass('selected');
		}
	});
}

function tileSelectSizeInit() {
	$( ".product-swatches select" ).selectmenu ({
		//Add class to Dropdown Set for css targeting
		width: false,
		position: {  my: "left top", at: "left bottom", collision: "flip flip"  },
		classes: { "ui-selectmenu-menu": "pdp-color-select" },
		change: function(event, ui) {
			var $element = $(event.delegateTarget).attr('id');
			$('.ui-selectmenu-button[aria-owns= "'+$element+'"]').addClass('selected');
		}
	});
}

function simpleSearchClearFunc() {
	var $resetLink = $('.search-form-wrapper button[type="reset"]');
	$('.search-form-wrapper input[type="text"]').on('input',function(e){
		if($(this).val() == '') {
			$resetLink.hide();
		} else {
			$resetLink.show();
		}
	});
	$resetLink.on('click', function(){
		$('.search-form-wrapper input[type="text"]').val('');
		$resetLink.hide();
		return false;
	});
}

function simpleSearchStickyFunc() {
	// Cache selectors outside callback for performance. 
	if ($('.product-search-form-page').length > 0) {
		var $window = $(window),
			$stickyEl = $('.product-search-form-page'),
			elTop = $stickyEl.offset().top;
		if (currLayout == 'mobile') {
			$window.scroll(function () {
				if ($window.scrollTop() > 10 && $(".search-results").length == 1) {
					$stickyEl.addClass('sticky');
				}
				else {
					$stickyEl.removeClass('sticky');
				}
			});
		} else {
			if ($stickyEl.hasClass('sticky')) {
				$stickyEl.removeClass('sticky');
			}
		}
	}
}


//Listen for orientation changes
$(window).on('resize orientationchange', function(){
	simpleSearchStickyFunc();
}, false);

function viewMorePosition() {
	if($('.renderbottommotiveimage').length > 0 && $('.pagination-buttons').length > 0) {
		if (!$('.exclusive-items + .pagination-buttons').length > 0) {
			$('.pagination-buttons').insertAfter(".exclusive-items");
		}
	}
}

function ellipsifyContentDesc(str, charlength) {
	if (str.length > charlength) {
		return (str.substring(0, charlength) + "...");
	}
	else {
		return str;
	}
}

function ellipsifyContentDescInt() {
	if(('.search-folder-content-list .tutorial-detail-link').length > 0){
		$('.search-folder-content-list .content-description').each(function( index ) {
			$(this).html(ellipsifyContentDesc($(this).html(), 85));
		});
	}
}

exports.init = function () {

	video.init(function () {
		initializeEvents();
	});

	compareWidget.init();
	//$("#view-more").on("click", viewMoreClick);

	$(document).on("click", "#view-more", viewMoreClick);
	$(document).on("click", ".wishlist .button.articles-view-more", viewMoreContent);
	productTile.init();
	initializeEvents();
	bindFilterSortRefinement();
	// content navigation title link
	$('.nav.content-navigation .accordion-title span').on('click', function() {
		window.location = $(this).data('url');
	});

	// content navigation dropdown redirect
	$('.nav.content-navigation select').on('change', function() {
		window.location = $(this).val();
	});

	var $accordionToggle = $('.refinements .accordion-arrow');

	$accordionToggle.on('click', function(evt) {
		evt.preventDefault();

		$(this).next($('#category-level-2')).slideToggle();

		$(this).parent($('li')).toggleClass('expanded');
	});

	//Tutorial content featured carousel
	if($('.tutorial-carousel-slick').length > 0) {
		$('.tutorial-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}

	
	recommendations();
	groupingSelector();
	categoryCarousel();
	addToCart();
	simpleSearchClearFunc();
	simpleSearchStickyFunc();
	viewMorePosition();
	ellipsifyContentDescInt();	
	updateFolderDescriptionOnChange();

};
exports.viewMore = function() {
	$("#view-more").off();
	$("#view-more-content").off();
	$(document).on("click", "#view-more", viewMoreClick);
	$(document).on("click", ".wishlist .button.articles-view-more", viewMoreContent);
};

function updateFolderDescriptionOnChange() {
	if($('.tutorial-select').length > 0) {
		var $tutorialdropdown = $('.tutorial-select');
		$tutorialdropdown.on('selectmenuchange', function(event, ui) {
			$('.tutorial-desc').html($(this).find(':selected').data('description'));
			if(!(ui.item.value == '')) {
				window.location = ui.item.value;
			}
		});
	}
}

function groupingSelector(){
	$( "#grouping-cat" ).selectmenu('refresh');
	$( "#grouping-cat-sibling" ).selectmenu('refresh');
    $( "#grouping-cat" ).on( "selectmenuchange", function( event, ui ) {
        var nextCatUrl = window.location.origin+Urls.nextLevelCategory+'?cgid='+ui.item.value;
        $( "#grouping-cat-sibling" ).selectmenu( "option", "disabled", true );
        $.ajax({
            type: 'GET',
            url: nextCatUrl,
            success: function (response) {
                if(response !== '' && response !== "undefined"){
                    response = JSON.parse(response);
                    var nextLevelSelect = $.parseHTML("<select id='grouping-cat-sibling'><option>" + Resources.GROUPING_SELECTOR_SELECT_SHORT + "</option></select>");
                    for (var select in response) {
                        $(nextLevelSelect).append("<option value='"+response[select].url+"'>"+response[select].displayName+"</option>");
                    }
                    $( "#grouping-cat-sibling" ).replaceWith( $(nextLevelSelect) );
                } else {
                    $( "#grouping-cat-sibling" ).replaceWith( $.parseHTML("<select id='grouping-cat-sibling'><option>" + Resources.GROUPING_SELECTOR_SELECT_SHORT + "</option></select>"));
                }
                $( "select" ).selectmenu();
            }
        });
    });
    $( document ).on( "selectmenuchange", "#grouping-subcat, #grouping-cat-sibling",  function( event, ui ) {
    	if(!(ui.item.value == '')) {
    		window.location = ui.item.value
    	}
    });
}

function categoryCarousel(){
	if($('#category-hero').children().length > 1){
		$('#category-hero').slick({
			arrows: true,
			dots: true
		});
	}
}

function viewMoreContent() {
	$('.wishlist .ajax-loader').show();
	var gridUrl = $(this).attr('data-grid-url');
	$.ajax({
	    type: 'GET',
	    dataType: 'html',
	    url: gridUrl,
	    success: function (response) {
			$('.wishlist .ajax-loader').hide();
			$('.wishlist .article-bottom').replaceWith(response)
	    }
	});
}

},{"../compare-widget":25,"../detect-layout":30,"../order-replenishment":45,"../product-tile":90,"../progress":91,"../util":105,"../video":107,"./product/addToCart":66,"./product/recommendations":74}],81:[function(require,module,exports){
'use strict';

const addToCart = require('./product/addToCart');

/**
 * AddToCartButton ViewDto
 *
 * @typedef {Object} AddToCartButtonViewDto
 * @property {string} quantityOptions 数量選択肢
 * @property {number} quantity 選択中の数量
 * @property {boolean} isCartAvailableSite カート機能が有効なとき、true
 * @property {boolean} isShowOnStockNotificationPage 再入荷お知らせ画面に表示する場合、true
 * @property {string} productId 商品ID
 * @property {AddToCartButton} addToCartButton カートに入れるボタンViewDto
 */

/**
 * カート追加ボタンViewDto
 *
 * @typedef {Object} AddToCartButton
 * @property {string} [dataAttributesString] data属性
 * @property {string} [title] title属性
 * @property {string} label 表示テキスト
 */

/**
 * カート追加ボタンのtemplateタグのHTMLを取得する。
 *
 * @returns {void}
 */
async function loadAddToCartButtonTemplate() {
  await fetch(window.Urls.landingPageCartButtonTemplate)
    .then((response) => response.text())
    .then((html) => $('body').append(html));
}

/**
 * ajaxリクエストでカート追加ボタン表示用データを取得する。
 *
 * @returns {AddToCartButtonViewDto | null} カート追加ボタン表示用データ、またはnull。
 */
async function getAddToCartButtonProperties() {
  // 対象の商品IDを重複排除して取得
  const productIdList = getProductIdList();
  if (productIdList.length === 0) {
    return null;
  }
  // 戻り値
  var buttonProperties = null;
  // JSONで取得
  $.ajax({
    method: 'GET',
    url: window.Urls.landingPageCartButtonProperties,
    data: { productIdList: productIdList },
    async: false
  })
    .done((data) => {
      buttonProperties = data;
    })
    .fail(() => {
      // nothing to do
    });
  return buttonProperties;
}

/**
 * カート追加ボタンを作成、追加する。
 *
 * @param {AddToCartButtonViewDto} buttonProperty ボタン属性
 * @returns {void}
 */
function createAddToCartButton(buttonProperty) {
  // 表示無しの場合は何も出力しない
  if (!isShowAddToCartButton(buttonProperty)) {
    return;
  }
  // カート追加ボタン
  const $addToCartButtonArea = isAddToCartButtonEnabled(buttonProperty)
    ? createEnabledCartButton(buttonProperty)
    : createDisabledCartButton(buttonProperty);
  // hidden要素の後に追加
  $(
    `input[type=hidden][name^=addToCartPid][value=${buttonProperty.viewDto.productId}]`
  ).after($addToCartButtonArea);
}

/**
 * カート追加ボタンのテンプレートを取得する。
 *
 * @param {AddToCartButtonViewDto} buttonProperty ボタン属性
 * @returns {jQuery} 購入可否状態に応じたカート追加ボタンのテンプレート
 */
function getAddToCartButtonTemplate(buttonProperty) {
  // templateタグのIDを取得
  const templateId = buttonProperty.template.split('/').slice(-1)[0];
  const $template = $($(`template#${templateId}`).html());
  return $template.length > 0 ? $template : $($('template#unavailable').html());
}

/**
 * カート追加ボタンのクリック可否を判定する。
 *
 * @param {AddToCartButtonViewDto} buttonProperty ボタン属性
 * @returns {boolean} クリック可の場合、trueを返却
 */
function isAddToCartButtonEnabled(buttonProperty) {
  return buttonProperty.viewDto.addToCartButton != null;
}

/**
 * カート追加ボタンの表示判定
 *
 * @param {AddToCartButtonViewDto} buttonProperty ボタン属性
 * @returns {boolean} 表示する場合、trueを返却する。
 */
function isShowAddToCartButton(buttonProperty) {
  return buttonProperty.viewDto.isCartAvailableSite;
}

/**
 * 利用可能なカート追加ボタンエリア要素を作成する。
 *
 * @param {AddToCartButtonViewDto} buttonProperty ボタン属性
 * @returns {jQuery} 利用可能なカート追加ボタンエリア要素
 */
function createEnabledCartButton(buttonProperty) {
  const viewDto = buttonProperty.viewDto;
  const $template = getAddToCartButtonTemplate(buttonProperty);

  // hidden要素のvalue値を設定
  $template.find('input#pid').val(buttonProperty.viewDto.productId);

  // 数量選択肢を作成
  const $quantitySelect = $template.find('select#pdp-top-quantity');
  viewDto.quantityOptions.forEach((option) => {
    const $optionObject = $('<option>').val(option).text(option);
    $quantitySelect.append($optionObject);
  });
  // 先頭の選択肢を選択状態にする
  $quantitySelect.find('option:first-child()').prop('selected', true);

  // カート追加ボタンの属性を設定
  const $addToCartButton = $template.find('button#add-to-cart');
  $addToCartButton
    .attr('title', viewDto.addToCartButton.title)
    .val(viewDto.addToCartButton.title)
    .text(viewDto.addToCartButton.label);
  // カート追加ボタンのdata属性を追加
  viewDto.addToCartButton.dataAttributesString
    .split(' ')
    .forEach((dataAttributeString) => {
      const keyValue = dataAttributeString.split('=');
      const key = keyValue[0].replace(/"/g, '');
      const value = keyValue[1].replace(/"/g, '');
      $addToCartButton.attr(key, value);
    });

  return $template;
}

/**
 * 利用不可のカート追加ボタンエリア要素を作成する。
 *
 * @param {object} buttonProperty ボタン属性
 * @returns {jQuery} 利用不可のカート追加ボタンエリア要素
 */
function createDisabledCartButton(buttonProperty) {
  const viewDto = buttonProperty.viewDto;
  const $template = getAddToCartButtonTemplate(buttonProperty);
  const $addToCartButton = $template.find('button#add-to-cart');
  $addToCartButton
    .attr('title', viewDto.title)
    .val(viewDto.title)
    .text(viewDto.label);
  return $template;
}

/**
 * カート追加ボタンクリックイベントを設定する。
 */
function bindAddToCartClickEvent() {
  $(document)
    .off('click.addToCartLp')
    .on(
      'click.addToCartLp',
      '.lp-text-block .add-to-cart',
      addToCart.skinCheck
    );
}

/**
 * 重複排除したカート追加ボタンを設置する商品IDリストを取得する。
 *
 * @returns {string[]} 重複排除した商品IDリスト
 */
function getProductIdList() {
  const idList = $('input[type=hidden][name^=addToCartPid]')
    .toArray()
    .map((element) => $(element).val());
  return Array.from(new Set(idList));
}

/**
 * 初期化処理
 */
async function init() {
  // カート追加ボタンtemplateタグHTMLをロードする
  await loadAddToCartButtonTemplate();
  // カート追加ボタン出力用データを取得する。
  const buttonProperties = await getAddToCartButtonProperties();
  if (buttonProperties == null) {
    return;
  }
  // カート追加ボタンを生成する。
  buttonProperties.forEach(createAddToCartButton);
  // クリックイベントを設定する。
  bindAddToCartClickEvent();
}

module.exports = {
  init: init()
};

},{"./product/addToCart":66}],82:[function(require,module,exports){
'use strict';

exports.init = function() {
  $('select')
    .filter('[data-style != default]')
    .selectmenu({
      width: false,
      position: { my: 'left top', at: 'left bottom', collision: 'flip flip' },
      change: function(event, ui) {
        var $element = $(event.delegateTarget).attr('id');
        $('.ui-selectmenu-button[aria-owns= "' + $element + '"]').addClass(
          'selected'
        );
      }
    });
};

},{}],83:[function(require,module,exports){
'use strict';

var productTile = require('../product-tile'),
	recommendations = require('./product/recommendations');

exports.init = function () {
	productTile.init();
    recommendations();
    $('#homepage-hero').slick({
    	arrows: true,
    	autoplay: true,
    	autoplaySpeed: 4000,
    	dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
             {
               breakpoint: 480,
                  settings: {
                	  arrows: false
                  }
             }
        ]
    });
    $('.sub-feature-article').slick({
    	arrows: false,
    	dots: false,
    	infinite: false,
    	slidesToShow: 3,
    	slidesToScroll: 3,
    	responsive: [
	         {
	       	  breakpoint: 480,
	             settings: {
	            	slidesToShow: 1,
	     	        slidesToScroll: 1,
	     	        infinite: true,
	     	        arrows: false,
	     	        dots: true
	             }
	         }
       ]
    });
    
};

},{"../product-tile":90,"./product/recommendations":74}],84:[function(require,module,exports){
'use strict';
var dialog = require('../dialog');

exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
};

},{"../dialog":31}],85:[function(require,module,exports){
'use strict';

//function to open accordion by default on one layout only
function updateSummaryAccordion() {
	//For Cart,Shipping,Billing page promo code form 
    $(document).on('keydown','.cart-coupon-code input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').click();
        }
    });
    if($('.reviewstepclass, .billingstepclass, .shippingstepclass').length > 0) {
    	$('.checkout-products-accordion .accordion_title').addClass('open');
    	$('.checkout-products-accordion .accordion_description').show();
	}

	if($('.pt_cart').length > 0  && $(window).width() > 768 && $('.order-help-container').length > 0) {
		$('.order-help-container h3').addClass('open');
		$('.order-help-container .accordion_description').show();
	} else {
		$('.order-help-container h3').removeClass('open');
		$('.order-help-container .accordion_description').hide();
	}	
}

//Place order button sticky
function stickyPlaceOrder() {
    $(window).on('scroll', function() {
	if($(window).width() < 769) {
			if ($('.checkout-step.review .place-order-button').isInViewport()) {
				$('.place-order-checkout').removeClass('show');
			} else {
				$('.place-order-checkout').addClass('show');
            }            			
        }
    });
}


exports.init = function () {
	updateSummaryAccordion();
	$(window).on('resize', function() {
		if($('.cart-right-column').length > 0 || $('.checkout-right-column').length > 0) {
			updateSummaryAccordion();
		}
	});
	if($('.checkout-step.review').length){
        stickyPlaceOrder();
    }
};

},{}],86:[function(require,module,exports){
'use strict';

var addToCart = require('./product/addToCart'),
productTile = require('../product-tile');



function initTutorialCarousel () {
	$('.related-carousel-wrapper .tutorial-wrapper').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [
          {
        	  breakpoint: 1024,
        	  settings: {
    	        slidesToShow: 3,
    	        slidesToScroll: 1,
    	        infinite: true,
                arrows: false,
    	        dots: true
        	  }
          },
          {
        	  breakpoint: 640,
              settings: {
            	slidesToShow: 1,
      	        slidesToScroll: 1,
      	        infinite: true,
      	        arrows: false,
      	        dots: true
              }
          }
        ]
    });
	
	if ($("#thumbnails li").length == 0 ) {
        return false;
    } else if ($("#thumbnails li").length > 1 && window.innerWidth > 767 ) {
    	tutorialThumbnailCarousel();
    } else if ($("#thumbnails li").length > 1 && window.innerWidth < 768 ) {
    	tutorialMainImageCarousel();
    }
	tutorialImages();
}

function tutorialThumbnailCarousel() {
    $('#thumbnails ul').slick({
        dots: false,
        infinite: true,
        arrows: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1
    });
}

function tutorialMainImageCarousel() {
	$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
    $('#thumbnails ul').slick({
        dots: true,
        vertical: false,
        infinite: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 1
    });
}

// tutorial image carousel
function tutorialImages () {
	$("#thumbnails").on('click', '.productthumbnail', function () {
		var $that = $(this);
		
		$("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
		$that.addClass('selected');
		setTutorialMainImage($that.find('img').attr('src'));
	});
}

function setTutorialMainImage(src) {
    $('#tutorial-image-template .primary-image').attr('src', src);	
}

exports.init = function () {
	initTutorialCarousel();
    addToCart();
    productTile.init();

};
},{"../product-tile":90,"./product/addToCart":66}],87:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
  page = require('../page'),
  login = require('../login'),
  util = require('../util'),
  account = require('./account'),
  minicart = require('../minicart'),
  customModal = require('../modal'),
  formPrepare = require('./checkout/formPrepare'),
  productTile = require('../product-tile'),
  index = require('./product/index'),
  validator = require('../validator');

function changeQuantity() {
  $('.quantity-container select').change(function () {
    var quantity = $(this).find('option:selected').val();

    $('.option-quantity-desired input').val(quantity);
    $(this).closest('form').find('.update-item').click();
  });
}

function addItemToBag() {
  $(document).on('click', 'button.add-all-to-cart', function (e) {
    e.preventDefault();

    $(document)
      .find('button[name$="_addToCart"]')
      .each(function (e) {
        $(this).click();
      });
  });

  $(document).on('click', 'button[name$="_addToCart"]', function (e) {
    e.preventDefault();

    var $form = $(this).closest('form');
    var divError = $form.find('div.product-error');

    $.ajax({
      type: 'POST',
      url: util.ajaxUrl(Urls.wishlistAddToCart),
      data: $form.serialize(),
      success: function (response) {
        if (response.error) {
          divError.html(response.error);
        } else {
          minicart.show(response);
        }
      }
    });
  });
}

var wishlistProducts = window.User.wishlistProducts;
var favouriteContents = window.User.FevouriteContents;
// PLP wishlist heart icon

$(document).on('click', '.wishlist-icon', function (e) {
  e.preventDefault();
  var ajaxUrl;
  var _this = $(this);
  var currProductID = _this.attr('data-element-pid');
  var productInwishlist, data;

  if (currProductID) {
    productInwishlist = _this.attr('data-item-in-wishlist');
    data = { pid: currProductID };
  } else {
    var currArticleID = _this.attr('data-element-cid');
    data = { aid: currArticleID };
  }

  if (_this.hasClass('wishlist-added')) {
    ajaxUrl = _this.attr('data-ajax-remove');
  } else {
    ajaxUrl = _this.attr('data-ajax-add');
  }

  if (window.pageContext.ns === 'orderconfirmation') {
    ajaxUrl = util.appendParamToURL(ajaxUrl, 'page', 'confirmation');
  }

  ajaxUrl = util.appendParamToURL(ajaxUrl, 'format', 'ajax');

  $.ajax({
    type: 'GET',
    url: ajaxUrl,
    data: data
  }).done(function (response) {
    if (currProductID) {
      $('.wishlist-item .product-tile-inner').removeClass('hovered');
    }
    if (
      response &&
      response.error === undefined &&
      response.url === undefined
    ) {
      customModal.createCustomModal('login-modal');
      $('.login-modal').find('.modal-body').html(response);
      var windowWidth = $(window).width();
      $('.modal-overlay .modal-body').addClass('login-modal-height');
      index.bodyPositionFixed('login-modal');

      validator.initForm('.login-modal form[id$="dwfrm_login"]');
      var $resetpasswordlink = $('.reset-password-link');
      var url = Urls.passwordReset;
      login.wishlistAjaxLogin('form[id$="dwfrm_login"]');
      $('.login-modal .modal-close').click(function () {
        _this.removeClass('wishlist-added');
      });
      // GAログインイベント
      require('../analytics/login/accountLogin')();
    } else {
      if (currProductID) {
        if (wishlistProducts === null) {
          window.location.reload();
        } else {
          if (_this.hasClass('wishlist-added')) {
            wishlistProducts = arrayRemove(
              wishlistProducts,
              _this.attr('data-element-pid')
            );
          } else {
            wishlistProducts.push(_this.attr('data-element-pid'));
          }
        }
      } else {
        if (favouriteContents === null) {
          window.location.reload();
        } else {
          if (_this.hasClass('wishlist-added')) {
            favouriteContents = arrayRemove(
              favouriteContents,
              _this.attr('data-element-cid')
            );
          } else {
            favouriteContents.push(_this.attr('data-element-cid'));
          }
        }
      }
    }
  });
});

//Wishlist Favourite article heart icon

function arrayRemove(arr, value) {
  return arr.filter(function (ele) {
    return ele != value;
  });
}
function checkWhishlistProduct(wishlistProd) {
  $('.wishlist-icon').each(function () {
    var _this = $(this);
    var currEle = _this.attr('data-element-pid');
    _this.removeClass('wishlist-added');
    if (wishlistProd != null && wishlistProd.indexOf(currEle) >= 0) {
      _this.addClass('wishlist-added');
      if (_this.attr('data-disable-if-added') === 'true') {
        _this.attr('tabindex', '-1');
        _this.css('pointer-events', 'none');
        _this.css('display', 'inline-block');
      }
    }
  });
}

function checkFavouriteContents(favouriteContents) {
  $(
    '.ginza-edit-tile .wishlist-icon, .article-tile .wishlist-icon, .article-full-col .wishlist-icon, .article-description-section .wishlist-icon, .article.ginza-type .wishlist-icon'
  ).each(function () {
    var _this = $(this);
    var currEle = _this.attr('data-element-cid');
    _this.removeClass('wishlist-added');
    if (favouriteContents != null && favouriteContents.indexOf(currEle) >= 0) {
      _this.addClass('wishlist-added');
    }
  });
}

window.onload = function () {
  checkWhishlistProduct(window.User.wishlistProducts);
  checkFavouriteContents(window.User.FevouriteContents);
  productTile.init();
};

$(document).ajaxComplete(function () {
  checkWhishlistProduct(wishlistProducts);
  checkFavouriteContents(favouriteContents);
  productTile.init();
});

exports.init = function () {
  addProductToCart();
  changeQuantity();
  addItemToBag();

  $('#editAddress').on('change', function () {
    page.redirect(
      util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val())
    );
  });

  //add js logic to remove the , from the qty feild to pass regex expression on client side
  $('.option-quantity-desired input').on('focusout', function () {
    $(this).val($(this).val().replace(',', ''));
  });
  login.init();
  account.initMobileMenu();
};

},{"../analytics/login/accountLogin":12,"../login":41,"../minicart":42,"../modal":43,"../page":46,"../product-tile":90,"../util":105,"../validator":106,"./account":47,"./checkout/formPrepare":54,"./product/addToCart":66,"./product/index":70}],88:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.PinchZoom = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    /*
    
        PinchZoom.js
        Copyright (c) Manuel Stofer 2013 - today
    
        Author: Manuel Stofer (mst@rtp.ch)
        Version: 2.2.0
    
        Permission is hereby granted, free of charge, to any person obtaining a copy
        of this software and associated documentation files (the "Software"), to deal
        in the Software without restriction, including without limitation the rights
        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies of the Software, and to permit persons to whom the Software is
        furnished to do so, subject to the following conditions:
    
        The above copyright notice and this permission notice shall be included in
        all copies or substantial portions of the Software.
    
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        THE SOFTWARE.
    
    */

    // polyfills
    if (typeof Object.assign != 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
            value: function assign(target, varArgs) {
                // .length of function is 2
                if (target == null) {
                    // TypeError if undefined or null
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource != null) {
                        // Skip over if undefined or null
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

    if (typeof Array.from != 'function') {
        Array.from = function (object) {
            return [].slice.call(object);
        };
    }

    // utils
    var buildElement = function buildElement(str) {
        // empty string as title argument required by IE and Edge
        var tmp = document.implementation.createHTMLDocument('');
        tmp.body.innerHTML = str;
        return Array.from(tmp.body.children)[0];
    };

    var triggerEvent = function triggerEvent(el, name) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(name, true, false);
        el.dispatchEvent(event);
    };

    var definePinchZoom = function definePinchZoom() {

        /**
         * Pinch zoom
         * @param el
         * @param options
         * @constructor
         */
        var PinchZoom = function PinchZoom(el, options) {
            this.el = el;
            this.zoomFactor = 1;
            this.lastScale = 1;
            this.offset = {
                x: 0,
                y: 0
            };
            this.initialOffset = {
                x: 0,
                y: 0
            };
            this.options = Object.assign({}, this.defaults, options);
            this.setupMarkup();
            this.bindEvents();
            this.update();

            // The image may already be loaded when PinchZoom is initialized,
            // and then the load event (which trigger update) will never fire.
            if (this.isImageLoaded(this.el)) {
                this.updateAspectRatio();
                this.setupInitialOffset();
            }

            this.enable();
        },
            sum = function sum(a, b) {
            return a + b;
        },
            isCloseTo = function isCloseTo(value, expected) {
            return value > expected - 0.01 && value < expected + 0.01;
        };

        PinchZoom.prototype = {

            defaults: {
                tapZoomFactor: 2,
                zoomOutFactor: 1.3,
                animationDuration: 300,
                maxZoom: 4,
                minZoom: 0.5,
                draggableUnzoomed: true,
                lockDragAxis: false,
                use2d: true,
                zoomStartEventName: 'pz_zoomstart',
                zoomUpdateEventName: 'pz_zoomupdate',
                zoomEndEventName: 'pz_zoomend',
                dragStartEventName: 'pz_dragstart',
                dragUpdateEventName: 'pz_dragupdate',
                dragEndEventName: 'pz_dragend',
                doubleTapEventName: 'pz_doubletap',
                verticalPadding: 0,
                horizontalPadding: 0
            },

            /**
             * Event handler for 'dragstart'
             * @param event
             */
            handleDragStart: function handleDragStart(event) {
                triggerEvent(this.el, this.options.dragStartEventName);
                this.stopAnimation();
                this.lastDragPosition = false;
                this.hasInteraction = true;
                this.handleDrag(event);
            },

            /**
             * Event handler for 'drag'
             * @param event
             */
            handleDrag: function handleDrag(event) {
                var touch = this.getTouches(event)[0];
                this.drag(touch, this.lastDragPosition);
                this.offset = this.sanitizeOffset(this.offset);
                this.lastDragPosition = touch;
            },

            handleDragEnd: function handleDragEnd() {
                triggerEvent(this.el, this.options.dragEndEventName);
                this.end();
            },

            /**
             * Event handler for 'zoomstart'
             * @param event
             */
            handleZoomStart: function handleZoomStart(event) {
                triggerEvent(this.el, this.options.zoomStartEventName);
                this.stopAnimation();
                this.lastScale = 1;
                this.nthZoom = 0;
                this.lastZoomCenter = false;
                this.hasInteraction = true;
            },

            /**
             * Event handler for 'zoom'
             * @param event
             */
            handleZoom: function handleZoom(event, newScale) {
                // a relative scale factor is used
                var touchCenter = this.getTouchCenter(this.getTouches(event)),
                    scale = newScale / this.lastScale;
                this.lastScale = newScale;

                // the first touch events are thrown away since they are not precise
                this.nthZoom += 1;
                if (this.nthZoom > 3) {

                    this.scale(scale, touchCenter);
                    this.drag(touchCenter, this.lastZoomCenter);
                }
                this.lastZoomCenter = touchCenter;
            },

            handleZoomEnd: function handleZoomEnd() {
                triggerEvent(this.el, this.options.zoomEndEventName);
                this.end();
            },

            /**
             * Event handler for 'doubletap'
             * @param event
             */
            handleDoubleTap: function handleDoubleTap(event) {
                var center = this.getTouches(event)[0],
                    zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
                    startZoomFactor = this.zoomFactor,
                    updateProgress = function (progress) {
                    this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                }.bind(this);

                if (this.hasInteraction) {
                    return;
                }

                this.isDoubleTap = true;

                if (startZoomFactor > zoomFactor) {
                    center = this.getCurrentZoomCenter();
                }

                this.animate(this.options.animationDuration, updateProgress, this.swing);
                triggerEvent(this.el, this.options.doubleTapEventName);
            },

            /**
             * Compute the initial offset
             *
             * the element should be centered in the container upon initialization
             */
            computeInitialOffset: function computeInitialOffset() {
                this.initialOffset = {
                    x: -Math.abs(this.el.offsetWidth * this.getInitialZoomFactor() - this.container.offsetWidth) / 2,
                    y: -Math.abs(this.el.offsetHeight * this.getInitialZoomFactor() - this.container.offsetHeight) / 2
                };
            },

            /**
             * Determine if image is loaded
             */
            isImageLoaded: function isImageLoaded(el) {
                if (el.nodeName === 'IMG') {
                    return el.complete && el.naturalHeight !== 0;
                } else {
                    return Array.from(el.querySelectorAll('img')).every(this.isImageLoaded);
                }
            },

            setupInitialOffset: function setupInitialOffset() {
                if (this._initialOffsetSetup) {
                    return;
                }

                this._initialOffsetSetup = true;

                this.computeInitialOffset();
                this.offset.x = this.initialOffset.x;
                this.offset.y = this.initialOffset.y;
            },

            /**
             * Max / min values for the offset
             * @param offset
             * @return {Object} the sanitized offset
             */
            sanitizeOffset: function sanitizeOffset(offset) {
                var elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
                var elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
                var maxX = elWidth - this.getContainerX() + this.options.horizontalPadding,
                    maxY = elHeight - this.getContainerY() + this.options.verticalPadding,
                    maxOffsetX = Math.max(maxX, 0),
                    maxOffsetY = Math.max(maxY, 0),
                    minOffsetX = Math.min(maxX, 0) - this.options.horizontalPadding,
                    minOffsetY = Math.min(maxY, 0) - this.options.verticalPadding;

                return {
                    x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
                    y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
                };
            },

            /**
             * Scale to a specific zoom factor (not relative)
             * @param zoomFactor
             * @param center
             */
            scaleTo: function scaleTo(zoomFactor, center) {
                this.scale(zoomFactor / this.zoomFactor, center);
            },

            /**
             * Scales the element from specified center
             * @param scale
             * @param center
             */
            scale: function scale(_scale, center) {
                _scale = this.scaleZoomFactor(_scale);
                this.addOffset({
                    x: (_scale - 1) * (center.x + this.offset.x),
                    y: (_scale - 1) * (center.y + this.offset.y)
                });
                triggerEvent(this.el, this.options.zoomUpdateEventName);
            },

            /**
             * Scales the zoom factor relative to current state
             * @param scale
             * @return the actual scale (can differ because of max min zoom factor)
             */
            scaleZoomFactor: function scaleZoomFactor(scale) {
                var originalZoomFactor = this.zoomFactor;
                this.zoomFactor *= scale;
                this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
                return this.zoomFactor / originalZoomFactor;
            },

            /**
             * Determine if the image is in a draggable state
             *
             * When the image can be dragged, the drag event is acted upon and cancelled.
             * When not draggable, the drag event bubbles through this component.
             *
             * @return {Boolean}
             */
            canDrag: function canDrag() {
                return this.options.draggableUnzoomed || !isCloseTo(this.zoomFactor, 1);
            },

            /**
             * Drags the element
             * @param center
             * @param lastCenter
             */
            drag: function drag(center, lastCenter) {
                if (lastCenter) {
                    if (this.options.lockDragAxis) {
                        // lock scroll to position that was changed the most
                        if (Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
                            this.addOffset({
                                x: -(center.x - lastCenter.x),
                                y: 0
                            });
                        } else {
                            this.addOffset({
                                y: -(center.y - lastCenter.y),
                                x: 0
                            });
                        }
                    } else {
                        this.addOffset({
                            y: -(center.y - lastCenter.y),
                            x: -(center.x - lastCenter.x)
                        });
                    }
                    triggerEvent(this.el, this.options.dragUpdateEventName);
                }
            },

            /**
             * Calculates the touch center of multiple touches
             * @param touches
             * @return {Object}
             */
            getTouchCenter: function getTouchCenter(touches) {
                return this.getVectorAvg(touches);
            },

            /**
             * Calculates the average of multiple vectors (x, y values)
             */
            getVectorAvg: function getVectorAvg(vectors) {
                return {
                    x: vectors.map(function (v) {
                        return v.x;
                    }).reduce(sum) / vectors.length,
                    y: vectors.map(function (v) {
                        return v.y;
                    }).reduce(sum) / vectors.length
                };
            },

            /**
             * Adds an offset
             * @param offset the offset to add
             * @return return true when the offset change was accepted
             */
            addOffset: function addOffset(offset) {
                this.offset = {
                    x: this.offset.x + offset.x,
                    y: this.offset.y + offset.y
                };
            },

            sanitize: function sanitize() {
                if (this.zoomFactor < this.options.zoomOutFactor) {
                    this.zoomOutAnimation();
                } else if (this.isInsaneOffset(this.offset)) {
                    this.sanitizeOffsetAnimation();
                }
            },

            /**
             * Checks if the offset is ok with the current zoom factor
             * @param offset
             * @return {Boolean}
             */
            isInsaneOffset: function isInsaneOffset(offset) {
                var sanitizedOffset = this.sanitizeOffset(offset);
                return sanitizedOffset.x !== offset.x || sanitizedOffset.y !== offset.y;
            },

            /**
             * Creates an animation moving to a sane offset
             */
            sanitizeOffsetAnimation: function sanitizeOffsetAnimation() {
                var targetOffset = this.sanitizeOffset(this.offset),
                    startOffset = {
                    x: this.offset.x,
                    y: this.offset.y
                },
                    updateProgress = function (progress) {
                    this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
                    this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
                    this.update();
                }.bind(this);

                this.animate(this.options.animationDuration, updateProgress, this.swing);
            },

            /**
             * Zooms back to the original position,
             * (no offset and zoom factor 1)
             */
            zoomOutAnimation: function zoomOutAnimation() {
                if (this.zoomFactor === 1) {
                    return;
                }

                var startZoomFactor = this.zoomFactor,
                    zoomFactor = 1,
                    center = this.getCurrentZoomCenter(),
                    updateProgress = function (progress) {
                    this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                }.bind(this);

                this.animate(this.options.animationDuration, updateProgress, this.swing);
            },

            /**
             * Updates the aspect ratio
             */
            updateAspectRatio: function updateAspectRatio() {
                this.setContainerY(this.container.parentElement.offsetHeight);
            },

            /**
             * Calculates the initial zoom factor (for the element to fit into the container)
             * @return {number} the initial zoom factor
             */
            getInitialZoomFactor: function getInitialZoomFactor() {
                var xZoomFactor = this.container.offsetWidth / this.el.offsetWidth;
                var yZoomFactor = this.container.offsetHeight / this.el.offsetHeight;

                return Math.min(xZoomFactor, yZoomFactor);
            },

            /**
             * Calculates the aspect ratio of the element
             * @return the aspect ratio
             */
            getAspectRatio: function getAspectRatio() {
                return this.el.offsetWidth / this.el.offsetHeight;
            },

            /**
             * Calculates the virtual zoom center for the current offset and zoom factor
             * (used for reverse zoom)
             * @return {Object} the current zoom center
             */
            getCurrentZoomCenter: function getCurrentZoomCenter() {
                var offsetLeft = this.offset.x - this.initialOffset.x;
                var centerX = -1 * this.offset.x - offsetLeft / (1 / this.zoomFactor - 1);

                var offsetTop = this.offset.y - this.initialOffset.y;
                var centerY = -1 * this.offset.y - offsetTop / (1 / this.zoomFactor - 1);

                return {
                    x: centerX,
                    y: centerY
                };
            },

            /**
             * Returns the touches of an event relative to the container offset
             * @param event
             * @return array touches
             */
            getTouches: function getTouches(event) {
                var rect = this.container.getBoundingClientRect();
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
                var posTop = rect.top + scrollTop;
                var posLeft = rect.left + scrollLeft;

                return Array.prototype.slice.call(event.touches).map(function (touch) {
                    return {
                        x: touch.pageX - posLeft,
                        y: touch.pageY - posTop
                    };
                });
            },

            /**
             * Animation loop
             * does not support simultaneous animations
             * @param duration
             * @param framefn
             * @param timefn
             * @param callback
             */
            animate: function animate(duration, framefn, timefn, callback) {
                var startTime = new Date().getTime(),
                    renderFrame = function () {
                    if (!this.inAnimation) {
                        return;
                    }
                    var frameTime = new Date().getTime() - startTime,
                        progress = frameTime / duration;
                    if (frameTime >= duration) {
                        framefn(1);
                        if (callback) {
                            callback();
                        }
                        this.update();
                        this.stopAnimation();
                        this.update();
                    } else {
                        if (timefn) {
                            progress = timefn(progress);
                        }
                        framefn(progress);
                        this.update();
                        requestAnimationFrame(renderFrame);
                    }
                }.bind(this);
                this.inAnimation = true;
                requestAnimationFrame(renderFrame);
            },

            /**
             * Stops the animation
             */
            stopAnimation: function stopAnimation() {
                this.inAnimation = false;
            },

            /**
             * Swing timing function for animations
             * @param p
             * @return {Number}
             */
            swing: function swing(p) {
                return -Math.cos(p * Math.PI) / 2 + 0.5;
            },

            getContainerX: function getContainerX() {
                return this.container.offsetWidth;
            },

            getContainerY: function getContainerY() {
                return this.container.offsetHeight;
            },

            setContainerY: function setContainerY(y) {
                return this.container.style.height = y + 'px';
            },

            /**
             * Creates the expected html structure
             */
            setupMarkup: function setupMarkup() {
                this.container = buildElement('<div class="pinch-zoom-container"></div>');
                this.el.parentNode.insertBefore(this.container, this.el);
                this.container.appendChild(this.el);

                this.container.style.overflow = 'hidden';
                this.container.style.position = 'relative';

                this.el.style.webkitTransformOrigin = '0% 0%';
                this.el.style.mozTransformOrigin = '0% 0%';
                this.el.style.msTransformOrigin = '0% 0%';
                this.el.style.oTransformOrigin = '0% 0%';
                this.el.style.transformOrigin = '0% 0%';

                this.el.style.position = 'absolute';
            },

            end: function end() {
                this.hasInteraction = false;
                this.sanitize();
                this.update();
            },

            /**
             * Binds all required event listeners
             */
            bindEvents: function bindEvents() {
                var self = this;
                detectGestures(this.container, this);

                window.addEventListener('resize', this.update.bind(this));
                Array.from(this.el.querySelectorAll('img')).forEach(function (imgEl) {
                    imgEl.addEventListener('load', self.update.bind(self));
                });

                if (this.el.nodeName === 'IMG') {
                    this.el.addEventListener('load', this.update.bind(this));
                }
            },

            /**
             * Updates the css values according to the current zoom factor and offset
             */
            update: function update(event) {
                if (this.updatePlaned) {
                    return;
                }
                this.updatePlaned = true;

                window.setTimeout(function () {
                    this.updatePlaned = false;
                    this.updateAspectRatio();

                    if (event && event.type === 'resize') {
                        this.computeInitialOffset();
                    }

                    if (event && event.type === 'load') {
                        this.setupInitialOffset();
                    }

                    var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor,
                        offsetX = -this.offset.x / zoomFactor,
                        offsetY = -this.offset.y / zoomFactor,
                        transform3d = 'scale3d(' + zoomFactor + ', ' + zoomFactor + ',1) ' + 'translate3d(' + offsetX + 'px,' + offsetY + 'px,0px)',
                        transform2d = 'scale(' + zoomFactor + ', ' + zoomFactor + ') ' + 'translate(' + offsetX + 'px,' + offsetY + 'px)',
                        removeClone = function () {
                        if (this.clone) {
                            this.clone.parentNode.removeChild(this.clone);
                            delete this.clone;
                        }
                    }.bind(this);

                    // Scale 3d and translate3d are faster (at least on ios)
                    // but they also reduce the quality.
                    // PinchZoom uses the 3d transformations during interactions
                    // after interactions it falls back to 2d transformations
                    if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                        this.is3d = true;
                        removeClone();

                        this.el.style.webkitTransform = transform3d;
                        this.el.style.mozTransform = transform2d;
                        this.el.style.msTransform = transform2d;
                        this.el.style.oTransform = transform2d;
                        this.el.style.transform = transform3d;
                    } else {
                        // When changing from 3d to 2d transform webkit has some glitches.
                        // To avoid this, a copy of the 3d transformed element is displayed in the
                        // foreground while the element is converted from 3d to 2d transform
                        if (this.is3d) {
                            this.clone = this.el.cloneNode(true);
                            this.clone.style.pointerEvents = 'none';
                            this.container.appendChild(this.clone);
                            window.setTimeout(removeClone, 200);
                        }

                        this.el.style.webkitTransform = transform2d;
                        this.el.style.mozTransform = transform2d;
                        this.el.style.msTransform = transform2d;
                        this.el.style.oTransform = transform2d;
                        this.el.style.transform = transform2d;

                        this.is3d = false;
                    }
                }.bind(this), 0);
            },

            /**
             * Enables event handling for gestures
             */
            enable: function enable() {
                this.enabled = true;
            },

            /**
             * Disables event handling for gestures
             */
            disable: function disable() {
                this.enabled = false;
            }
        };

        var detectGestures = function detectGestures(el, target) {
            var interaction = null,
                fingers = 0,
                lastTouchStart = null,
                startTouches = null,
                setInteraction = function setInteraction(newInteraction, event) {
                if (interaction !== newInteraction) {

                    if (interaction && !newInteraction) {
                        switch (interaction) {
                            case "zoom":
                                target.handleZoomEnd(event);
                                break;
                            case 'drag':
                                target.handleDragEnd(event);
                                break;
                        }
                    }

                    switch (newInteraction) {
                        case 'zoom':
                            target.handleZoomStart(event);
                            break;
                        case 'drag':
                            target.handleDragStart(event);
                            break;
                    }
                }
                interaction = newInteraction;
            },
                updateInteraction = function updateInteraction(event) {
                if (fingers === 2) {
                    setInteraction('zoom');
                } else if (fingers === 1 && target.canDrag()) {
                    setInteraction('drag', event);
                } else {
                    setInteraction(null, event);
                }
            },
                targetTouches = function targetTouches(touches) {
                return Array.from(touches).map(function (touch) {
                    return {
                        x: touch.pageX,
                        y: touch.pageY
                    };
                });
            },
                getDistance = function getDistance(a, b) {
                var x, y;
                x = a.x - b.x;
                y = a.y - b.y;
                return Math.sqrt(x * x + y * y);
            },
                calculateScale = function calculateScale(startTouches, endTouches) {
                var startDistance = getDistance(startTouches[0], startTouches[1]),
                    endDistance = getDistance(endTouches[0], endTouches[1]);
                return endDistance / startDistance;
            },
                cancelEvent = function cancelEvent(event) {
                event.stopPropagation();
                event.preventDefault();
            },
                detectDoubleTap = function detectDoubleTap(event) {
                var time = new Date().getTime();

                if (fingers > 1) {
                    lastTouchStart = null;
                }

                if (time - lastTouchStart < 300) {
                    cancelEvent(event);

                    target.handleDoubleTap(event);
                    switch (interaction) {
                        case "zoom":
                            target.handleZoomEnd(event);
                            break;
                        case 'drag':
                            target.handleDragEnd(event);
                            break;
                    }
                } else {
                    target.isDoubleTap = false;
                }

                if (fingers === 1) {
                    lastTouchStart = time;
                }
            },
                firstMove = true;

            el.addEventListener('touchstart', function (event) {
                if (target.enabled) {
                    firstMove = true;
                    fingers = event.touches.length;
                    detectDoubleTap(event);
                }
            });

            el.addEventListener('touchmove', function (event) {
                if (target.enabled && !target.isDoubleTap) {
                    if (firstMove) {
                        updateInteraction(event);
                        if (interaction) {
                            cancelEvent(event);
                        }
                        startTouches = targetTouches(event.touches);
                    } else {
                        switch (interaction) {
                            case 'zoom':
                                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
                                break;
                            case 'drag':
                                target.handleDrag(event);
                                break;
                        }
                        if (interaction) {
                            cancelEvent(event);
                            target.update();
                        }
                    }

                    firstMove = false;
                }
            });

            el.addEventListener('touchend', function (event) {
                if (target.enabled) {
                    fingers = event.touches.length;
                    updateInteraction(event);
                }
            });
        };

        return PinchZoom;
    };

    var PinchZoom = definePinchZoom();

    exports.default = PinchZoom;
});

},{}],89:[function(require,module,exports){
'use strict';
var pressrelease = {
	init: function() {
		$(function() {
			$('.press-rel-filter-wrap select option[value="'+window.location.href+'"]').attr("selected","selected");
		});
	}
};
module.exports = pressrelease;

},{}],90:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
  images = require('./pages/product/image'),
  quickview = require('./quickview'),
  variant = require('./pages/product/variant'),
  Promise = require('promise'),
  minicart = require('./minicart'),
  currentLayout = require('./detect-layout'),
  util = require('./util'),
  skincheck = require('./pages/product/skincheck_modal');

var currLayoutVal = currentLayout.init(),
  flagToSetTileHeight = true;

function initQuickViewButtons() {
  if (!quickViewEnabled) {
    return;
  }

  $('.tiles-container .product-image').on('mouseenter', function() {
    var $qvButton = $('#quickviewbutton');
    if ($qvButton.length === 0) {
      $qvButton = $(
        '<a id="quickviewbutton" class="quickview">' +
          Resources.QUICK_VIEW +
          '</a>'
      );
    }
    var $link = $(this).find('.thumb-link');
    $qvButton
      .attr({
        href: $link.attr('href'),
        title: $link.attr('title')
      })
      .appendTo(this);

    $qvButton.off();
    $qvButton.on('click', function(e) {
      e.preventDefault();

      var url = $(this).attr('href');

      quickview.show({
        url: $(this).attr('href'),
        source: 'quickview',
        callback: function() {
          images();
          variant();
          renderThumbnails();

          $('#BVRRSummaryContainer').on(
            'click',
            '.bv-rating-stars-container',
            function() {
              window.location.href = url + '#reviews'; // redirect when rating star is clicked
            }
          );

          $(document).on('click', '.bv-popup-in .bv-read-review', function() {
            window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
          });
        }
      });
    });
  });
}

function initQuickViewPlusIconButtons() {
  if (!quickViewOnPlusIconEnabled) {
    return;
  }

  $('.tiles-container .plp-icon-block .plp-quickshop-icon').on(
    'click',
    function(e) {
      var $tile = $(this).closest('.product-tile');
      var $link = $tile.find('.thumb-link');
      e.preventDefault();
      quickview.show({
        url: $link.attr('href'),
        source: 'quickview',
        callback: function() {
          images();
          variant();
          renderThumbnails();

          $('#BVRRSummaryContainer').on(
            'click',
            '.bv-rating-stars-container',
            function() {
              window.location.href = url + '#reviews'; // redirect when rating star is clicked
            }
          );

          $(document).on('click', '.bv-popup-in .bv-read-review', function() {
            window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
          });
        }
      });
    }
  );
}

function gridViewToggle() {
  $('.toggle-grid').on('click', function() {
    $('.search-result-content').toggleClass('wide-tiles');
    $(this).toggleClass('wide');
  });
}

function renderThumbnails() {
  if ($('#thumbnails').length > 0) {
    $('#thumbnails').empty(); // clear the list
    images(); // populate the thumbnails
  }
}

function initCarouselSwatches() {
  if ($('.plp-product-grid-block')[0]) {
    $('.swatch-list')
      .not('.slick-slider')
      .slick({
        dots: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false
            }
          }
        ]
      });
  }
  $('.swatch-list')
    .not('.slick-slider')
    .slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 300,
      slide: 'li',
      rows: 0,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false
          }
        }
      ]
    });
}

function updateMainImageOnVariantChnage(data, $tile, heartIcon) {
  var dataAlt = $(this)
    .children('img')
    .filter(':first')
    .data('thumb-alt');
  var dataVariantId = $(this)
    .children('img')
    .filter(':first')
    .data('variant-sku');

  heartIcon.attr('data-element-pid', dataVariantId);
  var wishlistProd = window.User.wishlistProducts;
  if (wishlistProd != null && wishlistProd.indexOf(dataVariantId) == -1) {
    heartIcon.removeClass('plp-active-wishlist');
  } else {
    heartIcon.addClass('plp-active-wishlist');
  }

  var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
  var currentAttrs = {
    src: data.src,
    alt: data.alt,
    title: data.title
  };
  $thumb.attr(currentAttrs);
  $thumb.attr('data-alt-src', dataAlt);
  $thumb.data('current', currentAttrs);
}

function tileQuantitySelect() {
  $('.tile-cta-warpper select').selectmenu({
    width: false,
    position: { my: 'left top', at: 'left bottom', collision: 'flip flip' },
    classes: {
      'ui-selectmenu-menu': 'tileQtySelector'
    },
    change: function(event, ui) {
      var $element = $(event.delegateTarget).attr('id');
      $('.ui-selectmenu-button[aria-owns= "' + $element + '"]').addClass(
        'selected'
      );
      var tileQtyId = 'select#' + $(this).attr('id');
      $(tileQtyId)
        .closest('.product-tile-inner')
        .addClass('hovered');
    },
    open: function(event, ui) {
      var tileQtyId = 'select#' + $(this).attr('id');
      $(tileQtyId)
        .closest('.product-tile-inner')
        .addClass('maintainHover');
    },
    close: function(event, ui) {
      var tileQtyId = 'select#' + $(this).attr('id');
      $(tileQtyId)
        .closest('.product-tile-inner')
        .removeClass('maintainHover');
      $(tileQtyId)
        .closest('.product-tile-inner')
        .removeClass('hovered');
    }
  });
}

function shopByCategory() {
  $('#clp-collection-select').on('selectmenuchange', function() {
    var categoryID = $(this).val();
    $('html, body').animate(
      { scrollTop: $('#' + categoryID).offset().top },
      500
    );
  });
}

var parseQueryString = function(url) {
  var urlParams = {};
  url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function(
    $0,
    $1,
    $2,
    $3
  ) {
    if (typeof $3 != 'undefined') {
      urlParams[$1] = $3;
    }
  });
  return urlParams;
};

function bindSwatchClick() {
  $('.product-tile:not(.product-tile-cart-in) .variation-select').on('selectmenuchange', function(
    event,
    ui
  ) {
    var $selectedSize = $(this)
        .find('option:selected')
        .val(),
      $tileOuter = $(this).closest('.product-tile-inner'),
      $tileLoader = $tileOuter.find('.tile-ajax-loader'),
      currProductID = $(this)
        .closest('.product-tile')
        .attr('data-itemid'),
      $imageWrapperHeight = $tileOuter.find('.product-image').outerHeight(true);

    if ($selectedSize == 'select color') {
      return;
    }
    $tileLoader.show();
    $tileOuter.find('.product-tile').css('opacity', 0);
    $tileOuter.find('.thumb-link').attr('href', $selectedSize);
    $tileOuter.find('name-link').attr('href', $selectedSize);
    // selectedSizeはテンプレート上で encodeURI されているので、2回 encodeURI されるのを防止
    var urlToParse = decodeURI($selectedSize);
    var result = JSON.parse(JSON.stringify(parseQueryString(urlToParse)));

    if (result && typeof result.pid == 'undefined') {
      result.pid = $tileOuter.find('.product-tile').data('masterpid');
    }

    $.ajax({
      url: util.appendParamToURL(Urls.transactionalHitTile, 'format', 'ajax'),
      data: result,
      type: 'GET'
    }).done(function(data) {
      require('./jquery-ext')();
      if (currProductID) {
        $('.search-result-items .product-tile-outer').removeClass('hovered');
      }
      $tileOuter.html(data);
      // Do not display hover content
      // $tileOuter.addClass('hovered');
      $tileOuter.find('.product-image').css('min-height', $imageWrapperHeight);
      initCarouselSwatches();
      bindSwatchClick();
      tileQuantitySelect();
      $tileLoader.hide();
      $tileOuter.find('.product-tile').css('opacity', 1);
      $(document).trigger('gttilevariationchange');
    });
  });
  $('.swatch-list .swatch').on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('selected')) {
      return;
    }
    var $tileOuter = $(this).closest('.product-tile-inner'),
      $imageWrapperHeight = $tileOuter.find('.product-image').outerHeight(true);
    var $tile = $(this).closest('.product-tile');
    var productID = $tile.attr('data-itemid');
    var heartIcon = $('#hearting-' + productID);
    $(this)
      .closest('.swatch-list')
      .find('.swatch.selected')
      .removeClass('selected');
    $(this).addClass('selected');
    $tile.find('.thumb-link').attr('href', $(this).data('url'));
    $tile.find('.name-link').attr('href', $(this).data('url'));
    $tile.find('.buy-button').attr('href', $(this).data('url'));
    $tile.find('.shades-label').html($(this).data('shades'));
    var data = $(this)
      .children('img')
      .filter(':first')
      .data('thumb');
    updateMainImageOnVariantChnage(data, $tile, heartIcon);
  });

  $('button.add-to-cart')
    .unbind('click')
    .bind('click', plpAddItemToCart);
  $('.product-tile a.buy-button')
    .unbind('click')
    .bind('click', plpAddItemToCart);
}

function plpAddItemToCart(e, $this) {
  e.preventDefault();
  var $that = $(this);
  if ($this) {
    $that = $this;
  }
  if (
    $this ||
    $that.closest('.product-tile-inner').hasClass('hovered') ||
    $that.hasClass('buy-button')
  ) {
    var $tile = $that.closest('.product-tile');
    var $cartAction = $that.data('cartaction');
    var $pid = $that.data('pid');
    var $qty =
      $tile.find('.quantity option:selected').val() || $that.data('quantity');

    var $data = { Quantity: $qty, cartAction: $cartAction, pid: $pid };
    var skinCheckResultCookie = skincheck.readCookie('skinCheckResult');
    if ($that.data('skincheck') === false || skinCheckResultCookie === 'OK') {
      tileaddItemToCart($data, $tile).then(
        function(response) {
          $(document).trigger('gtadd-to-cart');
          minicart.show(response);
        }.bind(this)
      );
    } else {
      skincheck.skinTroubleExecute(skinCheckResultCookie, $that);
    }
  }
}
exports.plpAddItemToCart = plpAddItemToCart;

function tileaddItemToCart($data, $tile) {
  //FIXME: add csrf_token to post parameter.
  return Promise.resolve(
    $.ajax({
      type: 'POST',
      url: util.ajaxUrl(Urls.addProduct, 'format', 'ajax'),
      data: $data
    })
  ).then(function(response) {
    // handle error in the response
    if (response.error) {
      $tile
        .find('#a2c-error')
        .html(response.error)
        .slideDown('fast', function() {
          setTimeout(function() {
            $tile.find('#a2c-error').slideUp(500);
          }, 2000);
        });
      if ($('#product-tile-sp-error-message').length === 0) {
        $('body').append(
          '<p id="product-tile-sp-error-message"><span class="alert"></span><p>'
        );
      }
      var $spError = $('#product-tile-sp-error-message');
      $spError.find('.alert').html(response.error);
      if ($spError.attr('aria-busy') !== 'true') {
        $spError.attr('aria-busy', 'true');
        $spError.show();
        setTimeout(function() {
          $spError.addClass('show');
          setTimeout(function() {
            $spError.removeClass('show');
            setTimeout(function() {
              $spError.hide();
              $spError.attr('aria-busy', 'false');
            }, 400);
          }, 2000);
        }, 10);
      }
      throw new Error(response.error);
      return false;
    } else {
      $tile.find('#a2c-error').hide();
    }

    return response;
  });
}

function bindMainImageChange() {
  /* Do not display hover content.
	if (currLayoutVal == 'desktop' && $('.marketing').length == 0) {
		$('.product-tile-inner').not(".disable-hover").on('mouseenter mouseleave', function (event) {
			if (event.type == 'mouseenter') {
				$('.product-tile-inner').each(function () {
					$(this).removeClass('hovered maintainHover');
					$(this).find('select').selectmenu('close');
				});
				$(this).addClass('hovered');
			} else if (event.type == 'mouseleave' && !($(this).hasClass('maintainHover'))) {
				$(this).removeClass('hovered');
			}
		});
	}
	*/
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
  initQuickViewButtons();
  initQuickViewPlusIconButtons();
  gridViewToggle();
  $('.swatch-list').on('mouseleave', function() {
    // Restore current thumb image
    var $tile = $(this).closest('.product-tile'),
      $thumb = $tile.find('.product-image .thumb-link img').eq(0),
      data = $thumb.data('current');

    if (!data) {
      return;
    }

    $thumb.attr({
      src: data.src,
      alt: data.alt,
      title: data.title
    });
  });

  bindMainImageChange();
  bindSwatchClick();
  tileQuantitySelect();
  shopByCategory();
}

function tileHeight($tiles) {
  $tiles
    .syncHeight({ updateOnResize: true, parentElement: '.product-tile-outer' })
    .each(function(idx) {
      $(this).data('idx', idx);
      $(this)
        .closest('.product-tile-inner')
        .addClass('tile-inner');
    });
}

function setTileHeightFlag(updateLayoutVal) {
  if (
    updateLayoutVal == 'mobile' &&
    $('.pt_storefront .recommendation-block').length > 0
  ) {
    flagToSetTileHeight = false;
  } else {
    flagToSetTileHeight = true;
  }
}

function updateSinglePromoTileHeight() {
  if ($('.product-grids-container .single-tile-content').length > 0) {
    var gridHeight = $('.product-tile-outer').height();
    $('.product-grids-container .single-tile-content').each(function() {
      $(this).css('min-height', gridHeight);
    });
  }
}

$(window).on('resize orientationchange', function(event) {
  updateSinglePromoTileHeight();
  updateTileHeight();
  setTimeout(function() {
    var $currLayoutVal = currentLayout.init();
    setTileHeightFlag($currLayoutVal);
    if (flagToSetTileHeight) {
      tileHeight($('.recommendation .product-tile'));
      event.stopImmediatePropagation();
    } else {
      $('.recommendation .product-tile').each(function() {
        $(this).removeAttr('style');
        $(this)
          .closest('.product-tile-outer')
          .removeAttr('style');
        event.stopImmediatePropagation();
      });
    }
  }, 100);
});
if ('ontouchstart' in window) {
  $(document)
    .on('touchstart', 'a.wishlist-icon.icon-heart', function(event) {
      $(event.target).addClass('hover');
    })
    .on('touchend touchcancel', 'a.wishlist-icon.icon-heart', function(event) {
      $(event.target).removeClass('hover');
    });
} else {
  $(document)
    .on('mouseenter', 'a.wishlist-icon.icon-heart', function(event) {
      $(event.target).addClass('hover');
    })
    .on('mouseleave', 'a.wishlist-icon.icon-heart', function(event) {
      $(event.target).removeClass('hover');
    });
}

function updateTileHeight() {
  //alert("changed");
  var $tiles = $(
    '.product-grids-container .product-tile, .collection-block .product-tile, .recommendation .product-tile, .cart-recommendation-container .product-tile, .wishlist-item .product-tile, .products-used-wrapper .product-tile,.article-recommend-sec .product-tile, .defend-and-regenerate-wrapper .product-tile'
  );
  if ($tiles.length === 0) {
    return;
  }
  imagesLoaded('.tiles-container').on('done', function() {
    if (flagToSetTileHeight) {
      tileHeight($tiles);
    }
  });
}

//FFファンデーションSTEP用
$(window).on('load resize', function() {
  if ($('#applicationtips').length) {
    var height = 0;
    $('.product-tile-outer').removeAttr('style');
    $('.product-grid-inner').each(function(index, element) {
      if ($(element).height() > height) {
        height = $(element).height();
      }
    });
    $('.product-tile-outer').css('height', height);
  }
});

exports.init = function() {
  setTileHeightFlag(currLayoutVal);
  updateTileHeight();
  updateSinglePromoTileHeight();
  initializeEvents();
  initCarouselSwatches();
};

exports.initCarouselSwatches = initCarouselSwatches;

},{"./detect-layout":30,"./jquery-ext":39,"./minicart":42,"./pages/product/image":69,"./pages/product/skincheck_modal":75,"./pages/product/variant":77,"./quickview":92,"./util":105,"imagesloaded":111,"promise":113}],91:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],92:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
  product = require('./pages/product'),
  util = require('./util'),
  modal = require('./modal').global,
  variant = require('./pages/product/variant'),
  images = require('./pages/product/image'),
  _ = require('lodash'),
  customModal = require('./modal');

var makeUrl = function (url, source, productListID) {
  if (source) {
    url = util.appendParamToURL(url, 'source', source);
  }
  if (productListID) {
    url = util.appendParamToURL(url, 'productlistid', productListID);
  }
  return url;
};

var removeParam = function (url) {
  if (url.indexOf('?') !== -1) {
    return url.substring(0, url.indexOf('?'));
  } else {
    return url;
  }
};
var updateQuickviewScroll = function () {
  $('.quickview-modal .modal-body').scrollBox();
};

function renderThumbnails() {
  if ($('#thumbnails').length > 0) {
    $('#thumbnails').empty(); // clear the list
    images(); // populate the thumbnails
  }
}
var quickview = {
  init: function () {
    if (!this.exists()) {
      this.$container = $('<div/>')
        .attr('id', 'QuickViewDialog')
        .appendTo(document.body);
    }
    this.productLinks = $('#search-result-items .thumb-link').map(function (
      index,
      thumbLink
    ) {
      return $(thumbLink).attr('href');
    });
  },

  setup: function (qvUrl) {
    var $btnNext = $('.quickview-next'),
      $btnPrev = $('.quickview-prev');

    product.initializeEvents();

    this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
      return removeParam(url) === removeParam(qvUrl);
    });

    // hide the buttons on the compare page or when there are no other products
    if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
      $btnNext.hide();
      $btnPrev.hide();
      return;
    }

    if (this.productLinkIndex === this.productLinks.length - 1) {
      $btnNext.attr('disabled', 'disabled');
    }
    if (this.productLinkIndex === 0) {
      $btnPrev.attr('disabled', 'disabled');
    }

    $btnNext.on(
      'click',
      function (e) {
        e.preventDefault();
        this.navigateQuickview(1);
      }.bind(this)
    );
    $btnPrev.on(
      'click',
      function (e) {
        e.preventDefault();
        this.navigateQuickview(-1);
      }.bind(this)
    );
  },

  /**
   * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
   */
  navigateQuickview: function (step) {
    // default step to 0
    this.productLinkIndex += step ? step : 0;
    var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
    dialog.replace({
      url: url,
      callback: this.setup.bind(this, url)
    });
  },

  /**
   * @description show quick view dialog
   * @param {Object} options
   * @param {String} options.url - url of the product details
   * @param {String} options.source - source of the dialog to be appended to URL
   * @param {String} options.productlistid - to be appended to URL
   * @param {Function} options.callback - callback once the dialog is opened
   */
  show: function (options) {
    var url = makeUrl(options.url, options.source, options.productlistid),
      windowScrollPosition = $(window).scrollTop();

    url = util.appendParamToURL(url, 'format', 'ajax');
    $.ajax({
      url: url,
      dataType: 'html',
      success: function (response) {
        customModal.createCustomModal('quickview-modal');
        $('.quickview-modal').find('.modal-body').html(response);
        $('.quickview-modal select').selectmenu({
          classes: {
            'ui-selectmenu-menu': 'qv-select'
          }
        });
        $('.add-to-cart-in-stock select#quantity').selectmenu({
          position: { my: 'top', at: 'top', collision: 'none' }
        });
      }
    }).done(function (data) {
      variant();
      renderThumbnails();
      updateQuickviewScroll();
      if (navigator.userAgent.match(/(iPhone|iPad)/)) {
        $('body').addClass('body-fixed');
        $('.header-wrapper').css('transform', 'translate3d(0px,-100%,0)');
        $('.quickview-modal .modal-close, .quickview-modal .modal-close-outer')
          .off('click')
          .on('click', function () {
            $('quickview-modal').remove();
            $('body').removeClass('body-fixed');
            $('html').removeClass('modal-open');
            setTimeout(function () {
              $('#wrapper').removeAttr('style');
              $('.header-wrapper').css('transform', '');
            }, 1);
            $(window).scrollTop(windowScrollPosition);
          });
      }
      require('./analytics/pdp/colorChange')();
    });
  },
  exists: function () {
    return this.$container && this.$container.length > 0;
  }
};

module.exports = quickview;

},{"./analytics/pdp/colorChange":14,"./dialog":31,"./modal":43,"./pages/product":70,"./pages/product/image":69,"./pages/product/variant":77,"./util":105,"lodash":112}],93:[function(require,module,exports){
'use strict';

var addToCart = require('./pages/product/addToCart'),
analytics = require('./analytics');


function createStepsIndicators() {
    var questionsLength = $('.question.main').length;

    updateStepsIndicator(questionsLength);
    goToNextStep(0);
}

function updateStepsIndicator(numberOfSteps) {
    var stepsContainer = $('#quiz-form .step-indicator');
    stepsContainer.empty();

    for (var i = 0; i < numberOfSteps; i++) {
        var step = '<div class="steps step-' + i + '"><span class="pipe">&nbsp;</span><h4>' + (i + 1) + ' | ' + numberOfSteps + '</h4></div>';
        stepsContainer.append(step);
    }
}

function goToNextStep(newQuestion) {
    var stepsContainer = $('#quiz-form .step-indicator');
    stepsContainer.find('.steps').removeClass('active');
    stepsContainer.find('.step-' + newQuestion).addClass('active');
}

function switchQuestions(currentQuestion, newQuestion){
    $('#question-' + currentQuestion).removeClass('active').hide();
    $('#question-' + newQuestion).addClass('active').show();
    $('.current-question').val(newQuestion);
}

function handlePrevNextLinks(newQuestion) {
    var prevLink = $('.js-quiz-back'),
        nextLink = $('.js-quiz-next'),
        finishLink = $('.js-quiz-finish'),
        firstQuestion = 0,
        lastQuestion = $('.question.main').length - 1;

    prevLink[newQuestion === firstQuestion ? 'hide' : 'show']();
    nextLink[newQuestion === lastQuestion ? 'hide' : 'show']();
    finishLink[newQuestion === lastQuestion ? 'show' : 'hide']();

    goToNextStep(newQuestion);
}

function updateSubmitButtonState() {
    var activeQuestion = $('.question.active'),
        nextLink = $('.js-quiz-next'),
        finishLink = $('.js-quiz-finish');

    if (activeQuestion.data('mandatory')) {
        var inputs = activeQuestion.find('.js-answer-option');

        nextLink.attr("disabled", !inputs.is(":checked"));
        finishLink.attr("disabled", !inputs.is(":checked"));
    } else {
        nextLink.attr("disabled", false);
        finishLink.attr("disabled", false);
    }
}

function updateCustomerSelection(currentQuestion) {
    var questionSelection = currentQuestion.find('input[name="' + currentQuestion.attr('id') + '"]:checked');

    switch (currentQuestion.data('scoring')) {
        case 'age':
            var ageValue = questionSelection.val();
            $('.agerange').val(ageValue);
            break;
        case 'defend':
            var defendValue = questionSelection.length || 0;
            $('.defend').val(defendValue);
            break;
        case 'regenerate':
            var showOptionalQuestion = false;
            var isCorncernNotSelected = !currentQuestion.data('mandatory') && questionSelection.length === 0;

            var regenerateType = questionSelection.first().val();

            var differentChoices = questionSelection.filter(function () {
                var currentValue = $(this).val();

                if (currentValue !== 'basic') {
                    regenerateType = currentValue;
                    return currentValue;
                }
            });

            if (differentChoices.length > 1 || isCorncernNotSelected) {
                showOptionalQuestion = true;
            }

            if (!currentQuestion.hasClass('additional')) {
                $('.regenerate').val(questionSelection.length || 0);
            }
            
            if (showOptionalQuestion) {
                var currentQuestionNumber = parseInt($('.current-question').val(), 10);
                var nextQuestion = currentQuestionNumber + 1;

                updateStepsIndicator($('.question.main').length + 1);
                goToNextStep(nextQuestion);
                switchQuestions(currentQuestionNumber, nextQuestion);
                updateSubmitButtonState();

                $('.regenerateConcern').val('');
            } else {
                $('.regenerateConcern').val(regenerateType);
            }
             
            break;
    }
}

function bindQuizEvents() {

    $('.js-quiz-next').on('click', function () {
    	registerClick('next');
    	var activeQuestion = $('.question.active');
        var currentQuestion = parseInt($('.current-question').val(), 10);
        var nextQuestion = currentQuestion + 1;

        updateCustomerSelection(activeQuestion);
        switchQuestions(currentQuestion, nextQuestion);
        updateSubmitButtonState();
        handlePrevNextLinks(nextQuestion);
        registerPageView();
    });
    
    $('.js-quiz-back').on('click', function () {
    	registerClick('back');
        var currentQuestion = parseInt($('.current-question').val(), 10);
        var prevQuestion = currentQuestion - 1;
        switchQuestions(currentQuestion, prevQuestion);
        updateSubmitButtonState();
        handlePrevNextLinks(prevQuestion);
        registerPageView();
    });

    $('.js-quiz-finish').on('click', function() {
    	registerClick('next');
        var activeQuestion = $('.question.active');
        updateCustomerSelection(activeQuestion);

        var quizForm = $('#quiz-form');

        var emptyFields = quizForm.find('.submit-value').filter(function() {
            return $(this).val() !== '';
        });

        if (emptyFields.length === quizForm.find('.submit-value').length) {
            var baseUrl = quizForm.attr('action');
            window.location.href = baseUrl + '?' + quizForm.find('.submit-value').serialize();
        }
        registerPageView();
    });

    $('.js-answer-option').on('click', function(){
        updateSubmitButtonState();
    });
}

function registerPageView() {
	var quizModal = $('#quiz-modal'),
    quizContent = quizModal.find('.questions-content');
	var data = {};
	var activeData = quizContent.find('.active');
	data.toolname = 'Suncare Finder';    
    data.pagename = activeData.find('.quiz-question h2').text();
    analytics.tagmanager.pageview(data);
};

function registerClick(event) {
	var quizModal = $('#quiz-modal'),
    quizContent = quizModal.find('.questions-content');
	var data = {};
	var activeData = quizContent.find('.active');
	data.event = "consultationBack";
	if (event === 'next') {
		data.event = "consultationNext";
	}
	data.toolname = 'skincareConsultation';
    data.question = activeData.find('.quiz-question h2').text();
    var answers = '';
    activeData.find('.question-body input').each(function(index) {
    	if ($(this).is(':checked')) {
    		if (answers === '') {
    			answers = answers+(index+1);
    		} else {
    			answers = answers+','+(index+1);
    		}
    	}
    });
    data.answers = answers;
    analytics.tagmanager.click(data);
};
exports.init = function () {
	addToCart();
};
exports.bindQuizEvents = bindQuizEvents;
exports.createStepsIndicators = createStepsIndicators;
exports.registerPageView = registerPageView;
exports.registerClick = registerClick;
},{"./analytics":2,"./pages/product/addToCart":66}],94:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            var pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            var rating = getRating(pid);
            var baseRating = Math.floor(rating);
            var starsCount = 0;
            for (var i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }
            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }
            if (starsCount < 5) {
                for (var j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],95:[function(require,module,exports){
'use strict';

var util = require('./util'),
  modal = require('./modal').global,
  ajax = require('./ajax'),
  sampleCookieName = 'sample.selection.shown',
  customModal = require('./modal');

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookie = function () {
  util.setCookie(sampleCookieName, '1');
};

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelection = function () {
  return !SitePreferences.SAMPLES_ENABLED ? false : true;
};

/**
 * Adjust Items
 */
var adjustItems = function () {
  const length = $('.product-tile-shortDescription').length;
  const columnMax = window.innerWidth <= 768 ? 2 : 3;
  for (let i = 0; i < length; i++) {
    $('.product-tile-shortDescription').eq(i).css('height', '');
  }
  for (let row = 0; row < Math.ceil(length / columnMax); row++) {
    let max = 0;
    for (let column = 0; column < columnMax; column++) {
      const height = $('.product-tile-shortDescription')
        .eq(row * columnMax + column)
        .height();
      if (max < height) {
        max = height;
      }
    }
    for (let column = 0; column < columnMax; column++) {
      $('.product-tile-shortDescription')
        .eq(row * columnMax + column)
        .height(max);
    }
  }
};

/**
 * Render Samples
 * @return {boolean}
 */
var showSelection = function () {
  // render content to modal by url
  var url = util.appendParamToURL(
    Urls.showSampleSelectionInCart,
    'format',
    'ajax'
  );

  $('.ajax-loader').show();
  $.ajax({
    url: url,
    dataType: 'html',
    success: function (response) {
      if (response && response.indexOf('error no-selection') == -1) {
        const sampleId = 'bonus-sample-selection';
        customModal.createCustomModal(sampleId);
        $(`.${sampleId}`).find('.modal-body').html(response);
        // サンプル商品選択時にサンプルモーダルを削除するイベントを付与
        $(`.${sampleId} .modal-close, .${sampleId} .modal-close-outer`)
          .off('click')
          .on('click', function () {
            $(`.modal-overlay.${sampleId}`).remove();
          });
        $('.header-wrapper').css('transform', 'translate3d(0px,-100%,0)');
      }
      $('.ajax-loader').hide();
    }
  }).complete(function (data) {
    if (
      data &&
      data.responseText &&
      data.responseText.indexOf('error no-selection') == -1
    ) {
      resetModalScroll();
      updateModalScroll();
    }
  });
};

var showSelectionInCart = function (isNotCart) {
  // render content to modal by url
  var sampleID = 'bonus-sample-selection',
    index = require('./pages/product/index');
  if (typeof isNotCart != 'undefined') {
    var url = util.appendParamToURL(Urls.showSampleSelection, 'format', 'ajax');
  } else {
    var url = util.appendParamToURL(
      Urls.showSampleSelectionInCart,
      'format',
      'ajax'
    );
  }

  $('.sample-container .ajax-loader').show();
  $.ajax({
    url: url,
    dataType: 'html',
    success: function (response) {
      customModal.createCustomModal(sampleID);
      $('.' + sampleID)
        .find('.modal-body')
        .html(response);
      index.bodyPositionFixed(sampleID);
      $('.header-wrapper').css('transform', 'translate3d(0px,-100%,0)');
      if (response.indexOf('no-selection') > -1) {
        $('.modal-overlay.bonus-sample-selection').addClass('error');
      }
      $('.sample-container .ajax-loader').hide();
    }
  }).complete(function (data) {
    resetModalScroll();
    updateModalScroll();
  });
};

var resetModalScroll = function () {
  var headerHeight = $('.bonus-sample-selection .sample-header').outerHeight();
  var listHeight = $('.bonus-sample-selection .product-listing').outerHeight();
  var footerHeight = $(
    '.bonus-sample-selection .add-btn-container'
  ).outerHeight();

  var maxHeight = $('.bonus-sample-selection .modal-body').css('max-height');
  var totalHeight = headerHeight + listHeight + footerHeight;
  var bodyHeight = Math.min(parseInt(maxHeight), totalHeight);
  var contentHeight = bodyHeight - footerHeight;

  if (contentHeight && bodyHeight) {
    $('.bonus-sample-selection .sample-bonus-contents').css(
      'height',
      contentHeight + 'px'
    );
    $('.bonus-sample-selection .sb-content').css(
      'max-height',
      contentHeight + 'px'
    );
    $('.bonus-sample-selection .modal-body').css('height', bodyHeight + 'px');
    $('.bonus-sample-selection .sample-bonus-contents').scrollBox();
    $(window).trigger('resize.scrollBox');
  }
  adjustItems();
};

var updateModalScroll = function () {
  $(window).on('resize', function (e) {
    resetModalScroll();
  });
};

$(document)
  .on(
    'click',
    'a#selectsample , .sample-tile.sample-select-tile',
    function (e) {
      showSelectionInCart();
    }
  )
  .on('click', '.sample_at_home', function (e) {
    showSelectionInCart(true);
  });

exports.createSelectionShownCookie = createSelectionShownCookie;
exports.canShowSelection = canShowSelection;
exports.showSelection = showSelection;
exports.showSelectionInCart = showSelectionInCart;
exports.updateModalScroll = updateModalScroll;

},{"./ajax":1,"./modal":43,"./pages/product/index":70,"./util":105}],96:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */
function initializeEvents() {
    $('.search-text').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    })
    .blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() === input.attr('placeholder')) {
            input.val(input.attr('placeholder'));
        }
    })
    .blur();
}

exports.init = initializeEvents;

},{}],97:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $submitButton = $searchForm.find('button[type="submit"]');
        var $cancelButton = $searchForm.find('button[type="reset"]');

        // disable go button on page load
//        $submitButton.prop('disabled', true);
        
        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // Search overlay show/hide
        $('.search-icon, .header-search .icon-close, .js-search-link').on('click', function(e){
            e.preventDefault();
            $('html').toggleClass('sticky-header-search');
            util.scrollBanner();
           if(!$('html').hasClass('sticky-header-search')){
                $cancelButton.trigger('click');
                lastQuery = null;   
            }
            $('.nav-open').removeClass('nav-open');
            if($('.overlay').length == 0){
                $('body').append('<div class="overlay"></div>')
            }

            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
            return false;
        });

        // cancel button hide
       $cancelButton.on('click', function(){
            this.clearResults();
            lastQuery = null;
            $cancelButton.hide();
        }.bind(this));
        
        function closeOverlay() {
            $cancelButton.trigger('click');
            lastQuery = null;
            $('html').removeClass('sticky-header-search');
        }

        // Close search overlay
        $(document).on('click touchstart', '.overlay', function(){
            if($('html').hasClass('sticky-header-search')){
                closeOverlay();
            }
        });
        $(document).on('keyup', function(e){
            if (e.keyCode == 27 && $('html').hasClass('sticky-header-search')) { // escape key maps to keycode `27`
            closeOverlay();
            }
        }.bind(this));

        $(window).scroll(function(){
            if($('.header-search-wrapper').is(':visible') && $( window ).scrollTop() > ($('.header-search-wrapper').offset().top + $('.header-search-wrapper').outerHeight())){
                closeOverlay();
            }
        }.bind(this));
        
       
            
        

        // on blur listener
        $searchField.on('blur', function (e) {
        	this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));

        // Populate popular text in header search 
        $(document).on('click', '.header-search .popular-search li a', function(e){
            e.preventDefault();
            popularSearch($(this).text());
        });
        
        var popularSearch = function(query){
            lastQuery = null
            $searchField.val(query)
            currentQuery = query;
            $cancelButton.show();
            // no query currently running, init an update
            if ((!runningQuery && currentQuery.length > 2) || (!runningQuery && currentQuery.length == 0)) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this);


        // on key up listener
        $searchField.keyup(function (e) {

            // get display cancel button on type
            if ($searchField.val().length > 0){
                $cancelButton.show();
            } else {
                $cancelButton.hide();
            }

            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                this.checkInput(e, $searchField, $submitButton, defaultValue);
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if ((!runningQuery && currentQuery.length > 2) || (!runningQuery && currentQuery.length == 0)) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));
        
        $submitButton.on('click', function(e){
            $searchForm.find('input[name="q"]').val($searchField.val())
        	this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
                $('.search-default').show().find('.search-text-msg').hide();
                $('.no-search-text').show().find('.query-text').text(runningQuery);
            } else {
                // update the results div
                $('.search-default').hide();
                $resultsContainer.html(suggestionHTML).fadeIn(200);
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {$resultsContainer.empty();});
        $('.search-default').show().find('.search-text-msg').show();
        $('.no-search-text').hide();
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    },
    
    checkInput: function (e, $searchField, $submitButton, defaultValue) {
    	if($searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()){
    		e.preventDefault();
    		e.stopImmediatePropagation();
    		$searchField.val(defaultValue);
//    		$submitButton.prop('disabled', true);
            return false;
    	}
    },
    
};

module.exports = searchsuggest;

},{"./util":105}],98:[function(require,module,exports){
'use strict';
var shadedtool = {
	init: function() {
		if (screen.width < 768) {
			$(function() {
				$('#shaded-tool-carousel').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
					]
				});
			});
		}
	}
};

if (screen.width < 768) {
	$(function() {
		$('#ultimate-beauty').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	});
	
}
	
$( function() {
	$( "#tabs" ).tabs();
});

	
$('.skincare-tab').click(function(){	
	if(this.id == 'scin-tab1') {
		$('.ultimate-beauty-regimen-skin-concern-day').show();
		$('.ultimate-beauty-regimen-skin-concern-night').hide();
	} else{
		$('.ultimate-beauty-regimen-skin-concern-day').hide();
		$('.ultimate-beauty-regimen-skin-concern-night').show();
	}
})

function update() {
	var $lis = $('.skincare-produtssets > li'),
		$checked = $('input:checked.regimen-checkbox'),
		limit = 2,
		$notchecked =  $('input:not(:checked).regimen-checkbox');
		var disableuncheckedbox = false;
		$lis.hide().removeClass("checked-product-filter");
		$(".skin-choose-desc").removeClass("skin-choose-desc-selected");
		$(".regimen-filter-heading-checked").removeClass("regimen-day-night-checked");
		$(".reginmen-product-setlist").removeClass("reginmen-product-setlist-proddisplay");
		if ($checked.length) {
			$(".regimen-filter-heading-checked").addClass("regimen-day-night-checked");
			$(".reginmen-product-setlist").addClass("reginmen-product-setlist-proddisplay");
			if($checked.length >= 2) {
				disableuncheckedbox = true;
			}
			var selector = $checked.map(function () {
				 $lis.filter( '.' + $(this).attr('rel')).show().addClass("checked-product-filter");
				 $(this).parent().parent().find(".icon-heading").addClass("icon-heading-selected");
				 var img = $(this).parent().find("img");
				 var checkeddatasrc = img.attr('data-src-checked');
				 img.attr( "src", checkeddatasrc);
				return '.' + $(this).attr('rel');
			}).get().join('');
	
		} else {
			$lis.show();
		}
		if ($notchecked.length) {
			var selector = $notchecked.map(function () {
				if(disableuncheckedbox) {
					 $(this).attr("disabled",true);
				}
				else {
					 $(this).attr("disabled",false);
				}  
				$(this).parent().parent().find(".icon-heading").removeClass("icon-heading-selected");
				var img = $(this).parent().find("img");
				var uncheckeddatasrc = img.attr('data-src-uncheked');
				img.attr( "src", uncheckeddatasrc);
				return '.' + $(this).attr('rel');
			}).get().join('');
		} else {
			
		}
}
if ($(".regimen-skin-concern")[0]) {
	$('.regimen-skin-icons img').on('click', function(){ 
		$(".skin-choose-desc").addClass("skin-choose-desc-selected");
	});	
	$('div.tags').delegate('input[type=checkbox].regimen-checkbox', 'click', update);
	update();
}


module.exports = shadedtool;


},{}],99:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */
exports.init = function () {
   $('.slick').slick();
};

},{}],100:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function (storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function () {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        var data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options')
                    .removeClass('loading')
                    .children().show();
            }
        });
    },
    init: function () {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":101}],101:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function (zipCode) {
    var regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        },
        valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":31,"../util":105,"lodash":112,"promise":113}],102:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./'),
    util = require('../util');

var newLine = '\n';
var pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

var storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        var self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        var $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }
    }
};




module.exports = productInventory;


$('img.product-image-initial').bind('mouseenter mouseleave', function() {
	$(this).attr({
	src: $(this).attr('data-alt-src')
	, 'data-alt-src': $(this).attr('src')
		})
	});


$('#product-list-page-carousel').slick({
	  dots: false,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        infinite: true,
	        dots: false
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});


$('#product-image-carousel').slick({
	  dots: false,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        infinite: true,
	        dots: false
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});


$('#product-video-carousel').slick({
	  dots: false,
	  infinite: false,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        infinite: true,
	        dots: false
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});

function isScrolledIntoView(elem){
	var $elem = $(elem),
		$window = $(window),
		docViewTop = $window.scrollTop(),
		docViewBottom = docViewTop + $window.height(),
		elemTop = $elem.offset().top,
		elemBottom = elemTop + $elem.height();
	
	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * @description PDP Sticky Navigation and Sticky Buy Desktop
 **/
if ($('.pdp-jump-links').length) {
	var pdpnavbar = $('.pdp-jump-links'),
		moduleLength = pdpnavbar.find('.link-wrapper li').length;
	if(moduleLength <= 1) {
		$('.pdp-jump-links').remove();
	} else {
		$('.pdp-jump-links').removeClass('d-none');
	}

	var sticky = pdpnavbar.offset().top;
}

function productStickyNav() {
	if ($('.pdp-jump-links').length) {
		if ($(window).scrollTop() >= sticky) {
			pdpnavbar.addClass('sticky');
			window.setTimeout( function(){
				pdpnavbar.addClass('animation');
			}, 100);
		} else {
			pdpnavbar.removeClass('sticky animation');
			$('.stick-buy-container').removeClass('open');
			$('.sticky-buy-link').removeClass('active');
		}
	}
}

/**
 * @description PDP Sticky Buy Mobile
 **/
if ($('.sticky-buy-mobile').length) {
	var stickyBuyMobile = $('.sticky-buy-mobile'),
		addToCartButtonWrapper = $('.product-details-wrapper .product-add-to-cart'),
		addToCartButtonPosition = addToCartButtonWrapper.offset().top;

	$('.sticky-buy-mobile').on('click', function() {
		var scrollPosition = (addToCartButtonWrapper.offset().top + addToCartButtonWrapper.height()) - $(window).height();
		$('html, body').animate({scrollTop : scrollPosition}, 500);
	});
}

function productStickyBuyMobile() {
	if ($('.sticky-buy-mobile').length) {
		if($(window).scrollTop() >= addToCartButtonPosition && !isScrolledIntoView(addToCartButtonWrapper)) {
			stickyBuyMobile.addClass('sticky');
		} else {
			stickyBuyMobile.removeClass('sticky');
		}
	}
}

$(document).on('click', '.sticky-buy-link, .stick-buy-outer-close', function() {
	$('.sticky-buy-link').toggleClass('active');
	$('.stick-buy-container').toggleClass('open');
	$('.swatches-dropdown').removeClass('active');
});

$(window).on('resize orientationchange', function() {
	productStickyNav();
	productStickyBuyMobile();
});

$(window).on('scroll', function() {
	productStickyNav();
	productStickyBuyMobile();
});

$('#product-list-page-carousel > .slick-arrow').click(function(){
	$('.product-list-carousel > iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
});

},{"../util":105,"./":101,"lodash":112}],103:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                util.setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                util.setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{"./util":105}],104:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
	$(document).tooltip({
		items: '.tooltip',
		track: true,
		content: function () {
			return $(this).find('.tooltip-content').html();
		},
		tooltipClass: 'custom-tooltip'
	});

	$('.share-link').on('click', function (e) {
		e.preventDefault();
		var target = $(this).data('target');
		if (!target) {
			return;
		}
		$(target).toggleClass('active');
	});
};

},{}],105:[function(require,module,exports){
'use strict';

var _ = require('lodash');

var util = {
  /**
   * 検査対象が空文字、undefinedの場合、空オブジェクト、空配列かを判定する。
   *
   * @private
   * @param {any} property 検査対象
   * @returns {boolean} 空文字、undefinedの場合、空オブジェクト、空配列の場合、true。その他はfalse。
   */
  isEmptyProperty: function (property) {
    if (property === null) {
      return true;
    }
    if (typeof property === 'object') {
      if (Object.keys(property).length === 0) {
        return true;
      }
      return Object.keys(property).every((val) => this.isEmptyProperty(val));
    }
    // 数値のゼロは空判定しない
    if (property === 0) {
      return false;
    }
    // boolean値の場合は空判定しない
    if (typeof property === 'boolean') {
      return false;
    }
    return !Boolean(property);
  },

  /**
   * 空の要素を排除したオブジェクトを取得する。
   *
   * @param {JSON | Array} object JSONまたは配列のオブジェクト
   * @returns {JSON | Array} 空の要素を排除したオブジェクト（ディープコピー）
   */
  getEmptyPropertyDeletedObject: function (object) {
    const resultObject = Array.isArray(object) ? [] : {};
    Object.keys(object).forEach((key) => {
      if (this.isEmptyProperty(object[key])) {
        return;
      }
      if (typeof object[key] === 'object') {
        // オブジェクトから空の要素を削除
        const _resultObject = this.getEmptyPropertyDeletedObject(object[key]);
        // オブジェクトが空になったら追加しない
        if (!this.isEmptyProperty(_resultObject)) {
          Array.isArray(resultObject)
            ? resultObject.push(_resultObject)
            : (resultObject[key] = _resultObject);
        }
      } else {
        Array.isArray(resultObject)
          ? resultObject.push(object[key])
          : (resultObject[key] = object[key]);
      }
    });
    return resultObject;
  },

  /**
   * @function
   * @description appends the parameter with the given name and value to the given url and returns the changed url
   * @param {String} url the url to which the parameter will be added
   * @param {String} name the name of the parameter
   * @param {String} value the value of the parameter
   */
  appendParamToURL: function (url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
      return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';

    return url + separator + name + '=' + encodeURIComponent(value);
  },

  /**
   * @function
   * @description remove the parameter and its value from the given url and returns the changed url
   * @param {String} url the url from which the parameter will be removed
   * @param {String} name the name of parameter that will be removed from url
   */
  removeParamFromURL: function (url, name) {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
      return url;
    }
    var hash;
    var params;
    var domain = url.split('?')[0];
    var paramUrl = url.split('?')[1];
    var newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
      hash = paramUrl.split('#')[1] || '';
      paramUrl = paramUrl.split('#')[0];
    }
    params = paramUrl.split('&');
    for (var i = 0; i < params.length; i++) {
      // put back param to newParams array if it is not the one to be removed
      if (params[i].split('=')[0] !== name) {
        newParams.push(params[i]);
      }
    }
    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
  },

  /**
   * @function
   * @description appends the parameters to the given url and returns the changed url
   * @param {String} url the url to which the parameters will be added
   * @param {Object} params
   */
  appendParamsToUrl: function (url, params) {
    var _url = url;
    _.each(
      params,
      function (value, name) {
        _url = this.appendParamToURL(_url, name, value);
      }.bind(this)
    );

    return _url;
  },
  /**
   * @function
   * @description extract the query string from URL
   * @param {String} url the url to extra query string from
   **/
  getQueryString: function (url) {
    var qs;
    if (!_.isString(url)) {
      return;
    }
    var a = document.createElement('a');
    a.href = url;
    if (a.search) {
      qs = a.search.substr(1); // remove the leading ?
    }
    return qs;
  },

  updateQueryStringParam: function (url, paramName, newVal) {
    var _url = url;

    if (_url.indexOf(paramName) === -1) {
      return _url;
    }

    var newParamObj = new Object();
    newParamObj[paramName] = newVal;

    _url = this.removeParamFromURL(_url, paramName);
    _url = this.appendParamsToUrl(_url, newParamObj);

    return _url;
  },

  getHashParam: function (paramName) {
    var output = '';

    var hashParams = window.location.hash.replace('#', '').split('&');
    for (var i = 0; i < hashParams.length; i++) {
      if (hashParams[i].indexOf(paramName) > -1) {
        output = hashParams[i].split('=')[1];
      }
    }

    return output;
  },

  /**
   * @function
   * @description
   * @param {String}
   * @param {String}
   */
  elementInViewport: function (el, offsetToTop) {
    var top = el.offsetTop,
      left = el.offsetLeft,
      width = el.offsetWidth,
      height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    if (typeof offsetToTop !== 'undefined') {
      top -= offsetToTop;
    }

    if (window.pageXOffset !== null) {
      return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
      );
    }

    if (document.compatMode === 'CSS1Compat') {
      return (
        top <
          window.document.documentElement.scrollTop +
            window.document.documentElement.clientHeight &&
        left <
          window.document.documentElement.scrollLeft +
            window.document.documentElement.clientWidth &&
        top + height > window.document.documentElement.scrollTop &&
        left + width > window.document.documentElement.scrollLeft
      );
    }
  },

  /**
   * @function
   * @description Appends the parameter 'format=ajax' to a given path
   * @param {String} path the relative path
   */
  ajaxUrl: function (path) {
    return this.appendParamToURL(path, 'format', 'ajax');
  },

  /**
   * @function
   * @description
   * @param {String} url
   */
  toAbsoluteUrl: function (url) {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
      url = '/' + url;
    }
    return url;
  },
  /**
   * @function
   * @description Loads css dynamically from given urls
   * @param {Array} urls Array of urls from which css will be dynamically loaded.
   */
  loadDynamicCss: function (urls) {
    var i,
      len = urls.length;
    for (i = 0; i < len; i++) {
      this.loadedCssFiles.push(this.loadCssFile(urls[i]));
    }
  },

  /**
   * @function
   * @description Loads css file dynamically from given url
   * @param {String} url The url from which css file will be dynamically loaded.
   */
  loadCssFile: function (url) {
    return $('<link/>')
      .appendTo($('head'))
      .attr({
        type: 'text/css',
        rel: 'stylesheet'
      })
      .attr('href', url); // for i.e. <9, href must be added after link has been appended to head
  },
  // array to keep track of the dynamically loaded CSS files
  loadedCssFiles: [],

  /**
   * @function
   * @description Removes all css files which were dynamically loaded
   */
  clearDynamicCss: function () {
    var i = this.loadedCssFiles.length;
    while (0 > i--) {
      $(this.loadedCssFiles[i]).remove();
    }
    this.loadedCssFiles = [];
  },

  /**
   * @function
   * @description Extracts all parameters from a given query string into an object
   * @param {String} qs The query string from which the parameters will be extracted
   */
  getQueryStringParams: function (qs, decodeAfter) {
    if (!qs || qs.length === 0) {
      return {};
    }
    var params = {},
      unescapedQS = decodeAfter ? qs : decodeURIComponent(qs);
    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    unescapedQS.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      function ($0, $1, $2, $3) {
        if (decodeAfter) {
          params[decodeURIComponent($1)] = decodeURIComponent($3);
        } else {
          params[$1] = $3;
        }
      }
    );
    return params;
  },

  fillAddressFields: function (address, $form) {
    for (var field in address) {
      if (field === 'ID' || field === 'UUID' || field === 'key') {
        continue;
      }
      // if the key in address object ends with 'Code', remove that suffix
      // keys that ends with 'Code' are postalCode, stateCode and countryCode
      $form
        .find('[name$="' + field.replace('Code', '') + '"]')
        .val(address[field]);
      // update the state fields
      if (field === 'countryCode') {
        $form.find('[name$="country"]').trigger('change');
        // retrigger state selection after country has changed
        // this results in duplication of the state code, but is a necessary evil
        // for now because sometimes countryCode comes after stateCode
        $form.find('[name$="state"]').val(address.stateCode);
      }
    }
  },
  /**
   * @function
   * @description Updates the number of the remaining character
   * based on the character limit in a text area
   */
  limitCharacters: function () {
    $('form')
      .find('textarea[data-character-limit]')
      .each(function () {
        var characterLimit = $(this).data('character-limit');
        var charCountHtml = String.format(
          Resources.CHAR_LIMIT_MSG,
          '<span class="char-used-count"> 0 </span>',
          '<span class="char-allowed-count">' + characterLimit + '</span>'
        );

        //if window size is small then char-count should be after
        var containerPlacement = $(this).prev('div.char-count');
        var containerInsert = $('<div class="char-count"/>').insertBefore(
          $(this)
        );

        var charCountContainer = containerPlacement;
        if (charCountContainer.length === 0) {
          charCountContainer = containerInsert;
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).change();
      });
  },
  /**
   * @function
   * @description Binds the onclick-event to a delete button on a given container,
   * which opens a confirmation box with a given message
   * @param {String} container The name of element to which the function will be bind
   * @param {String} message The message the will be shown upon a click
   */
  setDeleteConfirmation: function (container, message) {
    $(container).on('click', '.delete', function () {
      return window.confirm(message);
    });
  },
  /**
   * @function
   * @description Scrolls a browser window to a given x point
   * @param {String} The x coordinate
   */
  scrollBrowser: function (xLocation) {
    $('html, body').animate({ scrollTop: xLocation }, 500);
  },

  isMobile: function () {
    var mobileAgentHash = [
      'mobile',
      'tablet',
      'phone',
      'ipad',
      'ipod',
      'android',
      'blackberry',
      'windows ce',
      'opera mini',
      'palm'
    ];
    var idx = 0;
    var isMobile = false;
    var userAgent = navigator.userAgent.toLowerCase();

    while (mobileAgentHash[idx] && !isMobile) {
      isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
      idx++;
    }
    return isMobile;
  },

  /**
   * @function getCookieSelector
   * @description Returns the cookie value
   **/
  getCookieSelector: function (cookieName) {
    var regularExpression =
      '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
    var regExp = new RegExp(regularExpression, '');

    return document.cookie.replace(regExp, '$1');
  },

  /**
   * @function setCookie
   *
   * @param {string} key - The cookie name
   * @param {string} value - The cookie value
   * @param {integer} minutes - The number of minutes to expire the cookie
   **/
  setCookie: function (key, value, minutes) {
    var duration = '';

    if (minutes) {
      var date = new Date();

      date.setTime(date.getTime() + minutes * 60 * 1000);

      duration = ' expires=' + date.toGMTString() + ';';
    }

    document.cookie = key + '=' + value + ';' + duration + ' path=/';
  },

  /**
   * @function validateEmail
   *
   * @description Returns boolean
   * @param {string} emailAddress - The email address
   **/
  validateEmail: function (emailAddress) {
    var emailRegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$');

    return emailRegExp.test(emailAddress);
  },

  /**
   * @function validateMessage
   *
   * @description Returns boolean
   * @param {string} message - The message
   **/
  validateMessage: function (message) {
    var messageRegExp = /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/;

    return messageRegExp.test(message);
  },

  /**
   * @function maximizeCheckoutSummary
   *
   * @description Maximizes/Expands the Order Checkout Summary
   **/
  maximizeCheckoutSummary: function () {
    if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
      $('.accordion-navigation').addClass('is-active');
      $('.accordion-title').attr('aria-expanded', true);
      $('.accordion-title').attr('aria-selected', true);
      $('#panel11a').css('display', 'block');
    }
  },
  /**
   * @function ieAnimation
   *
   * @description animation support for IE browser
   **/
  ieAnimation: function () {
    $('html, body').animate(
      { scrollTop: $('.header-wrapper').offset().top },
      300,
      'linear',
      function () {}
    );
  },
  /**
   * @function scrollBanner
   *
   * @description Scroll top banner to bottom
   **/
  scrollBanner: function () {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var amountoScrolled =
      $('.header-wrapper').offset().top - $(window).scrollTop();
    if (
      navigator.userAgent.match(/msie/i) ||
      navigator.userAgent.match(/trident/i)
    ) {
      window.requestAnimationFrame(util.ieAnimation);
    } else if (isSafari && navigator.userAgent.match(/iPad/i)) {
      $('html, body').animate(
        { scrollTop: $('.header-wrapper').offset().top },
        500,
        'linear',
        function () {}
      );
    } else {
      window.scrollBy({ top: amountoScrolled, left: 0, behavior: 'smooth' });
    }
  }
};

module.exports = util;

},{"lodash":112}],106:[function(require,module,exports){
'use strict';

var formPrepare = require('./pages/checkout/formPrepare');

var naPhone =
  /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
  phone: {
    us: naPhone,
    ca: naPhone,
    fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
    it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
    jp: /^((0[0-9]{1}0[0-9]{7,8})|(0[0-9]{8,9}))$/,
    cn: /.*/,
    gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
    other:
      /^\(?([0-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
  },
  postal: {
    us: /^\d{5}(-\d{4})?$/,
    ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
    fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
    it: /^([0-9]){5}$/,
    jp: /^([0-9]){7}$/,
    cn: /^([0-9]){6}$/,
    gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
    other: /^\d{5}(-\d{4})?$/
  },
  notCC: /^(?!(([0-9 -]){13,19})).*$/,
  // @see https://static.mul-pay.jp/doc/card-token/#tag/gettokenjs#multipaymentgettokencard-callback
  owner: /^[0-9a-zA-Z\s\x2c-\x2f]{0,50}$/,
  name: /^[a-zA-Z\s.-]*$/,
  simpletext: /^[0-9a-zA-Z .,'-]*$/,
  password: /^(?=.*[\d])(?=.*[a-zA-Z])[\w]{6,12}$/,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i,
  hasPOBox: /[p]+(ost)*\.*\s*[o|0]+(ffice)*\.*\s*b[o|0]x/gi,
  message: /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/,
  ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
  cvn: /^\d{3,4}$/,
  alphanumeric: /^[a-z0-9]+$/i,
  addr2regex:
    /(^((.{0,30})|([a-zA-Z0-9 -/:-@\[-\`\{-\~]{0,60}|([^a-zA-Z0-9 -/:-@\[-\`\{-\~]){0,30}))$)/
};
// global form validator settings
var settings = {
  errorClass: 'error',
  errorElement: 'span',
  onkeyup: false,
  onfocusout: function (element) {
    if (!this.checkable(element)) {
      this.element(element);
    }
  },
  errorPlacement: function (error, element) {
    $(element).parents('.form-row').find('.error-placement').remove();
    $(
      "<div class='error-placement'><i class='error-icon'></i><span class='error'>" +
        $(error).html() +
        '</span></div>'
    ).insertBefore($(element).parent());
  },
  ignore: ':hidden, .ignore'
};

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = (function (arr) {
  return function (ccNum) {
    var len = ccNum.length;
    var bit = 1;
    var sum = 0;
    var val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
  var country = getSelectedCountry(el, regex.phone);

  var rgx = regex.phone[country];
  var isOptional = this.optional(el);
  var isValid = rgx.test($.trim(value));

  // format the phone number if country is US
  if (country === 'us') {
    $(el).val(value.replace(/^(\d{3})[\s-]*(\d{3})[\s-]*(\d+)$/, '($1) $2-$3'));
  }

  return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a Address2 is not a Address2
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateAddress2 = function (value) {
  var isValid = regex.addr2regex.test($.trim(value));
  return isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
  var isValid = regex.owner.test($.trim(value));
  return isValid;
};

/**
 * @function
 * @description Validates that a name contains no special characters, except for "-"
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateName = function (value) {
  var isValid = regex.name.test($.trim(value));
  return isValid;
};

/**
 * @function
 * @description Validates name for JP
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateNameForJp = function (value, el) {
  var country = getSelectedCountry(el);

  var isValid = false;
  if (country === 'jp') {
    var rgx = /^[^ｦ-ﾟｰA-Za-z0-9 -/:-@\[-\`\{-\~]+$/;
    isValid = rgx.test($.trim(value));
  } else {
    isValid = validateName(value);
  }
  return isValid;
};

function getSelectedCountry(element, regex) {
  var $form = $(element).closest('form');
  var country = $form.find('select[name$="_country"]').val();
  if (
    country === undefined ||
    country.length === 0 ||
    (regex !== undefined && !regex[country.toLowerCase()])
  ) {
    return 'other';
  }
  return country.toLowerCase();
}

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add Address2 validation method to jQuery validation plugin.
 * Text fields must have 'address2' css class to be validated as address2
 */
$.validator.addMethod('address2', validateAddress2, Resources.INVALID_ADDRESS2);

/**
 * Add First and Last Name validation method to jQuery validation plugin.
 * Text fields must have 'firstname' or 'lastname' css class to be validated.
 */
$.validator.addMethod(
  'firstname',
  validateNameForJp,
  Resources.INVALID_FIRSTNAME
);
$.validator.addMethod(
  'lastname',
  validateNameForJp,
  Resources.INVALID_LASTNAME
);
$.validator.addMethod('fullname', validateName, simpleTextMessage);

$.validator.addMethod(
  'simpletext',
  function (value) {
    var isValid = regex.simpletext.test($.trim(value));
    return isValid;
  },
  simpleTextMessage
);

$.validator.addClassRules({
  city: {
    simpletext: true
  },
  address1: {
    simpletext: true,
    address: true
  },
  province: {
    simpletext: true
  }
});

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod(
  'alphanumeric',
  function (value) {
    var isValid = regex.alphanumeric.test($.trim(value));
    return isValid;
  },
  simpleTextMessage
);

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod(
  'create-password',
  function (value) {
    var isValid = regex.password.test($.trim(value));
    return isValid;
  },
  Resources.VALIDATE_PASSWORD
);

/**
 * Modify email validation method of jQuery validation plugin.
 * Text fields must have 'email' css class to be validated.
 */
$.validator.addMethod(
  'email',
  function (value) {
    var isValid = regex.email.test($.trim(value));
    return isValid;
  },
  Resources.VALIDATE_EMAIL
);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod(
  'gift-cert-amount',
  function (value, el) {
    var isOptional = this.optional(el);
    var isValid =
      !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
    return isOptional || isValid;
  },
  Resources.GIFT_CERT_AMOUNT_INVALID
);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod(
  'positivenumber',
  function (value) {
    if ($.trim(value).length === 0) {
      return true;
    }
    return !isNaN(value) && Number(value) >= 0;
  },
  ''
); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod(
  'number',
  function (value) {
    // number == Credit card number
    var isValid = luhnCheck($.trim(value));
    return isValid;
  },
  Resources.VALIDATE_NUMBER
);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod(
  'cvn',
  function (value) {
    var isValid = regex.cvn.test($.trim(value));
    return isValid;
  },
  Resources.VALIDATE_CVN
);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod(
  'ordernumber',
  function (value) {
    var isValid = regex.ordernumber.test($.trim(value));
    return isValid;
  },
  Resources.INVALID_ORDER_NUMBER
);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod(
  'equal-to',
  function (value, el) {
    var equalTo = $(el).attr('equal-to');
    var $equalToEl = $(el).closest('form').find(equalTo);

    return value === $equalToEl.val();
  },
  function (value, el) {
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_EQUALTO;
  }
);

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address1' css class to be validated
 */
$.validator.addMethod(
  'address',
  function (value, el) {
    // check 'PO BOX' value in string and complement result
    var isValid = !$.trim(value).match(regex.hasPOBox);

    return isValid;
  },
  Resources.ADDRESS_PO_BOX_ERROR
);

/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated
 */
$.validator.addMethod(
  'postal',
  function (value, el) {
    var $form = $(el).closest('form');
    var $country = $form.find('select[name$="_country"]');
    var selectedCountry =
      $country.length > 0 ? $country.val().toLowerCase() : 'us';

    var rgx = null;
    var isValid = false;
    if ($(el).hasClass('global-zip')) {
      // if universal, it accepts both US and CN values
      isValid =
        regex.postal['us'].test($.trim(value)) ||
        regex.postal['cn'].test($.trim(value));
    } else {
      rgx = regex.postal[selectedCountry];
      isValid = rgx.test($.trim(value));
    }

    return isValid;
  },
  Resources.INVALID_ZIP
);

/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postcode' css class to be validated
 * Adding this for China addresses
 */
$.validator.addMethod(
  'postcode',
  function (value, el) {
    var $form = $(el).closest('form');
    var $country = $form.find('select[name$="_country"]');
    var selectedCountry = $country.length > 0 ? $country.val() : 'us';

    var rgx = regex.postal[selectedCountry];
    var isValid = rgx.test($.trim(value));

    return isValid;
  },
  Resources.INVALID_POSTAL
);

/**
 * Add message validation method to jQuery validation plugin.
 * Text fields must have 'message' css class to be validated
 */
$.validator.addMethod(
  'message',
  function (value, el) {
    var isValid = regex.message.test($.trim(value));
    return isValid;
  },
  Resources.INVALID_MESSAGE
);

var requiredMessage = function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var simpleTextMessage = function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var passwordMessage = function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_PASSWORD;
};

var maxLengthMessage = function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || $.validator.format(Resources.VALIDATE_MAXLENGTH);
};

var minLengthMessage = function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || $.validator.format(Resources.VALIDATE_MINLENGTH);
};
var stateValidation = function () {
  var customstateRow = $('.state.form-row label');
  if (
    $('.state select option:selected').val() == '' ||
    $('.state .ui-selectmenu-text').text() == 'Select State'
  ) {
    customstateRow.next('.error-placement').remove();
    $(
      '<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">' +
        Resources.INVALID_STATE +
        '</span></div>'
    ).insertAfter(customstateRow);
    $('.state span.ui-selectmenu-button').addClass('dropdownerror');
  } else {
    $('.state .error-placement').remove();
    $('.state span.ui-selectmenu-button').removeClass('dropdownerror');
  }
};

$.extend($.validator.messages, {
  required: requiredMessage,
  remote: Resources.VALIDATE_REMOTE,
  email: Resources.VALIDATE_EMAIL,
  address1: Resources.ADDRESS_PO_BOX_ERROR,
  password: passwordMessage,
  url: Resources.VALIDATE_URL,
  date: Resources.VALIDATE_DATE,
  dateISO: Resources.VALIDATE_DATEISO,
  number: Resources.VALIDATE_NUMBER,
  digits: Resources.VALIDATE_DIGITS,
  creditcard: Resources.VALIDATE_CREDITCARD,
  equalTo: Resources.VALIDATE_EQUALTO,
  maxlength: maxLengthMessage,
  minlength: minLengthMessage,
  rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
  range: $.validator.format(Resources.VALIDATE_RANGE),
  max: $.validator.format(Resources.VALIDATE_MAX),
  min: $.validator.format(Resources.VALIDATE_MIN),
  postal: Resources.INVALID_ZIP,
  message: Resources.INVALID_MESSAGE,
  fullname: simpleTextMessage,
  simpletext: simpleTextMessage,
  alphanumeric: simpleTextMessage
});
// Updated code to populate green tick check if the password meets the requirements.
var validator = {
  regex: regex,
  settings: settings,
  init: function () {
    var _self = this;
    $('form:not(.suppress)')
      .not(function (index, element) {
        return (
          $(element).closest('.entry-container, .entry-modal, .entry-wrapper')
            .length > 0
        );
      })
      .each(function () {
        _self.initForm(this);
      })
      .on('blur', '.create-password', function () {
        var isValid = regex.password.test($.trim($(this).val())),
          currentItem = $(this),
          parentOfCurrent = currentItem.parent('.field-wrapper'),
          topParentofCurrent = parentOfCurrent.parent('.form-row');
        if (isValid == true) {
          topParentofCurrent.find('.error-placement').remove();
          parentOfCurrent
            .addClass('ticmark')
            .find('.create-password')
            .removeClass('error');
        } else {
          parentOfCurrent.removeClass('ticmark');
        }
      })
      .on('blur', '.passwordconfirm, .newpasswordconfirm', function () {
        var currentItem = $(this),
          currentPassword = $('.create-password').val(),
          confirmPassword = $('.passwordconfirm,.newpasswordconfirm').val(),
          parentOfCurrent = currentItem.parent('.field-wrapper'),
          topParentofCurrent = parentOfCurrent.parent('.form-row'),
          existError = $('.create-password')
            .parent('.field-wrapper')
            .find('span.error').length;
        if (currentPassword === confirmPassword && existError == 0) {
          topParentofCurrent.find('.error-placement').remove();
          parentOfCurrent
            .addClass('ticmark')
            .find('.passwordconfirm')
            .removeClass('error');
        } else {
          parentOfCurrent.removeClass('ticmark');
        }
      });
  },
  initForm: function (f) {
    var _self = this;
    var $form = $(f);
    var $submitForm = $form.find('button[type="submit"]:not(.ignore)');
    var fp = formPrepare();
    fp.init(
      {
        formSelector: $form,
        continueSelector: $submitForm
      },
      _self.settings
    );
  },
  initStateValidation: function (e) {
    $('.state .ui-selectmenu-button').on('blur', function () {
      $('select').selectmenu('refresh');
      stateValidation();
    });
    $('.state select').on('selectmenuchange', function () {
      stateValidation();
    });
  }
};

module.exports = validator;

},{"./pages/checkout/formPrepare":54}],107:[function(require,module,exports){
var modal = require('./modal').global;

module.exports = {
	initialize: function () {
		//bind video play,pause buttons with respective video playbacks
		$('.play-pause-btn').click(function() {
			var $this = $(this),
				$linkedVideo = document.getElementById($(this).data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				if($this.hasClass('active')){
					$linkedVideo.pause();
				}
				else{
					$linkedVideo.play();
				}
				$this.toggleClass('active');
			}
	
			//Add class to hide picture tag once video played
			$this.parent().addClass('hide-poster');
			
			//link end event for playing video
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.onended = function(){
					$this.removeClass('active');
				};
			}
		});

		$('.modal-close').click(function() {
			var $linkedVideo = document.getElementById($(this).data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.pause();
			}
		});
		
		$('#category-hero .slick-arrow').click(function() {
			var playPauseButton = $(this).parent('.slick-slider').find('.slick-active .play-pause-btn');
			var $linkedVideo = document.getElementById(playPauseButton.data('videoid'));
			if($linkedVideo !== undefined && $linkedVideo !== null) {
				$linkedVideo.pause();
				playPauseButton.removeClass('active');
			}
		});
	},

	init: function (cb) {
		if((typeof window.YT !== "undefined") && (typeof cb !== 'undefined')) {
			return cb();
		}

		window.onYouTubeIframeAPIReady = cb;

		// load youtube iframe api
		var tag = document.createElement("script");

		tag.async = true;
		tag.src = "https://www.youtube.com/iframe_api";

		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	playInline: function ($ele, videoId) {
		var eleId = $ele.attr("id");
		if(!eleId || !videoId) { return; }

		new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: {rel: 0},
			events: {
				onReady: function (evt) {
					var player = evt.target;
					player.playVideo();
				}
			}
		})
	},

	playInModal: function (videoId) {
		if(!videoId) { return; }

		modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

		new YT.Player("video-player", {
			videoId: videoId,
			events: {
				onReady: function (evt) {
					var player = evt.target;
					modal.events.onOpen(function () {
						var modalBodyWidth = $(".modal-body").width();
						//$("#video-player").width(modalBodyWidth);
						player.playVideo();
					});
					modal.events.onClose(function () { player.destroy(); });
					modal.open();
				}
			}
		})
	}
};
},{"./modal":43}],108:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":109}],109:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],110:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],111:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":110,"wolfy87-eventemitter":132}],112:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],113:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":118}],114:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":109}],115:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":114}],116:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":114}],117:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":114}],118:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":114,"./done.js":115,"./es6-extensions.js":116,"./finally.js":117,"./node-extensions.js":119,"./synchronous.js":120}],119:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":114,"asap":108}],120:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":114}],121:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],122:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

},{}],123:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":122,"./parse":124,"./stringify":125}],124:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};

},{"./utils":126}],125:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var formats = require('./formats');

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":122,"./utils":126}],126:[function(require,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

var encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

},{}],127:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],128:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],129:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":127,"./encode":128}],130:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":131,"punycode":121,"querystring":129}],131:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],132:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}]},{},[21]);
